angular.module("templates-dist", ["../app/views/activate/activate-step1.html", "../app/views/activate/activate-success.html", "../app/views/card-balance/card-balance.html", "../app/views/card-balance/view-card-balance.html", "../app/views/collect/agreements.html", "../app/views/collect/esign-disclosure-redeem.html", "../app/views/collect/esign-disclosure.html", "../app/views/collect/plastic-step1.html", "../app/views/collect/redeem-success.html", "../app/views/collect/redeem-virtual-step1.html", "../app/views/collect/register-step1.html", "../app/views/collect/register-step2.html", "../app/views/collect/virtual-step1.html", "../app/views/consumer-choice/layout.html", "../app/views/consumer-choice/step1.html", "../app/views/consumer-choice/step2.html", "../app/views/contact/contact.html", "../app/views/fees/fees.html", "../app/views/gift-collection/gift-collection.html", "../app/views/giftCard/layout.html", "../app/views/giftCard/step1.html", "../app/views/giftCard/step2.html", "../app/views/giftCard/step3.html", "../app/views/giftCard/success.html", "../app/views/giftCard/widget-header.html", "../app/views/giftCard/widget-layout.html", "../app/views/index/top-header.html", "../app/views/join/cdd-info.html", "../app/views/join/contact-info.html", "../app/views/join/email-verify.html", "../app/views/join/esign-disclosure.html", "../app/views/join/fee-schedule.html", "../app/views/join/getting-started.html", "../app/views/join/layout.html", "../app/views/join/mobile-welcome.html", "../app/views/join/security.html", "../app/views/join/success.html", "../app/views/join/wait-list.html", "../app/views/join/welcome.html", "../app/views/legal/privacy-policy.html", "../app/views/login/login.html", "../app/views/login/loginFraud.html", "../app/views/login/sso.html", "../app/views/member/ach/header-content.html", "../app/views/member/ach/side-options.html", "../app/views/member/ach/step1.html", "../app/views/member/ach/step2.html", "../app/views/member/bank/add/confirmation.html", "../app/views/member/bank/add/error.html", "../app/views/member/bank/add/newBankList.html", "../app/views/member/bank/add/side-text.html", "../app/views/member/bank/add/step1.html", "../app/views/member/bank/detail/list.html", "../app/views/member/bank/manage/list.html", "../app/views/member/bank/recurring/manage/confirmation.html", "../app/views/member/bank/recurring/manage/edit.html", "../app/views/member/bank/recurring/manage/list.html", "../app/views/member/bank/recurring/manage/step2.html", "../app/views/member/bank/recurring/schedule/confirmation.html", "../app/views/member/bank/recurring/schedule/step1.html", "../app/views/member/bank/recurring/schedule/step2.html", "../app/views/member/bank/transfer/confirmation.html", "../app/views/member/bank/transfer/step1.html", "../app/views/member/bank/transfer/step2.html", "../app/views/member/billpay/list.html", "../app/views/member/billpay/new.html", "../app/views/member/blockload/step1.html", "../app/views/member/cashload/step1.html", "../app/views/member/corpdeposit/layout.html", "../app/views/member/corpdeposit/side-text.html", "../app/views/member/corpdeposit/step1.html", "../app/views/member/debit-card-withdrawal/side-options.html", "../app/views/member/debit-card-withdrawal/step1.html", "../app/views/member/debit-card-withdrawal/step2.html", "../app/views/member/debit-card-withdrawal/step3.html", "../app/views/member/directdeposit/layout.html", "../app/views/member/directdeposit/print.html", "../app/views/member/directdeposit/side-text.html", "../app/views/member/directdeposit/step1.html", "../app/views/member/expanded/feed.html", "../app/views/member/expanded/print.html", "../app/views/member/home/feed.html", "../app/views/member/limits/list.html", "../app/views/member/paypal/layout.html", "../app/views/member/paypal/side-options.html", "../app/views/member/paypal/step1.html", "../app/views/member/paypal/step2.html", "../app/views/member/paypal/step3.html", "../app/views/member/profile/account/step1.html", "../app/views/member/profile/account/step2.html", "../app/views/member/profile/activate/step1.html", "../app/views/member/profile/atm/step1.html", "../app/views/member/profile/atm/step2.html", "../app/views/member/profile/changepin/step1.html", "../app/views/member/profile/feesummary/step1.html", "../app/views/member/profile/password/step1.html", "../app/views/member/profile/reissue/confirmation-side-text.html", "../app/views/member/profile/reissue/step1-side-text.html", "../app/views/member/profile/reissue/step1.html", "../app/views/member/profile/reissue/step2-header-text.html", "../app/views/member/profile/reissue/step2-side-options.html", "../app/views/member/profile/reissue/step2.html", "../app/views/member/profile/smsmanage/step1.html", "../app/views/member/profile/smsmanage/step2.html", "../app/views/member/profile/statements/step1.html", "../app/views/member/profile/verification/denied.html", "../app/views/member/profile/verification/footer.html", "../app/views/member/profile/verification/review.html", "../app/views/member/profile/verification/step1.html", "../app/views/member/profile/verification/step2.html", "../app/views/member/profile/verification/step3.html", "../app/views/member/profile/verification/submitted.html", "../app/views/member/rdc/step1.html", "../app/views/member/request/header-content.html", "../app/views/member/request/step2.html", "../app/views/member/request/step3.html", "../app/views/member/request/step4.html", "../app/views/member/send-check/side-options.html", "../app/views/member/send-check/step1.html", "../app/views/member/send-check/step2.html", "../app/views/member/send-check/step3.html", "../app/views/member/send-physical-card/confirmation.html", "../app/views/member/send-physical-card/step1.html", "../app/views/member/send/gift/step1.html", "../app/views/member/send/gift/step2.html", "../app/views/member/send/manage/list.html", "../app/views/member/send/recurring/header-content.html", "../app/views/member/send/recurring/step1.html", "../app/views/member/send/recurring/step2.html", "../app/views/member/send/recurring/step3.html", "../app/views/member/send/transfer/step1.html", "../app/views/member/send/transfer/step2.html", "../app/views/member/send/transfer/step3.html", "../app/views/member/send/transfer/step4.html", "../app/views/member/shared/accountSelector.html", "../app/views/member/shared/card-image-small.html", "../app/views/member/shared/card-image.html", "../app/views/member/shared/checkboxes.html", "../app/views/member/shared/confirmation-modal.html", "../app/views/member/shared/double-wide-widgets.html", "../app/views/member/shared/feed-container.html", "../app/views/member/shared/feed.html", "../app/views/member/shared/footer.html", "../app/views/member/shared/in-active.html", "../app/views/member/shared/main-header.html", "../app/views/member/shared/overlay/calendar.html", "../app/views/member/shared/overlay/footer.html", "../app/views/member/shared/overlay/header-content.html", "../app/views/member/shared/overlay/header-default.html", "../app/views/member/shared/overlay/header-search.html", "../app/views/member/shared/overlay/header-transfer.html", "../app/views/member/shared/overlay/layout.html", "../app/views/member/shared/overlay/restricted.html", "../app/views/member/shared/overlay/side-options.html", "../app/views/member/shared/overlay/side-text.html", "../app/views/member/shared/viewAllCards.html", "../app/views/member/shared/virtual-card-expanded.html", "../app/views/member/shared/virtual-card.html", "../app/views/member/shared/widget.html", "../app/views/member/shared/widgets.html", "../app/views/member/subaccount/add/side-text.html", "../app/views/member/subaccount/add/step1.html", "../app/views/member/subaccount/add/step2.html", "../app/views/member/subaccount/close/step1.html", "../app/views/member/subaccount/disable/step1.html", "../app/views/member/subaccount/enable/step1.html", "../app/views/member/subaccount/feed/feed.html", "../app/views/member/subaccount/feed/transactions.html", "../app/views/member/subaccount/load/header-content.html", "../app/views/member/subaccount/retrieve/header-content.html", "../app/views/member/subaccount/retrieve/search.html", "../app/views/member/subaccount/retrieve/step1.html", "../app/views/member/subaccount/retrieve/step2.html", "../app/views/member/subaccount/retrieve/step3.html", "../app/views/member/transaction/detail.html", "../app/views/member/transaction/side-text.html", "../app/views/member/transfers/manage.html", "../app/views/member/upgrade/cip-failure.html", "../app/views/member/upgrade/header.html", "../app/views/member/upgrade/step1.html", "../app/views/member/upgrade/step2.html", "../app/views/member/upgrade/success.html", "../app/views/member/venmo/layout.html", "../app/views/member/venmo/side-options.html", "../app/views/member/venmo/step1.html", "../app/views/member/venmo/step2.html", "../app/views/member/venmo/step3.html", "../app/views/member/virtual/side-options.html", "../app/views/member/virtual/step1.html", "../app/views/member/wallet/apple.html", "../app/views/member/wallet/google.html", "../app/views/member/wallet/samsung.html", "../app/views/member/wallet/step1.html", "../app/views/mobile-id/mobile-id-collect.html", "../app/views/mobile-id/mobile-id-success.html", "../app/views/mobile-id/mobile-id.html", "../app/views/register/esign-disclosure.html", "../app/views/register/fee-schedule.html", "../app/views/register/register-step1.html", "../app/views/register/register-step2.html", "../app/views/register/register-step3.html", "../app/views/register/register-step4.html", "../app/views/register/register-success.html", "../app/views/resetpassword/corporate.html", "../app/views/resetpassword/error.html", "../app/views/resetpassword/layout.html", "../app/views/resetpassword/mobile-success.html", "../app/views/resetpassword/reset-step1.html", "../app/views/resetpassword/reset-step2.html", "../app/views/resetpassword/success.html", "../app/views/signup/confirmation.html", "../app/views/signup/create.html", "../app/views/signup/customize.html", "../app/views/signup/fee-schedule.html", "../app/views/signup/layout.html", "../app/views/signup/order.html", "../app/views/signup/signin.html", "../app/views/signup/signup-progress.html", "../app/partials/selectVerificationMethod.html", "../app/partials/verifyContact.html", "../app/partials/verifyEmailOld.html"]);

angular.module("../app/views/activate/activate-step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/activate/activate-step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.number.$invalid && submitted\">Please enter a valid card number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.exp.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.cvv.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.number.hasFocus,\n" +
    "					 \"has-success\": joinForm.number.$valid,\n" +
    "					 \"has-error\": joinForm.number.$invalid && (form.$submitted || joinForm.number.$touched),\n" +
    "					 \"is-empty\": !joinForm.number.$viewValue }'>\n" +
    "					<label for=\"number\">Card Number</label>\n" +
    "					<input\n" +
    "             id=\"number\"\n" +
    "             name=\"number\"\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             tabindex=\"1\"\n" +
    "             ng-model=\"formData.cardNumber\"\n" +
    "             mask=\"9999-9999-9999-9999\"\n" +
    "             clean=\"true\"\n" +
    "             required\n" +
    "						 ng-focus='joinForm.number.hasFocus=true',\n" +
    "             ng-blur='joinForm.number.hasFocus=false'>\n" +
    "				</div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.exp.hasFocus,\n" +
    "					 \"has-success\": joinForm.exp.$valid,\n" +
    "					 \"has-error\": joinForm.exp.$invalid && (form.$submitted || joinForm.exp.$touched),\n" +
    "					 \"is-empty\": !joinForm.exp.$viewValue }'>\n" +
    "					<label for=\"exp\">MM/YY</label>\n" +
    "					<input\n" +
    "             id=\"exp\"\n" +
    "             name=\"exp\"\n" +
    "             class=\"radius-none\"\n" +
    "             type=\"text\"\n" +
    "             tabindex=\"2\"\n" +
    "             ng-model=\"formData.exp\"\n" +
    "             exp-input-helper\n" +
    "             mask=\"99/99\"\n" +
    "             required\n" +
    "						 ng-focus='joinForm.exp.hasFocus=true',\n" +
    "             ng-blur='joinForm.exp.hasFocus=false'>\n" +
    "				</div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.cvv.hasFocus,\n" +
    "					 \"has-success\": joinForm.cvv.$valid,\n" +
    "					 \"has-error\": joinForm.cvv.$invalid && (form.$submitted || joinForm.cvv.$touched),\n" +
    "					 \"is-empty\": !joinForm.cvv.$viewValue }'>\n" +
    "					<label for=\"cvv\">CVV</label>\n" +
    "					<input\n" +
    "             id=\"cvv\"\n" +
    "             name=\"cvv\"\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             tabindex=\"3\"\n" +
    "             ng-model=\"formData.cvv\"\n" +
    "             required\n" +
    "             mask=\"999\"\n" +
    "						 ng-focus='joinForm.cvv.hasFocus=true',\n" +
    "             ng-blur='joinForm.cvv.hasFocus=false'>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.pin1.$error.required && submitted\">Please provide a pin for your card</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.pin1.hasFocus,\n" +
    "					 \"has-success\": joinForm.pin1.$valid,\n" +
    "					 \"has-error\": joinForm.pin1.$invalid && (form.$submitted || joinForm.pin1.$touched),\n" +
    "					 \"is-empty\": !joinForm.pin1.$viewValue }'>\n" +
    "          <label for=\"pin1\">Set Card Pin</label>\n" +
    "					<input\n" +
    "             class=\"radius-all\"\n" +
    "             type=\"password\"\n" +
    "             name=\"pin1\"\n" +
    "             tabindex=\"4\"\n" +
    "             ng-model=\"formData.pin1\"\n" +
    "             required\n" +
    "             data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "             maxlength=\"4\"\n" +
    "             ng-maxlength=\"4\"\n" +
    "             ng-minlength=\"4\"\n" +
    "             mask=\"9999\"\n" +
    "						 ng-focus='joinForm.pin1.hasFocus=true',\n" +
    "             ng-blur='joinForm.pin1.hasFocus=false'>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"(formData.pin1 != formData.pin2 || joinForm.pin2.$error.required) && submitted\">Please confirm the pins match</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.pin2.hasFocus,\n" +
    "					 \"has-success\": joinForm.pin2.$valid,\n" +
    "					 \"has-error\": joinForm.pin2.$invalid && (form.$submitted || joinForm.pin2.$touched),\n" +
    "					 \"is-empty\": !joinForm.pin2.$viewValue }'>\n" +
    "          <label for=\"pin2\">Confirm Pin</label>\n" +
    "					<input\n" +
    "             class=\"radius-all\"\n" +
    "             type=\"password\"\n" +
    "             name=\"pin2\"\n" +
    "             tabindex=\"5\"\n" +
    "             ng-model=\"formData.pin2\"\n" +
    "             required\n" +
    "             data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "             maxlength=\"4\"\n" +
    "             ng-maxlength=\"4\"\n" +
    "             ng-minlength=\"4\"\n" +
    "             mask=\"9999\"\n" +
    "						 ng-focus='joinForm.pin2.hasFocus=true',\n" +
    "             ng-blur='joinForm.pin2.hasFocus=false'>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "    <div class=\"modern-widget-right\">\n" +
    "        <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <a class=\"btn btn--float-right\" ng-click=\"attemptSubmission(joinForm)\">ACTIVATE</a>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/activate/activate-success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/activate/activate-success.html",
    "<div class=\"overlay modern-widget exMarginBtm join\">\n" +
    "  <div class=\"overlay-header bg-referral\">\n" +
    "    <div class=\"overlay-header-main\">\n" +
    "      <span class=\"icon-invite-forward\"></span>\n" +
    "      <h1>WELCOME</h1>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-header bg-gray\">\n" +
    "    <div class=\"modern-widget-info bg-white\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h2>Thanks for activating your {{brand.commonProgramName}}!</h2>\n" +
    "        <p ui-view=\"header\">Your card is ready to be used everywhere Debit Mastercard is accepted.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-body\">\n" +
    "    <div class=\"modern-widget-main\">\n" +
    "      <div class=\"modern-widget-section modern-form-section bg-white no-padding\">\n" +
    "        <img ng-src=\"assets/images/{{brand.name}}/join-welcome.png\">\n" +
    "      </div>\n" +
    "      <div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "        <div class=\"text-center\">\n" +
    "          <h2>{{activateSubTitle}}</h2>\n" +
    "          <a class=\"btn\" ui-sref=\"root.login\" ng-if=\"activateLogin\">LOGIN</a>\n" +
    "          <a class=\"btn\" ui-sref=\"root.register.step1\" ng-if=\"activateRegister\">REGISTER</a>\n" +
    "          <p class=\"activate-p\">{{activateInfo}}</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/card-balance/card-balance.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/card-balance/card-balance.html",
    "<div class=\"card-balance-container\">\n" +
    "    <div class=\"card-balance-title-container\">\n" +
    "        <div class=\"card-balance-sub-title\">\n" +
    "            Enter Card Information to\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-title\">\n" +
    "            View Card Balance\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <form name=\"myForm\" class=\"card-balance-form\" novalidate ng-submit=\"myForm.$valid && login()\">\n" +
    "        <div class=\"card-balance-input-container\">\n" +
    "            <div class=\"card-balance-input-description-container\">\n" +
    "                <div class=\"card-balance-description\">\n" +
    "                    Enter your card number\n" +
    "                </div>\n" +
    "                <a class=\"card-balance-info-icon-container\" ng-click=\"showCardNumberInfoModal = !showCardNumberInfoModal\">\n" +
    "                    <span class=\"icon-info card-balance-icon-info\"></span>\n" +
    "                </a>\n" +
    "            </div>\n" +
    "            <label>\n" +
    "                <input\n" +
    "                        type=\"text\"\n" +
    "                        class=\"card-balance-input\"\n" +
    "                        placeholder=\"Card number\"\n" +
    "                        name=\"cardNumberInput\"\n" +
    "                        ng-model=\"formData.cardNumber\"\n" +
    "                        ng-pattern=\"/^[0-9]*$/\"\n" +
    "                        ng-minlength=\"16\"\n" +
    "                        ng-maxlength=\"16\"\n" +
    "                        ng-class=\"{'card-balance-error-border': (myForm.cardNumberInput.$dirty || myForm.$submitted) && myForm.cardNumberInput.$invalid}\"\n" +
    "                        ng-model-options=\"{ debounce: 1000 }\"\n" +
    "                        required />\n" +
    "            </label>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"(myForm.cardNumberInput.$dirty || myForm.$submitted) && myForm.cardNumberInput.$error.required\">\n" +
    "                Card number is required.\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"myForm.cardNumberInput.$dirty && myForm.cardNumberInput.$error.pattern\">\n" +
    "                Only numbers are allowed.\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"myForm.cardNumberInput.$dirty && myForm.cardNumberInput.$error.minlength\">\n" +
    "                Card number cannot be less than 16 digits.\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"myForm.cardNumberInput.$dirty && myForm.cardNumberInput.$error.maxlength\">\n" +
    "                Card number cannot be more than 16 digits.\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-input-container\">\n" +
    "            <div class=\"card-balance-input-description-container\">\n" +
    "                <div class=\"card-balance-description\">\n" +
    "                    Enter your card's security code\n" +
    "                </div>\n" +
    "                <a class=\"card-balance-info-icon-container\" ng-click=\"showCvvNumberInfoModal = !showCvvNumberInfoModal\">\n" +
    "                    <span class=\"icon-info card-balance-icon-info\"></span>\n" +
    "                </a>\n" +
    "            </div>\n" +
    "            <label>\n" +
    "                <input\n" +
    "                        type=\"text\"\n" +
    "                        class=\"card-balance-input\"\n" +
    "                        placeholder=\"CVV number\"\n" +
    "                        name=\"cvvNumberInput\"\n" +
    "                        ng-model=\"formData.cvvNumber\"\n" +
    "                        ng-pattern=\"/^[0-9]*$/\"\n" +
    "                        ng-minlength=\"3\"\n" +
    "                        ng-maxlength=\"3\"\n" +
    "                        ng-class=\"{'card-balance-error-border': (myForm.cvvNumberInput.$dirty || myForm.$submitted) && myForm.cvvNumberInput.$invalid}\"\n" +
    "                        ng-model-options=\"{ debounce: 1000 }\"\n" +
    "                        required />\n" +
    "            </label>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"(myForm.cvvNumberInput.$dirty || myForm.$submitted) && myForm.cvvNumberInput.$error.required\">\n" +
    "                CVV number is required.\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"myForm.cvvNumberInput.$dirty && myForm.cvvNumberInput.$error.pattern\">\n" +
    "                Only numbers are allowed.\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"myForm.cvvNumberInput.$dirty && myForm.cvvNumberInput.$error.minlength\">\n" +
    "                CVV number is too short.\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-error-message\" ng-show=\"myForm.cvvNumberInput.$dirty && myForm.cvvNumberInput.$error.maxlength\">\n" +
    "                CVV number is too long.\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    <div class=\"card-balance-button-container\">\n" +
    "        <button\n" +
    "        type=\"submit\"\n" +
    "        class=\"card-balance-button\">\n" +
    "            Get Balance\n" +
    "        </button>\n" +
    "    </div>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div ng-show=\"showCardNumberInfoModal\" class=\"card-balance-modal-container\">\n" +
    "    <div class=\"card-balance-info-modal\">\n" +
    "        <div class=\"card-balance-modal-title\">\n" +
    "            <div class=\"card-balance-modal-info-title\">\n" +
    "                Card Number\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-modal-info-sub\">\n" +
    "                You can find this on the back of your physical card.\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-close-modal\">\n" +
    "            <a class=\"card-balance-info-icon-container\" ng-click=\"showCardNumberInfoModal = !showCardNumberInfoModal\">\n" +
    "                <span class=\"icon-close-fill card-balance-icon-info\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "        <div>\n" +
    "            <img class=\"card-balance-info-image\" ng-src=\"assets/images/card-number.png\" alt=\"\">\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-button-container\">\n" +
    "            <button\n" +
    "                    class=\"card-balance-button\"\n" +
    "                    ng-click=\"showCardNumberInfoModal = !showCardNumberInfoModal\">\n" +
    "                Back\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-show=\"showCvvNumberInfoModal\" class=\"card-balance-modal-container\">\n" +
    "    <div class=\"card-balance-info-modal\">\n" +
    "        <div class=\"card-balance-modal-title\">\n" +
    "            <div class=\"card-balance-modal-info-title\">\n" +
    "                CVV Number\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-modal-info-sub\">\n" +
    "                The number will be available on the back of the card under security code.\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-close-modal\">\n" +
    "            <a class=\"card-balance-info-icon-container\" ng-click=\"showCvvNumberInfoModal = !showCvvNumberInfoModal\">\n" +
    "                <span class=\"icon-close-fill card-balance-icon-info\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "        <div>\n" +
    "            <img class=\"card-balance-info-image\" ng-src=\"assets/images/cvv-number.png\" alt=\"\">\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-button-container\">\n" +
    "            <button\n" +
    "                    class=\"card-balance-button\"\n" +
    "                    ng-click=\"showCvvNumberInfoModal = !showCvvNumberInfoModal\">\n" +
    "                Back\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-show=\"showCardBalanceError\" class=\"card-balance-modal-container\">\n" +
    "    <div class=\"card-balance-info-modal\">\n" +
    "        <div class=\"card-balance-modal-title\">\n" +
    "            <div class=\"card-balance-modal-info-title\">\n" +
    "                Oops, something went wrong.\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-modal-info-sub\">\n" +
    "                {{cardBalanceErrorMessage}}\n" +
    "            </div>\n" +
    "            <div class=\"card-balance-modal-info-sub\">\n" +
    "                {{showCardBalanceErrorMessage}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-close-modal\">\n" +
    "            <a class=\"card-balance-info-icon-container\" ng-click=\"showCardBalanceError = !showCardBalanceError\">\n" +
    "                <span class=\"icon-close-fill card-balance-icon-info\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-button-container\">\n" +
    "            <button\n" +
    "                    class=\"card-balance-button\"\n" +
    "                    ng-click=\"showCardBalanceError = !showCardBalanceError\">\n" +
    "                Close\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-show=\"loading\" class=\"card-balance-modal-container\">\n" +
    "    <div class=\"card-balance-modal-container-loading\">\n" +
    "        <span class=\"loading-indicator\"></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/card-balance/view-card-balance.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/card-balance/view-card-balance.html",
    "<div class=\"card-balance-center-container\">\n" +
    "    <div class=\"card-balance-logo-container\">\n" +
    "        <img class=\"card-balance-brand-icon\" ng-src=\"assets/images/{{liteBrand.name}}/logo-color.svg\" alt=\"Brand Logo\">\n" +
    "    </div>\n" +
    "    <div class=\"card-balance-title\">\n" +
    "        Card Balance\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"card-balance-balance\">\n" +
    "    ${{liteCardBalance}}\n" +
    "</div>\n" +
    "<div class=\"card-balance-container\">\n" +
    "    <div class=\"card-balance-content\">\n" +
    "        <div class=\"card-balance-description\">\n" +
    "            <div class=\"card-balance-tagline\">\n" +
    "                Instant Balance, Infinite Convenience!\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-description\">\n" +
    "            <div class=\"content\">\n" +
    "                Why wait or wonder about your card balance? With our mobile app, your balance is just a tap away—anytime, anywhere.\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"card-balance-download-app\">\n" +
    "        <div class=\"card-balance-app-title\">\n" +
    "            Don't Have The App?\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-app-sub-title\">\n" +
    "            Download our app today\n" +
    "        </div>\n" +
    "        <div class=\"card-balance-app-container\">\n" +
    "            <a ng-href=\"{{liteBrand.app.appStoreUrl}}\" target=\"_blank\">\n" +
    "                <img class=\"card-balance-app\" ng-src=\"assets/images/appstore@2x.png\" alt=\"Download on the App Store\">\n" +
    "            </a>\n" +
    "            <a ng-href=\"{{liteBrand.app.playStoreUrl}}\" target=\"_blank\">\n" +
    "                <img class=\"card-balance-app\" ng-src=\"assets/images/googleplay@2x.png\" alt=\"Get it on Google Play\">\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/collect/agreements.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/agreements.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-controller=\"esignDisclosureCtrl as vm\">\n" +
    "\n" +
    "    <!-- E-Sign Disclosure Section -->\n" +
    "    <div ng-if=\"vm.section1\">\n" +
    "        <h3 class=\"exMarginBtm\">Read the E-Sign Disclosure below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the E-Sign Disclosure.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcDisclosure) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.eSignDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.eSignErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-esign\" class=\"btn btn-register\" ng-click=\"vm.section1 = false; vm.section2 = true; vm.eSignAgreed = true;\">Agree & Next</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.eSignAgreed\">\n" +
    "        <h3 class=\"exMarginBtm\">Download to read your agreed E-Sign Disclosure</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div class=\"checkbox-item__box\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed To E-Sign Disclosure\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Cardholder Agreement Section -->\n" +
    "    <div ng-if=\"vm.section2\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Cardholder Agreement below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Cardholder Agreement.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcAgreement) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.cardholderAgreementDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.cardholderAgreementErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-agreement\" class=\"btn btn-register\" ng-click=\"vm.section2 = false; vm.section3 = true; vm.disclosureAgreed = true;\">Agree & Next</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.disclosureAgreed\" style=\"padding-top: 60px\">\n" +
    "        <h3 class=\"exMarginBtm\">Download to read your agreed Cardholder Agreement Document</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div class=\"checkbox-item__box\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed To Cardholder Agreement Document\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Privacy Policy Section -->\n" +
    "    <div ng-if=\"vm.section3\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Sunrise Banks Privacy Policy below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Sunrise Banks Privacy Policy.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcPrivacyDownload, 'Sunrise_Banks_Privacy_Policy.pdf')\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcPrivacy) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.privacyPolicyDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.privacyPolicyErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-privacypolicy\" class=\"btn btn-register\" ng-click=\"goToSuccessPage\">Agree & Finish</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/collect/esign-disclosure-redeem.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/esign-disclosure-redeem.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-controller=\"redeemVirtualCtrl as vm\">\n" +
    "\n" +
    "  <!-- E-Sign Disclosure Section -->\n" +
    "  <div ng-if=\"vm.section1\">\n" +
    "    <h3 class=\"exMarginBtm\">Read the E-Sign Disclosure below</h3>\n" +
    "    <div class=\"modern-widget-info-top\">\n" +
    "      <div>Press the button below the document to agree to the E-Sign Disclosure.</div>\n" +
    "      <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "    </div>\n" +
    "    <iframe\n" +
    "            ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcDisclosure) }}\"\n" +
    "            width=\"100%\"\n" +
    "            height=\"400px\"\n" +
    "            style=\"border: solid 1px #EBEBEB\">\n" +
    "    </iframe>\n" +
    "    <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.eSignDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.eSignErrorMessage }}\n" +
    "            </span>\n" +
    "      <a id=\"btn-esign\" class=\"btn btn-register\" ng-click=\"vm.section1 = false; vm.section2 = true; vm.eSignAgreed = true;\">Agree & Continue</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.eSignAgreed\">\n" +
    "    <h3 class=\"exMarginBtm\">E-Sign Disclosure Document</h3>\n" +
    "    <div class=\"modern-widget-info-top-checked\">\n" +
    "      <div class=\"check-alignment-with-text\">\n" +
    "        <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "          <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "        </div>\n" +
    "        Agreed to E-Sign Disclosure\n" +
    "      </div>\n" +
    "      <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "    </div>\n" +
    "    <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- Cardholder Agreement Section -->\n" +
    "  <div ng-if=\"vm.section2\">\n" +
    "    <h3 class=\"exMarginBtm exMarginTop\">Read the Cardholder Agreement below</h3>\n" +
    "    <div class=\"modern-widget-info-top\">\n" +
    "      <div>Press the button below the document to agree to the Cardholder Agreement.</div>\n" +
    "      <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "    </div>\n" +
    "    <iframe\n" +
    "            ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcAgreement) }}\"\n" +
    "            width=\"100%\"\n" +
    "            height=\"400px\"\n" +
    "            style=\"border: solid 1px #EBEBEB\">\n" +
    "    </iframe>\n" +
    "    <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.cardholderAgreementDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.cardholderAgreementErrorMessage }}\n" +
    "            </span>\n" +
    "      <a id=\"btn-agreement\" class=\"btn btn-register\" ng-click=\"vm.section2 = false; vm.section3 = true; vm.disclosureAgreed = true;\">Agree & Continue</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.disclosureAgreed\" style=\"padding-top: 60px\">\n" +
    "    <h3 class=\"exMarginBtm\">Cardholder Agreement Document</h3>\n" +
    "    <div class=\"modern-widget-info-top-checked\">\n" +
    "      <div class=\"check-alignment-with-text\">\n" +
    "        <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "          <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "        </div>\n" +
    "        Agreed to Cardholder Agreement Document\n" +
    "      </div>\n" +
    "      <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "    </div>\n" +
    "    <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- Privacy Policy Section -->\n" +
    "  <div ng-if=\"vm.section3\">\n" +
    "    <h3 class=\"exMarginBtm exMarginTop\">Read the Sunrise Banks Privacy Policy below</h3>\n" +
    "    <div class=\"modern-widget-info-top\">\n" +
    "      <div>Press the button below the document to agree to the Sunrise Banks Privacy Policy.</div>\n" +
    "      <a ng-click=\"vm.downloadFile(vm.pdfGDSrcPrivacyDownload, 'Sunrise_Banks_Privacy_Policy.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "    </div>\n" +
    "    <iframe\n" +
    "            ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcPrivacy) }}\"\n" +
    "            width=\"100%\"\n" +
    "            height=\"400px\"\n" +
    "            style=\"border: solid 1px #EBEBEB\"\n" +
    "    >\n" +
    "    </iframe>\n" +
    "    <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.privacyPolicyDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.privacyPolicyErrorMessage }}\n" +
    "            </span>\n" +
    "      <a id=\"btn-privacypolicy\" class=\"btn btn-register\" ng-click=\"vm.redeemCode()\">Finish</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/collect/esign-disclosure.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/esign-disclosure.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-controller=\"giftVirtualRegister as vm\">\n" +
    "\n" +
    "    <!-- E-Sign Disclosure Section -->\n" +
    "    <div ng-if=\"vm.section1\">\n" +
    "        <h3 class=\"exMarginBtm\">Read the E-Sign Disclosure below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the E-Sign Disclosure.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcDisclosure) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.eSignDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.eSignErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-esign\" class=\"btn btn-register\" ng-click=\"vm.section1 = false; vm.section2 = true; vm.eSignAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.eSignAgreed\">\n" +
    "        <h3 class=\"exMarginBtm\">E-Sign Disclosure Document</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to E-Sign Disclosure\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Cardholder Agreement Section -->\n" +
    "    <div ng-if=\"vm.section2\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Cardholder Agreement below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Cardholder Agreement.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcAgreement) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.cardholderAgreementDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.cardholderAgreementErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-agreement\" class=\"btn btn-register\" ng-click=\"vm.section2 = false; vm.section3 = true; vm.disclosureAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.disclosureAgreed\" style=\"padding-top: 60px\">\n" +
    "        <h3 class=\"exMarginBtm\">Cardholder Agreement Document</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to Cardholder Agreement Document\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Privacy Policy Section -->\n" +
    "    <div ng-if=\"vm.section3\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Sunrise Banks Privacy Policy below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Sunrise Banks Privacy Policy.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcPrivacyDownload, 'Sunrise_Banks_Privacy_Policy.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcPrivacy) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\"\n" +
    "        >\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.privacyPolicyDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.privacyPolicyErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-privacypolicy\" class=\"btn btn-register\" ng-click=\"vm.submitRegistration()\">Finish</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/collect/plastic-step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/plastic-step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "          <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "           \"has-success\": joinForm.firstName.$valid,\n" +
    "           \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "           \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "          <label for=\"firstName\">Your First Name</label>\n" +
    "          <input\n" +
    "                  id=\"firstName\"\n" +
    "                  class=\"radius-left\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"firstName\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  tabindex=\"1\"\n" +
    "                  ng-model=\"formData.firstName\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.firstName.hasFocus=true'\n" +
    "                  ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "           \"has-success\": joinForm.lastName.$valid,\n" +
    "           \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "           \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "          <label for=\"lastName\">Your Last Name</label>\n" +
    "          <input\n" +
    "                  id=\"lastName\"\n" +
    "                  class=\"radius-right\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"lastName\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  tabindex=\"2\"\n" +
    "                  ng-model=\"formData.lastName\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.lastName.hasFocus=true'\n" +
    "                  ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-3-4\">\n" +
    "          <span ng-show=\"joinForm.address.$error.required && submitted\">Please provide your address</span>\n" +
    "          <span ng-show=\"joinForm.address.$invalid && !joinForm.address.$error.required && submitted\">Oops, we do not accept PO box's</span>\n" +
    "          <span ng-show=\"joinForm.address.$error.pattern\">Accented and special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-3-4\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.address.hasFocus,\n" +
    "           \"has-success\": joinForm.address.$valid,\n" +
    "           \"has-error\": joinForm.address.$invalid && (form.$submitted || joinForm.address.$touched),\n" +
    "           \"is-empty\": !joinForm.address.$viewValue }'>\n" +
    "          <label for=\"address\">Street Address</label>\n" +
    "          <input\n" +
    "                  id=\"address\"\n" +
    "                  class=\"radius-left\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"address\"\n" +
    "                  pattern=\"[A-Za-z0-9 .#]+\"\n" +
    "                  tabindex=\"3\"\n" +
    "                  ng-model=\"formData.address\"\n" +
    "                  validate-po-box\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.address.hasFocus=true'\n" +
    "                  ng-blur='joinForm.address.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-1-4\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.address2.hasFocus,\n" +
    "           \"has-success\": joinForm.address2.$valid,\n" +
    "           \"has-error\": joinForm.address2.$invalid && (form.$submitted || joinForm.address2.$touched),\n" +
    "           \"is-empty\": !joinForm.address2.$viewValue }'>\n" +
    "          <label for=\"address2\">Apt No.</label>\n" +
    "          <input\n" +
    "                  id=\"address2\"\n" +
    "                  class=\"radius-right\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"address2\"\n" +
    "                  tabindex=\"4\"\n" +
    "                  ng-model=\"formData.address2\"\n" +
    "                  ng-focus='joinForm.address2.hasFocus=true'\n" +
    "                  ng-blur='joinForm.address2.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.city.$error.required && submitted\">Please provide your city</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.state.$error.required && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.zip.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half mobile-11-20\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.city.hasFocus,\n" +
    "           \"has-success\": joinForm.city.$valid,\n" +
    "           \"has-error\": joinForm.city.$invalid && (form.$submitted || joinForm.city.$touched),\n" +
    "           \"is-empty\": !joinForm.city.$viewValue }'>\n" +
    "          <label for=\"city\">City</label>\n" +
    "          <input\n" +
    "                  id=\"city\"\n" +
    "                  class=\"radius-left\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"city\"\n" +
    "                  tabindex=\"5\"\n" +
    "                  ng-model=\"formData.city\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.city.hasFocus=true'\n" +
    "                  ng-blur='joinForm.city.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-1-4\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.state.hasFocus,\n" +
    "           \"has-success\": joinForm.state.$valid,\n" +
    "           \"has-error\": joinForm.state.$invalid && (form.$submitted || joinForm.state.$touched),\n" +
    "           \"is-empty\": !joinForm.state.$viewValue }'>\n" +
    "          <label for=\"state\">State</label>\n" +
    "          <input\n" +
    "                  id=\"state\"\n" +
    "                  class=\"radius-none\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"state\"\n" +
    "                  tabindex=\"6\"\n" +
    "                  required\n" +
    "                  max=\"2\"\n" +
    "                  maxlength=\"2\"\n" +
    "                  ng-maxlength=\"2\"\n" +
    "                  ng-model=\"formData.state\"\n" +
    "                  ng-focus='joinForm.state.hasFocus=true'\n" +
    "                  ng-blur='joinForm.state.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-1-4 mobile-3-10\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.zip.hasFocus,\n" +
    "           \"has-success\": joinForm.zip.$valid,\n" +
    "           \"has-error\": joinForm.zip.$invalid && (form.$submitted || joinForm.zip.$touched),\n" +
    "           \"is-empty\": !joinForm.zip.$viewValue }'>\n" +
    "          <label for=\"zip\">Zip</label>\n" +
    "          <input\n" +
    "                  id=\"zip\"\n" +
    "                  class=\"radius-right\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"zip\"\n" +
    "                  tabindex=\"7\"\n" +
    "                  required\n" +
    "                  autocomplete=\"new-password\"\n" +
    "                  min=\"5\"\n" +
    "                  minlength=\"5\"\n" +
    "                  ng-minlength=\"5\"\n" +
    "                  ng-model=\"formData.zip\"\n" +
    "                  ng-focus='joinForm.zip.hasFocus=true'\n" +
    "                  ng-blur='joinForm.zip.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.collectEmail.$error.required && submitted\">Please provide a valid email</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.collectEmail.hasFocus,\n" +
    "           \"has-success\": joinForm.collectEmail.$valid,\n" +
    "           \"has-error\": joinForm.collectEmail.$invalid && (form.$submitted || joinForm.collectEmail.$touched),\n" +
    "           \"is-empty\": !joinForm.collectEmail.$viewValue }'>\n" +
    "          <span class=\"input-no-edit-icon icon-edit-disabled\" ng-show=\"!canChangeEmail\"></span>\n" +
    "          <span class=\"input-no-edit-email\" ng-show=\"!canChangeEmail\">{{formData.email}}</span>\n" +
    "          <label for=\"collectEmail\" ng-show=\"canChangeEmail\">New Email</label>\n" +
    "          <input\n" +
    "                  id=\"collectEmail\"\n" +
    "                  class=\"radius-all\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"collectEmail\"\n" +
    "                  tabindex=\"8\"\n" +
    "                  autocomplete=\"new-password\"\n" +
    "                  ng-disabled=\"!canChangeEmail\"\n" +
    "                  ng-model=\"formData.updatedEmail\"\n" +
    "                  ng-focus='joinForm.collectEmail.hasFocus=true'\n" +
    "                  ng-blur='joinForm.collectEmail.hasFocus=false'>\n" +
    "          <span class=\"input-helper-btn\" ng-click=\"changeEmail()\" ng-show=\"!canChangeEmail\">Change<br>Email</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-2-3\">\n" +
    "          <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-3\">\n" +
    "          <span ng-show=\"joinForm.phone.$invalid && submitted\">Required phone number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "           \"has-success\": joinForm.password.$valid,\n" +
    "           \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "           \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "          <label for=\"password\">Password</label>\n" +
    "          <input\n" +
    "                  id=\"password\"\n" +
    "                  class=\"radius-left\"\n" +
    "                  name=\"password\"\n" +
    "                  tabindex=\"9\"\n" +
    "                  required\n" +
    "                  validate-password\n" +
    "                  autocomplete=\"new-password\"\n" +
    "                  type=\"{{passwordInputType}}\"\n" +
    "                  ng-model=\"formData.password\"\n" +
    "                  ng-focus='joinForm.password.hasFocus=true'\n" +
    "                  ng-blur='joinForm.password.hasFocus=false'>\n" +
    "          <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Password</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.phone.hasFocus,\n" +
    "           \"has-success\": joinForm.phone.$valid,\n" +
    "           \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "           \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "          <label for=\"phone\">Mobile Phone</label>\n" +
    "          <input\n" +
    "                  id=\"phone\"\n" +
    "                  name=\"phone\"\n" +
    "                  class=\"radius-right\"\n" +
    "                  type=\"tel\"\n" +
    "                  tabindex=\"10\"\n" +
    "                  required\n" +
    "                  minlength=\"10\"\n" +
    "                  maxlength=\"10\"\n" +
    "                  ak-input-only-numbers\n" +
    "                  ng-model-options=\"{ allowInvalid: true }\"\n" +
    "                  ng-model=\"formData.phone\"\n" +
    "                  ng-focus='joinForm.phone.hasFocus=true'\n" +
    "                  ng-blur='joinForm.phone.hasFocus=false'>\n" +
    "          <div\n" +
    "                  class=\"form-group__feedback\"\n" +
    "                  ak-format-phone-number=\"formData.phone\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- Checkbox: E-Sign disclosure -->\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"checkbox-item\" ng-click=\"formData.eSign = !formData.eSign\">\n" +
    "          <div class=\"checkbox-item__box\" ng-class=\"formData.eSign ? '' : 'checkbox-item__box--disabled'\">\n" +
    "            <span class=\"checkbox-item__icon\" ng-class=\"formData.eSign ? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "                    class=\"checkbox-item__input\"\n" +
    "                    type=\"checkbox\"\n" +
    "                    name=\"eSign\"\n" +
    "                    id=\"eSign\"\n" +
    "                    ng-model=\"formData.eSign\"\n" +
    "                    tabindex=\"11\"\n" +
    "                    required>\n" +
    "            <p class=\"checkbox-item__text checkbox-item__text--small\">\n" +
    "              Check this box if you agree to the\n" +
    "              <a target=\"_blank\" href=\"{{brand.programLegal.disclosure}}\">E-Sign Disclosure</a>\n" +
    "            </p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- Checkbox: Privacy Policy and Cardholder Agreement -->\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"checkbox-item\" ng-click=\"formData.Tos = !formData.Tos\">\n" +
    "          <div class=\"checkbox-item__box\" ng-class=\"formData.Tos ? '' : 'checkbox-item__box--disabled'\">\n" +
    "            <span class=\"checkbox-item__icon\" ng-class=\"formData.Tos ? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "                    class=\"checkbox-item__input\"\n" +
    "                    type=\"checkbox\"\n" +
    "                    name=\"terms_and_conditions\"\n" +
    "                    id=\"terms_and_conditions\"\n" +
    "                    ng-model=\"formData.Tos\"\n" +
    "                    tabindex=\"12\"\n" +
    "                    required>\n" +
    "            <p class=\"checkbox-item__text checkbox-item__text--small\">\n" +
    "              Check this box if you agree to the\n" +
    "              <a target=\"_blank\" href=\"{{brand.programLegal.privacy}}\">Privacy Policy</a>\n" +
    "              and <a target=\"_blank\" href=\"{{brand.programLegal.agreement}}\">Cardholder Agreement</a>\n" +
    "            </p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- Checkbox: Enroll in text alerts -->\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"checkbox-item\" ng-click=\"formData.textAlerts = !formData.textAlerts\">\n" +
    "          <div class=\"checkbox-item__box\" ng-class=\"formData.textAlerts ? '' : 'checkbox-item__box--disabled'\">\n" +
    "            <span class=\"checkbox-item__icon\" ng-class=\"formData.textAlerts ? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "                    class=\"checkbox-item__input\"\n" +
    "                    type=\"checkbox\"\n" +
    "                    name=\"textAlerts\"\n" +
    "                    ng-model=\"formData.textAlerts\"\n" +
    "                    tabindex=\"13\">\n" +
    "            <p class=\"checkbox-item__text checkbox-item__text--small\">Enroll in text alerts. Receive real-time purchase alerts with balance and transaction information.*</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "\n" +
    "      <span ng-show=\"(joinForm.eSign.$error.required || joinForm.terms_and_conditions.$error.required) && submitted\">\n" +
    "        <br/><br/>\n" +
    "        <span class=\"underline\">Please read and check that you agree with the agreement policies.</span>\n" +
    "        <br/><br/>\n" +
    "        If you have any questions, please contact us at {{brand.programContactPhone}} or email us at {{brand.programContactEmail}}\n" +
    "      </span>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right collect-slide-img\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gift-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "    <span class=\"loading-indicator\"></span>\n" +
    "    <p>Processing</p>\n" +
    "  </div>\n" +
    "  <a ng-hide=\"loading\" class=\"btn btn--float-right\" ng-click=\"attemptSubmission(joinForm)\">FINISH</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/verifyEmailOld.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/collect/redeem-success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/redeem-success.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "  <p class=\"modern-widget-warning-text\">{{ successMessage }}<br/>\n" +
    "  <img ng-src=\"assets/images/{{brand.name}}/join-welcome.png\" alt=\"\">\n" +
    "  <div class=\"text-center\">\n" +
    "    <a id='loginBtn' class=\"btn btn--float-right\" ng-click=\"goToLogin()\">Login</a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"alertError.show\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{alertError.message}}<br/>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"alertError.show = !alertError.show\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.overlayLoading\" class=\"overlay-wrapper\">\n" +
    "  <div class=\"overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/collect/redeem-virtual-step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/redeem-virtual-step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "      <ul class=\"floatingForm-form\">\n" +
    "        <li class=\"floatingForm-li\">\n" +
    "          <div class=\"error-block-top input-half\">\n" +
    "            <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "            <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "          </div>\n" +
    "          <div class=\"error-block-top input-half\">\n" +
    "            <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "            <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "          </div>\n" +
    "\n" +
    "          <!-- First name -->\n" +
    "          <div\n" +
    "             class=\"form-group input-half\"\n" +
    "             ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "             \"has-success\": joinForm.firstName.$valid,\n" +
    "             \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "             \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "            <label for=\"firstName\">Your First Name</label>\n" +
    "            <input\n" +
    "               class=\"radius-left\"\n" +
    "               type=\"text\"\n" +
    "               name=\"firstName\"\n" +
    "               pattern=\"[A-Za-z ]+\"\n" +
    "               id=\"firstName\"\n" +
    "               tabindex=\"1\"\n" +
    "               ng-model=\"formData.firstName\"\n" +
    "               required\n" +
    "               ng-focus='joinForm.firstName.hasFocus=true'\n" +
    "               ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "          </div>\n" +
    "          <!-- END: First name -->\n" +
    "\n" +
    "          <!-- Last name -->\n" +
    "          <div\n" +
    "             class=\"form-group input-half\"\n" +
    "             ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "             \"has-success\": joinForm.lastName.$valid,\n" +
    "             \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "             \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "            <label for=\"lastName\">Your Last Name</label>\n" +
    "            <input\n" +
    "               class=\"radius-right\"\n" +
    "               type=\"text\"\n" +
    "               name=\"lastName\"\n" +
    "               pattern=\"[A-Za-z ]+\"\n" +
    "               id=\"lastName\"\n" +
    "               tabindex=\"2\"\n" +
    "               ng-model=\"formData.lastName\"\n" +
    "               required\n" +
    "               ng-focus='joinForm.lastName.hasFocus=true'\n" +
    "               ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "          </div>\n" +
    "          <!-- END: Last name -->\n" +
    "\n" +
    "        </li>\n" +
    "        <li class=\"floatingForm-li\">\n" +
    "\n" +
    "          <!-- Redeem code -->\n" +
    "          <div class=\"info-icon\">\n" +
    "            <div class=\"error-block-top input-2-3\">\n" +
    "              <span ng-show=\"joinForm.RedeemCode.$error.required && submitted\">Please provide a valid redeem code</span>\n" +
    "            </div>\n" +
    "            <div class=\"error-block-top input-half\">\n" +
    "              <span ng-show=\"joinForm.Pin.$error.pattern\">Please enter only 4 numbers</span>\n" +
    "              <span ng-show=\"joinForm.Pin.$invalid && submitted &&\n" +
    "              joinForm.Pin.$viewValue != '0000' && joinForm.Pin.$viewValue != '1234' && !joinForm.Pin.$error.pattern\">\n" +
    "                Required 4 digit PIN\n" +
    "              </span>\n" +
    "              <span ng-show=\"joinForm.Pin.$viewValue == '0000' || joinForm.Pin.$viewValue == '1234'\">Enter an uncommon PIN.</span>\n" +
    "            </div>\n" +
    "            <div class=\"info-icon__wrapper\">\n" +
    "              <span class=\"icon-info\"></span>\n" +
    "              <span class=\"info-icon__tooltiptext\">Set a PIN for your card to be used when making debit purchases.</span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div\n" +
    "             class=\"form-group input-half\"\n" +
    "             ng-class='{ \"has-focus\": joinForm.RedeemCode.hasFocus,\n" +
    "             \"has-success\": joinForm.RedeemCode.$valid,\n" +
    "             \"has-error\": joinForm.RedeemCode.$invalid && (form.$submitted || joinForm.RedeemCode.$touched),\n" +
    "             \"is-empty\": !joinForm.RedeemCode.$viewValue }'>\n" +
    "            <label for=\"RedeemCode\">Redeem Code</label>\n" +
    "            <input\n" +
    "               class=\"radius-left\"\n" +
    "               type=\"text\"\n" +
    "               name=\"RedeemCode\"\n" +
    "               required\n" +
    "               id=\"RedeemCode\"\n" +
    "               tabindex=\"3\"\n" +
    "               ng-model=\"formData.RedeemCode\">\n" +
    "          </div>\n" +
    "          <!-- END: Redeem code -->\n" +
    "\n" +
    "          <!-- Pin -->\n" +
    "          <div\n" +
    "                  class=\"form-group input-half\"\n" +
    "                  ng-class='{ \"has-focus\": joinForm.Pin.hasFocus,\n" +
    "             \"has-success\": joinForm.Pin.$valid,\n" +
    "             \"has-error\": joinForm.Pin.$invalid && (form.$submitted || joinForm.Pin.$touched),\n" +
    "             \"is-empty\": !joinForm.Pin.$viewValue }'>\n" +
    "            <label for=\"Pin\">Set a PIN For Your Card</label>\n" +
    "            <input\n" +
    "                    class=\"radius-right\"\n" +
    "                    name=\"Pin\"\n" +
    "                    type=\"text\"\n" +
    "                    id=\"Pin\"\n" +
    "                    tabindex=\"3\"\n" +
    "                    minlength=\"4\"\n" +
    "                    maxlength=\"4\"\n" +
    "                    pattern=\"[0-9]*\"\n" +
    "                    required\n" +
    "                    validate-pin\n" +
    "                    ng-model=\"formData.Pin\"\n" +
    "                    ng-focus='joinForm.Pin.hasFocus=true'>\n" +
    "          </div>\n" +
    "          <!-- END: Pin -->\n" +
    "\n" +
    "        </li>\n" +
    "        <li class=\"floatingForm-li\">\n" +
    "\n" +
    "          <!-- Email -->\n" +
    "          <div class=\"error-block-top input-full\">\n" +
    "            <span ng-show=\"joinForm.email.$error.required && submitted\">Please provide a valid email</span>\n" +
    "            <span ng-show=\"joinForm.email.$error.pattern\">We're sorry but accented and special characters may not be used</span>\n" +
    "          </div>\n" +
    "          <div\n" +
    "             class=\"form-group input-full\"\n" +
    "             ng-class='{ \"has-focus\": joinForm.email.hasFocus,\n" +
    "             \"has-success\": joinForm.email.$valid,\n" +
    "             \"has-error\": joinForm.email.$invalid && (form.$submitted || joinForm.email.$touched),\n" +
    "             \"is-empty\": !joinForm.email.$viewValue }'>\n" +
    "            <span class=\"input-no-edit-icon icon-edit-disabled\" ng-hide=\"{{!isEmailReadonly}}\"></span>\n" +
    "            <label for=\"email\" ng-hide=\"{{isEmailReadonly}}\">Email</label>\n" +
    "            <input\n" +
    "               class=\"radius-all\"\n" +
    "               type=\"text\"\n" +
    "               name=\"email\"\n" +
    "               pattern=\"[A-Za-z0-9.@_+-]+\"\n" +
    "               id=\"email\"\n" +
    "               tabindex=\"5\"\n" +
    "               required\n" +
    "               ng-class='{ \"input-readonly\": isEmailReadonly }'\n" +
    "               ng-model=\"formData.email\"\n" +
    "               ng-readonly=\"{{isEmailReadonly}}\">\n" +
    "          </div>\n" +
    "          <!-- END: Email -->\n" +
    "\n" +
    "        </li>\n" +
    "        <li class=\"floatingForm-li\">\n" +
    "\n" +
    "          <!-- Password -->\n" +
    "          <div class=\"error-block-top input-2-3\">\n" +
    "            <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "          </div>\n" +
    "          <div class=\"error-block-top input-1-3\">\n" +
    "            <span ng-show=\"joinForm.phone.$invalid && submitted\">Required phone number</span>\n" +
    "          </div>\n" +
    "          <div\n" +
    "             class=\"form-group input-half\"\n" +
    "             ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "             \"has-success\": joinForm.password.$valid,\n" +
    "             \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "             \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "            <label for=\"password\">Create Your Password</label>\n" +
    "            <input\n" +
    "               class=\"radius-left\"\n" +
    "               name=\"password\"\n" +
    "               id=\"password\"\n" +
    "               tabindex=\"6\"\n" +
    "               required\n" +
    "               autocomplete=\"new-password\"\n" +
    "               validate-password\n" +
    "               type=\"{{passwordInputType}}\"\n" +
    "               ng-model=\"formData.password\"\n" +
    "               ng-focus='joinForm.password.hasFocus=true'\n" +
    "               ng-blur='joinForm.password.hasFocus=false'>\n" +
    "            <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Create Your Password</span>\n" +
    "          </div>\n" +
    "          <!-- END: Password -->\n" +
    "\n" +
    "          <!-- Phone -->\n" +
    "          <div\n" +
    "             class=\"form-group input-half\"\n" +
    "             ng-class='{ \"has-focus\": joinForm.phone.hasFocus, \"has-success\": joinForm.phone.$valid,\n" +
    "             \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "             \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "            <span class=\"input-no-edit-icon icon-edit-disabled\" ng-hide=\"{{!isPhoneReadonly}}\"></span>\n" +
    "            <label for=\"phone\" ng-hide=\"{{isPhoneReadonly}}\">Mobile Phone</label>\n" +
    "            <input\n" +
    "              id=\"phone\"\n" +
    "              name=\"phone\"\n" +
    "              class=\"radius-right\"\n" +
    "              type=\"tel\"\n" +
    "              tabindex=\"7\"\n" +
    "              minlength=\"10\"\n" +
    "              maxlength=\"15\"\n" +
    "              required\n" +
    "              ng-class='{ \"input-readonly\": isPhoneReadonly }'\n" +
    "              ng-model=\"formData.phone\"\n" +
    "              ng-readonly=\"{{isPhoneReadonly}}\"\n" +
    "              ng-model-options=\"{ allowInvalid: true }\">\n" +
    "          </div>\n" +
    "          <!-- END: Phone -->\n" +
    "\n" +
    "        </li>\n" +
    "        <br>\n" +
    "        <text-alerts-checkbox form-data=\"formData\"/>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  <div class=\"modern-widget-right collect-slide-img\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gift-vertical-banner.png\" alt=\"\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "      <span class=\"loading-indicator\"></span>\n" +
    "      <p>Processing</p>\n" +
    "  </div>\n" +
    "  <a ng-hide=\"loading\" id=\"finishBtn\" class=\"btn btn--float-right\" ng-click=\"attemptSubmission(joinForm)\">NEXT</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/selectVerificationMethod.html'\"></div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/collect/register-step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/register-step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-3-4\">\n" +
    "          <span ng-show=\"joinForm.number.$invalid && submitted\">Please enter a valid card number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.exp.$invalid && submitted\">Exp required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-3-4\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.number.hasFocus,\n" +
    "           \"has-success\": joinForm.number.$valid,\n" +
    "           \"has-error\": joinForm.number.$invalid && (form.$submitted || joinForm.number.$touched),\n" +
    "           \"is-empty\": !joinForm.number.$viewValue }'>\n" +
    "          <label for=\"number\">Card Number</label>\n" +
    "          <input\n" +
    "             id=\"number\"\n" +
    "             name=\"number\"\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             tabindex=\"1\"\n" +
    "             ng-model=\"formData.number\"\n" +
    "             mask=\"9999-9999-9999-9999\"\n" +
    "             clean=\"true\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.number.hasFocus=true',\n" +
    "             ng-blur='joinForm.number.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.exp.hasFocus,\n" +
    "           \"has-success\": joinForm.exp.$valid,\n" +
    "           \"has-error\": joinForm.exp.$invalid && (form.$submitted || joinForm.exp.$touched),\n" +
    "           \"is-empty\": !joinForm.exp.$viewValue }'>\n" +
    "          <label for=\"exp\">MM/YY</label>\n" +
    "          <input\n" +
    "             id=\"exp\"\n" +
    "             name=\"exp\"\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             tabindex=\"2\"\n" +
    "             ng-model=\"formData.exp\"\n" +
    "             exp-input-helper\n" +
    "             mask=\"99/99\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.exp.hasFocus=true',\n" +
    "             ng-blur='joinForm.exp.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "          <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "           \"has-success\": joinForm.firstName.$valid,\n" +
    "           \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "           \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "          <label for=\"firstName\">Your First Name</label>\n" +
    "          <input\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"firstName\"\n" +
    "             pattern=\"[A-Za-z ]+\"\n" +
    "             tabindex=\"3\"\n" +
    "             ng-model=\"formData.firstName\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.firstName.hasFocus=true',\n" +
    "             ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "           \"has-success\": joinForm.lastName.$valid,\n" +
    "           \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "           \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "          <label for=\"lastName\">Your Last Name</label>\n" +
    "          <input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"lastName\"\n" +
    "             pattern=\"[A-Za-z ]+\"\n" +
    "             tabindex=\"4\"\n" +
    "             ng-model=\"formData.lastName\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.lastName.hasFocus=true',\n" +
    "             ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-3-4\">\n" +
    "          <span ng-show=\"joinForm.address.$error.required && submitted\">Please provide your address</span>\n" +
    "          <span ng-show=\"joinForm.address.$invalid && !joinForm.address.$error.required && submitted\">Oops, we do not accept PO box's</span>\n" +
    "          <span ng-show=\"joinForm.email.$error.pattern\">Accented and special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-3-4\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.address.hasFocus,\n" +
    "           \"has-success\": joinForm.address.$valid,\n" +
    "           \"has-error\": joinForm.address.$invalid && (form.$submitted || joinForm.address.$touched),\n" +
    "           \"is-empty\": !joinForm.address.$viewValue }'>\n" +
    "          <label for=\"address\">Street Address</label>\n" +
    "          <input\n" +
    "             id=\"address\"\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"address\"\n" +
    "             pattern=\"[A-Za-z0-9 .#]+\"\n" +
    "             tabindex=\"5\"\n" +
    "             ng-model=\"formData.address\"\n" +
    "             required\n" +
    "             validate-po-box\n" +
    "             ng-focus='joinForm.address.hasFocus=true',\n" +
    "             ng-blur='joinForm.address.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.address2.hasFocus,\n" +
    "           \"has-success\": joinForm.address2.$valid,\n" +
    "           \"has-error\": joinForm.address2.$invalid && (form.$submitted || joinForm.address2.$touched),\n" +
    "           \"is-empty\": !joinForm.address2.$viewValue }'>\n" +
    "          <label for=\"address2\">Apt No.</label>\n" +
    "          <input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"address2\"\n" +
    "             tabindex=\"6\"\n" +
    "             ng-model=\"formData.address2\"\n" +
    "             ng-focus='joinForm.address2.hasFocus=true',\n" +
    "             ng-blur='joinForm.address2.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.city.$error.required && submitted\">Please provide your city</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.state.$error.required && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.zip.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half mobile-11-20\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.city.hasFocus,\n" +
    "           \"has-success\": joinForm.city.$valid,\n" +
    "           \"has-error\": joinForm.city.$invalid && (form.$submitted || joinForm.city.$touched),\n" +
    "           \"is-empty\": !joinForm.city.$viewValue }'>\n" +
    "          <label for=\"city\">City</label>\n" +
    "          <input\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"city\"\n" +
    "             tabindex=\"7\"\n" +
    "             ng-model=\"formData.city\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.city.hasFocus=true',\n" +
    "             ng-blur='joinForm.city.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.state.hasFocus,\n" +
    "           \"has-success\": joinForm.state.$valid,\n" +
    "           \"has-error\": joinForm.state.$invalid && (form.$submitted || joinForm.state.$touched),\n" +
    "           \"is-empty\": !joinForm.state.$viewValue }'>\n" +
    "          <label for=\"state\">State</label>\n" +
    "          <input\n" +
    "             class=\"radius-none\"\n" +
    "             type=\"text\"\n" +
    "             name=\"state\"\n" +
    "             tabindex=\"8\"\n" +
    "             required\n" +
    "             max=\"2\"\n" +
    "             maxlength=\"2\"\n" +
    "             ng-maxlength=\"2\"\n" +
    "             ng-model=\"formData.state\"\n" +
    "             ng-focus='joinForm.state.hasFocus=true',\n" +
    "             ng-blur='joinForm.state.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4 mobile-3-10\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.zip.hasFocus,\n" +
    "           \"has-success\": joinForm.zip.$valid,\n" +
    "           \"has-error\": joinForm.zip.$invalid && (form.$submitted || joinForm.zip.$touched),\n" +
    "           \"is-empty\": !joinForm.zip.$viewValue }'>\n" +
    "          <label for=\"zip\">Zip</label>\n" +
    "          <input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"zip\"\n" +
    "             tabindex=\"9\"\n" +
    "             required\n" +
    "             autocomplete=\"new-password\"\n" +
    "             min=\"5\"\n" +
    "             minlength=\"5\"\n" +
    "             ng-minlength=\"5\"\n" +
    "             ngMinlength=\"5\"\n" +
    "             ng-model=\"formData.zip\"\n" +
    "             ng-focus='joinForm.zip.hasFocus=true',\n" +
    "             ng-blur='joinForm.zip.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\" ng-if=\"emailParam\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.collectEmail.$error.required && submitted\">Please provide a valid email</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.collectEmail.hasFocus,\n" +
    "           \"has-success\": joinForm.collectEmail.$valid,\n" +
    "           \"has-error\": joinForm.collectEmail.$invalid && (form.$submitted || joinForm.collectEmail.$touched),\n" +
    "           \"is-empty\": !joinForm.collectEmail.$viewValue }'>\n" +
    "          <span class=\"input-no-edit-icon icon-edit-disabled\" ng-show=\"!canChangeEmail\"></span>\n" +
    "          <span class=\"input-no-edit-email\" ng-show=\"!canChangeEmail\">{{formData.email}}</span>\n" +
    "          <label for=\"collectEmail\" ng-show=\"canChangeEmail\">New Email</label>\n" +
    "          <input\n" +
    "             class=\"radius-all\"\n" +
    "             type=\"text\"\n" +
    "             name=\"collectEmail\"\n" +
    "             tabindex=\"8\"\n" +
    "             autocomplete=\"new-password\"\n" +
    "             ng-disabled=\"!canChangeEmail\"\n" +
    "             ng-model=\"formData.updatedEmail\"\n" +
    "             ng-focus='joinForm.collectEmail.hasFocus=true',\n" +
    "             ng-blur='joinForm.collectEmail.hasFocus=false'>\n" +
    "          <span class=\"input-helper-btn\" ng-click=\"changeEmail()\" ng-show=\"!canChangeEmail\">Change<br>Email</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\" ng-if=\"!emailParam\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.email.$invalid && submitted\">Please provide a valid email</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.email.hasFocus,\n" +
    "           \"has-success\": joinForm.email.$valid,\n" +
    "           \"has-error\": joinForm.email.$invalid && (form.$submitted || joinForm.email.$touched),\n" +
    "           \"is-empty\": !joinForm.email.$viewValue }'>\n" +
    "          <label for=\"email\">Email</label>\n" +
    "          <input\n" +
    "             class=\"radius-all\"\n" +
    "             name=\"email\"\n" +
    "             tabindex=\"8\"\n" +
    "             clean=\"true\"\n" +
    "             required\n" +
    "             type=\"text\"\n" +
    "             ng-model=\"formData.email\"\n" +
    "             ng-focus='joinForm.email.hasFocus=true',\n" +
    "             ng-blur='joinForm.email.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.phone.$invalid && submitted\">Please provide a valid phone number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.phone.hasFocus,\n" +
    "           \"has-success\": joinForm.phone.$valid,\n" +
    "           \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "           \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "          <label for=\"phone\">Phone</label>\n" +
    "          <input\n" +
    "            name=\"phone\"\n" +
    "            class=\"radius-all\"\n" +
    "            type=\"tel\"\n" +
    "            tabindex=\"10\"\n" +
    "            clean=\"true\"\n" +
    "            required\n" +
    "            minlength=\"10\"\n" +
    "            maxlength=\"10\"\n" +
    "            ak-input-only-numbers\n" +
    "            ng-model-options=\"{ allowInvalid: true }\"\n" +
    "            ng-model=\"formData.phone\"\n" +
    "            ng-focus='joinForm.phone.hasFocus=true',\n" +
    "            ng-blur='joinForm.phone.hasFocus=false'>\n" +
    "          <div\n" +
    "            class=\"form-group__feedback\"\n" +
    "            ak-format-phone-number=\"formData.phone\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right collect-slide-img\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gift-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "      <span class=\"loading-indicator\"></span>\n" +
    "      <p>Processing</p>\n" +
    "  </div>\n" +
    "  <a ng-hide=\"loading\" class=\"btn btn--float-right\" ng-click=\"attemptNextStep(joinForm)\">Next</a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/collect/register-step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/register-step2.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "					 \"has-success\": joinForm.password.$valid,\n" +
    "					 \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "					 \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "					<label for=\"password\">Password</label>\n" +
    "					<input\n" +
    "             class=\"radius-all\"\n" +
    "             name=\"password\"\n" +
    "             tabindex=\"1\"\n" +
    "             required\n" +
    "             validate-password\n" +
    "             type=\"{{passwordInputType}}\"\n" +
    "             ng-model=\"formData.password\"\n" +
    "						 ng-focus='joinForm.password.hasFocus=true',\n" +
    "             ng-blur='joinForm.password.hasFocus=false'>\n" +
    "          <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Password</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\" ng-if=\"requiresKyc\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.ssn.$invalid && submitted\">Please enter a valid Social Security Number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.ssn.hasFocus,\n" +
    "					 \"has-success\": joinForm.ssn.$valid,\n" +
    "					 \"has-error\": joinForm.ssn.$invalid && (form.$submitted || joinForm.ssn.$touched),\n" +
    "					 \"is-empty\": !joinForm.ssn.$viewValue }'>\n" +
    "					<label for=\"ssn\">Social Security Number</label>\n" +
    "					<input\n" +
    "             id=\"ssn\"\n" +
    "             name=\"ssn\"\n" +
    "             class=\"radius-all\"\n" +
    "             type=\"{{ssnInputType}}\"\n" +
    "             tabindex=\"2\"\n" +
    "             ng-model=\"formData.ssn\"\n" +
    "             mask=\"999-99-9999\"\n" +
    "             clean=\"true\"\n" +
    "             required\n" +
    "						 ng-focus='joinForm.ssn.hasFocus=true',\n" +
    "             ng-blur='joinForm.ssn.hasFocus=false'>\n" +
    "          <span ng-click=\"ssnInputType = (ssnInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.ssn.$valid\" class=\"input-helper-btn\">{{ssnInputType == 'text' ? 'Hide' : 'Show'}}<br>SSN</span>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "      <li class=\"birth-date floatingForm-li\" ng-if=\"requiresKyc\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"(joinForm.dob1.$error.required || joinForm.dob2.$error.required || joinForm.dob3.$error.required) && submitted\">Please enter your full birthday</span>\n" +
    "        </div>\n" +
    "        <div class=\"input-1-3\">\n" +
    "          <select\n" +
    "             id=\"birthDat1\"\n" +
    "             class=\"radius-left\"\n" +
    "             tabindex=\"3\"\n" +
    "             name=\"dob1\"\n" +
    "             ng-model=\"formData.Dob1\"\n" +
    "             required\n" +
    "             ng-options=\"month for month in range(1, 12)\">\n" +
    "            <option value=\"\" ng-if=\"!formData.Dob1\">Birth Month</option>\n" +
    "          </select>\n" +
    "        </div>\n" +
    "        <div class=\"input-1-3\">\n" +
    "          <select\n" +
    "             id=\"birthDate2\"\n" +
    "             class=\"radius-none\"\n" +
    "             tabindex=\"4\"\n" +
    "             name=\"dob2\"\n" +
    "             required\n" +
    "             ng-model=\"formData.Dob2\"\n" +
    "             ng-options=\"day for day in range(1,31)\">\n" +
    "            <option value=\"\" ng-if=\"!formData.Dob2\">Birth Day</option>\n" +
    "          </select>\n" +
    "        </div>\n" +
    "        <div class=\"input-1-3\">\n" +
    "          <select\n" +
    "             id=\"birthDate3\"\n" +
    "             class=\"radius-right\"\n" +
    "             tabindex=\"5\"\n" +
    "             name=\"dob3\"\n" +
    "             required\n" +
    "             ng-model=\"formData.Dob3\"\n" +
    "             ng-options=\"year for year in range(1900, latestAgeYear, true)\">\n" +
    "            <option value=\"\" ng-if=\"!formData.Dob3\">Birth Year</option>\n" +
    "          </select>\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please provide your date of birth. Your date of birth is requested to help validate your identity and for verification purposes when you contact us.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"!formData.question1 && submitted\">Please select a question to answer.</span>\n" +
    "        </div>\n" +
    "        <select\n" +
    "           id=\"SecurityQuestion1\"\n" +
    "           name=\"question1\"\n" +
    "           tabindex=\"6\"\n" +
    "           required\n" +
    "           ng-required=\"true\"\n" +
    "           ng-model=\"formData.question1\"\n" +
    "           ng-options=\"q.label for q in questions track by q.key\">\n" +
    "          <option value=\"\" ng-if=\"!formData.question1\">Choose a question</option>\n" +
    "        </select>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.answer1.$invalid && submitted\">Please answer the question</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.answer1.hasFocus,\n" +
    "					 \"has-success\": joinForm.answer1.$valid,\n" +
    "					 \"has-error\": joinForm.answer1.$invalid && (form.$submitted || joinForm.answer1.$touched),\n" +
    "					 \"is-empty\": !joinForm.answer1.$viewValue }'>\n" +
    "					<label for=\"answer1\">Answer</label>\n" +
    "					<input\n" +
    "             class=\"radius-all\"\n" +
    "             name=\"answer1\"\n" +
    "             tabindex=\"7\"\n" +
    "             required\n" +
    "             type=\"text\"\n" +
    "             ng-model=\"formData.answer1\"\n" +
    "						 ng-focus='joinForm.answer1.hasFocus=true',\n" +
    "             ng-blur='joinForm.answer1.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"!formData.question2 && submitted\">Please select a question to answer.</span>\n" +
    "        </div>\n" +
    "        <select\n" +
    "           id=\"SecurityQuestion2\"\n" +
    "           name=\"question2\"\n" +
    "           required\n" +
    "           ng-required=\"true\"\n" +
    "           tabindex=\"8\"\n" +
    "           ng-model=\"formData.question2\"\n" +
    "           ng-options=\"q.label for q in questions track by q.key\">\n" +
    "          <option value=\"\" ng-if=\"!formData.question2\">Choose a question</option>\n" +
    "        </select>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.answer2.$invalid && submitted\">Please answer the question</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.answer2.hasFocus,\n" +
    "					 \"has-success\": joinForm.answer2.$valid,\n" +
    "					 \"has-error\": joinForm.answer2.$invalid && (form.$submitted || joinForm.answer2.$touched),\n" +
    "					 \"is-empty\": !joinForm.answer2.$viewValue }'>\n" +
    "					<label for=\"answer2\">Answer</label>\n" +
    "					<input\n" +
    "             class=\"radius-all\"\n" +
    "             name=\"answer2\"\n" +
    "             tabindex=\"9\"\n" +
    "             required\n" +
    "             type=\"text\"\n" +
    "             ng-model=\"formData.answer2\"\n" +
    "						 ng-focus='joinForm.answer2.hasFocus=true',\n" +
    "             ng-blur='joinForm.answer2.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right collect-slide-img\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gift-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "      <span class=\"loading-indicator\"></span>\n" +
    "      <p>Processing</p>\n" +
    "  </div>\n" +
    "  <a ng-hide=\"loading\" class=\"btn btn--float-right\" ng-click=\"attemptSubmission(joinForm)\">Finish</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/verifyEmailOld.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/collect/virtual-step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/collect/virtual-step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "          <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "           \"has-success\": joinForm.firstName.$valid,\n" +
    "           \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "           \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "          <label for=\"firstName\">Your First Name</label>\n" +
    "          <input\n" +
    "                  class=\"radius-left\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"firstName\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  id=\"firstName\"\n" +
    "                  tabindex=\"1\"\n" +
    "                  ng-model=\"formData.firstName\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.firstName.hasFocus=true',\n" +
    "                  ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "           \"has-success\": joinForm.lastName.$valid,\n" +
    "           \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "           \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "          <label for=\"lastName\">Your Last Name</label>\n" +
    "          <input\n" +
    "                  class=\"radius-right\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"lastName\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  id=\"lastName\"\n" +
    "                  tabindex=\"2\"\n" +
    "                  ng-model=\"formData.lastName\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.lastName.hasFocus=true',\n" +
    "                  ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.collectEmail.$error.required && submitted\">Please provide a valid email</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.collectEmail.hasFocus,\n" +
    "           \"has-success\": joinForm.collectEmail.$valid,\n" +
    "           \"has-error\": joinForm.collectEmail.$invalid && (form.$submitted || joinForm.collectEmail.$touched),\n" +
    "           \"is-empty\": !joinForm.collectEmail.$viewValue }'>\n" +
    "          <span class=\"input-no-edit-icon icon-edit-disabled\" ng-show=\"!canChangeEmail\"></span>\n" +
    "          <span class=\"input-no-edit-email\" ng-show=\"!canChangeEmail\">{{formData.email}}</span>\n" +
    "          <label for=\"collectEmail\" ng-show=\"canChangeEmail\">{{collectEmailLabel}}</label>\n" +
    "          <input\n" +
    "                  class=\"radius-all\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"collectEmail\"\n" +
    "                  id=\"collectEmail\"\n" +
    "                  tabindex=\"3\"\n" +
    "                  autocomplete=\"new-password\"\n" +
    "                  ng-disabled=\"!canChangeEmail\"\n" +
    "                  ng-model=\"formData.updatedEmail\"\n" +
    "                  ng-focus='joinForm.collectEmail.hasFocus=true',\n" +
    "                  ng-blur='joinForm.collectEmail.hasFocus=false'>\n" +
    "          <span class=\"input-helper-btn\" ng-click=\"changeEmail()\" ng-show=\"!canChangeEmail\">Change<br>Email</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-2-3\">\n" +
    "          <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-3\">\n" +
    "          <span ng-show=\"joinForm.phone.$invalid && submitted\">Required phone number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "           \"has-success\": joinForm.password.$valid,\n" +
    "           \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "           \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "          <label for=\"password\">Password</label>\n" +
    "          <input\n" +
    "                  class=\"radius-left\"\n" +
    "                  name=\"password\"\n" +
    "                  id=\"password\"\n" +
    "                  tabindex=\"4\"\n" +
    "                  required\n" +
    "                  autocomplete=\"new-password\"\n" +
    "                  validate-password\n" +
    "                  type=\"{{passwordInputType}}\"\n" +
    "                  ng-model=\"formData.password\"\n" +
    "                  ng-focus='joinForm.password.hasFocus=true',\n" +
    "                  ng-blur='joinForm.password.hasFocus=false'>\n" +
    "          <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Password</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-half\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.phone.hasFocus,\n" +
    "           \"has-success\": joinForm.phone.$valid,\n" +
    "           \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "           \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "          <label for=\"phone\">Mobile Phone</label>\n" +
    "          <input\n" +
    "                  id=\"phone\"\n" +
    "                  name=\"phone\"\n" +
    "                  class=\"radius-right\"\n" +
    "                  type=\"tel\"\n" +
    "                  tabindex=\"5\"\n" +
    "                  clean=\"true\"\n" +
    "                  required\n" +
    "                  minlength=\"10\"\n" +
    "                  maxlength=\"10\"\n" +
    "                  ak-input-only-numbers\n" +
    "                  ng-model-options=\"{ allowInvalid: true }\"\n" +
    "                  ng-model=\"formData.phone\"\n" +
    "                  ng-focus='joinForm.phone.hasFocus=true',\n" +
    "                  ng-blur='joinForm.phone.hasFocus=false'>\n" +
    "          <div\n" +
    "                  class=\"form-group__feedback\"\n" +
    "                  ak-format-phone-number=\"formData.phone\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"info-icon\">\n" +
    "          <div class=\"error-block-top input-half\">\n" +
    "            <span ng-show=\"joinForm.Pin.$error.pattern\">Please enter only 4 numbers</span>\n" +
    "            <span ng-show=\"joinForm.Pin.$invalid && submitted &&\n" +
    "            joinForm.Pin.$viewValue != '0000' && joinForm.Pin.$viewValue != '1234' && !joinForm.Pin.$error.pattern\">\n" +
    "              Required 4 digit PIN\n" +
    "            </span>\n" +
    "            <span ng-show=\"joinForm.Pin.$viewValue == '0000' || joinForm.Pin.$viewValue == '1234'\">Enter an uncommon PIN.</span>\n" +
    "          </div>\n" +
    "          <div class=\"info-icon__wrapper\">\n" +
    "            <span class=\"icon-info\"></span>\n" +
    "            <span class=\"info-icon__tooltiptext\">Set a PIN for your card to be used when making debit purchases.</span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.Pin.hasFocus,\n" +
    "               \"has-success\": joinForm.Pin.$valid,\n" +
    "               \"has-error\": joinForm.Pin.$invalid && (form.$submitted || joinForm.Pin.$touched),\n" +
    "               \"is-empty\": !joinForm.Pin.$viewValue }'>\n" +
    "          <label for=\"Pin\">Set a PIN For Your Card</label>\n" +
    "          <input\n" +
    "                  class=\"radius-all\"\n" +
    "                  name=\"Pin\"\n" +
    "                  type=\"text\"\n" +
    "                  id=\"Pin\"\n" +
    "                  tabindex=\"6\"\n" +
    "                  minlength=\"4\"\n" +
    "                  maxlength=\"4\"\n" +
    "                  pattern=\"[0-9]*\"\n" +
    "                  required\n" +
    "                  validate-pin\n" +
    "                  ng-model=\"formData.Pin\"\n" +
    "                  ng-focus='joinForm.Pin.hasFocus=true'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <br>\n" +
    "      <tos-checkboxes form-data=\"formData\" show-elements=\"errorTos || (joinForm.eSign.$error.required || joinForm.terms_and_conditions.$error.required) && submitted\"/>\n" +
    "    </ul>\n" +
    "    <span ng-show=\"(joinForm.eSign.$error.required || joinForm.terms_and_conditions.$error.required) && submitted\">\n" +
    "      <br/><br/>\n" +
    "      <span class=\"underline\">Please read and check that you agree with the agreement policies.</span>\n" +
    "      <br/><br/>\n" +
    "      If you have any questions, please contact us at {{brand.programContactPhone}} or email us at {{brand.programContactEmail}}\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right collect-slide-img\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gift-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "    <span class=\"loading-indicator\"></span>\n" +
    "    <p>Processing</p>\n" +
    "  </div>\n" +
    "  <a ng-hide=\"loading\" id=\"finishBtn\" class=\"btn btn--float-right\" ng-click=\"attemptSubmission(joinForm)\">NEXT</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/consumer-choice/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/consumer-choice/layout.html",
    "<div class=\"overlay modern-widget join\">\n" +
    "    <div class=\"overlay-header\">\n" +
    "        <div class=\"overlay-header-main\">\n" +
    "            <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "            <h1 class=\"uppercase\">{{joinTitle}}</h1>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modern-widget-header bg-gray\">\n" +
    "        <div class=\"modern-widget-info bg-white\">\n" +
    "            <span class=\"icon-point-down\"></span>\n" +
    "            <div class=\"content\" ui-view=\"header\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"overlay-body\">\n" +
    "        <div class=\"modern-widget-main\">\n" +
    "            <form ng-class=\"parent.formType\" name=\"joinForm\">\n" +
    "                <div ui-view=\"step\"></div>\n" +
    "                <div class=\"modern-widget-section bg-gray\">\n" +
    "                    <div class=\"footnotes akimbo-footer\">\n" +
    "                        <p ng-if=\"showFooterAsterisks\">* Standard text message rates, fees and charges may apply.</p>\n" +
    "                        <p class=\"disclaimer\">\n" +
    "                            This Card is issued by Sunrise Banks N.A., Member FDIC, pursuant to a license from Mastercard International Incorporated. Mastercard is a registered\n" +
    "                            trademark, and the circles design is a trademark of Mastercard International Incorporated. This\n" +
    "                            card may be used everywhere Debit Mastercard is accepted. Use of this card constitutes\n" +
    "                            acceptance of the terms and conditions stated in the Cardholder Agreement.\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div><!-- .overlay-body -->\n" +
    "</div><!-- .overlay -->\n" +
    "<div ng-show=\"alertError.show\">\n" +
    "    <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "    <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "        <div class=\"con-overlay con-overlay-small\">\n" +
    "            <div class=\"con-overlay-header\">\n" +
    "                <div class=\"con-overlay-header-main\">\n" +
    "                    <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "                    <h1>Heads up!</h1>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"con-overlay-body\">\n" +
    "                <p class=\"con-large\" ng-show=\"alertError.message\">{{alertError.message}}<br/></p>\n" +
    "                <p class=\"con-large\" ng-show=\"alertError.brandLogin === true\"><a href=\"{{alertError.loginLink}}\">Cardholder Login</a><br/></p>\n" +
    "                <p class=\"con-large\" ng-show\"alertError.cardNotFoundLinkLogin\">We couldn't find a card associated with the provided information; this card may have already been collected. If you have an existing account, please <a ui-sref=\"root.login\" class=\"underline\">log in</a>.<br/></p>\n" +
    "                <p class=\"con-large\" ng-show=\"alertError.resetPassword\">If you forgot your username or password, please reset it <a ui-sref=\"root.resetpassword.step1\" class=\"underline\">here</a><br/></p>\n" +
    "                <p class=\"con-large\" ng-show=\"alertError.login\">In order to activate this card, please <a ui-sref=\"root.login\" class=\"underline\">log in</a>. If you don't have login credentials, please <a ui-sref=\"root.register.step1\" class=\"underline\">register</a>.<br/></p>\n" +
    "                <br/><p class=\"con-large\">If you continue to have problems please contact customer service at {{brand.programContactPhone}}.</p>\n" +
    "                <a class=\"btn btn-full-width\" ng-if=\"!alertError.toLogin\" ng-click=\"alertError.show = !alertError.show\">OK</a>\n" +
    "                <a class=\"btn btn-full-width\" ng-if=\"alertError.toLogin\" ui-sref=\"root.login\">OK, got it</a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.overlayLoading\" class=\"overlay-wrapper\">\n" +
    "    <div class=\"overlay-mask\"></div>\n" +
    "    <div class=\"overlay-loader\">\n" +
    "        <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.fullOverlayLoading\" class=\"overlay-wrapper\">\n" +
    "    <div class=\"full-overlay-mask\"></div>\n" +
    "    <div class=\"overlay-loader\">\n" +
    "        <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/consumer-choice/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/consumer-choice/step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding choice-view\">\n" +
    "  <h2 class=\"choice-top-header\">{{name}} has sent you ${{amount}}</h2>\n" +
    "  <div class=\"choice-call-to-action\">\n" +
    "    <div class=\"choice-line\"></div>\n" +
    "    <div class=\"choice-top-subtitle\">How would you like to collect your funds?</div>\n" +
    "    <div class=\"choice-line\"></div>\n" +
    "  </div>\n" +
    "  <div class=\"desktop-view\">\n" +
    "    <div class=\"choice-options\">\n" +
    "      <div class=\"choice-option {{selected == info.virtual ? 'selected' : ''}}\" ng-click=\"onSelect(info.virtual)\">\n" +
    "        <img class=\"choice-icon\" alt=\"Mastercard Logo\" ng-src=\"assets/images/mastercard-logo.svg\">\n" +
    "        <p class=\"choice-header\">View virtual Mastercard</p>\n" +
    "        <p class=\"choice-detail\">Available immediately</p>\n" +
    "      </div>\n" +
    "      <div class=\"choice-option {{selected == info.bank ? 'selected' : ''}}\" ng-click=\"onSelect(info.bank)\">\n" +
    "        <img class=\"choice-icon\" alt=\"Bank Icon\" ng-src=\"assets/images/bank.svg\">\n" +
    "        <p class=\"choice-header\">Withdraw to bank account</p>\n" +
    "        <p class=\"choice-detail\">Available in 1-2 banking days</p>\n" +
    "      </div>\n" +
    "      <div class=\"choice-option {{selected == info.check ? 'selected' : ''}}\" ng-click=\"onSelect(info.check)\">\n" +
    "        <img class=\"choice-icon\" alt=\"Check Icon\" ng-src=\"assets/images/check.svg\">\n" +
    "        <p class=\"choice-header\">Receive a paper check</p>\n" +
    "        <p class=\"choice-detail\">Available in 5-10 calendar days</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"choice-information {{option + '-selected'}}\">\n" +
    "      <p>{{selected.text}}</p>\n" +
    "      <button class=\"btn\" ng-click=\"onContinue(selected)\">{{selected.cta}}</button>\n" +
    "      <div class=\"choice-pay\" ng-show=\"selected == info.virtual\">\n" +
    "        <p>Your virtual Mastercard works with:</p>\n" +
    "        <img alt=\"Apple Pay\" ng-src=\"assets/images/applepay.svg\">\n" +
    "        <img alt=\"Google Pay\" ng-src=\"assets/images/gpay.svg\">\n" +
    "        <img alt=\"Samsung Pay\" ng-src=\"assets/images/samsungpay.svg\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div>\n" +
    "    <div class=\"mobile-view\">\n" +
    "      <div class=\"mobile-option\">\n" +
    "        <p class=\"choice-detail-option\">Option 1</p>\n" +
    "        <img class=\"choice-icon\" alt=\"Mastercard Logo\" ng-src=\"assets/images/mastercard-logo.svg\">\n" +
    "        <p class=\"choice-header\">View virtual Mastercard</p>\n" +
    "        <p class=\"choice-detail\">Available immediately</p>\n" +
    "        <p class=\"choice-info\">{{info.virtual.text}}</p>\n" +
    "        <button class=\"btn\" ng-click=\"onContinue(info.virtual)\">{{info.virtual.cta}}</button>\n" +
    "\n" +
    "        <div class=\"choice-pay\">\n" +
    "          <p>Your virtual Mastercard works with:</p>\n" +
    "          <img alt=\"Apple Pay\" ng-src=\"assets/images/applepay.svg\">\n" +
    "          <img alt=\"Google Pay\" ng-src=\"assets/images/gpay.svg\">\n" +
    "          <img alt=\"Samsung Pay\" ng-src=\"assets/images/samsungpay.svg\">\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"mobile-option\">\n" +
    "        <p class=\"choice-detail-option\">Option 2</p>\n" +
    "        <img class=\"choice-icon\" alt=\"Bank Icon\" ng-src=\"assets/images/bank.svg\">\n" +
    "        <p class=\"choice-header\">Withdraw to bank account</p>\n" +
    "        <p class=\"choice-detail\">Available in 1-2 banking days</p>\n" +
    "        <p class=\"choice-info\">{{info.bank.text}}</p>\n" +
    "        <button class=\"btn\" ng-click=\"onContinue(info.bank)\">{{info.bank.cta}}</button>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"mobile-option\">\n" +
    "        <p class=\"choice-detail-option\">Option 3</p>\n" +
    "        <img class=\"choice-icon\" alt=\"Check Icon\" ng-src=\"assets/images/check.svg\">\n" +
    "        <p class=\"choice-header\">Receive a paper check</p>\n" +
    "        <p class=\"choice-detail\">Available in 5-10 calendar days</p>\n" +
    "        <p class=\"choice-info\">{{info.check.text}}</p>\n" +
    "        <button class=\"btn\" ng-click=\"onContinue(info.check)\">{{info.check.cta}}</button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div>\n" +
    "    <p class=\"note\">\n" +
    "    Note: When you collect your funds, we will automatically create a virtual <span ng-bind-html=\"brand.fullProgramName\"></span> account where the funds will be deposited. You can always access the funds in this account by using the virtual account number for online purchases or with your mobile wallet. If you withdraw your funds to a bank account and the funds are returned, they will be loaded to your <span ng-bind-html=\"brand.fullProgramName\"></span> account.\n" +
    "    <br/><br/>\n" +
    "    The underlying funds do not expire. An Inactivity Fee of $4.95 per month will be\n" +
    "    deducted from your balance beginning in the 13th month after each 12-month period of inactivity.\n" +
    "    </p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/consumer-choice/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/consumer-choice/step2.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"consumer-choice-top-header\">{{collectType}}</div>\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"large-screen floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "          <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "           \"has-success\": joinForm.firstName.$valid,\n" +
    "           \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "           \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "          <label for=\"firstName\">Your First Name</label>\n" +
    "          <input\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"firstName\"\n" +
    "             pattern=\"[A-Za-z ]+\"\n" +
    "             id=\"firstName\"\n" +
    "             tabindex=\"1\"\n" +
    "             ng-model=\"formData.firstName\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.firstName.hasFocus=true',\n" +
    "             ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"form-group input-half\"\n" +
    "            ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "           \"has-success\": joinForm.lastName.$valid,\n" +
    "           \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "           \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "          <label for=\"lastName\">Your Last Name</label>\n" +
    "          <input\n" +
    "                  class=\"radius-right\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"lastName\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  id=\"lastName\"\n" +
    "                  tabindex=\"2\"\n" +
    "                  ng-model=\"formData.lastName\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.lastName.hasFocus=true',\n" +
    "                  ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"small-screen floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "         \"has-success\": joinForm.firstName.$valid,\n" +
    "         \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "         \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "          <label for=\"firstName\">Your First Name</label>\n" +
    "          <input\n" +
    "                  class=\"radius\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"firstName\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  id=\"firstName\"\n" +
    "                  tabindex=\"1\"\n" +
    "                  ng-model=\"formData.firstName\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.firstName.hasFocus=true',\n" +
    "                  ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"small-screen floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "          <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "         \"has-success\": joinForm.lastName.$valid,\n" +
    "         \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "         \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "          <label for=\"lastName\">Your Last Name</label>\n" +
    "          <input\n" +
    "                  class=\"radius\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"lastName\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  id=\"lastName\"\n" +
    "                  tabindex=\"2\"\n" +
    "                  ng-model=\"formData.lastName\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.lastName.hasFocus=true',\n" +
    "                  ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.collectEmail.$error.required && submitted\">Please provide a valid email</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.collectEmail.hasFocus,\n" +
    "           \"has-success\": joinForm.collectEmail.$valid,\n" +
    "           \"has-error\": joinForm.collectEmail.$invalid && (form.$submitted || joinForm.collectEmail.$touched),\n" +
    "           \"is-empty\": !joinForm.collectEmail.$viewValue }'>\n" +
    "          <span class=\"input-no-edit-icon icon-edit-disabled\" ng-show=\"!canChangeEmail\"></span>\n" +
    "          <span class=\"input-no-edit-email\" ng-show=\"!canChangeEmail\">{{formData.email}}</span>\n" +
    "          <label for=\"collectEmail\" ng-show=\"canChangeEmail\">{{collectEmailLabel}}</label>\n" +
    "          <input\n" +
    "             class=\"radius-all\"\n" +
    "             type=\"text\"\n" +
    "             ng-style=\"!canChangeEmail && {'color': 'transparent'}\"\n" +
    "             name=\"collectEmail\"\n" +
    "             id=\"collectEmail\"\n" +
    "             tabindex=\"3\"\n" +
    "             autocomplete=\"email\"\n" +
    "             ng-disabled=\"!canChangeEmail\"\n" +
    "             ng-model=\"formData.email\"\n" +
    "             ng-focus='joinForm.collectEmail.hasFocus=true',\n" +
    "             ng-blur='joinForm.collectEmail.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"large-screen floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-2-3\">\n" +
    "          <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-3\">\n" +
    "          <span ng-show=\"joinForm.phone.$invalid && submitted\">Required phone number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "           \"has-success\": joinForm.password.$valid,\n" +
    "           \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "           \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "          <label for=\"password\">Password</label>\n" +
    "          <input\n" +
    "             class=\"radius-left\"\n" +
    "             name=\"password\"\n" +
    "             id=\"password\"\n" +
    "             tabindex=\"4\"\n" +
    "             required\n" +
    "             autocomplete=\"new-password\"\n" +
    "             validate-password\n" +
    "             type=\"{{passwordInputType}}\"\n" +
    "             ng-model=\"formData.password\"\n" +
    "             ng-focus='joinForm.password.hasFocus=true',\n" +
    "             ng-blur='joinForm.password.hasFocus=false'>\n" +
    "          <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Password</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.phone.hasFocus,\n" +
    "           \"has-success\": joinForm.phone.$valid,\n" +
    "           \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "           \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "          <label for=\"phone\">Mobile Phone</label>\n" +
    "          <input\n" +
    "            id=\"phone\"\n" +
    "            name=\"phone\"\n" +
    "            class=\"radius-right\"\n" +
    "            type=\"tel\"\n" +
    "            tabindex=\"5\"\n" +
    "            clean=\"true\"\n" +
    "            required\n" +
    "            minlength=\"10\"\n" +
    "            maxlength=\"10\"\n" +
    "            ak-input-only-numbers\n" +
    "            ng-model-options=\"{ allowInvalid: true }\"\n" +
    "            ng-model=\"formData.phone\"\n" +
    "            ng-focus='joinForm.phone.hasFocus=true',\n" +
    "            ng-blur='joinForm.phone.hasFocus=false'>\n" +
    "          <div\n" +
    "            class=\"form-group__feedback\"\n" +
    "            ak-format-phone-number=\"formData.phone\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"small-screen floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-2-3\">\n" +
    "          <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "           \"has-success\": joinForm.password.$valid,\n" +
    "           \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "           \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "          <label for=\"password\">Password</label>\n" +
    "          <input\n" +
    "                  class=\"radius\"\n" +
    "                  name=\"password\"\n" +
    "                  id=\"password\"\n" +
    "                  tabindex=\"4\"\n" +
    "                  required\n" +
    "                  autocomplete=\"new-password\"\n" +
    "                  validate-password\n" +
    "                  type=\"{{passwordInputType}}\"\n" +
    "                  ng-model=\"formData.password\"\n" +
    "                  ng-focus='joinForm.password.hasFocus=true',\n" +
    "                  ng-blur='joinForm.password.hasFocus=false'>\n" +
    "          <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Password</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"small-screen floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-1-3\">\n" +
    "          <span ng-show=\"joinForm.phone.$invalid && submitted\">Required phone number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.phone.hasFocus,\n" +
    "           \"has-success\": joinForm.phone.$valid,\n" +
    "           \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "           \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "          <label for=\"phone\">Mobile Phone</label>\n" +
    "          <input\n" +
    "                  id=\"phone\"\n" +
    "                  name=\"phone\"\n" +
    "                  class=\"radius\"\n" +
    "                  type=\"tel\"\n" +
    "                  tabindex=\"5\"\n" +
    "                  clean=\"true\"\n" +
    "                  required\n" +
    "                  minlength=\"10\"\n" +
    "                  maxlength=\"10\"\n" +
    "                  ak-input-only-numbers\n" +
    "                  ng-model-options=\"{ allowInvalid: true }\"\n" +
    "                  ng-model=\"formData.phone\"\n" +
    "                  ng-focus='joinForm.phone.hasFocus=true',\n" +
    "                  ng-blur='joinForm.phone.hasFocus=false'>\n" +
    "          <div\n" +
    "                  class=\"form-group__feedback\"\n" +
    "                  ak-format-phone-number=\"formData.phone\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <br>\n" +
    "      <text-alerts-checkbox form-data=\"formData\"/>\n" +
    "    </ul>\n" +
    "    <span ng-show=\"(joinForm.eSign.$error.required || joinForm.terms_and_conditions.$error.required) && submitted\">\n" +
    "      <br/><br/>\n" +
    "      <span class=\"underline error\">Please read and check that you agree with the agreement policies.</span>\n" +
    "      <br/><br/>\n" +
    "      If you have any questions, please contact us at {{brand.programContactPhone}} or email us at {{brand.programContactEmail}}\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right collect-slide-img\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\" ng-show=\"submitted\">\n" +
    "  <span class=\"error-shown-hand\">\n" +
    "      <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "      <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <a id=\"backBtn\" class=\"btn normal btn-secondary btn--float-left\" ng-click=\"goBack()\">BACK</a>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "      <span class=\"loading-indicator\"></span>\n" +
    "      <p>Processing</p>\n" +
    "  </div>\n" +
    "  <a ng-hide=\"loading\" id=\"finishBtn\" class=\"btn btn--float-right\" ng-click=\"attemptSubmission(joinForm)\">FINISH</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/contact/contact.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/contact/contact.html",
    "<div class=\"overlay overlay-brand-bkg overlay--border-primary-1\">\n" +
    "  <div class=\"overlay-header\">\n" +
    "    <div class=\"overlay-header-main\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1><span ng-bind-html=\"brand.fullProgramName\"></span> Contact</h1>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"title-with-icon\">\n" +
    "    <h3 class=\"title-with-icon__text\">{{brand.programContactText ? brand.programContactText : 'Have a question or suggestion?'}}</h3>\n" +
    "  </div>\n" +
    "  <div class=\"info-box-wrap\">\n" +
    "    <div class=\"info-box\">\n" +
    "      <h2 class=\"info-box__title\">Phone</h2>\n" +
    "      <span class=\"info-box__icon icon-phone-circle\"></span>\n" +
    "      <p class=\"info-box__info info-box__info--max-width\">\n" +
    "        <a href=\"tel:{{phoneNumber}}\">{{brand.programContactPhone}}</a>\n" +
    "      </p>\n" +
    "      <p class=\"info-box__subinfo\">7:00 AM - 7:00 PM Central Time</p>\n" +
    "      <p class=\"info-box__subinfo\">Monday - Friday</p>\n" +
    "    </div>\n" +
    "    <div class=\"info-box\">\n" +
    "      <h2 class=\"info-box__title\">Email</h2>\n" +
    "      <span class=\"info-box__icon icon-envelope-circle\"></span>\n" +
    "      <p class=\"info-box__info\">\n" +
    "        <a href=\"mailto:{{brand.programContactEmail}}\">\n" +
    "          {{brand.programContactEmail}}\n" +
    "        </a>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"footnotes\">\n" +
    "    <p class=\"contact-disclaimer\"><strong>Reminder:</strong> Please do not send personal information such as your social security number (SSN), card number<br>or bank account number in your message.</p>\n" +
    "  </div>\n" +
    "</div><!-- .overlay -->\n" +
    "");
}]);

angular.module("../app/views/fees/fees.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/fees/fees.html",
    "<div class=\"overlay overlay-brand-bkg overlay--border-primary-1 join\">\n" +
    "  <div class=\"overlay-header\">\n" +
    "    <div class=\"overlay-header-main\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1><span ng-bind-html=\"brand.fullProgramName\"></span> Fee Schedule</h1>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-repeat=\"fee in brand.fees\">\n" +
    "    <hr class=\"overlay__divider\">\n" +
    "    <div class=\"overlay__section ak-reference\">\n" +
    "      <div class=\"ak-reference__concept\">\n" +
    "        <h2 class=\"ak-reference__title\">\n" +
    "          {{fee.FeeName}}\n" +
    "          <sup ng-if=\"fee.FeeDisclosure\" class=\"ak-reference__sup\">{{fee.FeeDisclosurePosition}}</sup>\n" +
    "        </h2>\n" +
    "        <h3 class=\"ak-reference__subtitle\">{{fee.FeeDescription}}</h3>\n" +
    "      </div>\n" +
    "      <div class=\"ak-reference__value\">{{fee.FeeAmount}}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <hr class=\"overlay__divider\">\n" +
    "  <div class=\"overlay__section signup-section-bkg-wrap\">\n" +
    "    <ol class=\"ak-reference-list\">\n" +
    "      <li ng-repeat=\"fee in brand.fees | filter: { FeeDisclosure: '' }\">{{fee.FeeDisclosure}}</li>\n" +
    "    </ol>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/gift-collection/gift-collection.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/gift-collection/gift-collection.html",
    "<div class=\"gift-collection\">\n" +
    "\n" +
    "  <h1 class=\"gift-collection__title\">Collect Your Card</h1>\n" +
    "\n" +
    "  <div class=\"gift-collection__card-shadow\">\n" +
    "    <img class=\"gift-collection__card-img\" ng-if=\"!!giftCard\" ng-src=\"{{giftCard}}\" alt=\"\">\n" +
    "    <img class=\"gift-collection__card-img\" ng-if=\"!giftCard\" ng-src=\"assets/images/mobile-cards/card-{{cardId}}.svg\">\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"overlay overlay--border-primary-1 overlay--gift-collection\">\n" +
    "\n" +
    "    <div class=\"overlay__section overlay__section--taller\">\n" +
    "      <h2 class=\"gift-collection__secondary-title\">\n" +
    "        ${{giftCollection.amount || 100}} from {{giftCollection.sender || brand.programName}}\n" +
    "      </h2>\n" +
    "\n" +
    "      <p class=\"gift-collection__text\">You're one step closer to using your <span ng-bind-html=\"brand.fullGiftProgramName\"></span>. Simply click collect virtual card below to create your account and view your virtual card.</p>\n" +
    "\n" +
    "      <div class=\"gift-collection__platforms\">\n" +
    "        <a ui-sref=\"root.collect.virtual({ email: giftCollection.email })\" class=\"btn btn-no-min-width btn--platforms gift-collection__platforms-item\">COLLECT VIRTUAL CARD</a>\n" +
    "      </div>\n" +
    "\n" +
    "      <p class=\"gift-collection__text\">Works with:</p>\n" +
    "\n" +
    "      <div class=\"gift-collection__payments\">\n" +
    "        <img alt=\"Apple Pay\" ng-src=\"assets/images/applepay.svg\">\n" +
    "        <img alt=\"Google Pay\" ng-src=\"assets/images/gpay.svg\">\n" +
    "        <img alt=\"Samsung Pay\" ng-src=\"assets/images/samsungpay.svg\">\n" +
    "      </div>\n" +
    "      <div>\n" +
    "        <p class=\"small\">\n" +
    "          Apple, Apple Pay, and the Apple logo, are trademarks of Apple, Inc., registered in the U.S. and other countries.\n" +
    "          </br>\n" +
    "          Google Play and Google Pay are a trademark of Google, Inc.\n" +
    "          </br>\n" +
    "          Samsung Pay is a registered trademark of Samsung.\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <hr class=\"overlay__divider\">\n" +
    "\n" +
    "    <div ng-show=\"supportsPhysical && !hideCollectByMail\" class=\"overlay__section overlay__section--taller overlay__section--bkg-gray\">\n" +
    "      <p class=\"gift-collection__text\">Want a physical card instead?</p>\n" +
    "      <p class=\"gift-collection__text\">We can send you one by mail.</p>\n" +
    "\n" +
    "      <a ui-sref=\"root.collect.plastic({ email: giftCollection.email })\" class=\"btn btn-no-min-width btn-secondary gift-collection__btn-by-mail\">Collect by Mail</a>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/giftCard/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/giftCard/layout.html",
    "<div class=\"giftCard modern-widget\">\n" +
    "  <div class=\"modern-widget-header bg-white content\">\n" +
    "    <img src=\"assets/images/{{brand.name}}/gift-order-logo.svg\"/>\n" +
    "    <div class=\"content\" ui-view=\"header\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-body\">\n" +
    "    <div class=\"modern-widget-main\">\n" +
    "      <form class=\"floatingForm-form\" name=\"overlayForm\">\n" +
    "        <div ui-view=\"step\"></div>\n" +
    "      </form>\n" +
    "      <div class=\"modern-widget-section bg-gray\">\n" +
    "        <div class=\"footnotes akimbo-footer\">\n" +
    "          <p class=\"disclaimer\">\n" +
    "              Important information for opening a card account: To help the federal government fight the funding of terrorism and money laundering activities, the USA PATRIOT Act requires all financial institutions and their third parties to obtain, verify and record information that identifies each person who opens a card account. What this means for you: When you open a card account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see a copy of your driver's license or other identifying documents.\n" +
    "          </p>\n" +
    "          <p class=\"disclaimer\" ng-show=\"brand.programName === 'Akimbo'\">\n" +
    "              All trademarks and service marks are the properties of their respective owners. {{brand.programName}} is a trademark of FiCentive, Inc.<span class=\"x-small\"><sup style=\"vertical-align:super\">&reg;</sup></span> 2016 FiCentive, Inc. All Rights Reserved.\n" +
    "          </p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div><!-- .overlay-body -->\n" +
    "</div><!-- .overlay -->\n" +
    "<div ng-show=\"alertError.show\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{alertError.message}}<br/><span ng-show=\"alertError.resetPassword\"><br/>If you forgot your username or password, please reset it <a href=\"https://app.akimbocard.com/app/#/{{brand.name}}/resetpassword\" class=\"underline\">here</a><br/></span><br/>If you continue to have problems please contact our customer service at {{brand.programContactPhone}}.</p>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"alertError.show = !alertError.show\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.overlayLoading\" class=\"overlay-wrapper\">\n" +
    "  <div class=\"overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/giftCard/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/giftCard/step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <ul class=\"floatingForm-form\">\n" +
    "    <li class=\"content\">\n" +
    "      <div class=\"card-container\">\n" +
    "        <img src=\"assets/images/{{brand.name}}/card-gift.svg\" class=\"giftcard-design\"/>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "      <div class=\"divider-section\"></div>\n" +
    "      <h2 class=\"gift-header\">Enter amount to load.</h2>\n" +
    "      <div class=\"card-container\">\n" +
    "        <div class=\"card-controls left-control\" ng-click=\"amountControl(-5)\">\n" +
    "          <span class=\"icon-icon-minus\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"amount-wrapper\">\n" +
    "          <div class=\"amount-container\">\n" +
    "            <div class=\"gift-dollar-sign\">$</div>\n" +
    "            <input\n" +
    "              class=\"gift-amount\"\n" +
    "              type=\"text\"\n" +
    "              clean=\"false\"\n" +
    "              ng-model=\"giftCardForm.amount\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"card-controls right-control\" ng-click=\"amountControl(5)\">\n" +
    "          <span class=\"icon-icon-plus\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <h2 class=\"gift-amount-cta\">Click amount to edit (USD)</h2>\n" +
    "      <div class=\"error-block-top\">\n" +
    "        <span ng-show=\"giftCardForm.amount < 5\">Gift card amount must be at least $5.00</span>\n" +
    "        <span ng-show=\"giftCardForm.amount > maxCardValue\">Gift card amount must be less than ${{maxCardValue}}.00</span>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "      <div class=\"divider-section\"></div>\n" +
    "      <h2 class=\"gift-header\">Please enter the recipient's name.</h2>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"overlayForm.firstName.$error.required && submitted\">Please provide the recipient first name</span>\n" +
    "          <span ng-show=\"overlayForm.firstName.$error.pattern && submitted\">Recipient first name must only contain alpha characters</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"overlayForm.lastName.$error.required && submitted\">Please provide the recipient last name</span>\n" +
    "          <span ng-show=\"overlayForm.lastName.$error.pattern && submitted\">Recipient last name must only contain alpha characters</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-half\"\n" +
    "          ng-class='{ \"has-focus\": overlayForm.firstName.hasFocus,\n" +
    "            \"has-success\": overlayForm.firstName.$valid,\n" +
    "            \"has-error\": overlayForm.firstName.$invalid && (form.$submitted || overlayForm.firstName.$touched),\n" +
    "            \"is-empty\": !overlayForm.firstName.$viewValue }'>\n" +
    "          <label for=\"firstName\">Recipient First Name</label>\n" +
    "          <input\n" +
    "            class=\"radius-left\"\n" +
    "            type=\"text\"\n" +
    "            name=\"firstName\"\n" +
    "            tabindex=\"1\"\n" +
    "            ng-model=\"giftCardForm.firstName\"\n" +
    "            required\n" +
    "            ng-pattern=\"/^[a-zA-Z]*$/\"\n" +
    "            ng-focus='overlayForm.firstName.hasFocus=true',\n" +
    "            ng-blur='overlayForm.firstName.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-half\"\n" +
    "          ng-class='{ \"has-focus\": overlayForm.lastName.hasFocus,\n" +
    "            \"has-success\": overlayForm.lastName.$valid,\n" +
    "            \"has-error\": overlayForm.lastName.$invalid && (form.$submitted || overlayForm.lastName.$touched),\n" +
    "            \"is-empty\": !overlayForm.lastName.$viewValue }'>\n" +
    "          <label for=\"lastName\">Recipient Last Name</label>\n" +
    "          <input\n" +
    "            class=\"radius-right\"\n" +
    "            type=\"text\"\n" +
    "            name=\"lastName\"\n" +
    "            tabindex=\"2\"\n" +
    "            ng-model=\"giftCardForm.lastName\"\n" +
    "            required\n" +
    "            ng-pattern=\"/^[a-zA-Z]*$/\"\n" +
    "            ng-focus='overlayForm.lastName.hasFocus=true',\n" +
    "            ng-blur='overlayForm.lastName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <div class=\"divider-section\"></div>\n" +
    "      <h2 class=\"gift-header\">Customize your gift card.</h2>\n" +
    "      <li class=\"floatingForm-li no-margin-bottom\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"overlayForm.from.$error.required && submitted\">Please provide a from name</span>\n" +
    "          <span ng-show=\"overlayForm.from.$error.maxlength && submitted\">From name must be less than 30 characters</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-full\"\n" +
    "          ng-class='{ \"has-focus\": overlayForm.from.hasFocus,\n" +
    "            \"has-success\": overlayForm.from.$valid,\n" +
    "            \"has-error\": overlayForm.from.$invalid && (form.$submitted || overlayForm.from.$touched),\n" +
    "            \"is-empty\": !overlayForm.from.$viewValue }'>\n" +
    "          <label for=\"from\">From</label>\n" +
    "          <input\n" +
    "            id=\"from\"\n" +
    "            class=\"radius-all\"\n" +
    "            type=\"text\"\n" +
    "            name=\"from\"\n" +
    "            tabindex=\"3\"\n" +
    "            ng-model=\"giftCardForm.from\"\n" +
    "            maxlength=\"30\"\n" +
    "            ng-maxlength=\"30\"\n" +
    "            required\n" +
    "            ng-focus='overlayForm.from.hasFocus=true',\n" +
    "            ng-blur='overlayForm.from.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"overlayForm.message.$error.required && submitted\">Please provide a message</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-full\"\n" +
    "          ng-class='{ \"has-focus\": overlayForm.message.hasFocus,\n" +
    "            \"has-success\": overlayForm.message.$valid,\n" +
    "            \"has-error\": overlayForm.message.$invalid && (form.$submitted || overlayForm.message.$touched),\n" +
    "            \"is-empty\": !overlayForm.message.$viewValue }'>\n" +
    "          <label for=\"message\">Add a message</label>\n" +
    "          <input\n" +
    "            id=\"message\"\n" +
    "            class=\"radius-all\"\n" +
    "            type=\"text\"\n" +
    "            name=\"message\"\n" +
    "            tabindex=\"3\"\n" +
    "            required\n" +
    "            maxlength=\"120\"\n" +
    "            ng-maxlength=\"120\"\n" +
    "            ng-model=\"giftCardForm.message\"\n" +
    "            ng-focus='overlayForm.message.hasFocus=true',\n" +
    "            ng-blur='overlayForm.message.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section btn-gift-container\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted && overlayForm.$invalid\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong.</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <a class=\"btn btn--float-right\" ng-click=\"attemptSubmission(overlayForm, 'root.giftCard.step2')\">NEXT</a>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/giftCard/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/giftCard/step2.html",
    "<div class=\"giftCardTab\">\n" +
    "  <div class=\"option left-option\" ng-click=\"selectTab('selectedDelivery', 0)\" ng-class=\"{active: giftCardForm.selectedDelivery == 0}\">\n" +
    "    <span class=\"icon-akimbo-desktop option-icon\"></span>\n" +
    "    <div class=\"option-title\">By email or text message<span ng-show=\"giftCardForm.selectedDelivery == 0\" class=\"icon-circle-check-fill option-check\"></span></div>\n" +
    "    <p><b>Delivered Immediately</b><br>\n" +
    "    Recipient can access a virtual card number and make purchases online and with a mobile wallet immediately</p>\n" +
    "  </div>\n" +
    "  <div class=\"option right-option\" ng-show=\"supportsPhysical\" ng-click=\"selectTab('selectedDelivery', 1)\" ng-class=\"{active: giftCardForm.selectedDelivery == 1}\">\n" +
    "    <span class=\"icon-akimbo-mailbox option-icon\"></span>\n" +
    "    <div class=\"option-title\">By mail<span ng-show=\"giftCardForm.selectedDelivery == 1\" class=\"icon-circle-check-fill option-check\"></span></div>\n" +
    "    <p><b>Delivered in 5-8 days</b><br>\n" +
    "    We'll send the gift card to the address you provide us.</p>\n" +
    "  </div>\n" +
    "  <br>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section modern-form-section bg-white\" >\n" +
    "  <p ng-show=\"(giftCardForm.selectedDelivery == 0)\"><b>How sending by email or text message works:</b> Enter the recipient's email address or mobile phone number below. They'll receive a message letting them know you've sent them a gift card.</p>\n" +
    "  <p ng-show=\"(giftCardForm.selectedDelivery == 1)\"><b>How sending by USPS mail works:</b> Please select where you would like us to send this <span ng-bind-html=\"brand.fullGiftProgramName\"></span>. You can enter your address if you want to give the gift in person, or enter the recipient's address and have us mail it to them directly. Either way, they're going to love your gift!</p>\n" +
    "  <ul class=\"floatingForm-form\">\n" +
    "    <li class=\"floatingForm-li\" ng-show=\"(giftCardForm.selectedDelivery == 0)\">\n" +
    "      <div class=\"error-block-top input-full\">\n" +
    "        <span ng-show=\"overlayForm.recipientEmail.$invalid && submitted\">Please provide the recipient email address or mobile phone number</span>\n" +
    "        <span ng-show=\"invalidPhone && submitted\">Phone number should be 10 digits long</span>\n" +
    "      </div>\n" +
    "      <div\n" +
    "         class=\"form-group input-full\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.recipientEmail.hasFocus,\n" +
    "				 \"has-success\": overlayForm.recipientEmail.$valid,\n" +
    "				 \"has-error\": (invalidPhone || overlayForm.recipientEmail.$invalid) && (form.$submitted || overlayForm.recipientEmail.$touched || submitted),\n" +
    "				 \"is-empty\": !overlayForm.recipientEmail.$viewValue }'>\n" +
    "				<label for=\"recipientEmail\">Recipient Email Address or Mobile Phone Number</label>\n" +
    "				<input\n" +
    "           id=\"recipientEmail\"\n" +
    "           class=\"radius-full\"\n" +
    "           type=\"text\"\n" +
    "           name=\"recipientEmail\"\n" +
    "           tabindex=\"1\"\n" +
    "           ng-required=\"giftCardForm.selectedDelivery == 0\"\n" +
    "           ng-model=\"giftCardForm.recipientEmail\"\n" +
    "					 ng-focus='overlayForm.recipientEmail.hasFocus=true',\n" +
    "           ng-blur='overlayForm.recipientEmail.hasFocus=false'>\n" +
    "			</div>\n" +
    "    </li>\n" +
    "    <h2 class=\"gift-header\" ng-show=\"(giftCardForm.selectedDelivery == 1)\">Where would you like this card delivered?</h2>\n" +
    "    <li class=\"floatingForm-li\" ng-show=\"(giftCardForm.selectedDelivery == 1)\">\n" +
    "      <div class=\"error-block-top input-half\">\n" +
    "        <span ng-show=\"overlayForm.shippingFirstName.$error.required && submitted\">Please provide a first name</span>\n" +
    "      </div>\n" +
    "      <div class=\"error-block-top input-half\">\n" +
    "        <span ng-show=\"overlayForm.shippingLastName.$error.required && submitted\">Please provide a last name</span>\n" +
    "      </div>\n" +
    "      <div\n" +
    "         class=\"form-group input-half\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.shippingFirstName.hasFocus,\n" +
    "				 \"has-success\": overlayForm.shippingFirstName.$valid,\n" +
    "				 \"has-error\": overlayForm.shippingFirstName.$invalid && (form.$submitted || overlayForm.shippingFirstName.$touched),\n" +
    "				 \"is-empty\": !overlayForm.shippingFirstName.$viewValue }'>\n" +
    "				<label for=\"shippingFirstName\">First Name</label>\n" +
    "				<input\n" +
    "           id=\"shippingFirstName\"\n" +
    "           class=\"radius-left\"\n" +
    "           type=\"text\"\n" +
    "           name=\"shippingFirstName\"\n" +
    "           tabindex=\"2\"\n" +
    "           ng-model=\"giftCardForm.shippingFirstName\"\n" +
    "           ng-required=\"giftCardForm.selectedDelivery == 1\"\n" +
    "					 ng-focus='overlayForm.shippingFirstName.hasFocus=true',\n" +
    "           ng-blur='overlayForm.shippingFirstName.hasFocus=false'>\n" +
    "			</div>\n" +
    "      <div\n" +
    "         class=\"form-group input-half\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.shippingLastName.hasFocus,\n" +
    "				 \"has-success\": overlayForm.shippingLastName.$valid,\n" +
    "				 \"has-error\": overlayForm.shippingLastName.$invalid && (form.$submitted || overlayForm.shippingLastName.$touched),\n" +
    "				 \"is-empty\": !overlayForm.shippingLastName.$viewValue }'>\n" +
    "				<label for=\"shippingLastName\">Last Name</label>\n" +
    "				<input\n" +
    "           class=\"radius-right\"\n" +
    "           type=\"text\"\n" +
    "           name=\"shippingLastName\"\n" +
    "           tabindex=\"3\"\n" +
    "           ng-model=\"giftCardForm.shippingLastName\"\n" +
    "           ng-required=\"giftCardForm.selectedDelivery == 1\"\n" +
    "					 ng-focus='overlayForm.shippingLastName.hasFocus=true',\n" +
    "           ng-blur='overlayForm.shippingLastName.hasFocus=false'>\n" +
    "			</div>\n" +
    "    </li>\n" +
    "    <li class=\"floatingForm-li\" ng-show=\"(giftCardForm.selectedDelivery == 1)\">\n" +
    "      <div class=\"error-block-top input-3-4\">\n" +
    "        <span ng-show=\"giftCardForm.shippingAddress1.$invalid && submitted\">Please provide the recipient shipping address.</span>\n" +
    "      </div>\n" +
    "      <div\n" +
    "         class=\"form-group input-3-4\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.shippingAddress1.hasFocus,\n" +
    "				 \"has-success\": overlayForm.shippingAddress1.$valid,\n" +
    "				 \"has-error\": overlayForm.shippingAddress1.$invalid && (form.$submitted || overlayForm.shippingAddress1.$touched),\n" +
    "				 \"is-empty\": !overlayForm.shippingAddress1.$viewValue }'>\n" +
    "				<label for=\"shippingAddress1\">Address</label>\n" +
    "				<input\n" +
    "           id=\"shippingAddress1\"\n" +
    "           class=\"radius-left\"\n" +
    "           type=\"text\"\n" +
    "           name=\"shippingAddress1\"\n" +
    "           tabindex=\"4\"\n" +
    "           ng-model=\"giftCardForm.shippingAddress1\"\n" +
    "           ng-required=\"giftCardForm.selectedTab == 1\"\n" +
    "           validate-po-box\n" +
    "					 ng-focus='overlayForm.shippingAddress1.hasFocus=true',\n" +
    "           ng-blur='overlayForm.shippingAddress1.hasFocus=false'>\n" +
    "			</div>\n" +
    "      <div\n" +
    "         class=\"form-group input-1-4\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.shippingAddress2.hasFocus,\n" +
    "				 \"has-success\": overlayForm.shippingAddress2.$valid,\n" +
    "				 \"has-error\": overlayForm.shippingAddress2.$invalid && (form.$submitted || overlayForm.shippingAddress2.$touched),\n" +
    "				 \"is-empty\": !overlayForm.shippingAddress2.$viewValue }'>\n" +
    "				<label for=\"shippingAddress2\">Apt/Suite</label>\n" +
    "				<input\n" +
    "           class=\"radius-right\"\n" +
    "           type=\"text\"\n" +
    "           name=\"shippingAddress2\"\n" +
    "           tabindex=\"5\"\n" +
    "           ng-model=\"giftCardForm.shippingAddress2\"\n" +
    "					 ng-focus='overlayForm.shippingAddress2.hasFocus=true',\n" +
    "           ng-blur='overlayForm.shippingAddress2.hasFocus=false'>\n" +
    "			</div>\n" +
    "    </li>\n" +
    "    <li class=\"floatingForm-li\" ng-show=\"(giftCardForm.selectedDelivery == 1)\">\n" +
    "      <div class=\"error-block-top input-half\">\n" +
    "        <span ng-show=\"overlayForm.shippingCity.$error.required && submitted\">Please provide recipient city</span>\n" +
    "      </div>\n" +
    "      <div class=\"error-block-top input-1-4\">\n" +
    "        <span ng-show=\"overlayForm.shippingState.$error.required && submitted\">Required</span>\n" +
    "      </div>\n" +
    "      <div class=\"error-block-top input-1-4\">\n" +
    "        <span ng-show=\"overlayForm.shippingZip.$invalid && submitted\">Required</span>\n" +
    "      </div>\n" +
    "      <div\n" +
    "         class=\"form-group input-half\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.shippingCity.hasFocus,\n" +
    "				 \"has-success\": overlayForm.shippingCity.$valid,\n" +
    "				 \"has-error\": overlayForm.shippingCity.$invalid && (form.$submitted || overlayForm.shippingCity.$touched),\n" +
    "				 \"is-empty\": !overlayForm.shippingCity.$viewValue }'>\n" +
    "				<label for=\"shippingCity\">City</label>\n" +
    "				<input\n" +
    "           class=\"radius-left\"\n" +
    "           type=\"text\"\n" +
    "           name=\"shippingCity\"\n" +
    "           tabindex=\"6\"\n" +
    "           ng-model=\"giftCardForm.shippingCity\"\n" +
    "           ng-required=\"giftCardForm.selectedDelivery == 1\"\n" +
    "					 ng-focus='overlayForm.shippingCity.hasFocus=true',\n" +
    "           ng-blur='overlayForm.shippingCity.hasFocus=false'>\n" +
    "			</div>\n" +
    "      <div\n" +
    "         class=\"form-group input-1-4\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.shippingState.hasFocus,\n" +
    "				 \"has-success\": overlayForm.shippingState.$valid,\n" +
    "				 \"has-error\": overlayForm.shippingState.$invalid && (form.$submitted || overlayForm.shippingState.$touched),\n" +
    "				 \"is-empty\": !overlayForm.shippingState.$viewValue }'>\n" +
    "				<label for=\"shippingState\">State</label>\n" +
    "				<input\n" +
    "           class=\"radius-none\"\n" +
    "           type=\"text\"\n" +
    "           name=\"shippingState\"\n" +
    "           tabindex=\"7\"\n" +
    "           ng-required=\"giftCardForm.selectedDelivery == 1\"\n" +
    "           max=\"2\"\n" +
    "           maxlength=\"2\"\n" +
    "           ng-maxlength=\"2\"\n" +
    "           ng-model=\"giftCardForm.shippingState\"\n" +
    "					 ng-focus='overlayForm.shippingState.hasFocus=true',\n" +
    "           ng-blur='overlayForm.shippingState.hasFocus=false'>\n" +
    "			</div>\n" +
    "      <div\n" +
    "         class=\"form-group input-1-4\"\n" +
    "				 ng-class='{ \"has-focus\": overlayForm.shippingZip.hasFocus,\n" +
    "				 \"has-success\": overlayForm.shippingZip.$valid,\n" +
    "				 \"has-error\": overlayForm.shippingZip.$invalid && (form.$submitted || overlayForm.shippingZip.$touched),\n" +
    "				 \"is-empty\": !overlayForm.shippingZip.$viewValue }'>\n" +
    "				<label for=\"shippingZip\">Zip</label>\n" +
    "				<input\n" +
    "           class=\"radius-right\"\n" +
    "           type=\"text\"\n" +
    "           name=\"shippingZip\"\n" +
    "           tabindex=\"8\"\n" +
    "           ng-required=\"giftCardForm.selectedDelivery == 1\"\n" +
    "           min=\"5\"\n" +
    "           minlength=\"5\"\n" +
    "           ng-minlength=\"5\"\n" +
    "           ngMinlength=\"5\"\n" +
    "           ng-model=\"giftCardForm.shippingZip\"\n" +
    "					 ng-focus='overlayForm.shippingZip.hasFocus=true',\n" +
    "           ng-blur='overlayForm.shippingZip.hasFocus=false'>\n" +
    "			</div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section btn-gift-container\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted && overlayForm.$invalid\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong.</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <a class=\"btn btn--float-right\" ng-click=\"attemptSubmission(overlayForm, 'root.giftCard.step3')\">NEXT</a>\n" +
    "  <a class=\"btn btn-light btn--float-left\" ui-sref=\"root.giftCard.step1\">BACK</a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/giftCard/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/giftCard/step3.html",
    "<iframe width=\"1\" height=\"1\" frameborder=\"0\" scrolling=\"no\" ng-src=\"{{kountUrl}}\">\n" +
    "  <img width=\"1\" height=\"1\" ng-src=\"{{kountUrl}}\">\n" +
    "</iframe>\n" +
    "<div class=\"modern-widget-section modern-form-section bg-white no-border\" ng-repeat=\"giftCard in shoppingCart track by giftCard.createdAt\">\n" +
    "  <h2 class=\"gift-header\">{{giftCard.firstName}} {{giftCard.lastName}}'s Gift Card:</h2>\n" +
    "  <div class=\"card-table\">\n" +
    "    <div class=\"card-top\">\n" +
    "      <div class=\"card-left\">\n" +
    "        <div class=\"card-container\">\n" +
    "          <img src=\"assets/images/{{brand.name}}/card-gift.svg\" class=\"giftcard-design\"/>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <ul class=\"card-meta-list\">\n" +
    "        <li class=\"card-meta-item\">\n" +
    "          Amount: {{giftCard.amount | akimboCurrency}}\n" +
    "        </li>\n" +
    "        <li class=\"card-meta-item\">\n" +
    "          To: {{giftCard.firstName}} {{giftCard.lastName}}\n" +
    "        </li>\n" +
    "        <li class=\"card-meta-item\">\n" +
    "          From: {{giftCard.from}}\n" +
    "        </li>\n" +
    "        <li class=\"card-meta-item\">\n" +
    "          Message: <i>{{giftCard.message}}</i>\n" +
    "        </li>\n" +
    "        <li class=\"card-meta-item\" ng-if=\"giftCard.deliveryType === 'email'\">\n" +
    "          <b>Delivery by Email</b>\n" +
    "        </li>\n" +
    "        <li class=\"card-meta-item\" ng-if=\"giftCard.deliveryType === 'phone'\">\n" +
    "          <b>Delivery by Text Message</b>\n" +
    "        </li>\n" +
    "        <li class=\"card-meta-item\" ng-if=\"giftCard.selectedDelivery == 1\">\n" +
    "          <b>Delivery by Mail</b>\n" +
    "        </li>\n" +
    "        <li ng-if=\"giftCard.selectedDelivery == 0\" class=\"card-meta-item\">\n" +
    "          {{giftCard.recipientEmail}}\n" +
    "        </li>\n" +
    "        <li ng-if=\"giftCard.selectedDelivery == 1\" class=\"card-meta-item\">\n" +
    "          {{giftCard.shippingAddress1}} {{giftCard.shippingAddress2}}<br> {{giftCard.shippingCity}} {{giftCard.shippingState}}, {{giftCard.shippingZip}}\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <div class=\"card-bottom\">\n" +
    "      <a ng-click=\"editCard(giftCard.createdAt)\" class=\"btn\">EDIT</a>\n" +
    "      <a ng-click=\"removeCard(giftCard.createdAt)\" class=\"btn\">REMOVE</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"create-btn\">\n" +
    "  <a ng-click=\"createAnother()\" class=\"btn\">CREATE ANOTHER</a>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section modern-widget-section__no-border bg-white\" ng-if=\"isOnDashboard\">\n" +
    "  <h2 class=\"gift-header\">How would you like to pay for this gift card?</h2>\n" +
    "</div>\n" +
    "<div class=\"brand-stripe\"></div>\n" +
    "<div class=\"giftCardTab\" ng-if=\"isOnDashboard\">\n" +
    "  <div class=\"option left-option\" ng-click=\"selectTab('selectedPayment', 0)\" ng-class=\"{active: formData.selectedPayment == 0}\">\n" +
    "    <span class=\"icon-{{brand.name}} option-icon\"></span>\n" +
    "    <div class=\"option-title\">\n" +
    "      By {{brand.commonProgramName}}\n" +
    "      <span ng-show=\"formData.selectedPayment == 0 && balance >= totalAmount\" class=\"icon-circle-check-fill option-check\"></span>\n" +
    "      <span ng-show=\"formData.selectedPayment == 0 && balance < totalAmount\" class=\"icon-circle-x option-check\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"option right-option\" ng-click=\"selectTab('selectedPayment', 1)\" ng-class=\"{active: formData.selectedPayment == 1}\" ng-hide=\"true\">\n" +
    "    <span class=\"icon-akimbo-withdraw option-icon\"></span>\n" +
    "    <div class=\"option-title\">By Bank Account\n" +
    "      <span ng-show=\"formData.selectedPayment == 1 && banks.length > 0 && canSendFromBank\" class=\"icon-circle-check-fill option-check\"></span>\n" +
    "      <span ng-show=\"formData.selectedPayment == 1 && banks.length === 0\" class=\"icon-circle-x option-check\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"option right-option\" ng-click=\"selectTab('selectedPayment', 2)\" ng-class=\"{active: formData.selectedPayment == 2}\">\n" +
    "    <span class=\"icon-card-sub option-icon\"></span>\n" +
    "    <div class=\"option-title\">By Credit Card\n" +
    "      <span ng-show=\"formData.selectedPayment == 2 && totalAmount <= 200\" class=\"icon-circle-check-fill option-check\"></span>\n" +
    "      <span ng-show=\"formData.selectedPayment == 2 && totalAmount > 200\" class=\"icon-circle-x option-check\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <br>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-show=\"formData.selectedPayment == 0\">\n" +
    "  <p ng-show=\"(balance >= (totalFeeAmount + totalAmount))\" class=\"payment-info\">Sweet, you have enough on your {{brand.commonProgramName}} balance!</p>\n" +
    "  <p ng-show=\"(balance < (totalFeeAmount + totalAmount))\" class=\"payment-info error\">Oops, you do not have enough on your {{brand.commonProgramName}} balance. Please send by a credit card.</p>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-show=\"formData.selectedPayment == 1\">\n" +
    "  <p ng-show=\"banks.length > 0 && canSendFromBank\" class=\"payment-info\">Please select the bank to send from:</p>\n" +
    "  <p ng-show=\"!canSendFromBank\" class=\"payment-info error\">Oops, you are unable to send a card by email using your bank account as a payment method. Please select a different payment method or edit the delivery method.</p>\n" +
    "  <p ng-show=\"banks.length === 0\" class=\"payment-info error\">Oops, you do not have a linked bank account. Please add a bank account below:</p>\n" +
    "  <ul class=\"checkbox-list\" ng-show=\"canSendFromBank\">\n" +
    "    <li ng-repeat=\"b in banks\">\n" +
    "      <div class=\"checkbox-item\" ng-click=\"formData.Bank = b\">\n" +
    "        <div class=\"checkbox-item__box\"\n" +
    "          ng-class=\"formData.Bank.Name == b.Name ? '' : 'checkbox-item__box--disabled'\">\n" +
    "          <span class=\"checkbox-item__icon\"\n" +
    "            ng-class=\"formData.Bank.Name == b.Name ? 'icon-check' : ''\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <input\n" +
    "            class=\"checkbox-item__input\"\n" +
    "            type=\"radio\"\n" +
    "            name=\"Source\"\n" +
    "            ng-model=\"formData.Bank\"\n" +
    "            ng-value=\"b\">\n" +
    "          <p class=\"checkbox-item__text\">{{b.Name}}</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "      <div class=\"checkbox-item\" ui-sref=\"member.home.bank/add.step1\">\n" +
    "        <div class=\"checkbox-item__box checkbox-item__box--no-border\">\n" +
    "          <span class=\"checkbox-item__icon icon-plus\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <p class=\"checkbox-item__text\">Add a Bank</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-show=\"formData.selectedPayment == 2\">\n" +
    "  <span ng-show=\"(totalAmount <= 200)\">\n" +
    "    <p ng-if=\"isOnDashboard\" class=\"payment-info\">Please provide credit card and billing information.</p>\n" +
    "    <h2 class=\"gift-header hide\">How would you like to pay for {{ shoppingCart.length > 1 ? 'these gift cards?' : 'this gift card?' }}</h2>\n" +
    "    <br>\n" +
    "    <p class=\"hide\"><b>Security is our top priority.</b> We protect your information, as well as the recipient's, throughout the {{brand.programName}} experience.</p>\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"overlayForm.cardNumber.$invalid && submitted\">Credit card must be 15-16 digits</span>\n" +
    "          <span ng-show=\"overlayForm.cardNumber.$valid &&\n" +
    "                         submitted &&\n" +
    "                         formData.cctype != 'Amex' &&\n" +
    "                         formData.cardNumber.length != 16\">Credit card must be 16 digits</span>\n" +
    "          <span ng-show=\"overlayForm.cardNumber.$valid &&\n" +
    "                         submitted &&\n" +
    "                         formData.cctype == 'Amex' &&\n" +
    "                         formData.cardNumber.length != 15\">Amex credit card must be 15 digits</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"overlayForm.expDate.$error.required && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"overlayForm.cvv.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.cardNumber.hasFocus,\n" +
    "				   \"has-success\": overlayForm.cardNumber.$valid,\n" +
    "				   \"has-error\": overlayForm.cardNumber.$invalid && (form.$submitted || overlayForm.cardNumber.$touched),\n" +
    "				   \"is-empty\": !overlayForm.cardNumber.$viewValue }'>\n" +
    "				  <label for=\"cardNumber\">Card Number</label>\n" +
    "				  <input\n" +
    "             id=\"cardNumber\"\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"cardNumber\"\n" +
    "             tabindex=\"1\"\n" +
    "             ng-model=\"formData.cardNumber\"\n" +
    "             credit-card-type\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "             data-ng-minlength=\"15\"\n" +
    "             maxlength=\"16\"\n" +
    "					   ng-focus='overlayForm.cardNumber.hasFocus=true'\n" +
    "             ng-blur='overlayForm.cardNumber.hasFocus=false'>\n" +
    "          <span class=\"input-helper-btn no-click\" ng-show=\"true\">{{formData.cctype}}</span>\n" +
    "			  </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.expDate.hasFocus,\n" +
    "				   \"has-success\": overlayForm.expDate.$valid,\n" +
    "				   \"has-error\": overlayForm.expDate.$invalid && (form.$submitted || overlayForm.expDate.$touched),\n" +
    "				   \"is-empty\": !overlayForm.expDate.$viewValue }'>\n" +
    "				  <label for=\"expDate\">Exp. Date</label>\n" +
    "				  <input\n" +
    "             id=\"expDate\"\n" +
    "             class=\"radius-none\"\n" +
    "             type=\"text\"\n" +
    "             name=\"expDate\"\n" +
    "             tabindex=\"2\"\n" +
    "             exp-input-helper\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             mask=\"99/99\"\n" +
    "             clean=\"false\"\n" +
    "             ng-model=\"formData.expDate\"\n" +
    "					   ng-focus='overlayForm.expDate.hasFocus=true'\n" +
    "             ng-blur='overlayForm.expDate.hasFocus=false'>\n" +
    "			  </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.cvv.hasFocus,\n" +
    "				   \"has-success\": overlayForm.cvv.$valid,\n" +
    "				   \"has-error\": overlayForm.cvv.$invalid && (form.$submitted || overlayForm.cvv.$touched),\n" +
    "				   \"is-empty\": !overlayForm.cvv.$viewValue }'>\n" +
    "				  <label for=\"cvv\">CVV</label>\n" +
    "				  <input\n" +
    "             id=\"cvv\"\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"cvv\"\n" +
    "             tabindex=\"3\"\n" +
    "             ng-model=\"formData.cvv\"\n" +
    "             cvv-length\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "             data-ng-minlength=\"3\"\n" +
    "             maxlength=\"4\"\n" +
    "					   ng-focus='overlayForm.cvv.hasFocus=true',\n" +
    "             ng-blur='overlayForm.cvv.hasFocus=false'>\n" +
    "          <span ng-click=\"alertCvv()\" class=\"input-helper-btn icon-info input-icon\"></span>\n" +
    "			  </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"overlayForm.billingFirstName.$error.required && submitted\">Please provide a billing first name</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"overlayForm.billingFirstName.$error.required && submitted\">Please provide a billing last name</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingFirstName.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingFirstName.$valid,\n" +
    "				   \"has-error\": overlayForm.billingFirstName.$invalid && (form.$submitted || overlayForm.billingFirstName.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingFirstName.$viewValue }'>\n" +
    "				  <label for=\"billingFirstName\">Billing First Name</label>\n" +
    "				  <input\n" +
    "             id=\"billingFirstName\"\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"billingFirstName\"\n" +
    "             tabindex=\"4\"\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             ng-model=\"formData.billingFirstName\"\n" +
    "					   ng-focus='overlayForm.billingFirstName.hasFocus=true'\n" +
    "             ng-blur='overlayForm.billingFirstName.hasFocus=false'>\n" +
    "			  </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingLastName.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingLastName.$valid,\n" +
    "				   \"has-error\": overlayForm.billingLastName.$invalid && (form.$submitted || overlayForm.billingLastName.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingLastName.$viewValue }'>\n" +
    "				  <label for=\"billingLastName\">Billing Last Name</label>\n" +
    "				  <input\n" +
    "             id=\"billingLastName\"\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"billingLastName\"\n" +
    "             tabindex=\"5\"\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             ng-model=\"formData.billingLastName\"\n" +
    "					   ng-focus='overlayForm.billingLastName.hasFocus=true'\n" +
    "             ng-blur='overlayForm.billingLastName.hasFocus=false'>\n" +
    "			  </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-3-4\">\n" +
    "          <span ng-show=\"overlayForm.billingAddress1.$error.required && submitted\">Please provide your address</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-3-4\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingAddress1.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingAddress1.$valid,\n" +
    "				   \"has-error\": overlayForm.billingAddress1.$invalid && (form.$submitted || overlayForm.billingAddress1.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingAddress1.$viewValue }'>\n" +
    "				  <label for=\"billingAddress1\">Billing Address</label>\n" +
    "				  <input\n" +
    "             id=\"address\"\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"billingAddress1\"\n" +
    "             tabindex=\"6\"\n" +
    "             ng-model=\"formData.billingAddress1\"\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "					   ng-focus='overlayForm.billingAddress1.hasFocus=true'\n" +
    "             ng-blur='overlayForm.billingAddress1.hasFocus=false'>\n" +
    "			  </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingAddress2.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingAddress2.$valid,\n" +
    "				   \"has-error\": overlayForm.billingAddress2.$invalid && (form.$submitted || overlayForm.billingAddress2.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingAddress2.$viewValue }'>\n" +
    "				  <label for=\"billingAddress2\">Apt/Suite.</label>\n" +
    "				  <input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             id=\"billingAddress2\"\n" +
    "             name=\"billingAddress2\"\n" +
    "             tabindex=\"7\"\n" +
    "             ng-model=\"formData.billingAddress2\"\n" +
    "					   ng-focus='overlayForm.billingAddress2.hasFocus=true',\n" +
    "             ng-blur='overlayForm.billingAddress2.hasFocus=false'>\n" +
    "			  </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"overlayForm.billingCity.$error.required && submitted\">Please provide your city</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"overlayForm.billingState.$error.required && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"overlayForm.billingZip.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half mobile-11-20\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingCity.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingCity.$valid,\n" +
    "				   \"has-error\": overlayForm.billingCity.$invalid && (form.$submitted || overlayForm.billingCity.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingCity.$viewValue }'>\n" +
    "				  <label for=\"billingCity\">City</label>\n" +
    "				  <input\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"billingCity\"\n" +
    "             id=\"billingCity\"\n" +
    "             tabindex=\"8\"\n" +
    "             ng-model=\"formData.billingCity\"\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "					   ng-focus='overlayForm.billingCity.hasFocus=true'\n" +
    "             ng-blur='overlayForm.billingCity.hasFocus=false'>\n" +
    "			  </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingState.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingState.$valid,\n" +
    "				   \"has-error\": overlayForm.billingState.$invalid && (form.$submitted || overlayForm.billingState.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingState.$viewValue }'>\n" +
    "				  <label for=\"billingState\">State</label>\n" +
    "				  <input\n" +
    "             class=\"radius-none\"\n" +
    "             type=\"text\"\n" +
    "             id=\"billingState\"\n" +
    "             name=\"billingState\"\n" +
    "             tabindex=\"9\"\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             max=\"2\"\n" +
    "             maxlength=\"2\"\n" +
    "             ng-maxlength=\"2\"\n" +
    "             ng-model=\"formData.billingState\"\n" +
    "					   ng-focus='overlayForm.billingState.hasFocus=true'\n" +
    "             ng-blur='overlayForm.billingState.hasFocus=false'>\n" +
    "			  </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4 mobile-3-10\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingZip.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingZip.$valid,\n" +
    "				   \"has-error\": overlayForm.billingZip.$invalid && (form.$submitted || overlayForm.billingZip.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingZip.$viewValue }'>\n" +
    "				  <label for=\"billingZip\">Zip</label>\n" +
    "				  <input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             id=\"billingZip\"\n" +
    "             name=\"billingZip\"\n" +
    "             tabindex=\"10\"\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             min=\"5\"\n" +
    "             minlength=\"5\"\n" +
    "             ng-minlength=\"5\"\n" +
    "             ngMinlength=\"5\"\n" +
    "             ng-model=\"formData.billingZip\"\n" +
    "             ng-focus='overlayForm.billingZip.hasFocus=true'\n" +
    "             ng-blur='overlayForm.billingZip.hasFocus=false'>\n" +
    "			  </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"overlayForm.billingEmail.$invalid && submitted\">Please provide an email address</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "				   ng-class='{ \"has-focus\": overlayForm.billingEmail.hasFocus,\n" +
    "				   \"has-success\": overlayForm.billingEmail.$valid,\n" +
    "				   \"has-error\": overlayForm.billingEmail.$invalid && (form.$submitted || overlayForm.billingEmail.$touched),\n" +
    "				   \"is-empty\": !overlayForm.billingEmail.$viewValue }'>\n" +
    "				  <label for=\"billingEmail\">Your Email Address</label>\n" +
    "				  <input\n" +
    "             id=\"billingEmail\"\n" +
    "             class=\"radius-full\"\n" +
    "             type=\"email\"\n" +
    "             name=\"billingEmail\"\n" +
    "             tabindex=\"11\"\n" +
    "             ng-required=\"formData.selectedPayment == 2\"\n" +
    "             ng-model=\"formData.billingEmail\"\n" +
    "             ng-focus='overlayForm.billingEmail.hasFocus=true'\n" +
    "             ng-blur='overlayForm.billingEmail.hasFocus=false'>\n" +
    "			  </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </span>\n" +
    "  <span ng-show=\"totalAmount > 200\">\n" +
    "    <p class=\"payment-info error\">Oops, please send from a bank or akimbo card.</p>\n" +
    "  </span>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <h2 class=\"gift-header\">Ready to purchase your gift card{{ shoppingCart.length > 1 ? 's' : '' }}?</h2>\n" +
    "  <div class=\"checkbox-container\">\n" +
    "    <div class=\"checkbox-error-messaging\"><span ng-show=\"(overlayForm.terms_and_conditions.$error.required || overlayForm.eSign.$error.required) && submitted\">Please read and check that you agree with the agreement policies.</span></div>\n" +
    "    <div class=\"checkbox-item\">\n" +
    "      <div class=\"checkbox-item__box\" ng-click=\"formData.eSign = !formData.eSign\" ng-class=\"formData.eSign ? '' : 'checkbox-item__box--disabled'\">\n" +
    "        <span class=\"checkbox-item__icon\" ng-class=\"formData.eSign ? 'icon-check' : ''\"></span>\n" +
    "      </div>\n" +
    "      <div class=\"checkbox-item__content\">\n" +
    "        <input\n" +
    "                class=\"checkbox-item__input\"\n" +
    "                type=\"checkbox\"\n" +
    "                name=\"eSign\"\n" +
    "                id=\"eSign\"\n" +
    "                ng-model=\"formData.eSign\"\n" +
    "                tabindex=\"12\"\n" +
    "                required>\n" +
    "        <p class=\"checkbox-item__text checkbox-item__text--small\">\n" +
    "          Check this box if you agree to the\n" +
    "          <a target=\"_blank\" href=\"{{brand.programLegal.disclosure}}\">E-Sign Disclosure</a>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"checkbox-item\">\n" +
    "      <div class=\"checkbox-item__box\" ng-click=\"formData.Tos = !formData.Tos\" ng-class=\"formData.Tos ? '' : 'checkbox-item__box--disabled'\">\n" +
    "        <span class=\"checkbox-item__icon\" ng-class=\"formData.Tos ? 'icon-check' : ''\"></span>\n" +
    "      </div>\n" +
    "      <div class=\"checkbox-item__content\">\n" +
    "        <input\n" +
    "          class=\"checkbox-item__input\"\n" +
    "          type=\"checkbox\"\n" +
    "          name=\"terms_and_conditions\"\n" +
    "          id=\"terms_and_conditions\"\n" +
    "          ng-model=\"formData.Tos\"\n" +
    "          tabindex=\"13\"\n" +
    "          required>\n" +
    "        <p class=\"checkbox-item__text checkbox-item__text--small\">\n" +
    "          Check this box if you agree to the\n" +
    "          <a target=\"_blank\" href=\"{{brand.programLegal.privacy}}\">Privacy Policy</a>\n" +
    "          and <a target=\"_blank\" href=\"{{brand.programLegal.agreement}}\">Cardholder Agreement</a>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "  <br>\n" +
    "  <div class=\"receipt-container bg-gray\">\n" +
    "    <h2>Please review your order:</h2>\n" +
    "    <table>\n" +
    "      <tr>\n" +
    "        <td>Gift Card Value Subtotal:</td>\n" +
    "        <td>{{totalAmount | akimboCurrency}}</td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td>Card Fees:</td>\n" +
    "        <td>{{totalFeeAmount - separatedFees.fee | akimboCurrency}}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-show=\"separatedFees.fee > 0\">\n" +
    "        <td>{{separatedFees.text}}:</td>\n" +
    "        <td>{{separatedFees.fee | akimboCurrency}}</td>\n" +
    "      </tr>\n" +
    "      <tr>\n" +
    "        <td><b>Total:</b></td>\n" +
    "        <td><b>{{(totalAmount + totalFeeAmount) | akimboCurrency}}</b></td>\n" +
    "      </tr>\n" +
    "    </table>\n" +
    "    <div ng-show=\"separatedFees.information\">\n" +
    "      <br/>\n" +
    "      {{separatedFees.information}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <span class=\"btn-gift-container\">\n" +
    "    <span class=\"error-shown-hand\" ng-show=\"submitted && overlayForm.$invalid\">\n" +
    "      <span id=\"akimbo-form-error-message\">Oops, something is wrong.</span>\n" +
    "      <span class=\"icon-point-up\"></span>\n" +
    "    </span>\n" +
    "    <a class=\"btn btn--float-right\" ng-click=\"processForm(overlayForm)\">PLACE ORDER</a>\n" +
    "  </span>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/giftCard/success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/giftCard/success.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"success-receipt\">\n" +
    "    <div class=\"receipt-column\">\n" +
    "      <div class=\"receipt-main-title\">Your Receipt</div>\n" +
    "      {{currentDate | date:'longDate'}}\n" +
    "    </div>\n" +
    "    <div class=\"receipt-column\" ng-repeat=\"card in shoppingCart\">\n" +
    "      <div class=\"receipt-info-title\">\n" +
    "        <b><span ng-bind-html=\"brand.fullGiftProgramName\"></span> for {{card.firstName}} <span style=\"float:right;\">{{card.amount | akimboCurrency}}</span></b>\n" +
    "      </div>\n" +
    "      <ul>\n" +
    "        <li>Amount: {{card.amount | akimboCurrency}}</li>\n" +
    "        <li>Recipient: {{card.firstName}} {{card.lastName}}</li>\n" +
    "        <li>From: {{card.from}}</li>\n" +
    "        <li>Message: {{card.message}}</li>\n" +
    "        <li ng-if=\"card.deliveryType === 'email'\">Delivery: By email to {{card.recipientEmail}}</li>\n" +
    "        <li ng-if=\"card.deliveryType === 'email'\">Status: Email sent</li>\n" +
    "        <li ng-if=\"card.deliveryType === 'phone'\">Delivery: By text to {{card.recipientEmail}}</li>\n" +
    "        <li ng-if=\"card.deliveryType === 'phone'\">Status: Text sent</li>\n" +
    "        <li ng-if=\"card.selectedDelivery == 1\">Delivery: By mail to {{card.shippingAddress1}} {{card.shippingAddress2}} {{card.shippingCity}}, {{card.shippingState}}, {{card.shippingZip}}</li>\n" +
    "        <li ng-if=\"card.selectedDelivery == 1\">Status: Gift card will arrrive in 5-7 days</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <div class=\"receipt-column align-end\">\n" +
    "      <table class=\"receipt-table\">\n" +
    "        <tr>\n" +
    "          <td>Gift Card Value Subtotal:</td>\n" +
    "          <td>{{totalAmount | akimboCurrency}}</td>\n" +
    "        </tr>\n" +
    "        <tr>\n" +
    "          <td>Card Fees:</td>\n" +
    "          <td>{{totalFeeAmount - separatedFees.fee | akimboCurrency}}</td>\n" +
    "        </tr>\n" +
    "        <tr ng-show=\"separatedFees.fee > 0\">\n" +
    "          <td>{{separatedFees.text}}:</td>\n" +
    "          <td>{{separatedFees.fee | akimboCurrency}}</td>\n" +
    "        </tr>\n" +
    "        <tr>\n" +
    "          <td><b>Amount Paid:</b></td>\n" +
    "          <td><b>{{(totalAmount + totalFeeAmount) | akimboCurrency}}</b></td>\n" +
    "        </tr>\n" +
    "      </table>\n" +
    "      <div ng-show=\"separatedFees.information\">\n" +
    "        <br/>\n" +
    "        {{separatedFees.information}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"content\">\n" +
    "    <div>\n" +
    "      <video ng-show=\"showVideo\" id=\"video\" class=\"giftcard-receipt-video\">\n" +
    "        <source src={{brand.giftCardReceiptVideo}} type=\"video/mp4\" />\n" +
    "      </video>\n" +
    "    </div>\n" +
    "    <div class=\"receipt-cta-margin\" ng-hide=\"showVideo\"></div>\n" +
    "    <div class=\"btn\" ng-click=\"printReceipt()\">PRINT RECEIPT</div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/giftCard/widget-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/giftCard/widget-header.html",
    "<div class=\"modern-widget-header bg-white content\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gift-order-logo.svg\"/>\n" +
    "    <div class=\"content\">\n" +
    "      <h2 class=\"gift-header\">{{title}}</h2>\n" +
    "      <p ng-bind-html=\"info\"></p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"brand-stripe\"></div>\n" +
    "");
}]);

angular.module("../app/views/giftCard/widget-layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/giftCard/widget-layout.html",
    "<div class=\"overlay-wrapper overlay-active widget-gift\">\n" +
    "  <div class=\"overlay {{overlay.headerClass}}\">\n" +
    "    <div class=\"overlay-close icon-circle-x\" ng-click=\"back()\"></div>\n" +
    "    <!-- .overlay-header -->\n" +
    "    <div class=\"content giftCard\" ui-view=\"header\"></div>\n" +
    "    <!-- .overlay-header-form -->\n" +
    "    <div class=\"overlay-body\">\n" +
    "      <div class=\"overlay-main\">\n" +
    "        <form name=\"overlayForm\" class=\"floatingForm-form giftCard\">\n" +
    "          <div ui-view=\"step\"></div>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "      <div ui-view=\"side\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-background\"></div>\n" +
    "</div>\n" +
    "<div class=\"widget-gift\" ui-view=\"footer\"></div>\n" +
    "<div class=\"overlay-mask\"></div>\n" +
    "<div ng-show=\"alertError.show\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{alertError.message}}<br/><span ng-show=\"alertError.resetPassword\"><br/>If you forgot your username or password, please reset it <a href=\"https://app.akimbocard.com/app/#/{{brand.name}}/resetpassword\" class=\"underline\">here</a><br/></span><br/>If you continue to have problems please contact customer service at {{brand.programContactPhone}}.</p>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"alertError.show = !alertError.show\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/index/top-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/index/top-header.html",
    "<div class=\"top-header\">\n" +
    "  <div class=\"container\">\n" +
    "    <a class=\"top-header__brand-logos\" href=\"/app/#/member/{{username}}/\" title=\"Home page\" rel=\"home\" style=\"color: #000\">\n" +
    "      <!-- Colored logos for transparent header -->\n" +
    "      <img class=\"top-header__brand-img\" ng-if=\"brand.defaultBrandLogo && header.removeBkg\" ng-src=\"assets/images/{{default_brand}}/logo-color.svg\" alt=\"\">\n" +
    "      <img class=\"top-header__brand-img\" ng-if=\"brand.brandLogo && header.removeBkg\" ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "      <!-- White logos for colored header -->\n" +
    "      <img class=\"top-header__brand-img\" ng-if=\"brand.defaultBrandLogo && !header.removeBkg\" ng-src=\"assets/images/{{default_brand}}/logo.svg\" alt=\"\">\n" +
    "      <img class=\"top-header__brand-img\" ng-if=\"brand.brandLogo && !header.removeBkg\" ng-src=\"assets/images/{{brand.name}}/logo.svg\" alt=\"\">\n" +
    "    </a>\n" +
    "    <ul class=\"top-header__nav\" ng-if=\"isDashboard\">\n" +
    "      <li class=\"account-li\" ng-if=\"firstName\">\n" +
    "        Hello {{firstName}}\n" +
    "      </li>\n" +
    "      <li class=\"hide-mobile\">\n" +
    "        <a ui-sref=\"member.home.profile.step1\" ng-show=\"!hideAccountAttribute()\">My Account</a>\n" +
    "      </li>\n" +
    "      <li class=\"hide-mobile\">\n" +
    "        <a ui-sref=\"logout\" id=\"logout\">Logout</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    <ul class=\"top-header__nav top-header__nav--right hide-mobile\" ng-if=\"!header.secondaryLinks\">\n" +
    "      <!-- So that the home button routes the user to the dashboard -->\n" +
    "      <li>\n" +
    "        <a ng-hide=\"brand.ssoHide\" href=\"/app/#/member/{{username}}/\">Home</a>\n" +
    "        <a ng-show=\"brand.ssoHide\" href=\"{{brand.homeUrl}}\">Home</a>\n" +
    "      </li>\n" +
    "      <li ng-repeat=\"link in brand.headerLinks track by $index\">\n" +
    "        <a href=\"{{link.url}}\">{{link.text}}</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    <ul class=\"top-header__nav top-header__nav--right hide-mobile\" ng-if=\"header.secondaryLinks\">\n" +
    "      <li>\n" +
    "        <a ui-sref=\"root.register.step1\">Register a card</a>\n" +
    "      </li>\n" +
    "      <li ng-show=\"brand.programLegal['fees']\">\n" +
    "        <a href=\"{{brand.programLegal.fees}}\">Fees</a>\n" +
    "      </li>\n" +
    "      <li ng-show=\"brand.programLegal['help']\">\n" +
    "        <a href=\"{{brand.programLegal.help}}\" title=\"\">Help</a>\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <a ui-sref=\"root.login\" title=\"\">Log In</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    <div class=\"mobile-nav\" ng-click=\"expanded = !expanded\">\n" +
    "      <span class=\"icon-menu-burger\"></span>Menu\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ul class=\"mobile-nav-menu\" ng-show=\"expanded\" ng-click=\"expanded = !expanded\" ng-if=\"!header.secondaryLinks\">\n" +
    "    <li>\n" +
    "      <a ng-hide=\"brand.ssoHide\" href=\"/app/#/member/{{username}}/\">Home</a>\n" +
    "      <a ng-show=\"brand.ssoHide\" href=\"{{brand.homeUrl}}\">Home</a>\n" +
    "    </li>\n" +
    "    <li ng-repeat=\"link in brand.headerLinks track by $index\">\n" +
    "      <a href=\"{{link.url}}\">{{link.text}}</a>\n" +
    "    </li>\n" +
    "    <li ng-if=\"isDashboard\">\n" +
    "      <a ui-sref=\"member.home.profile.step1\">My Account</a>\n" +
    "    </li>\n" +
    "    <li ng-if=\"isDashboard\">\n" +
    "      <a ui-sref=\"logout\">Logout</a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "  <ul class=\"mobile-nav-menu\" ng-show=\"expanded\" ng-click=\"expanded = !expanded\" ng-if=\"header.secondaryLinks\">\n" +
    "    <li>\n" +
    "      <a ui-sref=\"root.register.step1\">Register a card</a>\n" +
    "    </li>\n" +
    "    <li ng-show=\"brand.programLegal['fees']\">\n" +
    "      <a href=\"{{brand.programLegal.fees}}\">Fees</a>\n" +
    "    </li>\n" +
    "    <li ng-show=\"brand.programLegal['help']\">\n" +
    "      <a href=\"{{brand.programLegal.help}}\" title=\"\">Help</a>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "      <a ui-sref=\"root.login\" title=\"\">Log In</a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/cdd-info.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/cdd-info.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "    <div class=\"modern-widget-main\">\n" +
    "        <ul name=\"joinForm\" ng-form=\"joinForm\">\n" +
    "            <li>\n" +
    "                <div\n" +
    "                        class=\"input-full\"\n" +
    "                        ng-class='{ \"has-focus\": joinForm.employer.hasFocus,\n" +
    "                     \"has-success\": joinForm.employer.$valid,\n" +
    "                     \"has-error\": joinForm.employer.$invalid && (submitted || joinForm.employer.$touched),\n" +
    "                     \"is-empty\": !joinForm.employer.$viewValue }'>\n" +
    "                    <label for=\"employer\">Employer</label>\n" +
    "                    <input\n" +
    "                            id=\"employer\"\n" +
    "                            class=\"radius-all\"\n" +
    "                            type=\"text\"\n" +
    "                            name=\"employer\"\n" +
    "                            pattern=\"[A-Za-z ]+\"\n" +
    "                            tabindex=\"1\"\n" +
    "                            ng-model=\"formData.Employer\"\n" +
    "                            required\n" +
    "                            ng-focus='joinForm.employer.hasFocus=true'\n" +
    "                            ng-blur='joinForm.employer.hasFocus=false'>\n" +
    "                </div>\n" +
    "                <div class=\"error-red input-full\">\n" +
    "                    <span ng-show=\"joinForm.employer.$error.required && submitted\">*Please provide your employer.</span>\n" +
    "                    <span ng-show=\"joinForm.employer.$error.pattern\">*Special characters may not be used.</span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "                <div\n" +
    "                        class=\"input-full\"\n" +
    "                        ng-class='{ \"has-focus\": joinForm.occupation.hasFocus,\n" +
    "                     \"has-success\": joinForm.occupation.$valid,\n" +
    "                     \"has-error\": joinForm.occupation.$invalid && (submitted || joinForm.occupation.$touched),\n" +
    "                     \"is-empty\": !joinForm.occupation.$viewValue }'>\n" +
    "                    <label for=\"occupation\">Occupation</label>\n" +
    "                    <input\n" +
    "                            id=\"occupation\"\n" +
    "                            class=\"radius-all\"\n" +
    "                            type=\"text\"\n" +
    "                            name=\"occupation\"\n" +
    "                            pattern=\"[A-Za-z ]+\"\n" +
    "                            tabindex=\"1\"\n" +
    "                            ng-model=\"formData.Occupation\"\n" +
    "                            required\n" +
    "                            ng-focus='joinForm.occupation.hasFocus=true'\n" +
    "                            ng-blur='joinForm.occupation.hasFocus=false'>\n" +
    "                </div>\n" +
    "                <div class=\"error-red input-full\">\n" +
    "                    <span ng-show=\"joinForm.occupation.$error.required && submitted\">*Please provide your occupation.</span>\n" +
    "                    <span ng-show=\"joinForm.occupation.$error.pattern\">*Special characters may not be used.</span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"floatingForm-li\">\n" +
    "                <div>\n" +
    "                    <label for=\"countryCode\">Country of citizenship</label>\n" +
    "                    <select id=\"countryCode\" class=\"first force-dropdown-arrow\" tabindex=\"5\" ng-model=\"formData.Country\" ng-options=\"country.code as country.name for country in countries\" required>\n" +
    "                        <option value=\"\" ng-if=\"!formData.Country\" disabled selected>Select Country of Citizenship</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "                <div class=\"error-red input-full\">\n" +
    "                    <span ng-show=\"!formData.Country && submitted\">*Please provide your country of citizenship.</span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"floatingForm-li\">\n" +
    "                <div>\n" +
    "                    <label for=\"primarySourceOfFunds\">Primary Source of Funds</label>\n" +
    "                    <select id=\"primarySourceOfFunds\" class=\"first force-dropdown-arrow\" tabindex=\"5\" ng-model=\"formData.PrimarySource\" required>\n" +
    "                        <option value=\"\" ng-if=\"!formData.PrimarySource\">Select Primary Source of Funds</option>\n" +
    "                        <option value=\"paycheck\">Paycheck</option>\n" +
    "                        <option value=\"government benefits\">Government Benefits</option>\n" +
    "                        <option value=\"retirement\">Retirement</option>\n" +
    "                        <option value=\"cash\">Cash</option>\n" +
    "                        <option value=\"other\">Other</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "                <div class=\"error-red input-full\">\n" +
    "                    <span ng-show=\"!formData.PrimarySource && submitted\">*Please select your primary source of funds.</span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"floatingForm-li\">\n" +
    "                <div>\n" +
    "                    <label for=\"primaryUseOfAccount\">Primary Use of Account</label>\n" +
    "                    <select id=\"primaryUseOfAccount\" class=\"first force-dropdown-arrow\" tabindex=\"5\" ng-model=\"formData.PrimaryUse\" required>\n" +
    "                        <option value=\"\" ng-if=\"!formData.PrimaryUse\" disabled selected>Select Primary Use of Account</option>\n" +
    "                        <option value=\"household expense\">Household Expenses</option>\n" +
    "                        <option value=\"investment\">Investment</option>\n" +
    "                        <option value=\"savings\">Savings</option>\n" +
    "                        <option value=\"other\">Other</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "                <div class=\"error-red input-full\">\n" +
    "                    <span ng-show=\"!formData.PrimaryUse && submitted\">*Please select your primary use of your account.</span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "    <div ng-show=\"!loading\">\n" +
    "        <a class=\"btn btn--float-right\" id=\"finish-btn\" ng-click=\"finalizeStep4(joinForm)\">Finish</a>\n" +
    "        <a class=\"btn btn-light\" ui-sref=\"{{backStep4}}\">Back</a>\n" +
    "    </div>\n" +
    "    <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "        <span class=\"loading-indicator\"></span>\n" +
    "        <p>Processing</p>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/contact-info.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/contact-info.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul>\n" +
    "      <li class=\"contact-first-name\">\n" +
    "        <div class=\"first-name\">\n" +
    "          <label for=\"firstName\">First name</label>\n" +
    "          <input\n" +
    "            tabindex=\"1\"\n" +
    "            id=\"firstName\"\n" +
    "            type=\"text\"\n" +
    "            value=\"\"\n" +
    "            ng-model=\"formData.FirstName\">\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please provide your legal first name.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"contact-last-name\">\n" +
    "        <div class=\"last-name\">\n" +
    "          <label for=\"lastName\">Last name</label>\n" +
    "          <input\n" +
    "            tabindex=\"2\"\n" +
    "            id=\"lastName\"\n" +
    "            type=\"text\"\n" +
    "            value=\"\"\n" +
    "            ng-model=\"formData.LastName\">\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please provide your legal last name.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"contact-street-1\">\n" +
    "        <div class=\"street-address-1\">\n" +
    "          <label for=\"streetAddress1\">Street address\n" +
    "            <span\n" +
    "               ng-show=\"joinForm.streetAddress1.$invalid\"\n" +
    "               class=\"inputHelper\">\n" +
    "              Oops, we do not accept PO box's\n" +
    "            </span>\n" +
    "          </label>\n" +
    "          <input\n" +
    "             tabindex=\"3\"\n" +
    "             id=\"streetAddress1\"\n" +
    "             name=\"streetAddress1\"\n" +
    "             type=\"text\"\n" +
    "             value=\"\"\n" +
    "             validate-po-box\n" +
    "             ng-model=\"formData.StreetAddress\">\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Your card will be sent to this address. P.O. boxes cannot be used, please enter your physical address. You may only enter up to 30 characters in this field. Please use Address Line 2 if you need to enter additional information.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"contact-address-2\">\n" +
    "        <div class=\"street-address-2\">\n" +
    "          <label for=\"streetAddress2\">Apt / Suite Number</label>\n" +
    "          <input tabindex=\"4\" id=\"streetAddress2\" type=\"text\" value=\"\" ng-model=\"formData.SuiteNumber\">\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Optional Apt/Suite Number')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"contact-city\">\n" +
    "        <div class=\"city\">\n" +
    "          <label for=\"city\">City</label>\n" +
    "          <input tabindex=\"5\" id=\"city\" type=\"text\" value=\"\" ng-model=\"formData.City\">\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please provide your current city')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"contact-state-zip\">\n" +
    "        <div class=\"state\">\n" +
    "          <label for=\"state\">State</label>\n" +
    "          <select tabindex=\"6\" id=\"state\" ng-model=\"formData.State\" ng-options=\"s.key as s.state for s in states\">\n" +
    "            <option value=\"\" ng-if=\"!formData.State\">State</option>\n" +
    "          </select>\n" +
    "          <input type=\"hidden\" name=\"text\" value=\"{{ formData.State }}\" />\n" +
    "        </div>\n" +
    "        <div class=\"zip-code\">\n" +
    "          <label for=\"zipCode\">Zip code</label>\n" +
    "          <input tabindex=\"7\" id=\"zipCode\" type=\"text\" value=\"\" ng-model=\"formData.Zipcode\">\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Your card will be sent to this address. P.O. boxes cannot be used, please enter your physical address. You may only enter up to 30 characters in this field. Please use Address Line 2 if you need to enter additional information.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"contact-social-security-number\">\n" +
    "        <div class=\"social-security-number\">\n" +
    "          <label for=\"Ssn1\">Social security number</label>\n" +
    "          <div class=\"col-1-of-3\">\n" +
    "            <input ng-disabled=\"formData.NoSsn ? true : false\" tabindex=\"11\" auto-tab-to=\"Ssn2\" id=\"Ssn1\" type=\"password\" pattern=\"\\d*\" maxlength=\"3\" placeholder=\"\" value=\"\" ng-model=\"formData.Ssn1\">\n" +
    "          </div>\n" +
    "          <div class=\"col-1-of-3\">\n" +
    "            <input ng-disabled=\"formData.NoSsn ? true : false\" tabindex=\"12\" auto-tab-to=\"Ssn3\" id=\"Ssn2\" type=\"password\" pattern=\"\\d*\" maxlength=\"2\" placeholder=\"\" value=\"\" ng-model=\"formData.Ssn2\">\n" +
    "          </div>\n" +
    "          <div class=\"col-1-of-3 col-last\">\n" +
    "            <input ng-disabled=\"formData.NoSsn ? true : false\" tabindex=\"13\" id=\"Ssn3\" type=\"password\" pattern=\"\\d*\" maxlength=\"4\" placeholder=\"\" value=\"\" ng-model=\"formData.Ssn3\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please enter your 9-digit Social Security Number. You may enter in XXX-XX-XXXX or XXXXXXXXX formats. Why do we need your Social Security Number? - We use your SSN to verify your identity only.  We do not perform a credit check and we do not provide reports or information to any credit bureaus. ' + brand.programName + ' a trusted community and each member has been verified. The verification process is important to keep your account secure. If you lose your card or need to reset your password, you are required to enter the last 4 digits of your SSN. Verification is also required per the the US Patriot Act.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"checkbox-item\" tabindex=\"1\" ng-keyup=\"\" ng-click=\"clearSsn()\">\n" +
    "        <div id=\"nossn-checkbox\" class=\"checkbox-item__box\"\n" +
    "          ng-class=\"formData.NoSsn ? '' : 'checkbox-item__box--disabled'\" ng-click=\"formData.NoSsn = !formData.NoSsn\">\n" +
    "          <span class=\"checkbox-item__icon\"\n" +
    "            ng-class=\"formData.NoSsn ? 'icon-check' : ''\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <input\n" +
    "            ng-disabled=\"formData.NoSsn ? true : false\"\n" +
    "            class=\"checkbox-item__input\"\n" +
    "            type=\"checkbox\"\n" +
    "            name=\"NoSsn\"\n" +
    "            ng-model=\"formData.NoSsn\"\n" +
    "            >\n" +
    "          <h3 class=\"checkbox-item__title\">I do not have a Social Security Number</h3>\n" +
    "          <p>You will be required to provide a passport or ID card to complete enrollment.</p>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <div ng-show=\"!loading\">\n" +
    "    <a ng-show=\"validateAndSubmitBtn\" class=\"btn btn--float-right\" ng-click=\"validateAndSubmit(formData)\">Finish</a>\n" +
    "    <a ng-show=\"!validateAndSubmitBtn\" id=\"validateAndNext-btn\" class=\"btn btn--float-right\" ng-click=\"validateAndNext(formData)\">Next</a>\n" +
    "    <a class=\"btn btn-light\" ui-sref=\"{{backStep2}}\">Back</a>\n" +
    "  </div>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "    <span class=\"loading-indicator\"></span>\n" +
    "    <p>Processing</p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/email-verify.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/email-verify.html",
    "<div class=\"login-container\">\n" +
    "  <div class=\"login-box\">\n" +
    "    <div class=\"login-box-header\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1>Email Verification</h1>\n" +
    "    </div>\n" +
    "    <div class=\"login-box-body\">\n" +
    "      <form id=\"frm-login\" name=\"resetForm\" class=\"en-form reset-pw\">\n" +
    "        <div>\n" +
    "          <div class=\"alert\" ng-show=\"!loading\">\n" +
    "            <div ng-show=\"successVerification\">\n" +
    "              <span class=\"icon-thumbs-up\"></span>\n" +
    "              <p>Your email has been successfully verified!</p>\n" +
    "            </div>\n" +
    "            <div ng-show=\"!successVerification\">\n" +
    "              <span class=\"icon-warning-triangle\"></span>\n" +
    "              <p>Oops, we were unable to verify your email.</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "            <span class=\"loading-indicator\"></span>\n" +
    "            <p>Processing</p>\n" +
    "          </div>\n" +
    "          <div class=\"feedback\" ng-show=\"!loading\">\n" +
    "            <p>Please close this window and return to enrollment{{!successVerification ? ' and try again' : ''}}.</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/esign-disclosure.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/esign-disclosure.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-controller=\"esignDisclosureCtrl as vm\">\n" +
    "\n" +
    "    <!-- E-Sign Disclosure Section -->\n" +
    "    <div ng-if=\"vm.section1\">\n" +
    "        <h3 class=\"exMarginBtm\">Read the E-Sign Disclosure below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the E-Sign Disclosure.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcDisclosure) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.eSignDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.eSignErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-esign\" class=\"btn btn-register\" ng-click=\"vm.section1 = false; vm.section2 = true; vm.eSignAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.eSignAgreed\">\n" +
    "        <h3 class=\"exMarginBtm\">E-Sign Disclosure Document</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to E-Sign Disclosure\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Cardholder Agreement Section -->\n" +
    "    <div ng-if=\"vm.section2\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Cardholder Agreement below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Cardholder Agreement.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcAgreement) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.cardholderAgreementDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.cardholderAgreementErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-agreement\" class=\"btn btn-register\" ng-click=\"vm.section2 = false; vm.section3 = true; vm.disclosureAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.disclosureAgreed\" style=\"padding-top: 60px\">\n" +
    "        <h3 class=\"exMarginBtm\">Cardholder Agreement Document</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to Cardholder Agreement Document\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Privacy Policy Section -->\n" +
    "    <div ng-if=\"vm.section3\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Sunrise Banks Privacy Policy below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Sunrise Banks Privacy Policy.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcPrivacyDownload, 'Sunrise_Banks_Privacy_Policy.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcPrivacy) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\"\n" +
    "        >\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.privacyPolicyDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.privacyPolicyErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-privacypolicy\" class=\"btn btn-register\" ng-click=\"vm.section3 = false; vm.section4 = true; vm.privacyAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.privacyAgreed\" style=\"padding-top: 60px\">\n" +
    "        <h3 class=\"exMarginBtm\">Sunrise Bank's Privacy Policy</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to the Sunrise Bank's Privacy Policy\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcPrivacyDownload, 'Sunrise_Banks_Privacy_Policy.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Fee Schedule Section -->\n" +
    "    <div ng-if=\"vm.section4\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Fees Schedule below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Fees Schedule.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.feesScheduleDownload, 'Fee_Schedule.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                src=\"{{ vm.trustSrc(vm.feesSchedule) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.cardholderAgreementDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.cardholderAgreementErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-fees\" class=\"btn btn-register\" ng-click=\"vm.Finish('root.join.step2')\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/fee-schedule.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/fee-schedule.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <p>\n" +
    "    <a target=\"_blank\" ng-href=\"{{ feeSchedule.pdfSrc }}\">Download the Fee Schedule.</a>\n" +
    "  </p>\n" +
    "  <br/>\n" +
    "  <iframe\n" +
    "    src=\"{{ feeSchedule.trustSrc(feeSchedule.pdfSrc + '#toolbar=0') }}\"\n" +
    "    width=\"100%\"\n" +
    "    height=\"600px\"\n" +
    "    style=\"border: none;\">\n" +
    "  </iframe>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <a id=\"btn-fee-schedule\" class=\"btn btn-register\" ng-click=\"feeSchedule.goTo('root.join.step2')\">Next</a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/getting-started.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/getting-started.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul>\n" +
    "      <li class=\"reduced-input\">\n" +
    "        <label for=\"email\">Email\n" +
    "            <span\n" +
    "            ng-show=\"!validation.uniqueEmail && validation.validEmail && validation.emailBlurred\"\n" +
    "            class=\"inputHelper\">\n" +
    "              This email has already been taken\n" +
    "            </span>\n" +
    "            <span\n" +
    "              ng-show=\"!validation.validEmail && validation.emailBlurred\"\n" +
    "              class=\"inputHelper\">\n" +
    "                Please provide a valid email\n" +
    "            </span>\n" +
    "          </label>\n" +
    "        <input\n" +
    "          id=\"email\"\n" +
    "          type=\"email\"\n" +
    "          tabindex=\"1\"\n" +
    "          ng-model=\"formData.Email\"\n" +
    "          ng-blur=\"checkEmail(formData.Email)\"\n" +
    "          required/>\n" +
    "        <span ng-show=\"validation.uniqueEmail && validation.validEmail\" class=\"icon-check check check-green\"></span>\n" +
    "        <span ng-show=\"!validation.validEmail || !validation.uniqueEmail\" class=\"icon-check check check-gray\"></span>\n" +
    "      </li>\n" +
    "      <li class=\"security-password reduced-input\">\n" +
    "        <div class=\"password\">\n" +
    "          <label for=\"password\">Password <span ng-show=\"joinForm.Password.$invalid && passwordBlurred\" class=\"inputHelper\">At least 8 characters and 1 number</span></label>\n" +
    "          <input\n" +
    "                  id=\"password\"\n" +
    "                  name=\"Password\"\n" +
    "                  type=\"password\"\n" +
    "                  tabindex=\"2\"\n" +
    "                  ng-model=\"formData.Password\"\n" +
    "                  ng-blur=\"passwordBlurred = true;\"\n" +
    "                  validate-password\n" +
    "                  required>\n" +
    "          <span ng-show=\"joinForm.Password.$valid\" class=\"icon-check check check-green\"></span>\n" +
    "          <span ng-show=\"joinForm.Password.$invalid\" class=\"icon-check check check-gray\"></span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"reduced-input\">\n" +
    "        <div class=\"confirm-password\">\n" +
    "          <label for=\"confirmPassword\">Confirm password</label>\n" +
    "          <input\n" +
    "                  id=\"confirmPassword\"\n" +
    "                  name=\"Password1\"\n" +
    "                  type=\"password\"\n" +
    "                  tabindex=\"3\"\n" +
    "                  ng-model=\"formData.Password1\"\n" +
    "                  confirm-password\n" +
    "                  required>\n" +
    "          <span ng-show=\"joinForm.Password1.$valid\" class=\"icon-check check check-green\"></span>\n" +
    "          <span ng-show=\"joinForm.Password1.$invalid\" class=\"icon-check check check-gray\"></span>\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please provide a password for your account.Your password must be at least eight (8) characters and have at least one (1) number.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"contact-phone\">\n" +
    "        <div class=\"phone-number\">\n" +
    "          <label for=\"Phone1\">Mobile Phone</label>\n" +
    "          <div class=\"col-1-of-3\">\n" +
    "            <input tabindex=\"2\" auto-tab-to=\"Phone2\" maxlength=\"3\" id=\"Phone1\" type=\"text\" pattern=\"\\d*\" placeholder=\"\" value=\"\" ng-model=\"formData.Phone1\" ng-change=\"updatePhone()\">\n" +
    "          </div>\n" +
    "          <div class=\"col-1-of-3\">\n" +
    "            <input tabindex=\"3\" auto-tab-to=\"Phone3\" maxlength=\"3\" id=\"Phone2\" type=\"text\" pattern=\"\\d*\" placeholder=\"\" value=\"\" ng-model=\"formData.Phone2\" ng-change=\"updatePhone()\">\n" +
    "          </div>\n" +
    "          <div class=\"col-1-of-3 col-last\">\n" +
    "            <input tabindex=\"4\" maxlength=\"4\" id=\"Phone3\" type=\"text\" pattern=\"\\d*\" placeholder=\"\" value=\"\" ng-model=\"formData.Phone3\" ng-change=\"updatePhone()\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"birth-date\" ng-show=\"joinType != 'register'\">\n" +
    "        <label for=\"birthDate1\">Date of birth</label>\n" +
    "        <select id=\"birthDate1\" class=\"first\" tabindex=\"5\" ng-model=\"formData.Dob1\" ng-options=\"month for month in range(1, 12)\">\n" +
    "          <option value=\"\" ng-if=\"!formData.Dob1\">Month</option>\n" +
    "        </select>\n" +
    "        <select id=\"birthDate2\" tabindex=\"6\" ng-model=\"formData.Dob2\" ng-options=\"day for day in range(1,31)\">\n" +
    "          <option value=\"\" ng-if=\"!formData.Dob2\">Day</option>\n" +
    "        </select>\n" +
    "        <select id=\"birthDate3\" tabindex=\"7\" ng-model=\"formData.Dob3\" ng-options=\"year for year in range(1900, latestAgeYear, true)\">\n" +
    "          <option value=\"\" ng-if=\"!formData.Dob3\">Year</option>\n" +
    "        </select>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please provide your date of birth. Your date of birth is requested to help validate your identity and for verification purposes when you contact us.')\"></a>\n" +
    "      </li>\n" +
    "      <li ng-show=\"joinType != 'register' && displayPromoCode\">\n" +
    "        <label for=\"promo_code\">Invitation Code <span ng-hide=\"requirePromo()\"><p>(Optional)</p></span>\n" +
    "        </label>\n" +
    "        <input id=\"promo_code\" type=\"text\" tabindex=\"8\" ng-required=\"requirePromo()\" ng-model=\"formData.PromoCode\">\n" +
    "        <a class=\"info\" ng-click=\"requirePromo() ? showAlert('An invitation code is required to enroll. If you have an invitation code, please enter it here.') : showAlert('Please enter an invitation code here.')\"></a>\n" +
    "      </li>\n" +
    "      <li ng-show=\"joinType != 'register'\">\n" +
    "        <label ng-hide=\"brand.hideEnrollmentCardDesign\">{{cardStyles.cards.length > 1 ? \"Select your card style\" : \"Card style\"}}</label>\n" +
    "        <div class=\"card-checkbox\" ng-repeat=\"card in cardStyles.cards track by $index\" ng-init=\"formData.CardDesignId=cardStyles.cards[0]\">\n" +
    "          <label ng-hide=\"brand.hideEnrollmentCardDesign\">\n" +
    "            <input class=\"card-checkbox__input\" ng-model=\"formData.CardDesignId\" name=\"cards\" type=\"radio\" checked=\"checked\" value=\"{{card}}\">\n" +
    "            <div class=\"card-checkbox__check\">\n" +
    "              <span class=\"icon-check\"></span>\n" +
    "            </div>\n" +
    "            <img ng-src=\"assets/images/{{cardStyles.name}}/card-{{card}}.png\">\n" +
    "          </label>\n" +
    "        </div>\n" +
    "        <input ng-show=\"false\" type=\"checkbox\" ng-model=\"formData.Virtual\" class=\"enrollment-checkbox\" tabindex=\"9\"><div ng-show=\"false\" class=\"checkbox-label\" ng-click=\"formData.Virtual = !formData.Virtual\" >Skip the plastic and create a virtual card</div>\n" +
    "      </li>\n" +
    "      <text-alerts-checkbox form-data=\"formData\"/>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div ng-show=\"displaySideImage\" class=\"modern-widget-right\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <a id='nextBtn' class=\"btn btn-register\" ng-click=\"validate(formData)\">Next</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/selectVerificationMethod.html'\"></div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/join/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/layout.html",
    "<div class=\"overlay modern-widget join\">\n" +
    "  <div class=\"overlay-header\">\n" +
    "    <div class=\"overlay-header-main\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1 class=\"uppercase\">{{joinTitle}}</h1>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-header bg-gray\">\n" +
    "    <div class=\"modern-widget-info bg-white\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\" ui-view=\"header\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-body\">\n" +
    "    <div class=\"modern-widget-main\">\n" +
    "      <form ng-class=\"parent.formType\" name=\"joinForm\">\n" +
    "        <div ui-view=\"step\"></div>\n" +
    "        <div class=\"modern-widget-section bg-gray\">\n" +
    "          <div class=\"footnotes akimbo-footer\">\n" +
    "            <p ng-if=\"showFooterAsterisks\">* Standard text message rates, fees and charges may apply.</p>\n" +
    "            <p class=\"disclaimer\">\n" +
    "            Important information for opening a card account: To help the federal government fight the funding of terrorism and money laundering activities, the USA PATRIOT Act requires all financial institutions and their third parties to obtain, verify and record information that identifies each person who opens a card account. What this means for you: When you open a card account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see a copy of your driver's license or other identifying documents.\n" +
    "            </p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "  </div><!-- .overlay-body -->\n" +
    "</div><!-- .overlay -->\n" +
    "<div ng-show=\"alertError.show\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\" ng-show=\"alertError.message\">{{alertError.message}}<br/></p>\n" +
    "        <p class=\"con-large\" ng-show=\"alertError.brandLogin === true\"><a href=\"{{alertError.loginLink}}\">Cardholder Login</a><br/></p>\n" +
    "        <p class=\"con-large\" ng-show\"alertError.cardNotFoundLinkLogin\">We couldn't find a card associated with the provided information; this card may have already been collected. If you have an existing account, please <a ui-sref=\"root.login\" class=\"underline\">log in</a>.<br/></p>\n" +
    "        <p class=\"con-large\" ng-show=\"alertError.resetPassword\">If you forgot your username or password, please reset it <a ui-sref=\"root.resetpassword.step1\" class=\"underline\">here</a><br/></p>\n" +
    "        <p class=\"con-large\" ng-show=\"alertError.login\">In order to activate this card, please <a ui-sref=\"root.login\" class=\"underline\">log in</a>. If you don't have login credentials, please <a ui-sref=\"root.register.step1\" class=\"underline\">register</a>.<br/></p>\n" +
    "        <br/><p class=\"con-large\">If you continue to have problems please contact customer service at {{brand.programContactPhone}}.</p>\n" +
    "        <a class=\"btn btn-full-width\" ng-if=\"!alertError.toLogin\" ng-click=\"alertError.show = !alertError.show\">OK</a>\n" +
    "        <a class=\"btn btn-full-width\" ng-if=\"alertError.toLogin\" ui-sref=\"root.login\">OK, got it</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.overlayLoading\" class=\"overlay-wrapper\">\n" +
    "  <div class=\"overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.fullOverlayLoading\" class=\"overlay-wrapper\">\n" +
    "  <div class=\"full-overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/mobile-welcome.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/mobile-welcome.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/join-welcome.png\" alt=\"\">\n" +
    "    <div class=\"text-center\">\n" +
    "        <a class=\"btn\" href=\"akimbocardaction://x-callback-url/close\">Log in to Dashboard</a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/join/security.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/security.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "    <div class=\"modern-widget-left\">\n" +
    "        <ul>\n" +
    "            <li class=\"security-username reduced-input\">\n" +
    "                <div class=\"username\">\n" +
    "                    <label for=\"username\">Username <span ng-show=\"!validation.validUsername && validation.usernameBlurred\" class=\"inputHelper\">Username Must Be At least 6 characters</span><span ng-show=\"validation.validUsername && validation.usernameBlurred && !validation.uniqueUsername\" class=\"inputHelper\">Username Is Already Taken</span></label>\n" +
    "                    <input\n" +
    "                            id=\"username\"\n" +
    "                            name=\"Username\"\n" +
    "                            type=\"text\"\n" +
    "                            tabindex=\"1\"\n" +
    "                            ng-model=\"formData.Username\"\n" +
    "                            ng-blur=\"checkUsername(formData.Username)\"\n" +
    "                            required>\n" +
    "                    <span ng-show=\"validation.validUsername && validation.uniqueUsername\" class=\"icon-check check check-green\"></span>\n" +
    "                    <span ng-show=\"!validation.validUsername || !validation.uniqueUsername\" class=\"icon-check check check-gray\"></span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"security-password reduced-input\">\n" +
    "                <div class=\"password\">\n" +
    "                    <label for=\"password\">Password <span ng-show=\"joinForm.Password.$invalid && passwordBlurred\" class=\"inputHelper\">At least 8 characters and 1 number</span></label>\n" +
    "                    <input\n" +
    "                            id=\"password\"\n" +
    "                            name=\"Password\"\n" +
    "                            type=\"password\"\n" +
    "                            tabindex=\"2\"\n" +
    "                            ng-model=\"formData.Password\"\n" +
    "                            ng-blur=\"passwordBlurred = true;\"\n" +
    "                            validate-password\n" +
    "                            required>\n" +
    "                    <span ng-show=\"joinForm.Password.$valid\" class=\"icon-check check check-green\"></span>\n" +
    "                    <span ng-show=\"joinForm.Password.$invalid\" class=\"icon-check check check-gray\"></span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"reduced-input\">\n" +
    "                <div class=\"confirm-password\">\n" +
    "                    <label for=\"confirmPassword\">Confirm password</label>\n" +
    "                    <input\n" +
    "                            id=\"confirmPassword\"\n" +
    "                            name=\"Password1\"\n" +
    "                            type=\"password\"\n" +
    "                            tabindex=\"3\"\n" +
    "                            ng-model=\"formData.Password1\"\n" +
    "                            confirm-password\n" +
    "                            required>\n" +
    "                    <span ng-show=\"joinForm.Password1.$valid\" class=\"icon-check check check-green\"></span>\n" +
    "                    <span ng-show=\"joinForm.Password1.$invalid\" class=\"icon-check check check-gray\"></span>\n" +
    "                </div>\n" +
    "                <a class=\"info\" ng-click=\"showAlert('Please provide a password for your account.Your password must be at least eight (8) characters and have at least one (1) number.')\"></a>\n" +
    "            </li>\n" +
    "            <li class=\"security-question\">\n" +
    "                <div class=\"question\">\n" +
    "                    <label for=\"securityQuestion1\">Security question 1</label>\n" +
    "                    <select\n" +
    "                            id=\"securityQuestion1\"\n" +
    "                            tabindex=\"4\"\n" +
    "                            ng-model=\"formData.SecurityQuestionOption1\"\n" +
    "                            ng-options=\"q.label for q in questions track by q.key\">\n" +
    "                        <option value=\"\" ng-if=\"!formData.SecurityQuestionOption1\">Choose a question</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "                <div class=\"answer\">\n" +
    "                    <label for=\"answer1\">Answer</label>\n" +
    "                    <input id=\"answer1\" type=\"text\" tabindex=\"5\" ng-model=\"formData.SecurityAnswer1\">\n" +
    "                </div>\n" +
    "                <a class=\"info\" ng-click=\"showAlert('Please choose a security question')\"></a>\n" +
    "            </li>\n" +
    "            <li class=\"security-question\">\n" +
    "                <div class=\"question\">\n" +
    "                    <label for=\"SecurityQuestion2\">Security question 2</label>\n" +
    "                    <select\n" +
    "                            id=\"SecurityQuestion2\"\n" +
    "                            tabindex=\"6\"\n" +
    "                            ng-model=\"formData.SecurityQuestionOption2\"\n" +
    "                            ng-options=\"q.label for q in questions track by q.key\">\n" +
    "                        <option value=\"\" ng-if=\"!formData.securityQuestionOption2\">Choose a question</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "                <div class=\"answer\">\n" +
    "                    <label for=\"answer2\">Answer</label>\n" +
    "                    <input id=\"answer2\" type=\"text\" tabindex=\"7\" ng-model=\"formData.SecurityAnswer2\">\n" +
    "                </div>\n" +
    "                <a class=\"info\" ng-click=\"showAlert('Please choose another security question')\"></a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <div class=\"modern-widget-right\">\n" +
    "        <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "    <div ng-show=\"!loading\">\n" +
    "        <a class=\"btn btn--float-right\" id=\"finish-btn\" ng-click=\"validateStep3(formData)\">Finish</a>\n" +
    "        <a class=\"btn btn-light\" ui-sref=\"{{backStep3}}\">Back</a>\n" +
    "    </div>\n" +
    "    <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "        <span class=\"loading-indicator\"></span>\n" +
    "        <p>Processing</p>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/success.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "  <p class=\"modern-widget-warning-text\">{{ successMessage }}<br/>\n" +
    "  <img ng-src=\"assets/images/{{brand.name}}/join-welcome.png\" alt=\"\">\n" +
    "  <div class=\"text-center\">\n" +
    "    <a id='dashboardBtn' class=\"btn btn--float-right\" ng-click=\"goToDashboard()\">Continue To Dashboard</a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"alertError.show\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{alertError.message}}<br/>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"alertError.show = !alertError.show\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.overlayLoading\" class=\"overlay-wrapper\">\n" +
    "  <div class=\"overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/wait-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/wait-list.html",
    "<div class=\"overlay-body\" id=\"userInput\">\n" +
    "  <div class=\"modern-widget-main\">\n" +
    "    <div class=\"modern-widget-section modern-form-section bg-white join-email-section\" ng-show=\"!joinEmailSuccess\">\n" +
    "      <span\n" +
    "        ng-show=\"attempted\"\n" +
    "        class=\"joinEmailHelper\">\n" +
    "          Please provide a valid email\n" +
    "      </span>\n" +
    "      <div class=\"validateCodeInput\">\n" +
    "        <input\n" +
    "          name=\"joinEmail\"\n" +
    "          placeholder=\"email\"\n" +
    "          required=\"true\"\n" +
    "          type=\"email\"\n" +
    "          class=\"joinEmailInput\"\n" +
    "          ng-model=\"formData.joinEmail\"/>\n" +
    "      </div>\n" +
    "      <a class=\"btn\" ng-click=\"submitEmail(joinForm)\">JOIN</a>\n" +
    "    </div>\n" +
    "    <div class=\"modern-widget-section modern-form-section bg-white\" ng-show=\"joinEmailSuccess\">\n" +
    "      <h1 class=\"joinEmailSuccess\">Thanks, you'll be hearing from us soon!</h1>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/join/welcome.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/join/welcome.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "  <img ng-src=\"assets/images/{{brand.name}}/join-welcome.png\" alt=\"\">\n" +
    "  <div id=\"welcome-options\" class=\"text-center\">\n" +
    "    <a id=\"welcome-dash-btn\" class=\"btn\" ui-sref=\"member.home\">Continue to Dashboard</a>\n" +
    "    <a class=\"btn\" ui-sref=\"member.home.directdeposit.step1\">Direct Deposit</a>\n" +
    "    <a class=\"btn\" ui-sref=\"member.home.bank/add.step1\">Link Bank Account</a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/legal/privacy-policy.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/legal/privacy-policy.html",
    "<!DOCTYPE html><html lang=\"en\"><head><meta charSet=\"utf-8\"/><link rel=\"stylesheet\" href=\"/app/assets/css/privacy-policy.css\" data-precedence=\"next\"/><title>Create Next App</title><meta name=\"description\" content=\"Generated by create next app\"/><meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/><link rel=\"icon\" href=\"/favicon.ico\" type=\"image/x-icon\" sizes=\"16x16\"/><meta name=\"next-size-adjust\"/></head><body class=\"__className_20951f\"><main class=\"bg-white text-white flex justify-center p-24 max-w-screen-lg\"><div class=\"flex min-h-screen flex-col items-center max-w-screen-lg\"><div class=\"border-b border-black flex font-bold items-center w-full\"><div class=\"bg-neutral-800 text-white p-2 w-32 text-bold text-xl\">FACTS</div><div class=\"text-black flex-1 text-sm p-2\">WHAT DOES SUNRISE BANKS, N.A. DO WITH YOUR PERSONAL INFORMATION?</div></div><div class=\"border border-neutral-400 flex font-normal mt-2 text-lg w-full\"><div class=\"bg-neutral-400 font-bold text-white p-2 w-32\">Why?</div><div class=\"text-black text-sm p-3 pr-4 flex-1 whitespace-pre-line\">Financial Companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share and protect your personal information. Please read this notice carefully to understand what we do</div></div><div class=\"border border-neutral-400 flex font-normal mt-2 text-lg w-full\"><div class=\"bg-neutral-400 font-bold text-white p-2 w-32\">What?</div><div class=\"text-black text-sm p-3 pr-4 flex-1 whitespace-pre-line\">The types of personal information that we collect and share depend on the product or service you have with us. This can include:\n" +
    "\n" +
    "    • Social Security Number and Date of Birth\n" +
    "    • Address of Residence and Government Issued Identification\n" +
    "    • Transaction History\n" +
    "\n" +
    "When you are no longer our customer, we continue to share your information as described in this notice.</div></div><div class=\"border border-neutral-400 flex font-normal mt-2 text-lg w-full\"><div class=\"bg-neutral-400 font-bold text-white p-2 w-32\">How?</div><div class=\"text-black text-sm p-3 pr-4 flex-1 whitespace-pre-line\">All Financial Companies need to share customers’ personal information to run their everyday business. In the section below, we list the reasons Financial Companies can share their customers&#x27; personal information; the reasons Sunrise Banks, N.A. chooses to share; and whether you can limit the sharing.</div></div><div class=\"bg-neutral-400 p-2 w-full flex font-bold text-sm items-center mt-2\"><div class=\"w-1/2\">Reasons we can share your personal information</div><div class=\"flex-1\">Does Sunrise Banks, N.A. Share?</div><div class=\"flex-1\">Can you limit this sharing?</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"w-1/2 p-2\"><div class=\"bg-white font-bold text-black text-sm\">For our everyday business purposes –</div><div class=\"text-black pr-4 text-sm\">such as: to process your transaction, maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus.</div></div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">Yes</div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">No</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"w-1/2 p-2\"><div class=\"bg-white font-bold text-black text-sm\">For our marketing purposes –</div><div class=\"text-black pr-4 text-sm\">to offer our products and services to you.</div></div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">Yes</div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">No</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"w-1/2 p-2\"><div class=\"bg-white font-bold text-black text-sm\">For joint marketing with other financial companies.</div><div class=\"text-black pr-4 text-sm\"></div></div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">Yes</div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">No</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"w-1/2 p-2\"><div class=\"bg-white font-bold text-black text-sm\">For our affiliates’ everyday business purposes –</div><div class=\"text-black pr-4 text-sm\">information about your transactions and experiences.</div></div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">Yes</div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">No</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"w-1/2 p-2\"><div class=\"bg-white font-bold text-black text-sm\">For our affiliates’ everyday business purposes –</div><div class=\"text-black pr-4 text-sm\">information about your creditworthiness.</div></div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">No</div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">We don&#x27;t share</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"w-1/2 p-2\"><div class=\"bg-white font-bold text-black text-sm\">For our affiliates to market to you.</div><div class=\"text-black pr-4 text-sm\"></div></div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">No</div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">We don&#x27;t share</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"w-1/2 p-2\"><div class=\"bg-white font-bold text-black text-sm\">For non affiliates to market to you.</div><div class=\"text-black pr-4 text-sm\"></div></div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">No</div><div class=\"text-black text-sm p-3 flex-1 border-neutral-400 border-l\">We don&#x27;t share</div></div><div class=\"border border-neutral-400 flex font-normal mt-2 text-lg w-full\"><div class=\"bg-neutral-400 font-bold text-white p-2 w-32\">Questions?</div><div class=\"text-black text-sm p-3 pr-4 flex-1 whitespace-pre-line\">Call 1-855-449-2273</div></div><div class=\"bg-neutral-400 p-2 w-full flex font-bold text-sm items-center mt-2\">Who we are</div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"bg-white font-bold text-black text-sm w-2/5 p-2 pr-4 flex-none\">Who is providing this notice?</div><div class=\"border-l border-neutral-400 text-black text-sm p-3 pr-4 whitespace-pre-line\">Sunrise Banks, N.A</div></div><div class=\"bg-neutral-400 p-2 w-full flex font-bold text-sm items-center mt-2\">What we do</div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"bg-white font-bold text-black text-sm w-2/5 p-2 pr-4 flex-none\">How does Sunrise Banks, N.A.\n" +
    "protect my personal information?</div><div class=\"border-l border-neutral-400 text-black text-sm p-3 pr-4 whitespace-pre-line\">To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards, secured files and buildings.</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"bg-white font-bold text-black text-sm w-2/5 p-2 pr-4 flex-none\">How does Sunrise Banks, N.A. collect\n" +
    "my personal information?</div><div class=\"border-l border-neutral-400 text-black text-sm p-3 pr-4 whitespace-pre-line\">We collect personal information, for example, when you\n" +
    "\n" +
    "    • Open a Card Account or use your card\n" +
    "    • Pay your bills or make a purchase\n" +
    "    • Give us your contact information\n" +
    "\n" +
    "We also collect your personal information from others, such as credit bureaus, affiliates, or other companies.</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"bg-white font-bold text-black text-sm w-2/5 p-2 pr-4 flex-none\">Why can’t I limit all sharing?</div><div class=\"border-l border-neutral-400 text-black text-sm p-3 pr-4 whitespace-pre-line\">Federal law gives you the right to limit only:\n" +
    "\n" +
    "    • Sharing for affiliates everyday business purposes- information about your\n" +
    "creditworthiness,\n" +
    "    • Affiliates from using your information to market to you,\n" +
    "    • Sharing for non affiliates to market to you.\n" +
    "\n" +
    "State laws and individual companies may give you additional rights to limit sharing</div></div><div class=\"bg-neutral-400 p-2 w-full flex font-bold text-sm items-center mt-2\">Definitions</div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"bg-white font-bold text-black text-sm w-2/5 p-2 pr-4 flex-none\">Affiliates</div><div class=\"border-l border-neutral-400 text-black text-sm p-3 pr-4 whitespace-pre-line\">Companies related by common ownership or control. They can be financial and\n" +
    "nonfinancial companies.\n" +
    "\n" +
    "    • Our affiliates include financial companies such as University Financial Corp.\n" +
    "dba Sunrise Banks.</div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"bg-white font-bold text-black text-sm w-2/5 p-2 pr-4 flex-none\">Non affiliates</div><div class=\"border-l border-neutral-400 text-black text-sm p-3 pr-4 whitespace-pre-line\">Companies not related by common ownership or control. They can be financial or nonfinancial companies.\n" +
    "\n" +
    "    • Sunrise Banks, N.A. does not share with nonaffiliates so they can market to\n" +
    "you. </div></div><div class=\"border-b border-l border-r border-neutral-400 flex text-xs w-full\"><div class=\"bg-white font-bold text-black text-sm w-2/5 p-2 pr-4 flex-none\">Joint Marketing</div><div class=\"border-l border-neutral-400 text-black text-sm p-3 pr-4 whitespace-pre-line\">A formal agreement between non affiliated financial companies that together market financial products or services to you.\n" +
    "\n" +
    "    • Our joint marketing partners include prepaid card companies.</div></div></div></main></body></html>\n" +
    "");
}]);

angular.module("../app/views/login/login.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/login/login.html",
    "<div ng-hide=\"brand.ssoHide\" class=\"login-container\">\n" +
    "  <div class=\"login-box\">\n" +
    "    <div class=\"login-box-header\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1 id=\"login-title\">Login</h1>\n" +
    "    </div>\n" +
    "    <div class=\"login-box-body\">\n" +
    "      <form id=\"frm-login\" ng-submit=\"login(credentials)\" form-auto-fill-fix>\n" +
    "        <div ng-show=\"displayMessage\" class=\"alert\">\n" +
    "          <span class=\"icon-warning-triangle\"></span>\n" +
    "          <p>{{displayMessageText}}</p>\n" +
    "        </div>\n" +
    "        <input type=\"text\" name=\"username\" id=\"username\" placeholder=\"Username or Email\" class=\"large\" ng-model=\"credentials.username\">\n" +
    "        <input type=\"password\" name=\"password\" id=\"password\" placeholder=\"Password\" class=\"large\" ng-model=\"credentials.password\">\n" +
    "        <input type=\"hidden\" name=\"promo_code\" value=\"\" id=\"promo_code\">\n" +
    "        <input type=\"hidden\" name=\"gs\" value=\"0\">\n" +
    "        <a id=\"forgot-password\" ng-hide=\"brand.name === 'akimboco' || brand.ssoHide\" ui-sref=\"root.resetpassword.step1\" class=\"link\">Forgot <span class=\"mobile-hide\">your</span> username <span class=\"mobile-hide\">or</span> <span class=\"mobile-show\">/</span> password?</a>\n" +
    "        <a ng-show=\"brand.name === 'akimboco'\" ui-sref=\"root.resetpassword.corporate\" class=\"link\">Forgot <span class=\"mobile-hide\">your</span> username <span class=\"mobile-hide\">or</span> <span class=\"mobile-show\">/</span> password?</a>\n" +
    "        <input ng-show=\"!loading\" type=\"submit\" id=\"login\" class=\"btn x-large\" value=\"Login\">\n" +
    "        <div ng-show=\"loading\" id=\"loading-login\" style=\"float:right;\">\n" +
    "          <span class=\"loading-indicator\"></span>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "    <div class=\"login-box-footer\">\n" +
    "      <a ng-hide=\"hideEnrollmentLink || enrollmentHyperLink\" ui-sref=\"{{enrollmentLink}}\" ng-class=\"!registrationLink && !registrationHyperLink ? 'last-child' : ''\">Don&#39;t have an account? Sign up here</a>\n" +
    "      <a ng-show=\"enrollmentHyperLink\" href=\"{{enrollmentHyperLink}}\" ng-class=\"!registrationLink && !registrationHyperLink ? 'last-child' : ''\">Don&#39;t have an account? Sign up here</a>\n" +
    "      <a ng-hide=\"hideRegistrationLink || registrationHyperLink\" ui-sref=\"{{registrationLink}}\" ng-class=\"'last-child'\">{{registrationText}}</a>\n" +
    "      <a ng-show=\"registrationHyperLink\" ng-class=\"'last-child'\" href=\"{{registrationHyperLink}}\">{{registrationText}}</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-include=\"'app/partials/selectVerificationMethod.html'\"></div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/login/loginFraud.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/login/loginFraud.html",
    "<div class=\"login-container\">\n" +
    "  <div class=\"login-box\">\n" +
    "    <div class=\"login-box-header\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1 id=\"login-title\">{{fraud.title}}</h1>\n" +
    "    </div>\n" +
    "    <div class=\"login-box-body\">\n" +
    "      <form id=\"frm-login\" name=\"resetForm\" class=\"en-form reset-pw\">\n" +
    "        <div class=\"alert\">\n" +
    "          <span class=\"icon-warning-triangle\"></span>\n" +
    "          <p>{{fraud.info}}</p>\n" +
    "        </div>\n" +
    "        <div>\n" +
    "          <p>{{fraud.helperText}}</p>\n" +
    "          <p>We certainly apologize for the inconvenince. If you have any questions about this request, please call us at <b class=\"underline\">{{brand.programContactPhone}}</b>, 7am - 7pm Central Time, Monday-Friday, or email us at <a href=\"mailto:{{brand.programContactEmail}}\">{{brand.programContactEmail}}</a>.\n" +
    "          </p>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/login/sso.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/login/sso.html",
    "<div class=\"login-container\">\n" +
    "  <div class=\"login-box\">\n" +
    "    <div class=\"login-box-header\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1 id=\"login-title\">{{text}}</h1>\n" +
    "    </div>\n" +
    "    <div class=\"login-box-body\">\n" +
    "      <form id=\"frm-login\">\n" +
    "        <div ng-show=\"displayMessage\" class=\"alert\">\n" +
    "          <span class=\"icon-warning-triangle\"></span>\n" +
    "          <p>{{displayMessageText}}</p>\n" +
    "        </div>\n" +
    "        <div ng-show=\"loading\" id=\"loading-login\" style=\"display: flex; justify-content: center\">\n" +
    "          <span class=\"loading-indicator\"></span>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/ach/header-content.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/ach/header-content.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/ach/side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/ach/side-options.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Where can I find my routing number?</h2>\n" +
    "  <p>You can find your routing number at the bottom left corner of your personal checks. It’s the first nine digits of the long line of numbers there.</p>\n" +
    "  <h2>Where can I find my account number?</h2>\n" +
    "  <p>Your account number will be the numbers that appear AFTER your bank’s routing number.</p>\n" +
    "  <h2>Questions?</h2>\n" +
    "  <p>{{info}}</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/ach/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/ach/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"form-error\" ng-show=\"!formData.AccountName && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter an Account Name</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"AccountName\">Account Name</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.AccountName\" name=\"AccountName\" id=\"AccountName\" value=\"{{formData.AcountName}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"form-error\" ng-show=\"!formData.AccountType && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Select the Account Type</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"AccountType\">Account Type</label>\n" +
    "    <select\n" +
    "      id=\"AccountType\"\n" +
    "      name=\"AccountType\"\n" +
    "      required\n" +
    "      ng-model=\"formData.AccountType\"\n" +
    "      ng-options=\"f.label for f in typeOptions track by f.key\">\n" +
    "      <option value=\"\" ng-if=\"!formData.AccountType\">Select...</option>\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li class=\"form-error\" ng-show=\"!formData.RoutingNumber && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Your Routing Number</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-error\" ng-show=\"formData.RoutingNumber && attempted && !routingValid\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>{{routingMessage}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"RoutingNumber\">Routing Number</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.RoutingNumber\" name=\"RoutingNumber\" id=\"RoutingNumber\" value=\"{{formData.RoutingNumber}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"form-error\" ng-show=\"!formData.AccountNumber && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Your Account Number</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"AccountNumber\">Account Number</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.AccountNumber\" name=\"AccountNumber\" id=\"AccountNumber\" value=\"{{formData.AcountNumber}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"(formData.AccountNumber != formData.AccountConfirm) && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Confirm Account Numbers Match</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"AccountConfirm\">Confirm Account Number</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.AccountConfirm\" name=\"AccountConfirm\" id=\"AccountConfirm\" value=\"{{formData.AccountConfirm}}\" required ng-blur=\"confirmAccount()\">\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "        value=\"formData.Amount\"\n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\"\n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-min=\"0\"\n" +
    "        class=\"input-small\"\n" +
    "        ng-change=\"formatAmountMessage()\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\">\n" +
    "      <p>Balance: {{availableBalance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-show=\"amountMessage && !amountValid\" class=\"content amount-balance-not-enough\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>{{amountMessage}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/ach/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/ach/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Destination</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">Your Bank Account</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/add/confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/add/confirmation.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Bank Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"BankName\">{{ confirmation.bank.name }}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<ul class=\"form\" ng-repeat=\"account in confirmation.accounts\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"NickName\">{{ account.Name }}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Account\">{{ account.AccountLastFour }}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/add/error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/add/error.html",
    "<div class=\"overlay-main\">\n" +
    "  <ul class=\"form js-autoscroll-form\">\n" +
    "    <li ng-show=\"linkError\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>\n" +
    "          <strong>You have attempted to link an external bank account that does not permit ACH transfers.</strong>\n" +
    "          <br><br>\n" +
    "          Please try again with another bank account. <br><br>\n" +
    "          If you believe this message to be in error or if you have further questions please contact us at bankverification@{{brand.programUrl}}\n" +
    "          or by phone at {{brand.programContactPhone}}.\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <li ng-show=\"verifyError\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>\n" +
    "          <strong>Unfortunately, we were unable to verify your bank account electronically. Please double check the account and routing numbers you provided or try again with another bank account.\n" +
    "          <br><br>\n" +
    "          To request manual bank account verification you may contact us at {{brand.programContactPhone}}\n" +
    "          between 8:30am and 5:30pm Mon-Fri (Central Time).\n" +
    "          <br><br>\n" +
    "          You may also send a manual bank verification request via email to bankverification@{{brand.programUrl}}.\n" +
    "          We will require that you send us a copy of your most recent bank statement along with a photo ID\n" +
    "          (Driver's License or equivalent).\n" +
    "          </strong>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <li ng-show=\"authorizationError\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>\n" +
    "          <strong>Bummer...your {{brand.commonProgramName}} account is not authorized for bank transfers and therefore you can't link a new bank account.\n" +
    "          <br><br>\n" +
    "          To lift this restriction, you must send a picture or scan of your Driver's License or state issued ID along with a recent bank statement to bankverification@{{brand.programUrl}}.\n" +
    "          <br><br>\n" +
    "          If you have any questions please reach out to us at {{brand.programContactPhone}} Mon-Fri 8:30a - 5:30p Central time.</strong>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/bank/add/newBankList.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/add/newBankList.html",
    "<ul class=\"form\" ng-if=\"banks.length != 0\">\n" +
    "  <li class=\"form-select-grid\" >\n" +
    "    <label class=\"group-label\">Added Bank Accounts</label>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ng-repeat=\"bank in newBanks\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-akimbo-bank-load\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{bank.Name}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{bank.Account}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/add/side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/add/side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>{{title}}</h2>\n" +
    "  <p>{{info}}</p>\n" +
    "  <a ng-click=\"printManageBanks()\" class=\"btn btn-light btn-full-width large\">Manage Banks</a>\n" +
    "  <!-- Add more to the options so that the user has other options like manage banks -->\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/bank/add/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/add/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"group-label ak-aligned-label\"></label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"content\">\n" +
    "        Let's get started with linking your bank account with your {{brand.commonProgramName}} account! This will allow\n" +
    "        you to load your card account with funds from your bank account.  You'll also be able to\n" +
    "        withdraw funds to your bank account as well.</br></br>\n" +
    "        After clicking \"Get Started\" below, we'll connect you with Finicity, a Mastercard<sup>&reg;</sup> product, which\n" +
    "        will prompt you to log in to your bank account. This provides confirmation that you're an authorized user on the\n" +
    "        account.</br></br>\n" +
    "        <em>Note: We do not have access to and do not store your bank account login information.</em>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/detail/list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/detail/list.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Bank name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{bank.Name}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{bank.Account}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Status</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{bank.Active ? 'Active' : 'Inactive'}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/bank/manage/list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/manage/list.html",
    "<ul class=\"form\" ng-if=\"banks.length != 0\">\n" +
    "  <li ng-repeat=\"group in groupBanks()\" class=\"form-select-grid\">\n" +
    "    <label for=\"#\" class=\"group-label\">{{(group) ? 'Active' : 'Inactive'}}</label>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ng-repeat=\"bank in banks | groupBy:group:'Active'\" ui-sref=\"member.home.bank/detail.list({transferType: transferType, bankId: bank.Id})\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-akimbo-bank-load\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{bank.Name}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{bank.Account}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/recurring/manage/confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/recurring/manage/confirmation.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div id=\"bank-amount\" class=\"content\">\n" +
    "      <p>{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Source</label>\n" +
    "    <div id=\"source-name\" class=\"content\">\n" +
    "      <p>{{formData.Source.Name}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/bank/recurring/manage/edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/recurring/manage/edit.html",
    "<ul class=\"form js-autoscroll-form form-select-list\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.number\">Please enter only a number.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.max\">You can only transfer up to $1,000.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please enter the amount you would like to transfer.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\"\n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-max=\"1000\"\n" +
    "        ng-min=\"0\"\n" +
    "        class=\"input-small\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div ng-show=\"lowFunds\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>Oops, there's not enough on your {{brand.commonProgramName}}. Send from a bank.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"enoughFunds\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p>Sweet. You've got enough on your {{brand.commonProgramName}}.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Source.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Source.$error.required\">Please {{sourceLabel}} for the Transaction</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"dash-form\">\n" +
    "    <label>{{sourceLabel}}</label>\n" +
    "    <ul class=\"form-select-list akimbo-form-select-list\">\n" +
    "      <li ng-repeat=\"s in sources\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"Source\"\n" +
    "          ng-model=\"formData.Source\"\n" +
    "          ng-value=\"s\"\n" +
    "          required>\n" +
    "        <span class=\"list-checkbox\" ng-class=\"formData.Source.Id == s.Id ? 'icon-box-check' : 'icon-box'\" ng-click=\"formData.Source = s\">\n" +
    "          <span class=\"checkbox-label\">{{s.Name}}</span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Schedule</label>\n" +
    "    <a ng-click=\"showScheduleOption = true\" class=\"js-toggle-element js-offscreen\">\n" +
    "      <span class=\"icon-calendar\"></span>\n" +
    "      <p id=\"schedule-text-step1-frequency\">{{scheduleText}}</p>\n" +
    "    </a>\n" +
    "    <div class=\"popover-wrap\" ng-show=\"showScheduleOption\">\n" +
    "      <div id=\"schedule-step1-frequency\" class=\"popover popover-offscreen popover-no-padding\" style=\"display: block; left: 20px; top: -426px;\">\n" +
    "        <span class=\"popover-close icon-close\" ng-click=\"showScheduleOption = false\"></span>\n" +
    "        <h2 class=\"popover-title\" id=\"step1-frequency-text\">Schedule</h2>\n" +
    "        <div class=\"popover-body\">\n" +
    "          <p>How often would you like to load money onto your card? Would you like to schedule it around your paycheck? Customize the loading schedule below.</p>\n" +
    "        </div>\n" +
    "        <div class=\"popover-body\">\n" +
    "          <ul class=\"form\">\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>How often?</label>\n" +
    "                <select\n" +
    "                  id=\"frequency-select\"\n" +
    "                  ng-change=\"changeFreq()\"\n" +
    "                  ng-model=\"datePicker.frequency\"\n" +
    "                  ng-options=\"f.label for f in frequencyOptions track by f.key\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.frequency\">Select...</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>Pick your days</label>\n" +
    "                <select\n" +
    "                  id=\"day1-select\"\n" +
    "                  ng-change=\"changeDay1()\"\n" +
    "                  ng-model=\"datePicker.day1\"\n" +
    "                  value=\"\"\n" +
    "                  ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "                  class=\"select-small\"\n" +
    "                  style=\"width:35%;\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "                </select>\n" +
    "                <select\n" +
    "                  id=\"day2-select\"\n" +
    "                  ng-change=\"changeDay2()\"\n" +
    "                  ng-model=\"datePicker.day2\"\n" +
    "                  value=\"\"\n" +
    "                  ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "                  ng-show=\"datePicker.frequency.key == 'T'\"\n" +
    "                  class=\"select-small\"\n" +
    "                  style=\"width:35%;\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>Start date</label>\n" +
    "                <select\n" +
    "                  id=\"date-select\"\n" +
    "                  ng-change=\"changeDate()\"\n" +
    "                  ng-model=\"datePicker.dateSelect\"\n" +
    "                  ng-options=\"f.label for f in dateOptions track by f.formattedDate\">\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <a class=\"btn normal btn-secondary js-toggle-element js-toggle-element-close\" ng-click=\"showScheduleOption = false\">OK</a>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/recurring/manage/list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/recurring/manage/list.html",
    "<ul class=\"form\" ng-if=\"transfers.length != 0\">\n" +
    "  <li class=\"form-select-grid\" ng-repeat=\"group in groupTransfers()\">\n" +
    "    <label for=\"#\" class=\"group-label\">{{(group == 'A') ? 'Active' : 'Inactive'}}</label>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ui-sref=\"member.home.bank/recurring/edit.step1({transferType: transferType, recurringId: transfer.Id})\" ng-repeat=\"transfer in transfers | groupBy:group:'Status' | filter: {Direction: Direction}\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <div class=\"icon-wrap\">\n" +
    "              <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{banks[transfer.BankSerialNo]}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transfer.TransferAmount | akimboCurrency}} ({{transfer.scheduleText}})</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/recurring/manage/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/recurring/manage/step2.html",
    "<ul class=\"form\">\n" +
    "  <li ng-show=\"transferError\">\n" +
    "    <p>\n" +
    "      Bummer...your {{brand.commonProgramName}} account is not authorized for bank transfers.\n" +
    "      <br/><br/>\n" +
    "      To lift this restriction, you must send a picture or scan of your Driver\\'s License or state issued ID along with a recent bank statement to bankverification@{{brand.programUrl}}.\n" +
    "      <br/><br/>\n" +
    "      If you have any questions please reach out to us at {{brand.programContactPhone}} Mon-Fri 8:30a - 5:30p Central time.\n" +
    "    </p>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">{{sourceLabel}}</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Source.Name}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/recurring/schedule/confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/recurring/schedule/confirmation.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Source</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Source.Name}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/bank/recurring/schedule/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/recurring/schedule/step1.html",
    "<ul class=\"form js-autoscroll-form form-select-list\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.number\">Please enter only a number.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.max\">You can only transfer up to $1,000.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please enter the amount you would like to transfer.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\"\n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-max=\"1000\"\n" +
    "        ng-min=\"0\"\n" +
    "        class=\"input-small\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div ng-show=\"lowFunds\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>Oops, there's not enough on your {{brand.commonProgramName}}. Send from a bank.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"enoughFunds\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p>Sweet. You've got enough on your {{brand.commonProgramName}}.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Source.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Source.$error.required\">Please {{sourceLabel}} for the Transaction</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"dash-form\">\n" +
    "    <label>{{sourceLabel}}</label>\n" +
    "    <ul class=\"form-select-list akimbo-form-select-list\">\n" +
    "      <li ng-repeat=\"s in sources\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"Source\"\n" +
    "          ng-model=\"formData.Source\"\n" +
    "          ng-value=\"s\"\n" +
    "          required>\n" +
    "        <span class=\"list-checkbox\" ng-class=\"formData.Source == s ? 'icon-box-check' : 'icon-box'\" ng-click=\"formData.Source = s\">\n" +
    "          <span class=\"checkbox-label\">{{s.Name}}</span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.frequency.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li>Please select the schedule for the Transaction</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Schedule</label>\n" +
    "    <a ng-click=\"showScheduleOption = true\" class=\"js-toggle-element js-offscreen\">\n" +
    "      <span class=\"icon-calendar\"></span>\n" +
    "      <p id=\"schedule-text-step1-frequency\">{{scheduleText}}</p>\n" +
    "    </a>\n" +
    "    <div class=\"popover-wrap\" ng-show=\"showScheduleOption\">\n" +
    "      <div id=\"schedule-step1-frequency\" class=\"popover popover-offscreen popover-no-padding\" style=\"display: block; left: 20px; top: -426px;\">\n" +
    "        <span class=\"popover-close icon-close\" ng-click=\"showScheduleOption = false\"></span>\n" +
    "        <h2 class=\"popover-title\" id=\"step1-frequency-text\">Schedule</h2>\n" +
    "        <div class=\"popover-body\">\n" +
    "          <p>{{ scheduleMessage }}</p>\n" +
    "        </div>\n" +
    "        <div class=\"popover-body\">\n" +
    "          <ul class=\"form\">\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>How often?</label>\n" +
    "                <select\n" +
    "                  id=\"frequency-select\"\n" +
    "                  name=\"frequency\"\n" +
    "                  required\n" +
    "                  ng-change=\"changeFreq()\"\n" +
    "                  ng-model=\"datePicker.frequency\"\n" +
    "                  ng-options=\"f.label for f in frequencyOptions track by f.key\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.frequency\">Select...</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>Pick your days</label>\n" +
    "                <select\n" +
    "                  id=\"day1-select\"\n" +
    "                  ng-change=\"changeDay1()\"\n" +
    "                  ng-model=\"datePicker.day1\"\n" +
    "                  value=\"\"\n" +
    "                  ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "                  class=\"select-small\"\n" +
    "                  style=\"width:35%;\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "                </select>\n" +
    "                <select\n" +
    "                  id=\"day2-select\"\n" +
    "                  ng-change=\"changeDay2()\"\n" +
    "                  ng-model=\"datePicker.day2\"\n" +
    "                  value=\"\"\n" +
    "                  ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "                  ng-show=\"datePicker.frequency.key == 'T'\"\n" +
    "                  class=\"select-small\"\n" +
    "                  style=\"width:35%;\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>Start date</label>\n" +
    "                <select\n" +
    "                  id=\"date-select\"\n" +
    "                  ng-change=\"changeDate()\"\n" +
    "                  ng-model=\"datePicker.dateSelect\"\n" +
    "                  ng-options=\"f.label for f in dateOptions track by f.formattedDate\">\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <a class=\"btn normal btn-secondary js-toggle-element js-toggle-element-close\" ng-click=\"showScheduleOption = false\">OK</a>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/recurring/schedule/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/recurring/schedule/step2.html",
    "<ul class=\"form\">\n" +
    "  <li ng-show=\"transferError\">\n" +
    "    <p>\n" +
    "      Bummer...your {{brand.commonProgramName}} account is not authorized for bank transfers.\n" +
    "      <br/><br/>\n" +
    "      To lift this restriction, you must send a picture or scan of your Driver\\'s License or state issued ID along with a recent bank statement to bankverification@{{brand.programUrl}}.\n" +
    "      <br/><br/>\n" +
    "      If you have any questions please reach out to us at {{brand.programContactPhone}} Mon-Fri 8:30a - 5:30p Central time.\n" +
    "    </p>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">{{sourceLabel}}</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Source.Name}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <div class=\"referral-widget-section\" ng-if=\"transferType == 'load' && isExpense\">\n" +
    "      <p>I hereby authorize {{ brand.commonProgramName }}, to debit and/or credit my checking or savings account indicated above. I acknowledge the origination of ACH transactions to my account must comply with the provisions of U.S. law. I understand this authority is to remain in full force and effect until {{ brand.commonProgramName }} has received written notification 3 days prior to the payment date to process any changes to the above information.</br></br>\n" +
    "\n" +
    "      Your withdrawal will be initiated on the due date.  If the due date falls on a Saturday or Sunday, the withdrawal will be initiated the following Monday.  If the due date falls on a Federal Holiday, the withdrawal will be initiated the following business day.  Depending on when your account is drafted, you may incur interest costs and/or late fees which will be applied accordingly.</p>\n" +
    "  </div>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/transfer/confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/transfer/confirmation.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div id='bank-amount' class=\"content\">\n" +
    "      <p>{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Source</label>\n" +
    "    <div id=\"bank-source\" class=\"content\">\n" +
    "      <p>{{formData.Source.Name}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-if=\"formData.makeRecurring == 'on'\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_schedule\">{{formData.scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>  \n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/transfer/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/transfer/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.number\">Please enter only a number.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please enter the amount you would like to transfer.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">{{direction}}</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>Your {{brand.commonProgramName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input \n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\" \n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-min=\"0\"\n" +
    "        class=\"input-small\"\n" +
    "        ng-change=\"formatAmountMessage()\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\" ng-show=\"!amountMessage && !amountValid\">\n" +
    "      <p>{{brand.commonProgramName}} balance: {{balance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountMessage && !amountValid\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>{{amountMessage}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountValid\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p>{{amountMessage}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Source.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Source.$error.required\">Please {{sourceLabel}} for the Transaction</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"dash-form\">\n" +
    "    <label>{{sourceLabel}}</label>\n" +
    "    <ul class=\"form-select-list akimbo-form-select-list\">\n" +
    "      <li ng-repeat=\"s in sources\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"Source\"\n" +
    "          ng-model=\"formData.Source\"\n" +
    "          ng-value=\"s\"\n" +
    "          required>\n" +
    "        <span id='bank-checkbox' class=\"list-checkbox\" ng-class=\"formData.Source == s ? 'icon-box-check' : 'icon-box'\" ng-click=\"formData.Source = s\">\n" +
    "          <span class=\"checkbox-label\">{{s.Name}}</span>\n" +
    "          <span class=\"instant-transfer-available\" ng-if=\"isInstantTransfer(s)\">\n" +
    "            <span class=\"instant-transfer-available__icon icon-lightning\"></span>\n" +
    "            <span class=\"instant-transfer-available__message\">Instant Transfer Available</span>\n" +
    "          </span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "      <li ng-show=\"transferType == 'load'\">\n" +
    "        <span class=\"list-checkbox icon-icon-plus\" ui-sref=\"member.home.bank/add.step1\">\n" +
    "          <span class=\"checkbox-label\">Add a Bank</span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small calendar-directive\">\n" +
    "    <label>Make Recurring</label>\n" +
    "    <div class=\"toggle-input\">\n" +
    "      <div class=\"toggle-bg {{formData.makeRecurring}}\">\n" +
    "        <input type=\"radio\" name=\"toggle-recurring\" value=\"off\" ng-model=\"formData.makeRecurring\">\n" +
    "        <input type=\"radio\" name=\"toggle-recurring\" value=\"on\" ng-model=\"formData.makeRecurring\">\n" +
    "        <span class=\"switch {{formData.makeRecurring}}\"></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"content\">\n" +
    "      <p ng-show=\"formData.makeRecurring == 'on'\" ng-click=\"formData.showScheduleOption = true\" id=\"calendar-cta\">{{formData.scheduleText}}</p>\n" +
    "    </div>\n" +
    "    <calendar-modal default-today=\"true\"></calendar-modal>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/bank/transfer/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/bank/transfer/step2.html",
    "<div class=\"referral-widget-section\" ng-show=\"transferError\">\n" +
    "  <p>\n" +
    "    Bummer...your {{brand.commonProgramName}} account is not authorized for bank transfers.\n" +
    "    <br/><br/>\n" +
    "    To lift this restriction, you must send a picture or scan of your Driver's License or state issued ID along with a recent bank statement to bankverification@{{brand.programUrl}}.\n" +
    "    <br/><br/>\n" +
    "    If you have any questions please reach out to us at {{brand.programContactPhone}} Mon-Fri 8:30a - 5:30p Central time.\n" +
    "  </p>\n" +
    "</div>\n" +
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div id=\"bank-amount\" class=\"content\">\n" +
    "      <p>{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">{{sourceLabel}}</label>\n" +
    "    <div id=\"bank-source\" class=\"content\">\n" +
    "      <p>{{formData.Source.Name}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-if=\"formData.makeRecurring == 'on'\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_schedule\">{{formData.scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <div class=\"referral-widget-section\" ng-if=\"transferType == 'load' && isExpense\">\n" +
    "      <p>I hereby authorize {{ brand.commonProgramName }}, to debit and/or credit my checking or savings account indicated above. I acknowledge the origination of ACH transactions to my account must comply with the provisions of U.S. law. I understand this authority is to remain in full force and effect until {{ brand.commonProgramName }} has received written notification 3 days prior to the payment date to process any changes to the above information.</br></br>\n" +
    "\n" +
    "      Your withdrawal will be initiated on the due date.  If the due date falls on a Saturday or Sunday, the withdrawal will be initiated the following Monday.  If the due date falls on a Federal Holiday, the withdrawal will be initiated the following business day.  Depending on when your account is drafted, you may incur interest costs and/or late fees which will be applied accordingly.</p>\n" +
    "  </div>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/billpay/list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/billpay/list.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-select-grid\">\n" +
    "    <label for=\"#\">Payees</label>\n" +
    "    <ul class=\"form-select-list-grid  \">\n" +
    "      <li>\n" +
    "        <div class=\"akimbo-media-box\" data-akimbo-widget-click=\"open\" data-akimbo-widget-source=\"/member/billpay/payee/569\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <img src=\"assets/images/transactions/img-ph-bank-out.png\" alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">Chad Sahlhoff</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">San Francisco, CA</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/billpay/new.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/billpay/new.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"payee_name\">Payee Name</label>\n" +
    "    <input ng-model=\"formData.payee_name\" type=\"text\" name=\"payee_name\" id=\"payee_name\" value=\"\">\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"address_line_1\">Address</label>\n" +
    "    <input ng-model=\"formData.address_line_1\" type=\"text\" name=\"address_line_1\" id=\"address_line_1\" value=\"\">\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"address_line_2\">Address</label>\n" +
    "    <input ng-model=\"formData.address_line_2\" type=\"text\" name=\"address_line_2\" id=\"address_line_2\" value=\"\">\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"city\">City</label>\n" +
    "    <input ng-model=\"formData.city\" type=\"text\" name=\"city\" id=\"city\" value=\"\">\n" +
    "  </li>\n" +
    "  <li class=\"form-select\">\n" +
    "    <label for=\"state\">State</label>\n" +
    "    <select tabindex=\"6\" id=\"state\" ng-model=\"formData.State\" ng-options=\"s.key as s.state for s in states\">\n" +
    "      <option value=\"\" ng-if=\"!formData.State\">State</option>\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"zipcode\">Zipcode</label>\n" +
    "    <input ng-model=\"formData.zipcode\" type=\"text\" name=\"zipcode\" id=\"zipcode\" value=\"\">\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"phone\">Phone</label>\n" +
    "    <input ng-model=\"formData.phone\" type=\"text\" name=\"phone\" id=\"phone\" value=\"\">\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input ng-model=\"formData.amount\" type=\"text\" name=\"amount\" id=\"amount\" value=\"\" class=\"input-small\">\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\">\n" +
    "      <p>{{brand.commonProgramName}} balance: $<span class=\"amount-balance-available\">{{balance}}</span></p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"(formData.amount > balance && formData.amount.length > 0)\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>Oops, there's not enough on your {{brand.commonProgramName}}. Send from a bank.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"(formData.amount < balance && formData.amount.length > 0)\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p>Sweet. You've got enough on your {{brand.commonProgramName}}.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "    <li>\n" +
    "      <label class=\"overlay-title-text\" for=\"memo\">Memo</label>\n" +
    "      <input ng-model=\"formData.memo\" type=\"text\" name=\"memo\" id=\"memo\" value=\"\">\n" +
    "    </li>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/blockload/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/blockload/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">\n" +
    "    </label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>Your account is currently restricted and will not accept any loads or deposits. You have full access to your current available balance, including using your card for purchases or cash withdrawals. However, any future loads or deposits will be rejected and/or returned.</p><br/><p>Please make sure to update your direct deposit information with any payers currently depositing funds to this account.  You may also request a refund check for the full available balance on your account.</p><br/><p>If you have questions regarding this restriction, please contact us at {{brand.programContactEmail}} or {{brand.programContactPhone}}, Mon-Fri, 8-5p CT.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/cashload/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/cashload/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">\n" +
    "    </label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>You can load your {{brand.commonProgramName}} with cash at retail locations that support one of the following networks:</p>\n" +
    "      <ul class=\"list-cards cash-load\">\n" +
    "        <li>Green Dot Reload @ the Register</li>\n" +
    "        <li>Vanilla Reload</li>\n" +
    "        <li>Mastercard rePower</li>\n" +
    "      </ul>\n" +
    "      <br>\n" +
    "      <p>To find a location near you, <a target=\"_blank\" confirmation-overlay href=\"https://www.mastercard.us/en-us/personal/get-support/reload-a-prepaid-card.html\">please click here</a>.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/corpdeposit/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/corpdeposit/layout.html",
    "<div class=\"overlay-wrapper overlay-active\">    \n" +
    "  <div class=\"overlay {{overlay.headerClass}}\">\n" +
    "    <div class=\"overlay-close icon-circle-x\" ng-click=\"closeOrRedirect()\"></div>\n" +
    "    <div class=\"overlay-header\">\n" +
    "      <div class=\"overlay-header-main\">\n" +
    "        <div class=\"{{overlay.icon}}\"></div>\n" +
    "        <h1>{{overlay.title}}</h1>\n" +
    "      </div>\n" +
    "    </div><!-- .overlay-header -->\n" +
    "    <div ui-view=\"header\"></div>\n" +
    "    <!-- .overlay-header-form -->\n" +
    "    <div class=\"overlay-body\">\n" +
    "      <div class=\"overlay-main\">\n" +
    "        <form name=\"overlayForm\" class=\"widget-form\" ng-submit=\"processForm(formData)\">\n" +
    "          <div ui-view=\"step\"></div>\n" +
    "        </form>   \n" +
    "      </div>\n" +
    "      <div ui-view=\"side\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-background\"></div>\n" +
    "</div>\n" +
    "<div ui-view=\"footer\"></div>\n" +
    "<div class=\"overlay-mask\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/corpdeposit/side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/corpdeposit/side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>{{title}}</h2>\n" +
    "  <p>{{info}}</p>\n" +
    "</div>");
}]);

angular.module("../app/views/member/corpdeposit/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/corpdeposit/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\"></label>\n" +
    "    <div class=\"content\">\n" +
    "      <p><strong>Deposits by ACH:</strong> Funds transferred by ACH may be sent to the bank account provided below. Deposits will be credited to your account automatically when received.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Bank name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{brand.issuer.bank}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Routing number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{Routing}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{AccountNumber}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account Type</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>Checking</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\"></label>\n" +
    "    <div class=\"content\">\n" +
    "      <p><strong>Deposits by Wire:</strong> Funds transferred by wire transfer may be sent to the bank account provided below. We also recommend that you send an email to prefunding@ficentive.com to notify us of the incoming wire transfer. Deposits will be credited on the same day in which the wire transfer is received. If your account is not credited in a timely manner, please send an email to <a href=\"mailto:prefunding@usio.com\">prefunding@usio.com.</a></p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>Usio, Inc.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Bank Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>Texas Partners Bank</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Bank Address</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>1900 NW Loop 410, San Antonio, TX 78213</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Routing Number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>114025641</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account Number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>0000015172</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Memo</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>[Your Company Name] Commercial Account.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/debit-card-withdrawal/side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/debit-card-withdrawal/side-options.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Questions?</h2>\n" +
    "  <p>{{info}}</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/debit-card-withdrawal/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/debit-card-withdrawal/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.FirstName && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter First Name</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"FirstName\">First Name</label>\n" +
    "        <input type=\"text\" ng-model=\"formData.FirstName\" name=\"FirstName\" id=\"FirstName\" value=\"{{formData.FirstName}}\" required>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.LastName && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter Last Name</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"LastName\">Last Name</label>\n" +
    "        <input type=\"text\" ng-model=\"formData.LastName\" name=\"LastName\" id=\"LastName\" value=\"{{formData.LastName}}\" required>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.Email && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter Email</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"Email\">Email</label>\n" +
    "        <input type=\"text\" ng-model=\"formData.Email\" name=\"Email\" id=\"Email\" value=\"{{formData.Email}}\" required>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.Address1 && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter Address</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"Address1\">Address</label>\n" +
    "        <input type=\"text\" ng-model=\"formData.Address1\" name=\"Address1\" id=\"Address1\" value=\"{{formData.Address1}}\" required>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"Address2\">Address 2</label>\n" +
    "        <input type=\"text\" name=\"Address2\" id=\"Address2\" value=\"{{formData.Address2}}\" ng-model=\"formData.Address2\">\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.City && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter City</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"City\">City</label>\n" +
    "        <input type=\"text\" name=\"City\" ng-model=\"formData.City\" id=\"City\" value=\"{{formData.City}}\" required>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.State && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter State</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li class=\"form-select\">\n" +
    "        <label for=\"State\">State</label>\n" +
    "        <select name=\"State\" id=\"State\" ng-model=\"formData.State\" ng-options=\"s.state for s in states track by s.key\" required>\n" +
    "        </select>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.Zipcode && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter Zipcode</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"Zipcode\">Zipcode</label>\n" +
    "        <input type=\"text\" name=\"Zipcode\" ng-model=\"formData.Zipcode\" id=\"Zipcode\" value=\"{{formData.Zipcode}}\" required>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"formData.CardNumber.$error.pattern && attempted || !formData.CardNumber && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter Valid Card Number</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"CardNumber\">3rd-party Card Number</label>\n" +
    "        <input\n" +
    "                type=\"text\"\n" +
    "                pattern=\"[0-9]*\"\n" +
    "                minlength=\"13\"\n" +
    "                maxlength=\"19\"\n" +
    "                ng-model=\"formData.CardNumber\"\n" +
    "                ng-change=\"updateLastFourCardNum()\"\n" +
    "                name=\"CardNumber\"\n" +
    "                id=\"CardNumber\"\n" +
    "                value=\"{{formData.CardNumber}}\"\n" +
    "                required>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.CVV && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter Valid CVV</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"CVV\">CVV</label>\n" +
    "        <input\n" +
    "                id=\"CVV\"\n" +
    "                type=\"text\"\n" +
    "                name=\"CVV\"\n" +
    "                ng-model=\"formData.CVV\"\n" +
    "                required\n" +
    "                data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "                data-ng-minlength=\"3\"\n" +
    "                maxlength=\"4\"\n" +
    "                ng-focus='overlayForm.CVV.hasFocus=true',\n" +
    "                ng-blur='overlayForm.CVV.hasFocus=false'>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.ExpDate && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Enter Expiration Date</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li>\n" +
    "        <label class=\"overlay-title-text\" for=\"ExpDate\">Exp. Date</label>\n" +
    "        <input\n" +
    "                id=\"ExpDate\"\n" +
    "                type=\"text\"\n" +
    "                name=\"ExpDate\"\n" +
    "                required\n" +
    "                mask=\"99/99\"\n" +
    "                exp-input-helper\n" +
    "                ng-model=\"formData.ExpDate\"\n" +
    "                ng-focus='overlayForm.ExpDate.hasFocus=true'\n" +
    "                ng-blur='overlayForm.ExpDate.hasFocus=false'>\n" +
    "    </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"amountMessage && !amountValid\">\n" +
    "        <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>{{amountMessage}}</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "        <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "        <div class=\"input-full\">\n" +
    "            <input\n" +
    "                    id=\"Amount\"\n" +
    "                    value=\"{{formData.Amount}}\"\n" +
    "                    type=\"number\"\n" +
    "                    name=\"Amount\"\n" +
    "                    ng-model=\"formData.Amount\"\n" +
    "                    class=\"input-small\"\n" +
    "                    ng-change=\"formatAmountMessage()\"\n" +
    "                    required>\n" +
    "        </div>\n" +
    "        <div class=\"content amount-balance\" style=\"display: table-cell;\">\n" +
    "            <p>Balance: {{balance | akimboCurrency}}</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/debit-card-withdrawal/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/debit-card-withdrawal/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label>Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{ formData.Amount | akimboCurrency }}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"address-label\">3rd Party Account</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"address-container\" id=\"transfer_to\">\n" +
    "        {{ formData.FirstName + \" \" + formData.LastName }}<br>\n" +
    "        Email: {{ formData.Email }}<br>\n" +
    "        {{ formData.Address1 }}<br>\n" +
    "        <span ng-show=\"formData.Address2\">{{ formData.Address2 }}<br></span>\n" +
    "        {{ formData.City }}, {{ formData.State.key }}<br>\n" +
    "        {{ formData.Zipcode}}<br>\n" +
    "        Card Number: ...{{ lastFourCardNum }}<br>\n" +
    "        Exp. Date: {{ formData.ExpDate }}\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/debit-card-withdrawal/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/debit-card-withdrawal/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"address-label\">3rd Party Account</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"address-container\" id=\"transfer_to\">\n" +
    "        {{ formData.FirstName + \" \" + formData.LastName }}<br>\n" +
    "        Email: {{ formData.Email }}<br>\n" +
    "        {{ formData.Address1 }}<br>\n" +
    "        <span ng-show=\"formData.Address2\">{{ formData.Address2 }}<br></span>\n" +
    "        {{ formData.City }}, {{ formData.State.key }}<br>\n" +
    "        {{ formData.Zipcode}}\n" +
    "        Card Number: ...{{ lastFourCardNum }}<br>\n" +
    "        CVV: {{ formData.CVV }}<br>\n" +
    "        Exp. Date: {{ formData.ExpDate }}\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/directdeposit/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/directdeposit/layout.html",
    "<div class=\"overlay-wrapper overlay-active\">    \n" +
    "  <div class=\"overlay {{overlay.headerClass}}\">\n" +
    "    <div class=\"overlay-close icon-circle-x\" ng-click=\"closeOrRedirect()\"></div>\n" +
    "    <div class=\"overlay-header\">\n" +
    "      <div class=\"overlay-header-main\">\n" +
    "        <div class=\"{{overlay.icon}}\"></div>\n" +
    "        <h1>{{overlay.title}}</h1>\n" +
    "      </div>\n" +
    "    </div><!-- .overlay-header -->\n" +
    "    <div ui-view=\"header\"></div>\n" +
    "    <!-- .overlay-header-form -->\n" +
    "    <div class=\"overlay-body\">\n" +
    "      <div class=\"overlay-main\">\n" +
    "        <form name=\"overlayForm\" class=\"widget-form\" ng-submit=\"processForm(formData)\">\n" +
    "          <div ui-view=\"step\"></div>\n" +
    "        </form>   \n" +
    "      </div>\n" +
    "      <div ui-view=\"side\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-background\"></div>\n" +
    "</div>\n" +
    "<div ui-view=\"footer\"></div>\n" +
    "<div class=\"overlay-mask\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/directdeposit/print.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/directdeposit/print.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Bank name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{bank}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Routing number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{routing}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{accountNumber}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account Type</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>Checking</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/directdeposit/side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/directdeposit/side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>{{title}}</h2>\n" +
    "  <p>{{info}}</p>     \n" +
    "  <a ng-click=\"printDirectDeposit()\" class=\"btn btn-light btn-full-width large\">Print Direct Deposit</a>\n" +
    "</div>");
}]);

angular.module("../app/views/member/directdeposit/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/directdeposit/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Bank name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"bank-name\">{{brand.issuer.bank}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Routing number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"bank-routing\">{{Routing}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"bank-account\">{{AccountNumber}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Account Type</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"bank-type\">Checking</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/expanded/feed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/expanded/feed.html",
    "<div class=\"feed-back-header\">\n" +
    "  <button class=\"back-btn\" ng-click=\"goBack()\">\n" +
    "    <span class=\"icon-arrow-left-full\"></span>\n" +
    "    Back\n" +
    "  </button>\n" +
    "  <div class=\"print\">\n" +
    "      <button ng-click=\"print()\" class=\"icon-print tooltip-wrap\">\n" +
    "        <span class=\"tooltip\">Print</span>\n" +
    "      </button>\n" +
    "      <button ng-click=\"downloadCsv()\" class=\"icon-circle-arrow-down tooltip-wrap\">\n" +
    "        <span class=\"tooltip\">Download CSV</span>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"expanded-feed-container\">\n" +
    "  <div class=\"col-feed\">\n" +
    "    <ul class=\"expanded-feed-tools\">\n" +
    "      <li class=\"search-form\">\n" +
    "        <form>\n" +
    "          <span class=\"icon-search\"></span>\n" +
    "          <input type=\"text\" name=\"search\" placeholder=\"Search\" ng-model=\"searchText\">\n" +
    "        </form>\n" +
    "      </li>\n" +
    "      <li class=\"filter\">\n" +
    "        <div class=\"popover-wrap\">\n" +
    "          <div class=\"filter-trigger js-toggle-element\" ng-click=\"openDrawer('filterList')\" click-anywhere-but-here=\"closeDrawer('filterList')\">\n" +
    "            <button class=\"icon-cog\"></button>\n" +
    "            <div class=\"filter-text\">\n" +
    "              <h2>Filter</h2>\n" +
    "              <p>{{query.selectedFilterList}}</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <ul id=\"filterList\" ng-show=\"filterList\" class=\"popover popover-no-padding\">\n" +
    "            <li ng-click=\"selectFilterList('All transactions')\">All transactions</li>\n" +
    "            <li ng-click=\"selectFilterList('Network')\"><span class=\"icon-arrow-right\"></span>Network</li>\n" +
    "            <li ng-click=\"selectFilterList('Loads')\"><span class=\"icon-arrow-right\"></span>Loads</li>\n" +
    "            <li ng-click=\"selectFilterList('Withdrawals')\"><span class=\"icon-arrow-right\"></span>Withdrawals</li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"date-alt\">\n" +
    "        <div class=\"popover-wrap\">\n" +
    "          <div class=\"filter-trigger js-toggle-element\" ng-click=\"openDrawer('calendarList')\" click-anywhere-but-here=\"closeDrawer('calendarList')\">\n" +
    "            <div class=\"filter-text\">\n" +
    "              <button class=\"icon-calendar\"></button>\n" +
    "              <h2>Date Range</h2>\n" +
    "            </div>\n" +
    "            <input\n" +
    "              class=\"date-range-picker\"\n" +
    "              date-range-picker\n" +
    "              class=\"form-control date-picker\"\n" +
    "              type=\"text\"\n" +
    "              min=\"datePicker.min\"\n" +
    "              max=\"datePicker.max\"\n" +
    "              options=\"datePicker.options\"\n" +
    "              ng-model=\"datePicker.date\"\n" +
    "              />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"download\">\n" +
    "        <!--\n" +
    "        <button class=\"icon-circle-arrow-down tooltip-wrap\">\n" +
    "          <span class=\"tooltip\">Download</span>\n" +
    "        </button>\n" +
    "        -->\n" +
    "      </li>\n" +
    "      <li class=\"reset\" ng-click=\"reset()\">\n" +
    "        <button>Reset Filters</button>\n" +
    "      </li>\n" +
    "\n" +
    "    </ul>\n" +
    "    <table class=\"expanded-feed\">\n" +
    "      <tr>\n" +
    "        <th class=\"date\" ng-click=\"sort = 'Time'; reverse=!reverse\">Date</th>\n" +
    "        <th class=\"transaction\" ng-click=\"sort = 'Title'; reverse=!reverse\">Transaction</th>\n" +
    "        <th class=\"amount\" ng-click=\"sort = 'Amount'; reverse=!reverse\">Amount</th>\n" +
    "        <th class=\"balance\" ng-click=\"sort = 'Balance'; reverse=!reverse\" ng-show=\"query.selectedFilterList == 'All transactions'\">Balance</th>\n" +
    "        <th class=\"description\" ng-click=\"sort = 'Description'; reverse=!reverse\">Description</th>\n" +
    "      </tr>\n" +
    "      <tr ng-repeat=\"transaction in transactions | filter:searchText | orderBy:sort:reverse\" ng-show=\"!loading\">\n" +
    "        <td class=\"date\">\n" +
    "          <p>{{transaction.FormattedDate}}</p>\n" +
    "        </td>\n" +
    "        <td class=\"transaction\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span ng-class=\"transaction.Amount > 0 ? 'in-transaction' : 'out-transaction'\" class=\"{{transaction.Icon}}\"></span>\n" +
    "          </div>\n" +
    "          <p class=\"transaction-title\">{{transaction.Title}}</p>\n" +
    "        </td>\n" +
    "        <td class=\"amount\">\n" +
    "          <p><strong>{{transaction.Amount | akimboCurrency}}</strong></p>\n" +
    "          <p ng-if=\"transaction.Status\">{{transaction.Status}}</p>\n" +
    "        </td>\n" +
    "        <td class=\"balance\" ng-show=\"query.selectedFilterList == 'All transactions'\"><strong>{{transaction.Balance | akimboCurrency}}</strong></td>\n" +
    "        <td class=\"description\">\n" +
    "          <p>{{transaction.Description}}</p>\n" +
    "          <p class=\"location\" ng-if=\"transaction.Location\">{{transaction.Location}}</p>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr ng-show=\"loading\"><td class=\"date\"><span id=\"loadingFeed\" class=\"loading-indicator\"></span></td></tr>\n" +
    "    </table>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/expanded/print.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/expanded/print.html",
    "<div class=\"akimbo-print-header\">\n" +
    "  <div class=\"icon-akimbo-logo-full\"></div>\n" +
    "  <div class=\"account\">\n" +
    "    <h1>{{name}}'s transactions</h1>\n" +
    "    <h2>Account: #### #### #### {{accountLastFour}}</h2>\n" +
    "  </div>\n" +
    "  <div class=\"customer\">\n" +
    "    <p>For Customer Service,</p>\n" +
    "    <p>please call {{brand.programContactPhone}}</p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"expanded-feed-title\">\n" +
    "  <div>{{sectionTitle}} transactions from {{startDate}} to {{endDate}}</div>\n" +
    "</div>\n" +
    "<div class=\"expanded-feed-wrap\">\n" +
    "  <table class=\"expanded-feed\">\n" +
    "    <tbody>\n" +
    "      <tr>\n" +
    "        <th class=\"date\">Date</th>\n" +
    "        <th class=\"type\">Type</th>\n" +
    "        <th class=\"transaction\">Transaction</th>\n" +
    "        <th class=\"description\">Description</th>\n" +
    "        <th class=\"location\">Location</th>\n" +
    "        <th class=\"amount\">Amount</th>\n" +
    "        <th class=\"balance\" ng-show=\"section == 'all'\">Balance</th>\n" +
    "      </tr>\n" +
    "      <tr ng-repeat=\"transaction in transactions\">\n" +
    "        <td class=\"date\">\n" +
    "          {{transaction.FormattedDate}}<small>{{transaction.FormattedTime}}</small>\n" +
    "        </td>\n" +
    "        <td class=\"type\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"{{transaction.Icon}}\"></span>\n" +
    "          </div>\n" +
    "        </td>\n" +
    "        <td class=\"transaction\">{{transaction.Title}}</td>\n" +
    "        <td class=\"description\">{{transaction.Description}}</td>\n" +
    "        <td class=\"location\">{{transaction.Location}}</td>\n" +
    "        <td class=\"amount\">\n" +
    "          {{transaction.Amount | akimboCurrency}}<small></small>\n" +
    "        </td>\n" +
    "        <td class=\"balance\" ng-show=\"section == 'all'\">{{transaction.Balance | akimboCurrency}}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-show=\"loading\"><td class=\"date noBorder\"><span id=\"loadingFeed\" class=\"loading-indicator\"></span></td></tr>\n" +
    "    </tbody>\n" +
    "  </table>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/home/feed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/home/feed.html",
    "<div ng-controller=\"viewVirtualCardCtrl\" ng-include=\"'app/views/member/shared/virtual-card.html'\" ng-show=\"account.virtual && $root.isMobileView\"></div>\n" +
    "<ul id=\"feedList\" class=\"feed-list akimbo-widget-feed\" when-scrolled callback=\"loadMoreFeed()\" disabled=\"disabled\">\n" +
    "  <li class=\"akimbo-user akimbo-user-detailed bl-notification-transaction\" ng-repeat=\"notification in akimboFeed.notifications\" ng-click=\"notificationClick(notification)\">\n" +
    "    <div class=\"akimbo-media-box\">\n" +
    "      <div class=\"akimbo-media-box-content\">\n" +
    "        <h2 class=\"user-detailed-title\">{{notification.FormattedTitle}}</h2>\n" +
    "        <p class=\"user-detailed-subtitle\"><strong>{{notification.FormattedDescription}}</strong></p>\n" +
    "        <div class=\"user-detailed-subtitle\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"akimbo-balance\">\n" +
    "      <div class=\"akimbo-balance-container\">\n" +
    "        <div class=\"icon-wrap\">\n" +
    "          <span class=\"{{notification.Icon}}\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-repeat=\"transaction in akimboFeed.transactions\"\n" +
    "      ng-class=\"transaction.Amount > 0 ? 'bl-in-transaction' : 'bl-out-transaction'\"\n" +
    "      class=\"akimbo-user akimbo-user-detailed three-line-transaction\"\n" +
    "      ui-sref=\"member.home.transaction.detail({id: transaction.Id})\">\n" +
    "    <div class=\"akimbo-media-box\">\n" +
    "      <div class=\"icon-wrap\">\n" +
    "        <span ng-class=\"transaction.Amount > 0 ? 'in-transaction' : 'out-transaction'\" class=\"{{transaction.Icon}}\"></span>\n" +
    "      </div>\n" +
    "      <div class=\"akimbo-media-box-content\">\n" +
    "        <h2\n" +
    "          class=\"user-detailed-title\"\n" +
    "          ng-class=\"transaction.Amount > 0 ? 'in-transaction' : 'out-transaction'\">{{transaction.Status == 'pending' ?\n" +
    "        ('Pending ' + transaction.FeedTitle) : transaction.FeedTitle}}</h2>\n" +
    "        <p class=\"user-detailed-subtitle\"><strong>{{transaction.FormattedDate}}</strong></p>\n" +
    "        <div ng-class=\"transaction.Amount > 0 ? 'in-transaction' : 'out-transaction'\" class=\"user-detailed-text transaction-desc\">{{transaction.FeedDescription}}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"akimbo-balance\">\n" +
    "      <div class=\"akimbo-balance-container\">\n" +
    "        <p class=\"user-detailed-subtitle\"><strong>{{transaction.Amount\n" +
    "        | akimboCurrency}}</strong></p>\n" +
    "        <p ng-if=\"transaction.Balance != 0\" class=\"user-detailed-text\">{{transaction.Balance | akimboCurrency}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"waterfall-loading\">\n" +
    "    <span class=\"loading-indicator\" ng-show=\"disabled\"></span>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/limits/list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/limits/list.html",
    "<div class=\"overlay-list\">\n" +
    "  <div ng-if=\"disallowed.length\">\n" +
    "    <div class=\"overlay-list-header\">Your card may <b>not</b> be used at merchants that fall under the following categories:</div>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ng-repeat=\"m in disallowed\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"limits-mcc-code\">{{m.mcc}}</h5>\n" +
    "            <p class=\"limits-mcc-name\">{{m.mcc_name}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div ng-if=\"allowed.length\">\n" +
    "    <div class=\"overlay-list-header\">Your card may <b>only</b> be used at merchants that fall under the following categories:</div>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ng-repeat=\"m in allowed\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"limits-mcc-code\">{{m.mcc}}</h5>\n" +
    "            <p class=\"limits-mcc-name\">{{m.mcc_name}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"limits-no-restrictions\" ng-if=\"!disallowed.length && !allowed.length && loaded\">\n" +
    "    <p>There are no merchant restrictions configured on this card account.</p>\n" +
    "    <p>Please see your Cardholder Agreement for applicable transaction limits.</p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/paypal/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/paypal/layout.html",
    "<div class=\"overlay-wrapper overlay-active\">\n" +
    "  <div class=\"overlay {{overlay.headerClass}}\" ng-class=\"noSidebar ? 'overlay--no-sidebar' : ''\">\n" +
    "    <div id='close-widget' class=\"overlay-close icon-circle-x overlay-override-close\" ng-controller='overlayCtrl' ng-click=\"back()\"></div>\n" +
    "    <div class=\"overlay-header overlay-background-white-override\">\n" +
    "      <div class=\"overlay-header-main\">\n" +
    "        <svg width=\"105\" height=\"28\" viewBox=\"0 0 105 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
    "          <g clip-path=\"url(#clip0_2_22)\">\n" +
    "            <path d=\"M17.3793 3.97354C17.4465 3.97333 17.5138 3.97302 17.581 3.97263C17.7635 3.97186 17.9459 3.9724 18.1284 3.97322C18.3201 3.97391 18.5119 3.97354 18.7037 3.97333C19.0263 3.97314 19.3489 3.9738 19.6715 3.97498C20.0425 3.97631 20.4135 3.97632 20.7845 3.9756C21.143 3.97493 21.5014 3.97522 21.8599 3.97593C22.0116 3.97621 22.1633 3.97618 22.3149 3.97586C23.9432 3.97323 25.4025 4.2036 26.6259 5.38611C27.3444 6.11041 27.8747 7.15566 27.8778 8.18829C27.8768 8.23477 27.8758 8.28125 27.8747 8.32914C27.8756 8.45702 27.8756 8.45702 27.9192 8.57023C28.0631 8.69674 28.2219 8.77891 28.3911 8.86513C28.5891 8.97479 28.7568 9.13372 28.9255 9.28302C28.9692 9.32153 28.9692 9.32153 29.0139 9.36082C29.844 10.1395 30.2453 11.2443 30.3182 12.3582C30.3552 13.6796 29.8327 15.0416 28.9674 16.0335C28.9339 16.0731 28.9005 16.1126 28.866 16.1533C27.9765 17.1815 26.6402 17.8926 25.2779 18.0042C25.0906 18.0104 24.9033 18.0109 24.7159 18.0116C24.6339 18.0123 24.552 18.013 24.47 18.0138C24.2694 18.0157 24.0687 18.0173 23.8681 18.0179C23.755 18.0182 23.642 18.019 23.5289 18.0202C23.4229 18.0214 23.3169 18.022 23.2109 18.0218C22.8104 18.0255 22.8104 18.0255 22.4689 18.2138C22.321 18.4403 22.2968 18.6891 22.2578 18.9512C22.2502 18.9998 22.2426 19.0485 22.2348 19.0986C22.2184 19.204 22.2022 19.3094 22.1862 19.4148C22.1608 19.5818 22.1349 19.7487 22.1089 19.9155C22.0537 20.2698 21.9993 20.6241 21.9449 20.9785C21.8861 21.361 21.8272 21.7435 21.7676 22.1259C21.7376 22.3181 21.7083 22.5105 21.6791 22.7029C21.6634 22.8038 21.6477 22.9048 21.632 23.0057C21.6218 23.0741 21.6218 23.0741 21.6114 23.1438C21.5613 23.4607 21.5106 23.7421 21.2531 23.9581C21.1234 24.023 20.9861 24.0073 20.8436 24.0081C20.81 24.0084 20.7764 24.0088 20.7418 24.0091C20.6302 24.0102 20.5187 24.0109 20.4072 24.0115C20.3692 24.0117 20.3311 24.0119 20.2919 24.0121C20.0905 24.0133 19.8891 24.0141 19.6877 24.0147C19.4796 24.0154 19.2715 24.0173 19.0634 24.0194C18.9035 24.0208 18.7436 24.0213 18.5836 24.0215C18.5069 24.0218 18.4302 24.0224 18.3535 24.0235C18.2461 24.0248 18.1387 24.0248 18.0313 24.0245C17.9997 24.0252 17.968 24.0258 17.9354 24.0266C17.768 24.0246 17.6972 24.0064 17.5659 23.8989C17.417 23.7111 17.4228 23.5621 17.4379 23.3291C17.4682 23.085 17.5072 22.8425 17.5465 22.5997C17.5577 22.5291 17.5688 22.4584 17.58 22.3878C17.6033 22.2406 17.6269 22.0933 17.6505 21.9461C17.6809 21.7574 17.7109 21.5686 17.7408 21.3798C17.7638 21.2343 17.7869 21.0888 17.8101 20.9434C17.8212 20.8738 17.8323 20.8041 17.8434 20.7345C17.8588 20.6374 17.8744 20.5404 17.89 20.4434C17.8946 20.4146 17.8992 20.3859 17.9038 20.3562C17.9229 20.2385 17.9451 20.1302 17.9829 20.0168C17.9377 20.0171 17.8925 20.0173 17.8459 20.0176C17.4196 20.0202 16.9933 20.0221 16.567 20.0233C16.3479 20.0239 16.1287 20.0248 15.9096 20.0263C15.6981 20.0276 15.4866 20.0284 15.2751 20.0287C15.1944 20.0289 15.1138 20.0294 15.0331 20.0301C14.92 20.031 14.8071 20.0311 14.694 20.0311C14.644 20.0317 14.644 20.0317 14.593 20.0324C14.4019 20.0314 14.2707 20.02 14.1258 19.891C13.9802 19.636 13.9982 19.455 14.0467 19.1714C14.0561 19.1106 14.0561 19.1106 14.0657 19.0485C14.0787 18.9646 14.0921 18.8807 14.1058 18.7968C14.1242 18.685 14.1415 18.573 14.1584 18.4609C14.1907 18.2469 14.2244 18.0332 14.2583 17.8195C14.2711 17.7383 14.2838 17.657 14.2966 17.5758C14.3311 17.357 14.3656 17.1382 14.4002 16.9194C14.4371 16.6856 14.474 16.4517 14.5108 16.2178C14.5897 15.7171 14.6687 15.2163 14.7477 14.7156C14.8778 13.8919 15.0077 13.0681 15.1376 12.2444C15.1698 12.0401 15.202 11.8359 15.2342 11.6317C15.4202 10.4524 15.6056 9.27308 15.7888 8.09339C15.8177 7.90719 15.8466 7.721 15.8756 7.53481C15.8893 7.44689 15.903 7.35897 15.9166 7.27105C15.9254 7.21446 15.9343 7.15788 15.9431 7.1013C15.9966 6.75708 16.0499 6.41281 16.1028 6.0685C16.132 5.87875 16.1616 5.68905 16.1912 5.49937C16.2044 5.41442 16.2175 5.32945 16.2304 5.24447C16.2476 5.13131 16.2653 5.01823 16.283 4.90516C16.2878 4.87313 16.2926 4.8411 16.2975 4.8081C16.3415 4.53311 16.3935 4.21135 16.6335 4.03665C16.8649 3.94414 17.1334 3.97155 17.3793 3.97354Z\" fill=\"#002F86\"/>\n" +
    "            <path d=\"M27.8773 8.57022C28.8396 8.97157 29.5687 9.85123 29.9798 10.7889C30.4854 12.0256 30.3709 13.3528 29.8734 14.5678C29.6458 15.1029 29.35 15.5949 28.9674 16.0335C28.934 16.073 28.9005 16.1126 28.866 16.1533C27.9765 17.1814 26.6403 17.8926 25.278 18.0042C25.0906 18.0104 24.9033 18.0109 24.7159 18.0116C24.6339 18.0123 24.552 18.013 24.47 18.0138C24.2694 18.0157 24.0687 18.0173 23.8681 18.0178C23.755 18.0182 23.642 18.019 23.529 18.0202C23.4229 18.0214 23.3169 18.022 23.2109 18.0218C22.8104 18.0255 22.8104 18.0255 22.469 18.2138C22.321 18.4403 22.2968 18.6891 22.2578 18.9512C22.2502 18.9998 22.2426 19.0485 22.2348 19.0986C22.2184 19.204 22.2022 19.3094 22.1862 19.4148C22.1608 19.5818 22.135 19.7487 22.1089 19.9155C22.0538 20.2698 21.9993 20.6241 21.9449 20.9785C21.8861 21.361 21.8273 21.7435 21.7676 22.1258C21.7377 22.3181 21.7083 22.5105 21.6791 22.7029C21.6634 22.8038 21.6477 22.9047 21.632 23.0056C21.6252 23.0512 21.6184 23.0968 21.6114 23.1438C21.5613 23.4607 21.5106 23.7421 21.2531 23.9581C21.1234 24.0229 20.9861 24.0073 20.8436 24.0081C20.81 24.0084 20.7764 24.0088 20.7418 24.0091C20.6303 24.0102 20.5188 24.0109 20.4072 24.0115C20.3692 24.0117 20.3311 24.0119 20.2919 24.0121C20.0905 24.0133 19.8891 24.0141 19.6877 24.0147C19.4796 24.0154 19.2715 24.0172 19.0635 24.0194C18.9035 24.0208 18.7436 24.0213 18.5836 24.0215C18.5069 24.0218 18.4302 24.0224 18.3535 24.0234C18.2461 24.0248 18.1388 24.0248 18.0314 24.0245C17.9997 24.0251 17.9681 24.0258 17.9354 24.0265C17.768 24.0246 17.6973 24.0064 17.5659 23.8989C17.417 23.7112 17.4231 23.562 17.4379 23.3291C17.4673 23.0904 17.5053 22.8533 17.5435 22.6159C17.5545 22.5464 17.5655 22.4769 17.5765 22.4074C17.5994 22.262 17.6226 22.1167 17.6459 21.9715C17.6756 21.7869 17.7048 21.6023 17.7339 21.4176C17.7565 21.2741 17.7793 21.1306 17.8022 20.9871C17.813 20.9192 17.8238 20.8512 17.8345 20.7832C17.8834 20.4747 17.9335 20.1678 18.0019 19.8629C18.0946 19.4428 18.1555 19.0171 18.2214 18.5922C18.2359 18.4991 18.2505 18.4061 18.2651 18.3131C18.3032 18.0693 18.3411 17.8254 18.379 17.5816C18.4097 17.3844 18.4406 17.1873 18.4714 16.9901C18.5291 16.621 18.5868 16.2518 18.6442 15.8827C18.6571 15.8001 18.67 15.7175 18.6829 15.6349C18.7139 15.4366 18.7435 15.2382 18.7707 15.0393C18.7761 15.0011 18.7814 14.9629 18.7869 14.9236C18.7968 14.8524 18.8064 14.7811 18.8155 14.7097C18.8501 14.4626 18.9047 14.2667 19.094 14.0917C19.2776 13.9677 19.4416 13.9732 19.6552 13.9737C19.6889 13.9737 19.7226 13.9736 19.7573 13.9735C19.8307 13.9733 19.904 13.9733 19.9774 13.9732C20.1347 13.9731 20.292 13.9722 20.4493 13.9713C20.7419 13.9698 21.0344 13.9684 21.327 13.9685C22.6068 13.9854 22.6068 13.9854 23.8525 13.7275C23.8836 13.7174 23.9147 13.7074 23.9467 13.6971C24.8669 13.3985 25.6598 12.8766 26.3261 12.1761C26.3535 12.148 26.3809 12.1199 26.4091 12.0909C27.2588 11.19 27.7617 9.92114 27.828 8.68913C27.8354 8.61215 27.8354 8.61215 27.8773 8.57022Z\" fill=\"#006FDF\"/>\n" +
    "            <path d=\"M38.2156 7.96726C38.254 7.9669 38.2925 7.96655 38.332 7.96618C38.3948 7.96656 38.3948 7.96656 38.4589 7.96695C38.5032 7.96673 38.5476 7.96651 38.5932 7.96628C38.7402 7.96573 38.8871 7.9661 39.0341 7.96652C39.1366 7.96644 39.2391 7.96632 39.3416 7.96616C39.5568 7.96597 39.7721 7.96624 39.9874 7.96683C40.2617 7.96754 40.536 7.96714 40.8103 7.96638C41.0223 7.96592 41.2343 7.96607 41.4463 7.9664C41.5473 7.96648 41.6484 7.96638 41.7494 7.96608C42.985 7.96327 44.0762 8.18068 45.0249 9.03145C45.0514 9.05458 45.078 9.07771 45.1054 9.10155C45.6964 9.6492 46.1229 10.5341 46.1568 11.3375C46.159 11.3821 46.1612 11.4266 46.1634 11.4725C46.1941 12.6919 45.7288 13.7782 44.941 14.6918C44.914 14.7231 44.8871 14.7544 44.8593 14.7867C44.0166 15.6879 42.7917 16.1177 41.5829 16.1643C41.1914 16.1742 40.7997 16.1765 40.4081 16.1785C40.2596 16.1794 40.111 16.181 39.9625 16.1827C39.9169 16.1828 39.8713 16.1828 39.8244 16.1828C39.7613 16.1836 39.7613 16.1836 39.697 16.1845C39.6601 16.1847 39.6231 16.1849 39.5851 16.1851C39.4892 16.1946 39.4892 16.1946 39.4178 16.2522C39.3508 16.3471 39.3368 16.421 39.3187 16.5357C39.3082 16.5997 39.3082 16.5997 39.2974 16.6649C39.2904 16.7113 39.2833 16.7577 39.276 16.8055C39.2682 16.8539 39.2604 16.9023 39.2524 16.9522C39.2274 17.108 39.2031 17.2639 39.1789 17.4198C39.1627 17.5211 39.1465 17.6224 39.1303 17.7237C39.0655 18.1299 39.0012 18.5361 38.9427 18.9433C38.9354 18.9929 38.9282 19.0425 38.9207 19.0937C38.907 19.1875 38.8937 19.2813 38.8808 19.3753C38.8485 19.5957 38.8171 19.7838 38.6941 19.9748C38.5847 20.0295 38.5027 20.0233 38.3802 20.0249C38.308 20.0259 38.308 20.0259 38.2343 20.0269C38.0143 20.0288 37.7943 20.0305 37.5742 20.0314C37.458 20.032 37.3418 20.0332 37.2255 20.0349C37.0583 20.0374 36.8912 20.0381 36.7239 20.0387C36.6719 20.0397 36.6198 20.0406 36.5662 20.0416C36.4936 20.0414 36.4936 20.0414 36.4195 20.0412C36.3769 20.0416 36.3344 20.0419 36.2905 20.0423C36.1786 20.0168 36.1786 20.0168 36.077 19.9419C35.9233 19.6288 36.0688 19.1679 36.1225 18.8316C36.133 18.7645 36.133 18.7645 36.1437 18.696C36.167 18.5476 36.1905 18.3992 36.214 18.2508C36.2308 18.1438 36.2477 18.0368 36.2644 17.9298C36.3052 17.6703 36.3461 17.4108 36.3872 17.1513C36.4205 16.9404 36.4538 16.7295 36.487 16.5185C36.4941 16.4734 36.4941 16.4734 36.5014 16.4273C36.511 16.3661 36.5206 16.305 36.5303 16.2438C36.6204 15.6715 36.7108 15.0991 36.8012 14.5268C36.8788 14.0361 36.9561 13.5454 37.0333 13.0546C37.1231 12.4839 37.213 11.9132 37.3031 11.3425C37.3127 11.2817 37.3223 11.2208 37.3319 11.1599C37.3367 11.13 37.3414 11.1 37.3463 11.0692C37.3795 10.8585 37.4127 10.6478 37.4458 10.4371C37.4904 10.1535 37.5352 9.86996 37.5801 9.58644C37.5966 9.48238 37.613 9.37831 37.6293 9.27424C37.6516 9.13223 37.6741 8.99025 37.6967 8.84829C37.7031 8.80707 37.7095 8.76585 37.7161 8.72338C37.8064 8.16028 37.8064 8.16028 37.9327 8.02878C38.0356 7.97706 38.1008 7.96742 38.2156 7.96726ZM40.2453 10.5828C40.165 10.8774 40.1172 11.174 40.0708 11.4756C40.0584 11.5551 40.0584 11.5551 40.0457 11.6362C40.0284 11.7478 40.0111 11.8594 39.994 11.971C39.972 12.1137 39.9497 12.2564 39.9274 12.399C39.906 12.5358 39.8849 12.6726 39.8638 12.8095C39.8558 12.8605 39.8478 12.9116 39.8395 12.9642C39.8323 13.0118 39.825 13.0594 39.8175 13.1084C39.811 13.1501 39.8046 13.1918 39.7979 13.2348C39.7848 13.3445 39.7816 13.4495 39.7842 13.5597C40.0361 13.5629 40.2881 13.5652 40.5401 13.5667C40.6255 13.5673 40.711 13.5681 40.7965 13.5692C41.5813 13.5791 42.3221 13.5563 42.9268 12.988C43.2306 12.6364 43.3675 12.1924 43.3426 11.7332C43.3057 11.426 43.1915 11.1393 42.9705 10.9182C42.601 10.6312 42.2016 10.5633 41.7439 10.5705C41.7007 10.5707 41.6576 10.5709 41.6131 10.5711C41.4769 10.5718 41.3406 10.5733 41.2044 10.5749C41.1114 10.5756 41.0184 10.5762 40.9253 10.5767C40.6987 10.578 40.472 10.5801 40.2453 10.5828Z\" fill=\"#003087\"/>\n" +
    "            <path d=\"M67.3066 7.9723C67.364 7.97185 67.364 7.97185 67.4226 7.9714C67.4646 7.9715 67.5065 7.9716 67.5497 7.97171C67.594 7.9715 67.6383 7.97128 67.6839 7.97106C67.8308 7.97048 67.9778 7.97052 68.1248 7.97062C68.2272 7.97045 68.3297 7.97027 68.4321 7.97007C68.6475 7.96976 68.8628 7.96977 69.0782 7.96999C69.3525 7.97023 69.6267 7.96953 69.901 7.96855C70.113 7.96793 70.325 7.9679 70.537 7.96803C70.638 7.96801 70.7389 7.96779 70.8399 7.96736C72.046 7.96292 73.0918 8.1446 74.0373 8.94759C74.0656 8.96937 74.094 8.99115 74.1232 9.01359C74.7401 9.50438 75.158 10.3576 75.2531 11.1279C75.3208 12.3447 75.0654 13.5042 74.2625 14.456C73.3378 15.4797 72.2482 16.0733 70.8509 16.1593C70.6709 16.1645 70.4911 16.1651 70.311 16.1652C70.21 16.166 70.109 16.1668 70.0081 16.1677C69.8507 16.1689 69.6934 16.1698 69.5361 16.1698C69.383 16.17 69.2299 16.1714 69.0768 16.1731C69.0295 16.1728 68.9822 16.1725 68.9335 16.1722C68.8898 16.1729 68.8461 16.1736 68.8011 16.1743C68.7434 16.1745 68.7434 16.1745 68.6846 16.1747C68.5795 16.1932 68.5795 16.1932 68.5144 16.2883C68.4523 16.4313 68.4241 16.5694 68.4021 16.7226C68.3973 16.7532 68.3925 16.7838 68.3875 16.8154C68.3719 16.9163 68.3568 17.0172 68.3418 17.1181C68.3309 17.1886 68.32 17.259 68.3091 17.3294C68.2804 17.5147 68.2522 17.7 68.2242 17.8854C68.1793 18.1817 68.1337 18.478 68.088 18.7742C68.0722 18.8774 68.0566 18.9806 68.0411 19.0838C68.0313 19.1475 68.0215 19.2112 68.0118 19.275C68.0076 19.3034 68.0034 19.3318 67.999 19.3611C67.9256 19.8356 67.9256 19.8356 67.7999 19.9712C67.6836 20.028 67.6001 20.033 67.4708 20.0337C67.4235 20.0342 67.3762 20.0348 67.3275 20.0353C67.2766 20.0352 67.2257 20.0351 67.1733 20.0349C67.1209 20.0352 67.0685 20.0354 67.0145 20.0356C66.9037 20.0359 66.7929 20.0359 66.6821 20.0355C66.5402 20.035 66.3984 20.0358 66.2566 20.0371C66.1211 20.038 65.9855 20.0377 65.85 20.0376C65.7991 20.038 65.7482 20.0385 65.6958 20.039C65.6485 20.0386 65.6012 20.0382 65.5525 20.0378C65.5109 20.0378 65.4694 20.0378 65.4265 20.0378C65.3168 20.0168 65.3168 20.0168 65.2182 19.9552C65.0517 19.6996 65.1691 19.2911 65.2154 19.0046C65.2261 18.9361 65.2261 18.9361 65.237 18.8661C65.2608 18.7137 65.2851 18.5614 65.3094 18.409C65.3266 18.2995 65.3438 18.19 65.361 18.0805C65.4028 17.8143 65.445 17.5481 65.4872 17.282C65.5364 16.972 65.5853 16.6619 65.6342 16.3518C65.7215 15.7985 65.8091 15.2452 65.8968 14.692C65.9819 14.1553 66.0667 13.6187 66.1513 13.082C66.2435 12.4971 66.3358 11.9123 66.4283 11.3275C66.4382 11.2652 66.4481 11.2028 66.4579 11.1404C66.4628 11.1097 66.4676 11.0791 66.4726 11.0475C66.5068 10.8314 66.5409 10.6153 66.575 10.3992C66.6165 10.1359 66.6581 9.87264 66.7 9.6094C66.7213 9.47513 66.7426 9.34085 66.7637 9.20654C66.7866 9.06092 66.8098 8.91535 66.833 8.76978C66.8396 8.72738 66.8462 8.68497 66.853 8.64128C66.9174 8.24179 66.9174 8.24179 66.9938 8.06708C67.1257 7.97912 67.1562 7.97268 67.3066 7.9723ZM69.3416 10.5828C69.2814 10.9586 69.2213 11.3343 69.1612 11.7101C69.1333 11.8846 69.1054 12.059 69.0775 12.2335C69.0505 12.4018 69.0236 12.5701 68.9967 12.7383C68.9865 12.8026 68.9762 12.8669 68.9658 12.9312C68.9514 13.0211 68.9371 13.1109 68.9228 13.2008C68.9146 13.252 68.9064 13.3032 68.8979 13.356C68.8784 13.4695 68.8784 13.4695 68.8804 13.5597C69.1384 13.5629 69.3963 13.5652 69.6543 13.5667C69.7418 13.5673 69.8292 13.5681 69.9167 13.5692C70.6556 13.5783 71.4212 13.5814 72 13.0476C72.3496 12.6559 72.4719 12.2027 72.4585 11.6869C72.4231 11.3432 72.2465 11.056 71.9829 10.8344C71.7171 10.6826 71.4577 10.5772 71.1503 10.578C71.11 10.5781 71.0697 10.5781 71.0282 10.5781C70.9851 10.5783 70.9419 10.5785 70.8974 10.5787C70.853 10.5788 70.8086 10.5788 70.7628 10.5789C70.621 10.5791 70.4792 10.5797 70.3373 10.5802C70.2412 10.5804 70.145 10.5806 70.0488 10.5808C69.8131 10.5812 69.5773 10.5819 69.3416 10.5828Z\" fill=\"#0070E0\"/>\n" +
    "            <path d=\"M82.045 12.1761C82.0461 12.1478 82.0472 12.1195 82.0483 12.0903C82.0507 12.0529 82.0531 12.0155 82.0555 11.9769C82.0575 11.94 82.0594 11.903 82.0614 11.8649C82.0944 11.7253 82.1438 11.6789 82.2547 11.5891C82.3631 11.5681 82.3631 11.5681 82.4872 11.5681C82.5338 11.5677 82.5804 11.5673 82.6284 11.5669C82.7035 11.5676 82.7035 11.5676 82.7802 11.5683C82.8318 11.5682 82.8834 11.5682 82.9365 11.5681C83.0455 11.5682 83.1545 11.5687 83.2635 11.5695C83.3754 11.5703 83.4872 11.5708 83.5991 11.5704C83.7603 11.5699 83.9214 11.5702 84.0825 11.5709C84.1327 11.5708 84.1829 11.5707 84.2346 11.5705C84.281 11.5711 84.3275 11.5716 84.3754 11.5722C84.4163 11.5724 84.4572 11.5726 84.4994 11.5728C84.6231 11.5923 84.6525 11.6172 84.7283 11.7149C84.7983 12.0973 84.6831 12.5287 84.6225 12.9089C84.6111 12.982 84.5998 13.0551 84.5884 13.1283C84.5577 13.3257 84.5266 13.523 84.4954 13.7203C84.4693 13.8853 84.4434 14.0504 84.4176 14.2154C84.3566 14.6048 84.2952 14.9941 84.2336 15.3834C84.1702 15.7846 84.1072 16.1859 84.0446 16.5872C83.9907 16.9324 83.9365 17.2776 83.882 17.6227C83.8495 17.8285 83.8172 18.0344 83.7851 18.2403C83.7549 18.4338 83.7243 18.6272 83.6935 18.8205C83.6822 18.8914 83.6711 18.9623 83.6602 19.0332C83.6452 19.1301 83.6297 19.227 83.614 19.3239C83.6055 19.378 83.597 19.4322 83.5882 19.488C83.5392 19.7075 83.4974 19.887 83.3028 20.0168C83.2029 20.0277 83.2029 20.0277 83.0834 20.0283C83.0386 20.0287 82.9938 20.0291 82.9477 20.0295C82.8993 20.0295 82.851 20.0294 82.8012 20.0294C82.7515 20.0296 82.7018 20.0297 82.6506 20.0299C82.5455 20.0302 82.4404 20.0302 82.3353 20.03C82.1742 20.0299 82.0132 20.0309 81.8522 20.0319C81.7501 20.032 81.6481 20.032 81.546 20.032C81.4978 20.0324 81.4495 20.0328 81.3998 20.0332C81.3549 20.0329 81.31 20.0326 81.2637 20.0324C81.2045 20.0324 81.2045 20.0324 81.1441 20.0325C81.0194 20.0139 80.9619 19.9772 80.8711 19.891C80.8456 19.7962 80.8456 19.7962 80.8397 19.6944C80.8373 19.6606 80.8349 19.6267 80.8325 19.5917C80.8314 19.566 80.8303 19.5402 80.8292 19.5136C80.7951 19.5349 80.761 19.5562 80.7259 19.5782C80.4516 19.7447 80.1786 19.884 79.8754 19.9906C79.8472 20.0005 79.8191 20.0105 79.7901 20.0208C78.7573 20.3685 77.6335 20.2396 76.6689 19.7614C75.8582 19.3443 75.268 18.6487 74.9596 17.7945C74.5605 16.5382 74.6898 15.1371 75.2755 13.9618C75.4604 13.6051 75.6649 13.2809 75.9239 12.9727C75.9722 12.9142 75.9722 12.9142 76.0215 12.8545C77.551 11.0832 80.1836 10.8112 82.045 12.1761ZM77.8682 14.5737C77.4874 15.0254 77.2771 15.6016 77.3152 16.1955C77.37 16.6316 77.5576 17.0811 77.8944 17.3753C78.3972 17.7504 78.9189 17.899 79.5421 17.8186C80.1917 17.7008 80.7146 17.3776 81.0939 16.838C81.4214 16.3225 81.5459 15.7459 81.4324 15.1421C81.2843 14.6432 80.9795 14.2745 80.5357 14.0136C79.636 13.5303 78.5362 13.86 77.8682 14.5737Z\" fill=\"#0070E0\"/>\n" +
    "            <path d=\"M52.768 12.0896C52.8 12.1181 52.8319 12.1467 52.8649 12.1761C52.8725 12.1443 52.8802 12.1124 52.888 12.0796C52.8985 12.0379 52.9091 11.9963 52.9199 11.9533C52.9302 11.912 52.9404 11.8706 52.9509 11.828C52.993 11.7084 53.0171 11.6649 53.1165 11.5891C53.2196 11.5728 53.2196 11.5728 53.3436 11.5721C53.4133 11.5713 53.4133 11.5713 53.4844 11.5705C53.5596 11.5707 53.5596 11.5707 53.6364 11.5709C53.7137 11.5706 53.7137 11.5706 53.7926 11.5702C53.9296 11.5699 54.0667 11.5702 54.2037 11.5707C54.3428 11.5708 54.482 11.5693 54.6211 11.5682C54.727 11.5681 54.8329 11.5682 54.9387 11.5683C54.9888 11.5678 55.0389 11.5673 55.0906 11.5669C55.1371 11.5672 55.1837 11.5676 55.2317 11.568C55.2727 11.5681 55.3136 11.5681 55.3558 11.5681C55.4977 11.5956 55.5424 11.6449 55.632 11.7568C55.6431 11.8573 55.6431 11.8573 55.6284 11.9727C55.6203 12.0399 55.6203 12.0399 55.6121 12.1084C55.6048 12.1584 55.5975 12.2084 55.5901 12.2599C55.5787 12.3413 55.5787 12.3413 55.5671 12.4242C55.5397 12.6158 55.5096 12.807 55.4795 12.9982C55.4682 13.0714 55.4568 13.1446 55.4454 13.2178C55.4148 13.4151 55.3839 13.6124 55.3529 13.8097C55.3336 13.9332 55.3142 14.0566 55.2949 14.18C55.2276 14.6109 55.16 15.0419 55.0923 15.4728C55.0292 15.874 54.9666 16.2753 54.9042 16.6766C54.8504 17.0218 54.7964 17.367 54.7421 17.7122C54.7097 17.918 54.6775 18.1239 54.6456 18.3299C54.6156 18.5233 54.5852 18.7166 54.5545 18.9099C54.5433 18.9808 54.5323 19.0517 54.5214 19.1226C54.5065 19.2195 54.4911 19.3163 54.4756 19.4131C54.4628 19.4943 54.4628 19.4943 54.4498 19.5771C54.4154 19.7266 54.3683 19.843 54.2904 19.9748C54.1837 20.0282 54.1074 20.023 53.988 20.0242C53.9424 20.0247 53.8968 20.0253 53.8498 20.0258C53.7755 20.0263 53.7755 20.0263 53.6998 20.0267C53.6492 20.0271 53.5985 20.0274 53.5463 20.0278C53.4389 20.0284 53.3316 20.0288 53.2242 20.0291C53.0598 20.0299 52.8954 20.0317 52.7309 20.0335C52.6268 20.034 52.5226 20.0343 52.4185 20.0346C52.3692 20.0353 52.3198 20.0361 52.269 20.0368C52.2002 20.0367 52.2002 20.0367 52.13 20.0365C52.0897 20.0367 52.0493 20.037 52.0078 20.0372C51.8695 20.0108 51.82 19.9571 51.7329 19.849C51.7006 19.7354 51.6989 19.6326 51.691 19.5136C51.6549 19.5354 51.6189 19.5572 51.5818 19.5796C50.9056 19.9815 50.2312 20.2098 49.4375 20.2028C49.3862 20.2025 49.3348 20.2021 49.282 20.2018C48.2396 20.1824 47.3148 19.781 46.5808 19.0351C46.3933 18.8361 46.2471 18.621 46.1149 18.3815C46.0868 18.3335 46.0868 18.3335 46.0581 18.2846C45.7077 17.6463 45.5647 16.8398 45.6118 16.1174C45.6135 16.0903 45.6152 16.0632 45.617 16.0353C45.7065 14.7452 46.1827 13.6179 47.0792 12.6792C47.1043 12.651 47.1295 12.6227 47.1553 12.5936C48.5232 11.1133 51.1975 10.7996 52.768 12.0896ZM48.7562 14.566C48.3203 15.0769 48.1722 15.6682 48.2112 16.327C48.2911 16.8103 48.5743 17.2277 48.9619 17.5192C49.4115 17.8199 49.9408 17.8983 50.4688 17.8093C51.0707 17.6823 51.5685 17.4043 51.9319 16.8954C51.9969 16.7919 52.0549 16.6876 52.1103 16.5786C52.1266 16.5464 52.143 16.5142 52.1599 16.481C52.3789 15.9963 52.4154 15.4705 52.2436 14.9688C52.0493 14.4895 51.7141 14.155 51.2487 13.9386C50.3815 13.572 49.3783 13.9007 48.7562 14.566Z\" fill=\"#003087\"/>\n" +
    "            <path d=\"M56.6718 11.5728C56.7467 11.5722 56.7467 11.5722 56.8231 11.5716C56.9041 11.572 56.9041 11.572 56.9867 11.5724C57.0426 11.5723 57.0986 11.5722 57.1545 11.572C57.2716 11.5718 57.3888 11.5721 57.5059 11.5727C57.6561 11.5734 57.8062 11.573 57.9563 11.5723C58.0718 11.5718 58.1873 11.5719 58.3027 11.5723C58.385 11.5724 58.4673 11.572 58.5496 11.5716C58.5995 11.572 58.6495 11.5724 58.7009 11.5728C58.7449 11.5729 58.789 11.573 58.8343 11.5731C58.9441 11.5891 58.9441 11.5891 59.0188 11.6442C59.1036 11.7615 59.1371 11.8972 59.1778 12.0343C59.1879 12.0672 59.198 12.1001 59.2085 12.134C59.2421 12.244 59.2752 12.3542 59.3083 12.4644C59.3318 12.5416 59.3554 12.6188 59.379 12.6959C59.4439 12.9089 59.5082 13.1221 59.5725 13.3353C59.6325 13.5341 59.6927 13.7328 59.7529 13.9316C59.9311 14.5203 60.1087 15.1091 60.2857 15.6981C60.3134 15.6981 60.3411 15.6981 60.3696 15.6981C60.386 15.6695 60.4024 15.6409 60.4193 15.6114C60.7114 15.1024 61.0042 14.594 61.3076 14.0917C61.4695 13.8233 61.6293 13.5538 61.7887 13.284C61.9163 13.0682 62.0443 12.8527 62.1724 12.6373C62.2005 12.5901 62.2286 12.5428 62.2575 12.4941C62.338 12.3591 62.4189 12.2243 62.4999 12.0896C62.5243 12.0487 62.5486 12.0078 62.5737 11.9657C62.5963 11.9283 62.6189 11.8908 62.6422 11.8523C62.6619 11.8195 62.6816 11.7868 62.7018 11.753C62.7593 11.673 62.7593 11.673 62.8851 11.5891C63.0031 11.5782 63.0031 11.5782 63.1482 11.5776C63.2025 11.5772 63.2568 11.5768 63.3127 11.5764C63.372 11.5764 63.4313 11.5764 63.4906 11.5765C63.5513 11.5763 63.612 11.5761 63.6727 11.5759C63.7999 11.5756 63.9271 11.5756 64.0543 11.5759C64.2175 11.5761 64.3807 11.5754 64.5439 11.5744C64.6693 11.5738 64.7946 11.5738 64.92 11.5739C64.9802 11.5739 65.0404 11.5737 65.1006 11.5732C65.1846 11.5727 65.2686 11.5731 65.3526 11.5735C65.4004 11.5735 65.4483 11.5734 65.4976 11.5734C65.5348 11.5786 65.5719 11.5838 65.6103 11.5891C65.7089 11.7371 65.7122 11.7921 65.6941 11.9665C65.6367 12.0895 65.6367 12.0895 65.5559 12.2184C65.5414 12.2418 65.527 12.2652 65.5121 12.2893C65.465 12.3655 65.4171 12.4411 65.3692 12.5168C65.3361 12.57 65.3031 12.6232 65.2701 12.6765C65.2043 12.7827 65.1383 12.8888 65.072 12.9947C64.9555 13.1816 64.8424 13.3705 64.7298 13.5598C64.5133 13.9218 64.2943 14.2824 64.0752 14.6429C63.8872 14.9521 63.6998 15.2617 63.514 15.5723C63.2974 15.9343 63.0785 16.295 62.8594 16.6554C62.6714 16.9647 62.484 17.2743 62.2982 17.5849C62.0816 17.9469 61.8627 18.3075 61.6435 18.668C61.4555 18.9773 61.2681 19.2869 61.0823 19.5975C60.8092 20.0536 60.5337 20.5083 60.257 20.9623C60.163 21.1166 60.0694 21.2713 59.9761 21.4261C59.9151 21.5272 59.8538 21.6281 59.7924 21.729C59.7495 21.7998 59.7069 21.8709 59.6643 21.9419C59.6382 21.9847 59.6121 22.0274 59.5853 22.0714C59.5626 22.109 59.5399 22.1465 59.5165 22.1852C59.4425 22.2875 59.3874 22.3415 59.2795 22.4067C59.1599 22.4224 59.1599 22.4224 59.02 22.4223C58.9676 22.4226 58.9151 22.4228 58.861 22.4231C58.8039 22.4228 58.7469 22.4224 58.6898 22.4219C58.6311 22.4219 58.5724 22.4219 58.5137 22.422C58.3909 22.422 58.2681 22.4216 58.1453 22.4208C57.9879 22.4199 57.8304 22.4198 57.673 22.4201C57.5519 22.4203 57.4308 22.42 57.3097 22.4196C57.2517 22.4194 57.1936 22.4194 57.1355 22.4194C57.0545 22.4194 56.9734 22.4188 56.8923 22.4182C56.8462 22.418 56.8 22.4178 56.7525 22.4176C56.6382 22.4067 56.6382 22.4067 56.5124 22.3229C56.4666 22.1971 56.4619 22.1354 56.5105 22.0098C56.5315 21.974 56.5525 21.9383 56.5742 21.9014C56.5976 21.861 56.6211 21.8206 56.6453 21.779C56.6706 21.7371 56.696 21.6952 56.7221 21.652C56.7464 21.6113 56.7707 21.5707 56.7957 21.5288C56.8742 21.3989 56.9539 21.2699 57.0339 21.141C57.063 21.0939 57.0921 21.0468 57.122 20.9983C57.2942 20.7198 57.4674 20.442 57.6412 20.1645C57.6937 20.0805 57.746 19.9965 57.7981 19.9123C57.9178 19.7192 58.0393 19.5284 58.168 19.3412C58.1903 19.3077 58.2126 19.2743 58.2356 19.2398C58.2765 19.1785 58.3186 19.118 58.362 19.0585C58.4414 18.9376 58.4903 18.8506 58.4686 18.7038C58.4579 18.6684 58.4472 18.633 58.4361 18.5965C58.4239 18.5557 58.4118 18.5149 58.3992 18.4728C58.3853 18.4289 58.3715 18.3849 58.3572 18.3396C58.3431 18.2945 58.329 18.2493 58.3145 18.2028C58.266 18.0498 58.2165 17.8972 58.1667 17.7446C58.148 17.6871 58.1293 17.6295 58.1107 17.572C58.0711 17.45 58.0315 17.328 57.9918 17.2061C57.8977 16.9168 57.8039 16.6274 57.7101 16.3381C57.689 16.2731 57.6679 16.2081 57.6468 16.1431C57.4258 15.4617 57.2071 14.7797 56.9896 14.0972C56.8681 13.716 56.7458 13.3352 56.6204 12.9554C56.5982 12.888 56.5761 12.8207 56.5539 12.7533C56.5139 12.6316 56.4734 12.51 56.4326 12.3885C56.4151 12.3354 56.3976 12.2823 56.3801 12.2292C56.3651 12.1841 56.35 12.139 56.3345 12.0926C56.3008 11.9586 56.2879 11.8523 56.3028 11.7149C56.4046 11.5696 56.5016 11.5732 56.6718 11.5728Z\" fill=\"#003087\"/>\n" +
    "            <path d=\"M20.3919 8.01898C20.4405 8.01868 20.4892 8.01838 20.5393 8.01807C20.593 8.01796 20.6466 8.01785 20.7019 8.01773C20.7588 8.01747 20.8157 8.01719 20.8726 8.01689C21.06 8.01601 21.2475 8.01558 21.4349 8.01516C21.4996 8.01499 21.5644 8.01482 21.6291 8.01464C21.934 8.01384 22.2388 8.01325 22.5437 8.0129C22.8938 8.01249 23.244 8.01139 23.5941 8.00969C23.8657 8.00842 24.1372 8.0078 24.4087 8.00767C24.5703 8.00757 24.732 8.00721 24.8937 8.00614C25.7427 8.00082 26.5559 8.02341 27.3559 8.34486C27.389 8.3574 27.4222 8.36994 27.4563 8.38286C27.5957 8.43648 27.7102 8.48677 27.8354 8.57022C28.0379 9.43929 27.4648 10.6218 27.03 11.3451C26.8715 11.5987 26.6921 11.8264 26.4938 12.0503C26.4684 12.0807 26.443 12.1112 26.4168 12.1425C25.6683 13.0316 24.5639 13.605 23.4457 13.872C23.3864 13.8863 23.3274 13.9012 23.2687 13.9174C22.9252 14.0012 22.5782 13.9908 22.227 13.9905C22.1087 13.9905 21.9905 13.991 21.8722 13.9917C21.5361 13.9937 21.2001 13.9947 20.8641 13.995C20.6578 13.9952 20.4516 13.9962 20.2453 13.9977C20.167 13.9981 20.0888 13.9982 20.0105 13.998C19.901 13.9977 19.7916 13.9985 19.6822 13.9994C19.6502 13.9991 19.6182 13.9987 19.5852 13.9984C19.3225 14.0024 19.1475 14.0835 18.9498 14.262C18.9278 14.288 18.9278 14.288 18.9053 14.3145C18.9414 14.0044 18.9902 13.6965 19.0389 13.3883C19.0482 13.3294 19.0574 13.2706 19.0667 13.2117C19.0915 13.0538 19.1164 12.896 19.1413 12.7381C19.1673 12.5736 19.1932 12.4092 19.2191 12.2447C19.2509 12.0432 19.2827 11.8418 19.3144 11.6403C19.3789 11.232 19.4429 10.8236 19.5066 10.4152C19.5365 10.224 19.5664 10.0327 19.5964 9.84152C19.6125 9.73881 19.6285 9.63609 19.6444 9.53337C19.6665 9.39104 19.6888 9.24874 19.7112 9.10645C19.7207 9.04461 19.7207 9.04461 19.7305 8.98151C19.8355 8.31691 19.8355 8.31691 20.0792 8.06708C20.1887 8.01234 20.2693 8.0195 20.3919 8.01898Z\" fill=\"#001C64\"/>\n" +
    "            <path d=\"M87.1013 7.97039C87.1494 7.96972 87.1976 7.96905 87.2472 7.96836C87.2992 7.96814 87.3512 7.96791 87.4048 7.96768C87.4849 7.96711 87.4849 7.96711 87.5666 7.96653C87.6796 7.96592 87.7926 7.96552 87.9057 7.9654C88.0504 7.96517 88.195 7.96359 88.3397 7.96168C88.4779 7.96013 88.6161 7.96007 88.7543 7.95982C88.8062 7.959 88.8581 7.95818 88.9116 7.95734C88.9599 7.95759 89.0081 7.95785 89.0579 7.95811C89.1003 7.9579 89.1428 7.95768 89.1865 7.95746C89.2981 7.98324 89.2981 7.98324 89.3996 8.05819C89.5055 8.27351 89.4582 8.46359 89.4239 8.69603C89.42 8.72337 89.4162 8.75072 89.4122 8.7789C89.3795 9.00949 89.3431 9.23947 89.3065 9.46947C89.2944 9.54663 89.2822 9.6238 89.2701 9.70097C89.2372 9.91 89.2042 10.119 89.171 10.328C89.1359 10.5498 89.101 10.7717 89.066 10.9936C88.9994 11.4163 88.9326 11.839 88.8657 12.2617C88.7913 12.7323 88.7171 13.2029 88.6429 13.6735C88.5153 14.4828 88.3874 15.2921 88.2593 16.1013C88.1749 16.635 88.0907 17.1688 88.007 17.7026C87.9775 17.8907 87.9479 18.0787 87.9183 18.2668C87.8961 18.4081 87.8739 18.5494 87.8519 18.6907C87.8285 18.8408 87.8049 18.9909 87.7812 19.1409C87.7746 19.1836 87.768 19.2263 87.7612 19.2703C87.6711 19.8371 87.6711 19.8371 87.5468 19.9712C87.4305 20.028 87.347 20.033 87.2177 20.0337C87.1704 20.0343 87.1231 20.0348 87.0744 20.0353C87.0235 20.0352 86.9726 20.0351 86.9202 20.035C86.8678 20.0352 86.8154 20.0354 86.7614 20.0356C86.6505 20.0359 86.5398 20.0359 86.429 20.0355C86.2871 20.035 86.1453 20.0359 86.0035 20.0371C85.868 20.038 85.7324 20.0377 85.5969 20.0376C85.546 20.0381 85.4951 20.0385 85.4427 20.039C85.3954 20.0386 85.3481 20.0382 85.2994 20.0378C85.2578 20.0378 85.2163 20.0378 85.1734 20.0378C85.0637 20.0168 85.0637 20.0168 84.9651 19.9552C84.8119 19.7199 84.9026 19.3749 84.9459 19.1097C84.954 19.0581 84.954 19.0581 84.9623 19.0054C84.9802 18.891 84.9986 18.7767 85.017 18.6624C85.03 18.5799 85.043 18.4973 85.056 18.4148C85.0914 18.1907 85.1271 17.9667 85.1629 17.7426C85.2007 17.5056 85.2382 17.2684 85.2757 17.0313C85.3472 16.5798 85.4189 16.1282 85.4908 15.6767C85.579 15.1229 85.6668 14.5691 85.7545 14.0152C85.8466 13.4345 85.9387 12.8538 86.0311 12.2731C86.0604 12.0888 86.0897 11.9046 86.119 11.7203C86.126 11.6759 86.1331 11.6316 86.1404 11.5858C86.2247 11.0554 86.3086 10.5248 86.3912 9.99407C86.4051 9.90478 86.4191 9.81549 86.433 9.72621C86.4728 9.47117 86.5125 9.21611 86.5517 8.96098C86.5649 8.87651 86.5781 8.79204 86.5913 8.70757C86.5996 8.6526 86.5996 8.6526 86.6081 8.59652C86.6369 8.41355 86.6673 8.23848 86.7407 8.0671C86.8829 7.9723 86.9344 7.97215 87.1013 7.97039Z\" fill=\"#0070E0\"/>\n" +
    "          </g>\n" +
    "          <defs>\n" +
    "            <clipPath id=\"clip0_2_22\">\n" +
    "              <rect width=\"75.4658\" height=\"20\" fill=\"white\" transform=\"translate(14 4)\"/>\n" +
    "            </clipPath>\n" +
    "          </defs>\n" +
    "        </svg>\n" +
    "      </div>\n" +
    "    </div><!-- .overlay-header -->\n" +
    "    <div ui-view=\"header\"></div>\n" +
    "    <!-- .overlay-header-form -->\n" +
    "    <div class=\"overlay-body\">\n" +
    "      <div class=\"overlay-main\">\n" +
    "        <form name=\"overlayForm\" class=\"widget-form\" ng-submit=\"processForm(formData)\">\n" +
    "          <div ui-view=\"step\"></div>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "      <div ui-view=\"side\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-background\"></div>\n" +
    "</div>\n" +
    "<div ui-view=\"footer\"></div>\n" +
    "<div class=\"overlay-mask\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/paypal/side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/paypal/side-options.html",
    "<div class=\"overlay-side\">\n" +
    "    <h2>Questions?</h2>\n" +
    "    <p>{{info}}</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/paypal/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/paypal/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.recipient && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Destination Account</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"recipient\">Destination Account</label>\n" +
    "    <div class=\"error-block-top__hint-text input-full\">\n" +
    "      <span>Can be a PayPal email or PayPal phone number</span>\n" +
    "    </div>\n" +
    "    <input\n" +
    "            ng-model=\"formData.recipient\"\n" +
    "            name=\"recipient\"\n" +
    "            id=\"recipient\"\n" +
    "            ng-change=\"clearRecipientError()\"\n" +
    "            value=\"{{formData.recipient}}\">\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-show=\"recipientMessage && !recipientValid\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>{{recipientMessage}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "              id=\"Amount\"\n" +
    "              value=\"{{formData.Amount}}\"\n" +
    "              type=\"number\"\n" +
    "              name=\"Amount\"\n" +
    "              ng-model=\"formData.Amount\"\n" +
    "              class=\"input-small\"\n" +
    "              ng-change=\"formatAmountMessage()\"\n" +
    "              required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\">\n" +
    "      <p>Balance: {{balance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small content amount-balance-not-enough\" ng-show=\"amountMessage && !amountValid\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>{{amountMessage}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/paypal/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/paypal/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"address-label\">Recipient</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"address-container\" id=\"transfer_to\">\n" +
    "        {{ formData.recipient }}<br>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label>Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{ formData.Amount | akimboCurrency }}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/paypal/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/paypal/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"address-label\">Recipient</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"address-container\" id=\"transfer_to\">\n" +
    "        {{ formData.recipient }}<br>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/account/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/account/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Address.$error.required && overlayForm.Address.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter Address</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Address\">Address</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.Address\" name=\"Address\" id=\"Address\" value=\"{{formData.Address}}\" required>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"AddressSuite\">Address</label>\n" +
    "    <input type=\"text\" name=\"AddressSuite\" id=\"AddressSuite\" value=\"{{formData.AddressSuite}}\" ng-model=\"formData.AddressSuite\">\n" +
    "  </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.City.$error.required && overlayForm.City.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter City</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"City\">City</label>\n" +
    "    <input type=\"text\" name=\"City\" ng-model=\"formData.City\" id=\"City\" value=\"{{formData.City}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"form-select\">\n" +
    "    <label for=\"StateCode\">State</label>\n" +
    "    <select name=\"StateCode\" id=\"State\" ng-model=\"formData.State\" ng-options=\"s.state for s in states track by s.key\">\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.PostalCode.$error.required && overlayForm.PostalCode.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter PostalCode</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"PostalCode\">Zipcode</label>\n" +
    "    <input type=\"text\" name=\"PostalCode\" ng-model=\"formData.PostalCode\" id=\"PostalCode\" value=\"{{formData.PostalCode}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Phone.$error.required && overlayForm.Phone.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter Phone</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Phone\">Phone</label>\n" +
    "    <input type=\"text\"\n" +
    "           maxlength=\"12\"\n" +
    "           name=\"Phone\"\n" +
    "           ng-model=\"formData.Phone\"\n" +
    "           id=\"Phone\"\n" +
    "           value=\"{{formData.Phone}}\"\n" +
    "           required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Email.$error.required && overlayForm.Email.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter Email</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-hide=\"{{brand.ssoHide}}\">\n" +
    "    <label class=\"overlay-title-text\" for=\"email\">Email</label>\n" +
    "    <input type=\"text\" name=\"email\" ng-model=\"formData.Email\" id=\"email\" value=\"{{formData.Email}}\" readonly=\"true\">\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/account/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/account/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Address</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-address_line_1\">{{formData.Address}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-if=\"formData.AddressSuite\">\n" +
    "    <label for=\"#\">Address</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-address_line_1\">{{formData.AddressSuite}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">City</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-city\">{{formData.City}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">State</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-state\">{{formData.State.state || formData.State.key}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Zipcode</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-zipcode\">{{formData.PostalCode}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Phone</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-primary_phone\">{{formData.Phone}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-hide=\"{{brand.ssoHide}}\">\n" +
    "    <label for=\"#\">Email</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-email\">{{formData.Email}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/activate/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/activate/step1.html",
    "<ul class=\"form js-autoscroll-form dash-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"invalidRequest\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Sorry, we were unable to activate your card. Please check the card number and valid thru date then try again.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.CardNumber.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.CardNumber.$error.minlength\">Card must be 15-19 digits</li>\n" +
    "        <li ng-show=\"overlayForm.CardNumber.$error.maxlength\">Card must be 15-19 digits</li>\n" +
    "        <li ng-show=\"overlayForm.CardNumber.$error.pattern\">Card must be only numbers</li>\n" +
    "        <li ng-show=\"overlayForm.CardNumber.$error.required\">Please Enter Card Number</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"CardNumber\">Card Number</label>\n" +
    "    <input\n" +
    "      type=\"text\"\n" +
    "      ng-model=\"formData.CardNumber\"\n" +
    "      name=\"CardNumber\"\n" +
    "      id=\"CardNumber\"\n" +
    "      placeholder=\"XXXXXXXXXXXXXXXX\"\n" +
    "      data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "      ng-maxlength=\"19\"\n" +
    "      ng-minlength=\"15\"\n" +
    "      autocomplete=\"new-password\"\n" +
    "      required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"(!overlayForm.CardMonth.$valid || !overlayForm.CardYear.$valid) && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.CardMonth.$error.required\">Please Enter Card Valid Thru Month</li>\n" +
    "        <li ng-show=\"overlayForm.CardYear.$error.required\">Please Enter Card Valid Thru Year</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"ExpMonth\">Card Valid Thru Date</label>\n" +
    "    <select\n" +
    "      required\n" +
    "      name=\"CardMonth\"\n" +
    "      id=\"ExpMonth\"\n" +
    "      ng-model=\"formData.CardMonth\"\n" +
    "      ng-options=\"month for month in range(1, 12)\">\n" +
    "        <option value=\"\" ng-if=\"!formData.CardMonth\">Month</option>\n" +
    "      </select>\n" +
    "      <select\n" +
    "        required\n" +
    "        name=\"CardYear\"\n" +
    "        ng-model=\"formData.CardYear\"\n" +
    "        ng-options=\"year for year in range(minYear, maxYear, false)\">\n" +
    "          <option value=\"\" ng-if=\"!formData.CardYear\">Year</option>\n" +
    "      </select>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Cvv.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please re-enter your 3-digit Card Security Code found on the back of your card</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text x-small\" for=\"Cvv\">Card Security Code</label>\n" +
    "    <input\n" +
    "            type=\"password\"\n" +
    "            class=\"pinInput\"\n" +
    "            name=\"Cvv\"\n" +
    "            id=\"Cvv\"\n" +
    "            value=\"\"\n" +
    "            placeholder=\"XXX\"\n" +
    "            maxlength=\"3\"\n" +
    "            ng-model=\"formData.Cvv\"\n" +
    "            required\n" +
    "            data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "            ng-maxlength=\"3\"\n" +
    "            ng-minlength=\"3\">\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Pin.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please re-enter your New PIN using 4 numbers</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Pin\">Set Card PIN</label>\n" +
    "    <input\n" +
    "      type=\"password\"\n" +
    "      class=\"pinInput\"\n" +
    "      name=\"Pin\"\n" +
    "      id=\"Pin\"\n" +
    "      value=\"\"\n" +
    "      placeholder=\"XXXX\"\n" +
    "      maxlength=\"4\"\n" +
    "      ng-model=\"formData.Pin\"\n" +
    "      required\n" +
    "      data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "      ng-maxlength=\"4\"\n" +
    "      ng-minlength=\"4\">\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"(formData.Pin != formData.Pin1) && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Pins do not match</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Pin1\">Confirm PIN</label>\n" +
    "    <input\n" +
    "      type=\"password\"\n" +
    "      class=\"pinInput\"\n" +
    "      name=\"Pin1\"\n" +
    "      id=\"Pin1\"\n" +
    "      placeholder=\"XXXX\"\n" +
    "      maxlength=\"4\"\n" +
    "      value=\"\"\n" +
    "      match-elem\n" +
    "      ng-model=\"formData.Pin1\"\n" +
    "      required\n" +
    "      data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "      ng-maxlength=\"4\"\n" +
    "      ng-minlength=\"4\">\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/atm/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/atm/step1.html",
    "<ul class=\"form js-autoscroll-form noBorder\">\n" +
    "  <li>\n" +
    "    <label class=\"extra-space\">{{card.firstName}} {{card.lastName}}  x{{card.cardLastFour}}</label>\n" +
    "    <div class=\"toggle-input atm-toggle\">\n" +
    "      <div class=\"toggle-bg {{atmToggle}}\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"atm-toggle\"\n" +
    "          value=\"off\"\n" +
    "          ng-change=\"updated('off')\"\n" +
    "          ng-model=\"atmToggle\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"atm-toggle\"\n" +
    "          value=\"on\"\n" +
    "          ng-change=\"updated('on')\"\n" +
    "          ng-model=\"atmToggle\">\n" +
    "        <span class=\"switch {{atmToggle}}\"></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <h3 class=\"toggle-status\">{{atmToggle === 'on' ? 'Enabled': 'Disabled'}}</h3>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<div class=\"exPaddingBtm\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/atm/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/atm/step2.html",
    "<ul class=\"form js-autoscroll-form noBorder\">\n" +
    "  <li>\n" +
    "    <label class=\"extra-space\">{{card.firstName}} {{card.lastName}}  x{{card.cardLastFour}}</label>\n" +
    "    </div>\n" +
    "    <h3 class=\"toggle-status\">{{atmToggle === 'on' ? 'Enabled': 'Disabled'}}</h3>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<div class=\"exPaddingBtm\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/changepin/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/changepin/step1.html",
    "<ul class=\"form js-autoscroll-form noBorder\">\n" +
    "  <li ng-if=\"primary.firstName === getCardAccounts()[getCurrentAccount()].firstName && primary.lastName === getCardAccounts()[getCurrentAccount()].lastName\">\n" +
    "    <h3 class=\"list-title\">Primary Card</h3>\n" +
    "    <div class=\"toggle-input change-pin-toggle\">\n" +
    "      <div class=\"toggle-bg {{formData.change}}\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"toggle-1\"\n" +
    "          value=\"off\"\n" +
    "          ng-model=\"formData.change\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"toggle-1\"\n" +
    "          value=\"on\"\n" +
    "          ng-model=\"formData.change\">\n" +
    "        <span class=\"switch {{formData.change}}\"></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <h3 ng-init=\"formData.change = 'on'\" class=\"toggle-status change-pin-status\">{{formData.change == 'on' ? 'Change': 'Don\\'t Change'}}</h3>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.PrimaryPin.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please re-enter your New PIN using 4 numbers</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"noBorder\" ng-show=\"formData.change == 'on'\">\n" +
    "    <label class=\"overlay-title-text\" for=\"password\">New PIN</label>\n" +
    "    <input\n" +
    "      type=\"password\"\n" +
    "      class=\"pinInput\"\n" +
    "      name=\"PrimaryPin\"\n" +
    "      value=\"\"\n" +
    "      placeholder=\"XXXX\"\n" +
    "      maxlength=\"4\"\n" +
    "      ng-model=\"formData.PrimaryPin\"\n" +
    "      ng-change=\"formData.change = 'on'\"\n" +
    "      ng-required=\"formData.change == 'on'\"\n" +
    "      data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "      ng-maxlength=\"4\"\n" +
    "      ng-minlength=\"4\">\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"(formData.PrimaryPin != formData.PrimaryPin1) && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Confirm both PINs Match</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"noBorder\" ng-show=\"formData.change == 'on'\">\n" +
    "    <label class=\"overlay-title-text\">Confirm PIN</label>\n" +
    "    <input\n" +
    "      type=\"password\"\n" +
    "      class=\"pinInput\"\n" +
    "      name=\"PrimaryPin1\"\n" +
    "      placeholder=\"XXXX\"\n" +
    "      maxlength=\"4\"\n" +
    "      value=\"\"\n" +
    "      match-elem\n" +
    "      ng-model=\"formData.PrimaryPin1\"\n" +
    "      ng-change=\"formData.change = 'on'\"\n" +
    "      ng-required=\"formData.change == 'on'\"\n" +
    "      data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "      ng-maxlength=\"4\"\n" +
    "      ng-minlength=\"4\">\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<ul ng-show=\"loadingSubs\" ng-if=\"hasSubs\">\n" +
    "  <li>\n" +
    "    <h3 class=\"list-title\">Cards</h3>\n" +
    "    <span id=\"loadingSubs\" class=\"loading-indicator\" ></span>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<ul class=\"form js-autoscroll-form noBorder\" ng-repeat=\"sub in subCards\" ng-if=\"sub.FirstName === getCardAccounts()[getCurrentAccount()].firstName && sub.LastName === getCardAccounts()[getCurrentAccount()].lastName\">\n" +
    "  <li>\n" +
    "    <h3 class=\"list-title\">{{sub.FirstName}} {{sub.LastName}}</h3>\n" +
    "    <div class=\"toggle-input change-pin-toggle\">\n" +
    "      <div class=\"toggle-bg {{sub.change}}\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"subchange-{{$index}}\"\n" +
    "          value=\"off\"\n" +
    "          ng-model=\"sub.change\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"subchange-{{$index}}\"\n" +
    "          value=\"on\"\n" +
    "          ng-model=\"sub.change\">\n" +
    "        <span class=\"switch {{sub.change}}\"></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <h3 ng-init=\"sub.change = 'on'\" class=\"toggle-status change-pin-status\">{{sub.change == 'on' ? 'Change': 'Don\\'t Change'}}</h3>\n" +
    "  </li>\n" +
    "  <li class=\"noBorder\" ng-show=\"sub.change == 'on'\">\n" +
    "    <ng-form name=\"innerForm{{$index}}\">\n" +
    "      <ul class=\"form js=autoscroll-form\">\n" +
    "        <li class=\"akimbo-form-field-error form-error\" ng-show=\"!{{'innerForm' + $index}}.NewPin.$valid && attempted\">\n" +
    "          <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please re-enter your New PIN using 4 numbers</p>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "        <li class=\"noBorder\">\n" +
    "          <label class=\"overlay-title-text\">New Pin</label>\n" +
    "          <input\n" +
    "            type=\"password\"\n" +
    "            class=\"pinInput\"\n" +
    "            name=\"NewPin\"\n" +
    "            value=\"\"\n" +
    "            placeholder=\"XXXX\"\n" +
    "            ng-model=\"sub.NewPin\"\n" +
    "            ng-required=\"sub.change == 'on'\"\n" +
    "            data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "            ng-change=\"sub.change = 'on'\"\n" +
    "            maxlength=\"4\"\n" +
    "            ng-maxlength=\"4\"\n" +
    "            ng-minlength=\"4\">\n" +
    "        </li>\n" +
    "        <li class=\"akimbo-form-field-error form-error noBorder\" ng-show=\"(sub.NewPin != sub.ConfirmPin) && attempted\">\n" +
    "          <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <p>Please Confirm {{sub.FirstName}} {{sub.LastName}} PIN Match</p>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "        <li class=\"noBorder\">\n" +
    "          <label class=\"overlay-title-text\" for=\"Pin1\">Confirm PIN</label>\n" +
    "          <input\n" +
    "            type=\"password\"\n" +
    "            class=\"pinInput\"\n" +
    "            name=\"ConfirmPin\"\n" +
    "            value=\"\"\n" +
    "            placeholder=\"XXXX\"\n" +
    "            ng-model=\"sub.ConfirmPin\"\n" +
    "            ng-required=\"sub.change == 'on'\"\n" +
    "            data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "            ng-change=\"sub.change = 'on'\"\n" +
    "            maxlength=\"4\"\n" +
    "            ng-maxlength=\"4\"\n" +
    "            ng-minlength=\"4\">\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </form>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/feesummary/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/feesummary/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">{{PreviousMonthName}} Fees</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{PreviousMonthFees | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Current Fees</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{CurrentMonthFees | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">YTD Fees</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{YTDFees | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/profile/password/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/password/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"passError\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Sorry, we were unable to update your password</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Password.$error.required && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your old Password</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Current Password</label>\n" +
    "    <input \n" +
    "      type=\"password\" \n" +
    "      name=\"Password\" \n" +
    "      value=\"\" \n" +
    "      ng-model=\"formData.Password\" \n" +
    "      required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.NewPassword.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please re-enter your New Password using at least 8 characters</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">New Password</label>\n" +
    "    <input \n" +
    "      type=\"password\" \n" +
    "      name=\"NewPassword\" \n" +
    "      value=\"\" \n" +
    "      ng-model=\"formData.NewPassword\" \n" +
    "      ng-required=\"true\"\n" +
    "      validate-password \n" +
    "      ng-minlength=\"8\">\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.NewPassword1.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Fields do not match</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Confirm Password</label>\n" +
    "    <input \n" +
    "      type=\"password\" \n" +
    "      name=\"NewPassword1\" \n" +
    "      value=\"\" \n" +
    "      ng-model=\"formData.NewPassword1\" \n" +
    "      match-elem\n" +
    "      required>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/reissue/confirmation-side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/reissue/confirmation-side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Please Note</h2>\n" +
    "  <p>Your new card will arrive in 5-8 business days.</p>  \n" +
    "  <h2>Important</h2>\n" +
    "  <p>Your reissued card will have a new card number. If you have set up recurring payments or purchases using your card, you'll need to provide your new card number to these merchants, once your card arrives in the mail.</p>\n" +
    "  <h2>Direct Deposit</h2>\n" +
    "  <p>Your direct deposit number will also change. You can view your new account number by visiting the load menu.</p>\n" +
    "  <h2>Fee</h2>\n" +
    "  <p>Your first reissued card within a 12-month period is free, additional reissued cards will be assessed a $5.00 fee per card.</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/reissue/step1-side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/reissue/step1-side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Important</h2>\n" +
    "  <p>Your reissued card will have a new card number. If you have set up recurring payments or purchases using your card, you'll need to provide your new card number to these merchants<span ng-if=\"!card.virtual\">, once your card arrives in the mail.</span></p>\n" +
    "  <h2>Direct Deposit</h2>\n" +
    "  <p>Your direct deposit number will also change. You can view your new account number by visiting the load menu.</p>\n" +
    "  <h2>Fee</h2>\n" +
    "  <p>Your first reissued card within a 12-month period is free, additional reissued cards will be assessed a $5.00 fee per card.</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/reissue/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/reissue/step1.html",
    "<ul class=\"form js-autoscroll-form noBorder\">\n" +
    "  <li>\n" +
    "    <label class=\"extra-space\">{{card.firstName}} {{card.lastName}}  x{{card.cardLastFour}}</label>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<div class=\"exPaddingBtm\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/reissue/step2-header-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/reissue/step2-header-text.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "        <br>\n" +
    "        <p id=\"reissue-address\">\n" +
    "        {{address1}}<br>\n" +
    "        <span ng-show=\"address2\">{{address2}}<br></span>\n" +
    "        {{address3}}<br>\n" +
    "        </p>\n" +
    "        <br>\n" +
    "        <br>\n" +
    "        <p>If your address has changed, click UPDATE ADDRESS below.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/reissue/step2-side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/reissue/step2-side-options.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Update Address</h2>\n" +
    "  <a ui-sref=\"member.home.profile.step1\" class=\"btn btn-light btn-full-width large\">Update address</a>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/profile/reissue/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/reissue/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"extra-space\">{{card.firstName}} {{card.lastName}} x{{card.cardLastFour}}</label>\n" +
    "    <div class=\"content toggle-status\">\n" +
    "      <p>Reissue Card</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<div class=\"exPaddingBtm\"></div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/profile/smsmanage/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/smsmanage/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li ng-if=\"primary.firstName === getCardAccounts()[getCurrentAccount()].firstName && primary.lastName === getCardAccounts()[getCurrentAccount()].lastName\">\n" +
    "    <ul>\n" +
    "      <li class=\"akimbo-form-field-error form-error\" ng-show=\"!primary.PhoneNumber.length && primary.CardAlert == 'Enabled' && attempted\">\n" +
    "        <div class=\"alert\">\n" +
    "          <span class=\"icon-warning-triangle\"></span>\n" +
    "          <ul class=\"form\">\n" +
    "            <li>Please Enter Your Phone Number</li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <div class=\"text-alert-container\">\n" +
    "          <label class=\"overlay-title-text\">\n" +
    "            Primary Card\n" +
    "          </label>\n" +
    "          <input\n" +
    "                  type=\"text\"\n" +
    "                  placeholder=\"XXX-XXX-XXXX\"\n" +
    "                  maxlength=\"12\"\n" +
    "                  name=\"PhoneNumber\"\n" +
    "                  ng-model=\"primary.PhoneNumber\"\n" +
    "                  ng-required=\"primary.CardAlert == 'Enabled'\"\n" +
    "                  value=\"{{primary.PhoneNumber}}\">\n" +
    "        </div>\n" +
    "        <h3 class=\"toggle-status\">{{primary.CardAlert}}</h3>\n" +
    "        <div class=\"toggle-input\">\n" +
    "          <div class=\"toggle-bg {{primary.CardAlert}}\">\n" +
    "            <input type=\"radio\" name=\"toggle-{{$index}}\" value=\"Disabled\" ng-model=\"primary.CardAlert\">\n" +
    "            <input type=\"radio\" name=\"toggle-{{$index}}\" value=\"Enabled\" ng-model=\"primary.CardAlert\">\n" +
    "            <span class=\"switch {{primary.CardAlert}}\"></span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li ng-show=\"loadingSubs\">\n" +
    "    <h3 class=\"list-title\">Cards</h3>\n" +
    "    <span id=\"loadingSubs\" class=\"loading-indicator\"></span>\n" +
    "  </li>\n" +
    "  <li ng-repeat=\"card in subCards\" ng-if=\"card.FirstName === getCardAccounts()[getCurrentAccount()].firstName && card.LastName === getCardAccounts()[getCurrentAccount()].lastName\">\n" +
    "    <ng-form name=\"innerForm{{$index}}\">\n" +
    "      <ul>\n" +
    "        <li class=\"akimbo-form-field-error form-error\" ng-show=\"!{{'innerForm' + $index}}.PhoneNumber.$valid && attempted\">\n" +
    "          <div class=\"alert\">\n" +
    "            <span class=\"icon-warning-triangle\"></span>\n" +
    "            <ul class=\"form\">\n" +
    "              <li>Please Enter Your Phone Number</li>\n" +
    "            </ul>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <div class=\"text-alert-container\">\n" +
    "            <label class=\"overlay-title-text\">\n" +
    "              {{card.FirstName}} {{card.LastName}}\n" +
    "            </label>\n" +
    "            <input\n" +
    "                    type=\"text\"\n" +
    "                    placeholder=\"XXX-XXX-XXXX\"\n" +
    "                    maxlength=\"12\"\n" +
    "                    name=\"PhoneNumber\"\n" +
    "                    ng-model=\"card.PhoneNumber\"\n" +
    "                    ng-required=\"card.CardAlert == 'Enabled'\"\n" +
    "                    value=\"{{card.PhoneNumber}}\">\n" +
    "          </div>\n" +
    "          <h3 class=\"toggle-status\">{{card.CardAlert}}</h3>\n" +
    "          <div class=\"toggle-input\">\n" +
    "            <div class=\"toggle-bg {{card.CardAlert}}\">\n" +
    "              <input type=\"radio\" name=\"toggle-{{$index}}\" value=\"Disabled\" ng-model=\"card.CardAlert\">\n" +
    "              <input type=\"radio\" name=\"toggle-{{$index}}\" value=\"Enabled\" ng-model=\"card.CardAlert\">\n" +
    "              <span class=\"switch {{card.CardAlert}}\"></span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </ng-form>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/smsmanage/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/smsmanage/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\" ng-if=\"primary.firstName === getCardAccounts()[getCurrentAccount()].firstName && primary.lastName === getCardAccounts()[getCurrentAccount()].lastName\">\n" +
    "    <label>Primary Card</label>\n" +
    "    <div class=\"content toggle-status\">\n" +
    "      <p> Text Alerts: {{primary.CardAlert}}</p>\n" +
    "    </div>\n" +
    "    <div class=\"content toggle-status x-margin-right\" ng-if=\"primary.PhoneNumber\">\n" +
    "      <p>Mobile: {{primary.PhoneNumber}} </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-repeat=\"card in subCards\" ng-if=\"card.FirstName == getCardAccounts()[getCurrentAccount()].firstName && card.LastName == getCardAccounts()[getCurrentAccount()].lastName\">\n" +
    "    <label for=\"#\">{{card.FirstName}} {{card.LastName}}</label>\n" +
    "    <div class=\"content toggle-status\">\n" +
    "      <p>Text Alerts: {{card.CardAlert}}</p>\n" +
    "    </div>\n" +
    "    <div class=\"content toggle-status x-margin-right\" ng-if=\"card.PhoneNumber\">\n" +
    "      <p>Mobile: {{card.PhoneNumber}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/statements/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/statements/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li style=\"margin-top: 5em; text-align: center;\" ng-show=\"viewStatements.loading\">\n" +
    "    <span class=\"loading-indicator\"></span>\n" +
    "    <p>Processing</p>\n" +
    "  </li>\n" +
    "  <li ng-show=\"showList\" ng-repeat=\"year in viewStatements.periods\">\n" +
    "    <label class=\"overlay-title-text\" style=\"vertical-align: top; padding-top: 15px;\">\n" +
    "      {{year.year}}\n" +
    "    </label>\n" +
    "    <input type=\"button\"\n" +
    "      class=\"btn btn-light btn--margin-bottom btn--max-width\"\n" +
    "      ng-repeat=\"period in year.periods\"\n" +
    "      ng-click=\"viewStatements.get(period.date)\"\n" +
    "      value=\"{{period.label}}\"\n" +
    "    />\n" +
    "  </li>\n" +
    "  <li ng-hide=\"showList\">\n" +
    "    <object\n" +
    "      ng-attr-data=\"{{ viewStatements.pdfSrc }}\"\n" +
    "      type=\"application/pdf\"\n" +
    "      width=\"100%\"\n" +
    "      height=\"600px\">\n" +
    "      <p>\n" +
    "        Your browser does not support PDFs.\n" +
    "        <a ng-href=\"viewStatements.pdfSrc\">\n" +
    "          Download the PDF\n" +
    "        </a>.\n" +
    "      </p>\n" +
    "    </object>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/profile/verification/denied.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/verification/denied.html",
    "<div id=\"verificationWidget\" class=\"js-autoscroll-form noBorder\">\n" +
    "  <div class=\"fraud-txt\">\n" +
    "    <div class=\"form\">\n" +
    "      <div class=\"form-with-content-small\">\n" +
    "        <div class=\"content\">\n" +
    "          <p>{{deniedTxt}}</p>\n" +
    "        </div>\n" +
    "        <div class=\"padding-for-button\">\n" +
    "          <button ng-click=\"reVerifyAccount()\" class=\"btn normal\">Resubmit Documents</button>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"exPaddingBtm\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/verification/footer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/verification/footer.html",
    "<div class=\"overlay-footer-scroll-wrapper\">\n" +
    "  <div class=\"overlay-footer-wrapper\">\n" +
    "    <div class=\"overlay-footer\">\n" +
    "      <div id=\"akimbo-form-error-box\" class=\"message\" ng-show=\"alert.errorShown\">\n" +
    "        <span class=\"icon-point-up\"></span>\n" +
    "        <span id=\"akimbo-form-error-message\">{{ alert.alertMessage }}</span>\n" +
    "      </div>\n" +
    "      <div id=\"akimbo-form-error-box\" class=\"message\" ng-show=\"alert.waitMsg && loading\">\n" +
    "        <span class=\"icon-point-up\"></span>\n" +
    "        <span id=\"akimbo-form-error-message\">{{alert.waitMsg}}</span>\n" +
    "      </div>\n" +
    "      <div id=\"success-msg\" class=\"message success\" ng-show=\"alert.successShown\"><span class=\"icon-thumbs-up\"></span>Congratulations! {{alert.successMessage}}</div>\n" +
    "      <div id=\"akimbo-form-footer-buttons\" ng-show=\"!loading\">\n" +
    "        <button id=\"submit-btn\" ng-if=\"mainBtn.processForm\" class=\"btn normal \" ng-click=\"processForm(formData)\">{{mainBtn.title}}</button>\n" +
    "        <button ng-if=\"mainBtn.processGiftForm\" class=\"btn normal \" ng-click=\"processForm(overlayForm)\">{{mainBtn.title}}</button>\n" +
    "        <button id=\"next-btn\" ng-if=\"mainBtn.attemptSubmission\" class=\"btn normal \" ng-click=\"attemptSubmission(overlayForm, mainBtn.next)\">{{mainBtn.title}}</button>\n" +
    "        <button ng-if=\"primaryBtn\" ui-sref=\"{{primaryBtn.state}}\" class=\"btn normal\">{{primaryBtn.title}}</button>\n" +
    "        <span ng-if=\"verificationFooterResponse\" ng-hide=\"respSuccess\" class=\"loading-indicator\"></span>\n" +
    "        <button ng-if=\"verificationFooterResponseNext\" id=\"verification-next\" class=\"btn\" ng-class=\"{'btn-disabled' : !respSuccess && !waitingForAttempt}\" ng-click=\"waitingForAttempt ? attemptSubmission(overlayForm, mainBtn.next) : null\">Next</button>\n" +
    "        <button ng-if=\"mainBtn.attemptSubmissionAndProcessForm\" class=\"btn normal\" ng-click=\"attemptSubmissionAndProcessForm(overlayForm, formData)\">{{mainBtn.title}}</button>\n" +
    "        <button ng-if=\"showNext\" class=\"btn normal\" ng-click=\"selectAccount.attemptSubmission(overlayForm, selectAccount.accounts)\">NEXT</button>\n" +
    "        <button ng-repeat=\"btn in btns\" ui-sref=\"{{btn.state}}\" class=\"btn normal btn-secondary\">{{btn.title}}</button>\n" +
    "        <button ng-if=\"okBtn\" class=\"btn normal\" ng-click=\"back()\">{{okBtn.title}}</button>\n" +
    "        <button id=\"close-btn\" ng-controller='overlayCtrl' ng-if=\"close\" ng-click=\"back()\" class=\"btn normal btn-secondary\">CLOSE</button>\n" +
    "        <button id=\"cancel-btn\" ng-controller='overlayCtrl' ng-if=\"cancel\" ng-click=\"back()\" class=\"btn normal btn-secondary\">CANCEL</button>\n" +
    "        <button id=\"close-btn\" ng-if=\"showCloseOrRedirect\" ng-click=\"closeOrRedirect()\" class=\"btn normal btn-secondary\">CLOSE</button>\n" +
    "        <button id=\"cancel-btn\" ng-if=\"showCancelOrRedirect\" ng-click=\"closeOrRedirect()\" class=\"btn normal btn-secondary\">CANCEL</button>\n" +
    "        <button ng-if=\"showBack\" ng-click=\"nestedBack()\" class=\"btn normal btn-secondary\">BACK</button>\n" +
    "      </div>\n" +
    "      <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "        <span class=\"loading-indicator\" alt=\"\"></span>\n" +
    "        <p>Processing</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"alert.alertShown\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{alert.alertMessage}}</p>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"alert.alertShown=!alert.alertShown\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"secondaryAlert.alertShown\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>{{secondaryAlert.alertHeader}}</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{secondaryAlert.alertMessage}}</p>\n" +
    "        <a class=\"btn btn-small btn--float-left btn-no-min-width\" ng-click=\"secondaryAlert.secondaryFn()\">{{secondaryAlert.secondaryText}}</a>\n" +
    "        <a class=\"btn btn-small btn--float-right btn-no-min-width\" ng-click=\"secondaryAlert.primaryFn()\">{{secondaryAlert.primaryText}}</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"phoneNumber.alertShown\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Enter Mobile Number</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <form ng-submit=\"phoneNumber.send(number)\" autocomplete=\"off\">\n" +
    "          <label for=\"phoneNumber\">Phone Number</label>\n" +
    "          <br/>\n" +
    "          <input\n" +
    "            class=\"radius-left\"\n" +
    "            type=\"tel\"\n" +
    "            name=\"phoneNumber\"\n" +
    "            minlength=\"10\"\n" +
    "            maxlength=\"10\"\n" +
    "            tabindex=\"1\"\n" +
    "            ng-model=\"number\"\n" +
    "            required\n" +
    "            ak-input-only-numbers\n" +
    "            oninput=\"setCustomValidity('')\"\n" +
    "            oninvalid=\"setCustomValidity('Invalid phone number')\"\n" +
    "            >\n" +
    "            <br/>\n" +
    "            <a class=\"btn btn-small btn--float-left btn-no-min-width\" ng-click=\"phoneNumber.close()\">Close</a>\n" +
    "            <input ng-show=\"!phoneNumber.loading\" type=\"submit\" class=\"btn-send-phone btn btn-small btn--float-right btn-no-min-width\" value=\"Send\">\n" +
    "            <div ng-show=\"phoneNumber.loading\" id=\"loading-login\" style=\"float:right;\">\n" +
    "              <span class=\"loading-indicator\"></span>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/verification/review.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/verification/review.html",
    "<div id=\"verificationWidget\" class=\"js-autoscroll-form noBorder\">\n" +
    "    <div class=\"fraud-txt\">\n" +
    "        <div class=\"form\">\n" +
    "            <div class=\"form-with-content-small\">\n" +
    "                <div class=\"content\">\n" +
    "                    <p>{{reviewTxt}}</p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"exPaddingBtm\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/verification/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/verification/step1.html",
    "<div id=\"verificationWidget\" class=\"js-autoscroll-form noBorder\">\n" +
    "        <div class=\"form\">\n" +
    "            <div class=\"form-with-content-small padding-for-input\">\n" +
    "                <label class=\"group-label ak-aligned-label\"></label>\n" +
    "                <div class=\"content paragraph-wrapper\">\n" +
    "                    <p class=\"paragraph-margin\" ng-if=\"helperText1\">{{helperText1}}</p>\n" +
    "                    <p class=\"paragraph-margin\" ng-if=\"helperText2\">{{helperText2}}</p>\n" +
    "                    <p class=\"paragraph-margin\">Please enter your phone number below to begin the verification process.</p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <ul class=\"form js-autoscroll-form\">\n" +
    "            <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Phone.$error.required && overlayForm.Phone.$dirty\">\n" +
    "                <div class=\"alert\">\n" +
    "                    <span class=\"icon-warning-triangle\"></span>\n" +
    "                    <p>Please enter Phone</p>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "            <li class=\"form-border padding-for-input\">\n" +
    "                <label class=\"group-label ak-aligned-label\" for=\"Phone\">Phone</label>\n" +
    "                    <input type=\"text\"\n" +
    "                      minlength=\"10\"\n" +
    "                      maxlength=\"12\"\n" +
    "                      placeholder=\"123-456-7890\"\n" +
    "                      name=\"Phone\"\n" +
    "                      ng-model=\"formData.Phone\"\n" +
    "                      id=\"Phone\"\n" +
    "                      value=\"{{formData.Phone}}\"\n" +
    "                      required>\n" +
    "\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "<div class=\"exPaddingBtm\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/verification/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/verification/step2.html",
    "<div id=\"verificationWidget\" class=\"js-autoscroll-form noBorder\">\n" +
    "  <div ng-if=\"!errorShown\" class=\"fraud-txt\">\n" +
    "    <div class=\"form\">\n" +
    "      <div class=\"form-with-content-small\">\n" +
    "        <div class=\"content\">\n" +
    "          <p ng-show=\"loading\">{{verificationTxt}}</p>\n" +
    "          <p ng-show=\"!loading\">{{pollingStoppedMessage}}</p>\n" +
    "        </div>\n" +
    "        <div class=\"qrCodeWrapper\" ng-show=\"loading\">\n" +
    "          <img src=\"{{qrCodeImageSrc}}\" alt=\"QR Code\" height=\"200\" width=\"200\">\n" +
    "        </div>\n" +
    "        <div class=\"padding-for-button\">\n" +
    "          <button ng-show=\"!loading\" ng-click=\"reVerifyAccount()\" class=\"btn normal\">Verify Account</button>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"errorShown\" class=\"fraud-txt\">\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{alertMessage}}</p>\n" +
    "    </div>\n" +
    "    <button ng-if=\"showBack\" ng-click=\"nestedBack()\" class=\"btn normal btn-secondary\">BACK</button>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/profile/verification/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/verification/step3.html",
    "<div id=\"verificationWidget\" class=\"js-autoscroll-form noBorder\">\n" +
    "    <div class=\"fraud-txt\">\n" +
    "        <div class=\"form\">\n" +
    "            <div class=\"form-with-content-small\">\n" +
    "                <div class=\"content\">\n" +
    "                    <p>{{approvedTxt}}</p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"exPaddingBtm\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/profile/verification/submitted.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/profile/verification/submitted.html",
    "<div id=\"verificationWidget\" class=\"js-autoscroll-form noBorder\">\n" +
    "    <div class=\"fraud-txt\">\n" +
    "        <div class=\"form\">\n" +
    "            <div class=\"form-with-content-small\">\n" +
    "                <div class=\"content\">\n" +
    "                    <p ng-show=\"loading\">Your documents were submitted. Please wait for the approval.</p>\n" +
    "                    <p ng-show=\"!loading\">{{pollingStoppedMessage}}</p>\n" +
    "                </div>\n" +
    "                <div class=\"padding-for-button\">\n" +
    "                    <button ng-show=\"!loading\" ng-click=\"reVerifyAccount()\" class=\"btn normal\">Verify Account</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-loader-left\" ng-show=\"loading\">\n" +
    "            <span class=\"loading-indicator\"></span>\n" +
    "            <p>Processing</p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"exPaddingBtm\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/rdc/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/rdc/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">\n" +
    "      <img src=\"assets/images/partners/Ingo_logo_nav.png\">\n" +
    "    </label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>We've partnered with <a href=\"http://ingomoney.com\" target=\"_blank\" rel=\"external\" confirmation-overlay>Ingo Money</a>, a trusted platform that lets you load approved checks by snapping a picture with your smartphone. Funds can be loaded onto your {{brand.commonProgramName}} within minutes for a fee* or in 7 days with no fee.</p>\n" +
    "      <br>\n" +
    "      <p>To get started, download the Ingo Money app:</p>\n" +
    "      <p><a href=\"//itunes.apple.com/us/app/ingo-money/id656846983\" target=\"_blank\" rel=\"external\" confirmation-overlay>\n" +
    "      App Store<span class=\"x-small\"><sup style=\"vertical-align:super\">SM</sup></span></a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href=\"//play.google.com/store/apps/details?id=com.chexar.ingo.android\" target=\"_blank\" rel=\"external\" confirmation-overlay>Google Play<span class=\"x-small\"><sup style=\"vertical-align:super\">TM</sup></span> Store</a></p>\n" +
    "      <br>       \n" +
    "      <p style=\"font-size:9px;\">*The Ingo Network is operated by Ingo Money, Inc. as an agent of PreCash, Inc., a licensed money transmitter. Use of Ingo is subject to the Ingo Network Terms and Conditions available here: http://ingomoney.com/tc.html.  Checks are subject to approval for funding by Ingo Money in its sole discretion.  Review for approval usually takes 3 to 5 minutes but can take up to an hour. Unapproved checks will not be loaded to your card.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/request/header-content.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/request/header-content.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ul class=\"form js-autoscroll-form\">\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "      <label for=\"#\">Request From</label>\n" +
    "        <div class=\"content\">\n" +
    "          <div class=\"akimbo-media-box\">\n" +
    "            <div class=\"img-wrap\">\n" +
    "              <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "            </div>\n" +
    "            <div class=\"akimbo-media-box-content\">\n" +
    "              <h5 class=\"akimbo-media-box-title\">{{transferTo.FirstName + ' ' + transferTo.LastName}}</h5>\n" +
    "              <p class=\"akimbo-media-box-subtitle\">{{transferTo.Username}}</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      <div class=\"form-modify form-delete icon-circle-x\" ui-sref=\"member.home.request.step1\"></div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/request/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/request/step2.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.number\">Please enter only a number.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.max\">You can only send up to $1,000.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please enter the amount you would like to request.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input \n" +
    "        type=\"number\" \n" +
    "        name=\"Amount\" \n" +
    "        class=\"input-small\" \n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\" ng-show=\"!amountMessage && !amountValid\">\n" +
    "      <p>{{brand.commonProgramName}} balance: {{balance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small borderSeparator\" ng-show=\"formData.Note\">\n" +
    "    <label for=\"#\">Message</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">{{formData.Note}}</p>\n" +
    "    </div>\n" +
    "    <div class=\"form-modify form-delete icon-circle-x\" ng-click=\"clearMessage()\"></div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/request/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/request/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small borderSeparator\" ng-show=\"formData.Note\">\n" +
    "    <label for=\"#\">Message</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">{{formData.Note}}</p>\n" +
    "    </div>\n" +
    "    <div class=\"form-modify form-delete icon-circle-x\" ng-click=\"clearMessage()\"></div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/request/step4.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/request/step4.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small borderSeparator\" ng-show=\"formData.Note\">\n" +
    "    <label for=\"#\">Message</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">{{formData.Note}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/send-check/side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send-check/side-options.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Questions?</h2>\n" +
    "  <p>{{info}}</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/send-check/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send-check/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.Name && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter a Name</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Name\">Name</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.Name\" name=\"Name\" id=\"Name\" value=\"{{formData.Name}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.Address1 && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Address</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Address1\">Address</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.Address1\" name=\"Address1\" id=\"Address1\" value=\"{{formData.Address1}}\" required>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Address2\">Address 2</label>\n" +
    "    <input type=\"text\" name=\"Address2\" id=\"Address2\" value=\"{{formData.Address2}}\" ng-model=\"formData.Address2\">\n" +
    "  </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.City && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter City</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"City\">City</label>\n" +
    "    <input type=\"text\" name=\"City\" ng-model=\"formData.City\" id=\"City\" value=\"{{formData.City}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.State && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter State</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-select\">\n" +
    "    <label for=\"State\">State</label>\n" +
    "    <select name=\"State\" id=\"State\" ng-model=\"formData.State\" ng-options=\"s.state for s in states track by s.key\" required>\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.Zipcode && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Zipcode</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Zipcode\">Zipcode</label>\n" +
    "    <input type=\"text\" name=\"Zipcode\" ng-model=\"formData.Zipcode\" id=\"Zipcode\" value=\"{{formData.Zipcode}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.Memo && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Memo</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Memo\">Memo</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.Memo\" name=\"Memo\" id=\"Memo\" value=\"{{formData.Memo}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"formData.Account.$error.pattern && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Only Numbers</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Account\">Destination Account Number</label>\n" +
    "    <div class=\"error-block-top__hint-text input-full\">\n" +
    "      <span>Optional, commonly used when paying a bill.</span>\n" +
    "    </div>\n" +
    "    <input\n" +
    "        type=\"number\"\n" +
    "        pattern=\"[0-9]*\"\n" +
    "        ng-model=\"formData.Account\"\n" +
    "        name=\"Account\"\n" +
    "        id=\"Account\"\n" +
    "        value=\"{{formData.Account}}\">\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "        value=\"formData.Amount\"\n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\"\n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-min=\"0\"\n" +
    "        class=\"input-small\"\n" +
    "        ng-change=\"formatAmountMessage()\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\">\n" +
    "      <p>Balance: {{availableBalance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-show=\"amountMessage && !amountValid\" class=\"content amount-balance-not-enough\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>{{amountMessage}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send-check/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send-check/step2.html",
    "<ul class=\"form\">\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "        <label>Amount</label>\n" +
    "        <div class=\"content\">\n" +
    "            <p id=\"Amount\">{{ formData.Amount | akimboCurrency }}</p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "        <label class=\"address-label\">Recipient</label>\n" +
    "        <div class=\"content\">\n" +
    "            <p class=\"address-container\" id=\"transfer_to\">\n" +
    "                {{ formData.Name }}<br>\n" +
    "                {{ formData.Address1 }}<br>\n" +
    "                <span ng-show=\"formData.Address2\">{{ formData.Address2 }}<br></span>\n" +
    "                {{ formData.City }}, {{ formData.State.key }}<br>\n" +
    "                {{ formData.Zipcode}}\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send-check/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send-check/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"address-label\">Recipient</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"address-container\" id=\"transfer_to\">\n" +
    "        {{ formData.Name }}<br>\n" +
    "        {{ formData.Address1 }}<br>\n" +
    "        <span ng-show=\"formData.Address2\">{{ formData.Address2 }}<br></span>\n" +
    "        {{ formData.City }}, {{ formData.State.key }}<br>\n" +
    "        {{ formData.Zipcode}}\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send-physical-card/confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send-physical-card/confirmation.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Address</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-address_line_1\">{{formData.Address}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-if=\"formData.AddressSuite\">\n" +
    "    <label for=\"#\">Address</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-address_line_1\">{{formData.AddressSuite}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">City</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-city\">{{formData.City}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">State</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-state\">{{formData.State.state || formData.State.key}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Zipcode</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-zipcode\">{{formData.PostalCode}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send-physical-card/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send-physical-card/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Address.$error.required && overlayForm.Address.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter Address</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Address\">Address</label>\n" +
    "    <input type=\"text\" ng-model=\"formData.Address\" name=\"Address\" id=\"Address\" value=\"{{formData.Address}}\" required>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"AddressSuite\">Address</label>\n" +
    "    <input type=\"text\" name=\"AddressSuite\" id=\"AddressSuite\" value=\"{{formData.AddressSuite}}\" ng-model=\"formData.AddressSuite\">\n" +
    "  </li>\n" +
    "    <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.City.$error.required && overlayForm.City.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter City</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"City\">City</label>\n" +
    "    <input type=\"text\" name=\"City\" ng-model=\"formData.City\" id=\"City\" value=\"{{formData.City}}\" required>\n" +
    "  </li>\n" +
    "  <li class=\"form-select\">\n" +
    "    <label for=\"StateCode\">State</label>\n" +
    "    <select name=\"StateCode\" id=\"State\" ng-model=\"formData.State\" ng-options=\"s.state for s in states track by s.key\">\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.PostalCode.$error.required && overlayForm.PostalCode.$dirty\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter Zipcode</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"PostalCode\">Zipcode</label>\n" +
    "    <input type=\"text\" name=\"PostalCode\" ng-model=\"formData.PostalCode\" id=\"PostalCode\" value=\"{{formData.PostalCode}}\" required>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/gift/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/gift/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.number\">Please enter only a number.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.max\">You can only send up to $1,000.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please enter the amount you would like to send.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input \n" +
    "        type=\"number\" \n" +
    "        name=\"Amount\" \n" +
    "        class=\"input-small\" \n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-change=\"formatAmountMessage()\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\" ng-show=\"!amountMessage && !amountValid\">\n" +
    "      <p>{{brand.commonProgramName}} balance: {{balance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountMessage && !amountValid\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>{{amountMessage}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountValid\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p>Sweet. You've got enough on your {{brand.commonProgramName}}.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.FirstName.$error.required && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter First Name</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">First Name</label>\n" +
    "    <input \n" +
    "      type=\"text\" \n" +
    "      name=\"FirstName\" \n" +
    "      value=\"\" \n" +
    "      ng-model=\"formData.FirstName\" \n" +
    "      required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.LastName.$error.required && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Last Name</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Last Name</label>\n" +
    "    <input \n" +
    "      type=\"text\" \n" +
    "      name=\"LastName\"\n" +
    "      value=\"\" \n" +
    "      ng-model=\"formData.LastName\" \n" +
    "      required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Email.$error.required && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Recipient Email</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Email</label>\n" +
    "    <input \n" +
    "      type=\"email\" \n" +
    "      name=\"Email\" \n" +
    "      value=\"\" \n" +
    "      ng-model=\"formData.Email\" \n" +
    "      required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Note.$error.required && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Note</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Note</label>\n" +
    "    <input \n" +
    "      type=\"text\" \n" +
    "      name=\"Note\" \n" +
    "      value=\"\" \n" +
    "      ng-model=\"formData.Note\" \n" +
    "      required>\n" +
    "  </li>  \n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/gift/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/gift/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">First Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.FirstName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Last Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.LastName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Email</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Email}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Note</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Note}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/manage/list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/manage/list.html",
    "<ul class=\"form\" ng-if=\"transfers.length != 0\">\n" +
    "  <li class=\"form-select-grid\" ng-repeat=\"group in groupTransfers()\">\n" +
    "    <label for=\"#\" class=\"group-label\">{{(group == 'A') ? 'Active' : 'Inactive'}}</label>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ng-repeat=\"transfer in transfers | groupBy:group:'Status'\" ui-sref=\"member.home.send/recurring/edit.step1({recurringId: transfer.Id})\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <div class=\"icon-wrap\">\n" +
    "              <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{transfer.ToFirstName}} {{transfer.ToLastName}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transfer.TransferAmount | akimboCurrency}} ({{transfer.scheduleText}})</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/recurring/header-content.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/recurring/header-content.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ul class=\"form js-autoscroll-form\">\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "      <label for=\"#\">To</label>\n" +
    "      <div class=\"content\">\n" +
    "        <div class=\"akimbo-media-box\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{transferTo.FirstName + ' ' + transferTo.LastName}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transferTo.Username}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/send/recurring/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/recurring/step1.html",
    "");
}]);

angular.module("../app/views/member/send/recurring/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/recurring/step2.html",
    "<ul class=\"form js-autoscroll-form form-select-list\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please set an amount for the Transaction</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\"\n" +
    "        class=\"input-small\"\n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\" ng-show=\"!lowFunds\">\n" +
    "      <p>{{brand.commonProgramName}} balance: $<span class=\"amount-balance-available\">{{balance}}</span></p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"lowFunds\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>Oops, there's not enough on your {{brand.commonProgramName}}. Send from a bank.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div style=\"display: none;\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p>Sweet. You've got enough on your {{brand.commonProgramName}}.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Source.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Source.$error.required\">Please select source for the Transaction</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"dash-form\" ng-if=\"sources.length > 0\">\n" +
    "    <label>Select Source</label>\n" +
    "    <ul class=\"form-select-list akimbo-form-select-list\">\n" +
    "      <li ng-repeat=\"s in sources\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"Source\"\n" +
    "          ng-model=\"formData.Source\"\n" +
    "          ng-value=\"s\"\n" +
    "          required>\n" +
    "        <span class=\"list-checkbox\" ng-class=\"formData.Source.Id == s.Id ? 'icon-box-check' : 'icon-box'\" ng-click=\"formData.Source = s\">\n" +
    "          <span class=\"checkbox-label\">{{s.Name}}</span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "      <li ng-if=\"$root.hasMainAccess\">\n" +
    "        <span class=\"list-checkbox icon-icon-plus\" ui-sref=\"member.home.bank/add.step1\">\n" +
    "          <span class=\"checkbox-label\">Add a Bank</span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.frequency.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li>Please select the schedule for the Transaction</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Schedule</label>\n" +
    "    <a id=\"select-schedule\" ng-click=\"showScheduleOption = true\" class=\"js-toggle-element js-offscreen\">\n" +
    "      <span class=\"icon-calendar\"></span>\n" +
    "      <p id=\"schedule-text-step1-frequency\">{{scheduleText}}</p>\n" +
    "    </a>\n" +
    "    <div class=\"popover-wrap\" ng-show=\"showScheduleOption\">\n" +
    "      <div id=\"schedule-step1-frequency\" class=\"popover popover-offscreen popover-no-padding\" style=\"display: block; left: 20px; top: -426px;\">\n" +
    "        <span class=\"popover-close icon-close\" ng-click=\"showScheduleOption = false\"></span>\n" +
    "        <h2 class=\"popover-title\" id=\"step1-frequency-text\">Schedule</h2>\n" +
    "        <div class=\"popover-body\">\n" +
    "          <p>How often would you like to load money to this card? Customize the loading schedule below.</p>\n" +
    "        </div>\n" +
    "        <div class=\"popover-body\">\n" +
    "          <ul class=\"form\">\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>How often?</label>\n" +
    "                <select\n" +
    "                  required\n" +
    "                  id=\"frequency-select\"\n" +
    "                  name=\"frequency\"\n" +
    "                  ng-change=\"changeFreq()\"\n" +
    "                  ng-model=\"datePicker.frequency\"\n" +
    "                  ng-options=\"f.label for f in frequencyOptions track by f.key\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.frequency\">Select...</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>Pick your days</label>\n" +
    "                <select\n" +
    "                  id=\"day1-select\"\n" +
    "                  ng-change=\"changeDay1()\"\n" +
    "                  ng-model=\"datePicker.day1\"\n" +
    "                  value=\"\"\n" +
    "                  ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "                  class=\"select-small\"\n" +
    "                  style=\"width:35%;\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "                </select>\n" +
    "                <select\n" +
    "                  id=\"day2-select\"\n" +
    "                  ng-change=\"changeDay2()\"\n" +
    "                  ng-model=\"datePicker.day2\"\n" +
    "                  value=\"\"\n" +
    "                  ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "                  ng-show=\"datePicker.frequency.key == 'T'\"\n" +
    "                  class=\"select-small\"\n" +
    "                  style=\"width:35%;\">\n" +
    "                  <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <label>Start date</label>\n" +
    "                <select\n" +
    "                  id=\"date-select\"\n" +
    "                  ng-change=\"changeDate()\"\n" +
    "                  ng-model=\"datePicker.dateSelect\"\n" +
    "                  ng-options=\"f.label for f in dateOptions track by f.formattedDate\">\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <div class=\"popover-wrap\">\n" +
    "                <a id=\"ok\" class=\"btn normal btn-secondary js-toggle-element js-toggle-element-close\" ng-click=\"showScheduleOption = false\">OK</a>\n" +
    "              </div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/recurring/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/recurring/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Source</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Source.Name || 'Your brand.commonProgramName'}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/transfer/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/transfer/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-select-grid userpicker-load\" ng-show=\"searchLoading\">\n" +
    "    <label for=\"#\" id=\"userpicker-results-title-template\">Loading...</label>\n" +
    "    <ul class=\"form-select-list-grid\" id=\"userpicker-results-list-template\">\n" +
    "      <li>\n" +
    "        <div class=\"akimbo-media-box\">\n" +
    "          <span class=\"loading-indicator\"></span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small userpicker-no-results-message\" ng-show=\"memberResult.length == 0 && !searchLoading\">\n" +
    "    <label for=\"#\">Tip</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"content\">We didn't find any members that matched. Try searching using a username, email address or phone number.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-select-grid form-top-label userpicker-member-results\" ng-show=\"memberResult.length > 0\" ng-repeat=\"group in groupMembers()\">\n" +
    "    <label for=\"#\" style=\"display: table-cell;\">{{memberTypes[group]}}</label>\n" +
    "    <ul class=\"form-select-list-grid\" style=\"display: block;\">\n" +
    "      <li>\n" +
    "        <div\n" +
    "          class=\"akimbo-media-box userpicker-select\"\n" +
    "          ng-click=\"selectMember(member)\"\n" +
    "          ng-repeat=\"member in memberResult | groupBy:group:'Type'\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{member.FirstName + ' ' + member.LastName}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{member.Username}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/transfer/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/transfer/step2.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.number\">Please enter only a number.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.max\">You can only send up to $1,000.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please enter the amount you would like to send.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\"\n" +
    "        class=\"input-small\"\n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-change=\"formatAmountMessage()\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\" ng-show=\"!amountMessage && !amountValid\">\n" +
    "      <p>{{brand.commonProgramName}} balance: {{balance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountMessage && !amountValid\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>{{amountMessage}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountValid\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p ng-if=\"formData.Source.Id === 0\">Sweet. You've got enough on your {{brand.commonProgramName}}.</p>\n" +
    "        <p ng-if=\"formData.Source.Id !== 0\">Sweet. We're ready to send from your bank.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"dash-form\" ng-if=\"sources.length > 0\">\n" +
    "    <label>Select Source</label>\n" +
    "    <ul class=\"form-select-list akimbo-form-select-list\">\n" +
    "      <li ng-repeat=\"s in sources\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"Source\"\n" +
    "          ng-model=\"formData.Source\"\n" +
    "          ng-value=\"s\">\n" +
    "        <span class=\"list-checkbox\" ng-class=\"formData.Source.Id == s.Id ? 'icon-box-check' : 'icon-box'\" ng-click=\"formData.Source = s\">\n" +
    "          <span class=\"checkbox-label\">{{s.Name}}</span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "      <li ng-if=\"$root.hasMainAccess\">\n" +
    "        <span class=\"list-checkbox icon-icon-plus\" ui-sref=\"member.home.bank/add.step1\">\n" +
    "          <span class=\"checkbox-label\">Add a Bank</span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li ng-show=\"formData.Note\" class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Note</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Note}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <!-- <li class=\"form-with-content-small calendar-directive\"> -->\n" +
    "  <!--   <label>Make Recurring</label> -->\n" +
    "  <!--   <div class=\"toggle-input\"> -->\n" +
    "  <!--     <div class=\"toggle-bg {{formData.makeRecurring}}\"> -->\n" +
    "  <!--       <input type=\"radio\" name=\"toggle-recurring\" value=\"off\" ng-model=\"formData.makeRecurring\"> -->\n" +
    "  <!--       <input type=\"radio\" name=\"toggle-recurring\" value=\"on\" ng-model=\"formData.makeRecurring\"> -->\n" +
    "  <!--       <span class=\"switch {{formData.makeRecurring}}\"></span> -->\n" +
    "  <!--     </div> -->\n" +
    "  <!--   </div>     -->\n" +
    "  <!--   <div class=\"content\"> -->\n" +
    "  <!--     <p ng-show=\"formData.makeRecurring == 'on'\" ng-click=\"formData.showScheduleOption = true\" id=\"calendar-cta\">{{formData.scheduleText}}</p> -->\n" +
    "  <!--   </div> -->\n" +
    "  <!--   <calendar-modal default-today=\"true\"></calendar-modal> -->\n" +
    "  <!-- </li> -->\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/transfer/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/transfer/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Source</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">{{formData.Source.Name || 'Your brand.commonProgramName'}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-show=\"formData.Note\" class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Note</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Note}}</p>\n" +
    "    </div>\n" +
    "  </li>  \n" +
    "  <li class=\"form-with-content-small\" ng-if=\"formData.makeRecurring == 'on'\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_schedule\">{{formData.scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>  \n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/send/transfer/step4.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/send/transfer/step4.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Source</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">{{formData.Source.Name || 'Your brand.commonProgramName'}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-show=\"formData.Note\" class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Note</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{formData.Note}}</p>\n" +
    "    </div>\n" +
    "  </li>  \n" +
    "  <li class=\"form-with-content-small\" ng-if=\"formData.makeRecurring == 'on'\">\n" +
    "    <label for=\"#\">Schedule</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_schedule\">{{formData.scheduleText}}</p>\n" +
    "    </div>\n" +
    "  </li>  \n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/shared/accountSelector.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/accountSelector.html",
    "<div class=\"account-selector\">\n" +
    "  <ul class=\"account-list\">\n" +
    "    <li ng-repeat=\"account in accounts\" class=\"account-item\" ui-sref-active=\"selected\" ui-sref=\"member.home({username: account.username})\">\n" +
    "      <div class=\"account-left\">\n" +
    "        <div>\n" +
    "          <card-image-small design-id=\"account.designId\"/>\n" +
    "        </div>\n" +
    "        <div class=\"account-meta\">\n" +
    "          <span class=\"account-title\">{{account.title}}</span><span ng-show=\"account.cardLastFour\"> ..{{account.cardLastFour}}</span><br>\n" +
    "          {{account.cardDisplayType}}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"account-right\">\n" +
    "        {{account.balance | akimboCurrency}}\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "  <div class=\"account-selector-close-btn btn\" ng-click=\"closeAccountSelector()\">\n" +
    "    Close\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/shared/card-image-small.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/card-image-small.html",
    "<div>\n" +
    "  <img ng-show=\"hasMobileImage\" class=\"account-image-using-mobile\" ng-src=\"/app/assets/images/mobile-cards/card-{{designId}}.svg\"/>\n" +
    "  <img ng-show=\"!hasMobileImage && hasMobileImage !== undefined\" class=\"account-image\" ng-src=\"/app/assets/images/dashboard-cards/card-{{designId}}.svg\" fallback-src=\"/app/assets/images/dashboard-cards/card-default.svg\"/>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/card-image.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/card-image.html",
    "<svg class=\"card-design__img\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
    "  <g>\n" +
    "  <image ng-show=\"hasMobileImage\" x=\"43\" y=\"3\" width=\"140\" height=\"88\" xlink:href=\"\" ng-href=\"/app/assets/images/mobile-cards/card-{{designId}}.svg\"/>\n" +
    "  <image ng-show=\"!hasMobileImage && hasMobileImage !== undefined\" x=\"0\" y=\"0\" width=\"225\" height=\"110\" xlink:href=\"\" ng-href=\"/app/assets/images/dashboard-cards/card-{{designId}}.svg\" fallback-href=\"/app/assets/images/dashboard-cards/card-default.svg\"/>\n" +
    "  </g>\n" +
    "</svg>\n" +
    "");
}]);

angular.module("../app/views/member/shared/checkboxes.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/checkboxes.html",
    "<li ng-hide=\"disableText\" class=\"floatingForm-li\">\n" +
    "    <div class=\"checkbox-item\"\n" +
    "         ng-click=\"formData.textAlerts = !formData.textAlerts\">\n" +
    "        <div class=\"checkbox-item__box\"\n" +
    "             ng-class=\"formData.textAlerts ? '' : 'checkbox-item__box--disabled'\" tabindex=\"8\">\n" +
    "            <span class=\"checkbox-item__icon\"\n" +
    "                  ng-class=\"formData.textAlerts ? 'icon-check' : ''\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "                    class=\"checkbox-item__input\"\n" +
    "                    type=\"checkbox\"\n" +
    "                    name=\"textAlerts\"\n" +
    "                    id=\"text_alerts\"\n" +
    "                    ng-model=\"formData.textAlerts\"\n" +
    "                    tabindex=\"10\">\n" +
    "            <p class=\"checkbox-item__text checkbox-item__text--small\">Enroll in text alerts. Receive real-time purchase alerts with balance and transaction information.*</p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</li>\n" +
    "");
}]);

angular.module("../app/views/member/shared/confirmation-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/confirmation-modal.html",
    "<div id=\"confirmationOverlay\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">\n" +
    "          {{ confirmationOverlayMessage ? confirmationOverlayMessage : \"You are about to visit an external third party website that is not administered by \" + brand.programName + \". The following site's privacy policy may differ from our own.\" }}\n" +
    "        </p>\n" +
    "        <a class=\"btn btn-full-width\" href=\"{{outBoundLink}}\" ng-click=\"removeConfirmation()\" target=\"_blank\">OK, continue to site</a>\n" +
    "        <br>\n" +
    "        <div class=\"btn btn-full-width btn-secondary\" ng-click=\"removeConfirmation()\">No, stay here</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/double-wide-widgets.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/double-wide-widgets.html",
    "<div class=\"double-wide-widget\" ng-if=\"showCards\" ng-repeat=\"widget in widgetCards\" ng-class=\"{'upgrade-blue': widget.upgradeBlue}\"> \n" +
    "  <div class=\"widget-content-area\">\n" +
    "    <div class=\"widget-title\">{{widget.title}}</div>\n" +
    "    <div class=\"widget-subtitle\">{{widget.subTitle}}</div>\n" +
    "    <div class=\"widget-message\" ng-if=\"widget.message\">\"<i>{{widget.message}}</i>\"</div>\n" +
    "    <img ng-if=\"widget.image\" ng-src=\"{{widget.image}}\"/>\n" +
    "    <div class=\"widget-icons\" ng-if=\"widget.icons\">\n" +
    "      <div class=\"widget-icon-container\" ng-repeat=\"icon in widget.icons\">\n" +
    "        <div class=\"widget-title\">{{icon.title}}</div>\n" +
    "        <div ng-class=\"icon.icon\" class=\"widget-icon\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"widget-action-area\">\n" +
    "    <div class=\"action-section\" ng-repeat=\"section in widget.sections\">\n" +
    "      <div class=\"action-subtitle\"><span>{{section.subTitle}}</span></div>\n" +
    "      <div class=\"action-title\" ><span>{{section.title}}</span></div>\n" +
    "      <a ui-sref=\"{{section.state}}\" ng-class=\"section.classes\" class=\"btn btn-orange btn-xlarge\">{{section.btn}}</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/feed-container.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/feed-container.html",
    "<div class=\"feed-container\">\n" +
    "  <div class=\"feed-list-header\">\n" +
    "    <div ng-show=\"!loading\">\n" +
    "      <div class=\"feed-header-container\">\n" +
    "        <div class=\"feed-title\" ng-click=\"openAccount()\">\n" +
    "          <span id=\"ch-name\">{{account.title}}</span>\n" +
    "          <span ng-show=\"!hideAccountAttribute() && account.cardLastFour\" class=\"feed-last-four\">x{{account.cardLastFour}}</span>\n" +
    "          <span class=\"icon-arrow-down-fill\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"feed-balance\" ng-hide=\"hideAccountAttribute()\">\n" +
    "          {{account.balance | akimboCurrency}}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"feed-header-container\">\n" +
    "        <div class=\"feed-card-type\">\n" +
    "          {{account.cardDisplayType}}\n" +
    "        </div>\n" +
    "        <a ui-sref=\"member.home.expanded\">\n" +
    "          <div class=\"feed-view-statement btn-outline\">\n" +
    "            <div class=\"statement-text\">Detail View</div>\n" +
    "          </div>\n" +
    "        </a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <account-selector ng-if=\"openAccountSelector\"></account-selector>\n" +
    "  <ul id=\"switchView\" class=\"switch-view nav\">\n" +
    "    <li id=\"switchViewFeed\">\n" +
    "      <a ng-click=\"$root.displayWidgets=!$root.displayWidgets\">\n" +
    "        <span ng-class=\"($root.displayWidgets ? 'icon-feed' : 'icon-windows')\"></span>\n" +
    "        <p>{{($root.displayWidgets ? 'Feed' : 'Actions')}}</p>\n" +
    "      </a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "  <div id=\"feedView\" ng-hide=\"$root.isMobileView\">\n" +
    "    <div class=\"col-feed\" ui-view=\"feed\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/shared/feed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/feed.html",
    "<div class=\"feed-container\">\n" +
    "  <div id=\"feedView\" ng-hide=\"!$root.isMobileView\">\n" +
    "    <div class=\"col-feed\" ui-view=\"feed\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/shared/footer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/footer.html",
    "<div class=\"akimbo-footer\">\n" +
    "  <p>\n" +
    "  <span ng-hide=\"brand.hidePrograms\" class=\"normal\" style=\"text-align: center\">\n" +
    "    <span ng-bind-html=\"brand.fullProgramName\"></span>\n" +
    "    </span>\n" +
    "    <span ng-show=\"brand.hasGiftProgram && !brand.hidePrograms\" class=\"normal\" style=\"text-align: center\">\n" +
    "      and <span ng-bind-html=\"brand.fullGiftProgramName\"></span>\n" +
    "    </span>\n" +
    "    <br/>\n" +
    "    <span ng-hide=\"brand.hidePrograms\">The <span ng-bind-html=\"brand.fullProgramName\"></span><span ng-show=\"brand.hasGiftProgram\"> and <span ng-bind-html=\"brand.fullGiftProgramName\"></span></span> <span ng-show=\"brand.hasGiftProgram\">are</span><span ng-show=\"!brand.hasGiftProgram\">is</span></span><span ng-show=\"brand.hidePrograms\">This card is</span> issued by {{brand.issuer.bank}}, Member FDIC, pursuant to a license from Mastercard International Incorporated. This card may be used everywhere Debit Mastercard is accepted. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated. Use of this card constitutes acceptance of the terms and conditions stated in the Cardholder Agreement.\n" +
    "  </p>\n" +
    "</div>\n" +
    "<div ng-show=\"overlayLoading\" class=\"overlay-wrapper\">\n" +
    "  <div class=\"overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/in-active.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/in-active.html",
    "<div ng-show=\"inActiveState\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">For security purposes, we will log you out in {{countdown}} seconds unless you'd like to stay logged in.</p>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"inActiveState = !inActiveState\">Yes, keep me logged in please</a><br>\n" +
    "        <a class=\"btn btn-full-width btn-secondary\" ng-click=\"inActiveState = !inActiveState\" ui-sref=\"logout\">Log out now</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/main-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/main-header.html",
    "<div class=\"akimbo-main-header\">\n" +
    "  <div class=\"container\">\n" +
    "    <div class=\"akimbo-account-selector\">\n" +
    "      <a ui-sref=\"member.home({username: account.username})\" id=\"card-{{account.username}}\" class=\"akimbo-account\" ng-repeat=\"account in accountsInRow | limitTo: cardLimit\" ui-sref-active=\"selected\">\n" +
    "        <div class=\"card-meta\">\n" +
    "          <div class=\"title\">\n" +
    "            {{account.firstName}}\n" +
    "            {{account.lastName}}\n" +
    "          </div>\n" +
    "          <div class=\"balance\" ng-show=\"!hideAccountAttribute()\">\n" +
    "            {{account.balance | akimboCurrency}}\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"card-design\" ng-class=\"'card-design--' + account.cardStyle\">\n" +
    "          <img class=\"card-design__notification\" src=\"assets/images/bubble.svg\" alt=\"\" ng-if=\"account.status == 'Inactive' || account.status == 'Pre-Active' || account.status == 'Load Block'\">\n" +
    "          <div>\n" +
    "            <card-image design-id=\"account.designId\"/>\n" +
    "          </div>\n" +
    "          <div class=\"card-design__header-text\">\n" +
    "            <span class=\"card-design__header-card-type\">{{account.cardDisplayType}}</span>\n" +
    "            <span class=\"card-design__header-last-four\" ng-show=\"!hideAccountAttribute() && account.cardLastFour\"  width=\"60\" height=\"20\">..{{account.cardLastFour}}</span>\n" +
    "          </div>\n" +
    "            <svg class=\"card-design__shadow\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"225\" height=\"110\">\n" +
    "            <g>\n" +
    "            <image x=\"0\" y=\"0\" width=\"225\" height=\"110\" xlink:href=\"\" ng-href=\"/app/assets/images/dashboard-cards/akimbocard-shadow.svg\"/>\n" +
    "            </g>\n" +
    "          </svg>\n" +
    "        </div>\n" +
    "      </a>\n" +
    "      <a ui-sref=\"member.home.subaccount/add.step1\" class=\"akimbo-account\" ng-show=\"!loading && canAddSub && showCanAddSub && !hideAccountAttribute()\" >\n" +
    "        <div class=\"title\">\n" +
    "          Create<br>\n" +
    "          More Cards\n" +
    "        </div>\n" +
    "        <br>\n" +
    "        <div class=\"card-design\">\n" +
    "          <div class=\"card-design__brand-logo-container\">\n" +
    "            <img class=\"card-design__brand-logo\" src=\"assets/images/{{brand.name}}/logo.svg\"/>\n" +
    "          </div>\n" +
    "          <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"225\" height=\"110\">\n" +
    "            <g>\n" +
    "            <image x=\"0\" y=\"0\" width=\"225\" height=\"110\" xlink:href=\"/app/assets/images/dashboard-cards/addcard.svg\" class=\"account-card\" />\n" +
    "            </g>\n" +
    "          </svg>\n" +
    "        </div>\n" +
    "      </a>\n" +
    "      <a ui-sref=\"member.home.upgrade.step1\" class=\"akimbo-account\" ng-show=\"!loading && canUpgrade && showCanUpgrade\">\n" +
    "        <div class=\"title\">\n" +
    "          Get Reloadable<br>\n" +
    "          {{brand.commonProgramName}}\n" +
    "        </div>\n" +
    "        <br>\n" +
    "        <div class=\"card-design\">\n" +
    "          <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"225\" height=\"110\">\n" +
    "            <g>\n" +
    "            <image x=\"0\" y=\"0\" width=\"225\" height=\"110\" xlink:href=\"/app/assets/images/dashboard-cards/addcard.svg\" class=\"account-card\" />\n" +
    "            </g>\n" +
    "          </svg>\n" +
    "        </div>\n" +
    "      </a>\n" +
    "      <div id=\"viewAllCards\" class=\"akimbo-account\" ng-show=\"!loading && !hideAccountAttribute()\" ng-click=\"navToViewAllCards()\">\n" +
    "        <div class=\"title\">\n" +
    "          View<br>\n" +
    "          All Cards\n" +
    "        </div>\n" +
    "        <br>\n" +
    "        <div class=\"card-design\">\n" +
    "          <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"225\" height=\"110\">\n" +
    "            <g>\n" +
    "            <image x=\"0\" y=\"0\" width=\"225\" height=\"110\" xlink:href=\"/app/assets/images/dashboard-cards/viewall.svg\" class=\"account-card\" />\n" +
    "            </g>\n" +
    "          </svg>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/calendar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/calendar.html",
    "<div class=\"popover-wrap\" ng-show=\"formData.showScheduleOption\">\n" +
    "  <div id=\"schedule-step1-frequency\" class=\"popover popover-offscreen popover-no-padding\" style=\"display: block; left: 20px; top: -426px;\">\n" +
    "    <span class=\"popover-close icon-close\" ng-click=\"formData.showScheduleOption = false\"></span>\n" +
    "    <h2 class=\"popover-title\" id=\"step1-frequency-text\">Schedule</h2>\n" +
    "    <div class=\"popover-body\">\n" +
    "      <p>How often would you like to transfer money to/from your card? Would you like to schedule it around your paycheck? Customize the recurring schedule below.</p>\n" +
    "    </div>\n" +
    "    <div class=\"popover-body\">\n" +
    "      <ul class=\"form\">\n" +
    "        <li>\n" +
    "          <div class=\"popover-wrap\">\n" +
    "            <label>How often?</label>\n" +
    "            <select\n" +
    "               required\n" +
    "               id=\"frequency-select\" \n" +
    "               name=\"frequency\"\n" +
    "               ng-change=\"changeFreq()\"\n" +
    "               ng-model=\"datePicker.frequency\"\n" +
    "               ng-options=\"f.label for f in frequencyOptions track by f.key\">\n" +
    "              <option value=\"\" ng-if=\"!datePicker.frequency\">Select...</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <div class=\"popover-wrap\">\n" +
    "            <label>Pick your days</label>\n" +
    "            <select \n" +
    "               id=\"day1-select\" \n" +
    "               ng-change=\"changeDay1()\"\n" +
    "               ng-model=\"datePicker.day1\"\n" +
    "               value=\"\"\n" +
    "               ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "               class=\"select-small\" \n" +
    "               style=\"width:35%;\">\n" +
    "              <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "            </select>\n" +
    "            <select \n" +
    "               id=\"day2-select\" \n" +
    "               ng-change=\"changeDay2()\" \n" +
    "               ng-model=\"datePicker.day2\"\n" +
    "               value=\"\"\n" +
    "               ng-options=\"d.label for d in dayOptions track by d.key\"\n" +
    "               ng-show=\"datePicker.frequency.key == 'T'\"\n" +
    "               class=\"select-small\" \n" +
    "               style=\"width:35%;\">\n" +
    "              <option value=\"\" ng-if=\"!datePicker.day1\">Select...</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <div class=\"popover-wrap\">\n" +
    "            <label>Start date</label>\n" +
    "            <select \n" +
    "               id=\"date-select\" \n" +
    "               ng-change=\"changeDate()\" \n" +
    "               ng-model=\"datePicker.dateSelect\"\n" +
    "               ng-options=\"f.label for f in dateOptions track by f.formattedDate\">\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <div class=\"popover-wrap\">\n" +
    "            <a class=\"btn normal btn-secondary js-toggle-element js-toggle-element-close\" ng-click=\"formData.showScheduleOption = false\">OK</a>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/footer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/footer.html",
    "<div class=\"overlay-footer-scroll-wrapper\">\n" +
    "  <div class=\"overlay-footer-wrapper\">\n" +
    "    <div class=\"overlay-footer\">\n" +
    "      <div id=\"akimbo-form-error-box\" class=\"message\" ng-show=\"alert.errorShown\">\n" +
    "        <span class=\"icon-point-up\"></span>\n" +
    "        <span id=\"akimbo-form-error-message\">Oops, you've missed something above</span>\n" +
    "      </div>\n" +
    "      <div id=\"akimbo-form-error-box\" class=\"message\" ng-show=\"alert.waitMsg && loading\">\n" +
    "        <span class=\"icon-point-up\"></span>\n" +
    "        <span id=\"akimbo-form-error-message\">{{alert.waitMsg}}</span>\n" +
    "      </div>\n" +
    "      <div id=\"success-msg\" class=\"message success\" ng-show=\"alert.successShown\"><span class=\"icon-thumbs-up\"></span>Congratulations! {{alert.successMessage}}</div>\n" +
    "      <div id=\"success-msg-only\" class=\"message success\" ng-show=\"alert.successShownOnly\"></span>{{alert.successMessageOnly}}</div>\n" +
    "      <div id=\"akimbo-form-footer-buttons\" ng-show=\"!loading\">\n" +
    "        <button id=\"submit-btn\" class=\"btn normal \" ng-hide=\"alert.successShown\" ng-if=\"mainBtn.processForm\" ng-click=\"processForm(formData)\">{{mainBtn.title}}</button>\n" +
    "        <button ng-if=\"mainBtn.processGiftForm\" class=\"btn normal \" ng-click=\"processForm(overlayForm)\">{{mainBtn.title}}</button>\n" +
    "        <button id=\"next-btn\" ng-if=\"mainBtn.attemptSubmission\" class=\"btn normal \" ng-click=\"attemptSubmission(overlayForm, mainBtn.next)\">{{mainBtn.title}}</button>\n" +
    "        <button ng-if=\"primaryBtn\" ui-sref=\"{{primaryBtn.state}}\" class=\"btn normal\">{{primaryBtn.title}}</button>\n" +
    "        <span ng-if=\"getStarted\" ng-hide=\"respSuccess\" class=\"loading-indicator\"></span>\n" +
    "        <ul class=\"form noBorder footer-error\" ng-show=\"showFooterError\">\n" +
    "          <li class=\"form-error\">\n" +
    "            <div class=\"alert alert--full-width\">\n" +
    "              <span class=\"icon-warning-triangle\"></span>\n" +
    "              <ul class=\"form\">\n" +
    "                <li>Sorry, we're having a temporary issue. Please try again later.</li>\n" +
    "              </ul>\n" +
    "            </div>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "        <button ng-if=\"getStarted\" class=\"btn\" ng-class=\"{'btn-disabled' : !respSuccess}\" ng-click=\"loadingSuccess = true; open()\">GET STARTED</button>\n" +
    "        <button ng-if=\"mainBtn.attemptSubmissionAndProcessForm\" class=\"btn normal\" ng-click=\"attemptSubmissionAndProcessForm(overlayForm, formData)\">{{mainBtn.title}}</button>\n" +
    "        <button ng-if=\"showNext\" class=\"btn normal\" ng-click=\"selectAccount.attemptSubmission(overlayForm, selectAccount.accounts)\">NEXT</button>\n" +
    "        <button ng-repeat=\"btn in btns\" ui-sref=\"{{btn.state}}\" class=\"btn normal btn-secondary\">{{btn.title}}</button>\n" +
    "        <button ng-if=\"okBtn\" class=\"btn normal btn-secondary\" ng-click=\"back()\">{{okBtn.title}}</button>\n" +
    "        <button id=\"close-btn\" ng-controller='overlayCtrl' ng-if=\"close\" ng-click=\"back()\" class=\"btn normal btn-secondary\">CLOSE</button>\n" +
    "        <button id=\"cancel-btn\" ng-controller='overlayCtrl' ng-if=\"cancel\" ng-click=\"back()\" class=\"btn normal btn-secondary\">CANCEL</button>\n" +
    "        <button id=\"close-btn\" ng-if=\"showCloseOrRedirect\" ng-click=\"closeOrRedirect()\" class=\"btn normal btn-secondary\">CLOSE</button>\n" +
    "        <button id=\"cancel-btn\" ng-if=\"showCancelOrRedirect\" ng-click=\"closeOrRedirect()\" class=\"btn normal btn-secondary\">CANCEL</button>\n" +
    "        <button ng-if=\"showBack\" ng-click=\"nestedBack()\" class=\"btn normal btn-secondary\">BACK</button>\n" +
    "      </div>\n" +
    "      <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "        <span class=\"loading-indicator\" alt=\"\"></span>\n" +
    "        <p>Processing</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"alert.alertShown\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1 ng-if=\"!selectAccount.showError\">Heads up!</h1>\n" +
    "          <h1 ng-if=\"selectAccount.showError\">Oops! Something went wrong.</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{alert.alertMessage}}</p>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"alert.alertShown=!alert.alertShown\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"secondaryAlert.alertShown\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>{{secondaryAlert.alertHeader}}</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{secondaryAlert.alertMessage}}</p>\n" +
    "        <a class=\"btn btn-small btn--float-left btn-no-min-width\" ng-click=\"secondaryAlert.secondaryFn()\">{{secondaryAlert.secondaryText}}</a>\n" +
    "        <a class=\"btn btn-small btn--float-right btn-no-min-width\" ng-click=\"secondaryAlert.primaryFn()\">{{secondaryAlert.primaryText}}</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"finicityAlert\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Oops! Something went wrong.</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{finicityMessage}}</p>\n" +
    "          <a class=\"btn btn-full-width\" ng-click=\"finicityAlert = !finicityAlert\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/header-content.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/header-content.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ul class=\"form js-autoscroll-form\">\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "      <label for=\"#\">To</label>\n" +
    "        <div class=\"content\">\n" +
    "          <div class=\"akimbo-media-box\">\n" +
    "            <div class=\"img-wrap\">\n" +
    "              <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "            </div>\n" +
    "            <div class=\"akimbo-media-box-content\">\n" +
    "              <h5 class=\"akimbo-media-box-title\">{{transferTo.FirstName + ' ' + transferTo.LastName}}</h5>\n" +
    "              <p class=\"akimbo-media-box-subtitle\">{{transferTo.Username}}</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      <div class=\"form-modify form-delete icon-circle-x\" ui-sref=\"member.home.send/transfer.step1\"></div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/header-default.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/header-default.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p ng-bind-html=\"info\"></p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/header-search.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/header-search.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ul class=\"form js-autoscroll-form\">\n" +
    "    <li class=\"form-with-help\" style=\"border-bottom:none;\">\n" +
    "      <label class=\"overlay-title-text\">SEARCH</label>\n" +
    "      <input \n" +
    "        type=\"text\" \n" +
    "        name=\"transferTo\" \n" +
    "        id=\"transferTo\" \n" +
    "        value=\"\" \n" +
    "        class=\"userpicker\" \n" +
    "        placeholder=\"Search by username, email or phone number\" \n" +
    "        ng-model=\"searchInput.memberSearched\"\n" +
    "        ng-change=\"search(searchInput.memberSearched)\">\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/header-transfer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/header-transfer.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/layout.html",
    "<div class=\"overlay-wrapper overlay-active\">\n" +
    "  <div class=\"overlay {{overlay.headerClass}}\" ng-class=\"noSidebar ? 'overlay--no-sidebar' : ''\">\n" +
    "    <div id='close-widget' class=\"overlay-close icon-circle-x\" ng-controller='overlayCtrl' ng-click=\"back()\"></div>\n" +
    "    <div class=\"overlay-header\">\n" +
    "      <div class=\"overlay-header-main\">\n" +
    "        <span class=\"{{overlay.icon}}\"></span>\n" +
    "        <h1>{{overlay.title}}</h1>\n" +
    "      </div>\n" +
    "    </div><!-- .overlay-header -->\n" +
    "    <div ui-view=\"header\"></div>\n" +
    "    <!-- .overlay-header-form -->\n" +
    "    <div class=\"overlay-body\">\n" +
    "      <div class=\"overlay-main\">\n" +
    "        <form name=\"overlayForm\" class=\"widget-form\" ng-submit=\"processForm(formData)\">\n" +
    "          <div ui-view=\"step\"></div>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "      <div ui-view=\"side\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-background\"></div>\n" +
    "</div>\n" +
    "<div ui-view=\"footer\"></div>\n" +
    "<div class=\"overlay-mask\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/restricted.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/restricted.html",
    "<h3>This is a restricted message</h3>");
}]);

angular.module("../app/views/member/shared/overlay/side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/side-options.html",
    "<div class=\"overlay-side\">\n" +
    "  <div ng-if=\"info || bankTransferInfo\">\n" +
    "    <h2>{{title}}</h2>\n" +
    "    <p>{{info}}</p>\n" +
    "    <p ng-hide=\"isBankSelected(formData.Source)\" ng-bind-html=\"bankTransferInfo\"></p>\n" +
    "    <div ng-show=\"isInstantTransfer(formData.Source)\">\n" +
    "      <p>Your bank load will typically post within seconds. Current instant limit: ${{limits.pendingVolume}}.</p>\n" +
    "      <p>Loads over the instant limit will post on: {{postDateFormatted}}</p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"isStandardTransfer(formData.Source)\">\n" +
    "      <p>Your bank load will post on: {{postDateFormatted}}.</p>\n" +
    "      <p>{{isExpense ? \"To enable instant bank loading, please contact partnersupport@usio.com.\" : \"To enable instant loads on a bank account, process a successful standard bank load of $200 or more.\"}}</p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <h2 ng-hide=\"hideOptionsTitle\">Options</h2>\n" +
    "  <div ng-show=\"showRemoveBank\" class=\"popover-wrap\">\n" +
    "    <a class=\"btn btn-light btn-full-width large js-toggle-element\" ng-click=\"showRemoveBankOption=!showRemoveBankOption\">Remove</a>\n" +
    "    <div class=\"popover\" ng-show=\"showRemoveBankOption\">\n" +
    "      <p>Are you sure you want to permanently remove this bank account?</p>\n" +
    "      <a ng-click=\"removeBank()\" class=\"btn large\">Remove</a>\n" +
    "      <a ng-click=\"showRemoveBankOption=!showRemoveBankOption\" class=\"btn btn-secondary large js-toggle-element js-toggle-element-close\">Cancel</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div id=\"remove-btn\" ng-show=\"showRemoveTransfer\" class=\"popover-wrap\">\n" +
    "    <a class=\"btn btn-light btn-full-width large js-toggle-element\" ng-click=\"showRemoveTransferOption=!showRemoveTransferOption\">Remove</a>\n" +
    "    <div class=\"popover\" ng-show=\"showRemoveTransferOption\">\n" +
    "      <p>Are you sure you want to permanently remove this recurring transfer?</p>\n" +
    "      <a id=\"remove-submit-btn\" ng-click=\"removeTransfer()\" class=\"btn large\">Remove</a>\n" +
    "      <a ng-click=\"showRemoveTransferOption=!showRemoveTransferOption\" class=\"btn btn-secondary large js-toggle-element js-toggle-element-close\">Cancel</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-show=\"showRemoveRequest\" class=\"popover-wrap\">\n" +
    "    <a class=\"btn btn-light btn-full-width large js-toggle-element\" ng-click=\"showRemoveRequestOption=!showRemoveRequestOption\">Remove</a>\n" +
    "    <div class=\"popover\" ng-show=\"showRemoveRequestOption\">\n" +
    "      <p>Are you sure you want to permanently remove this request for funds?</p>\n" +
    "      <a ng-click=\"removeRequest('request')\" class=\"btn large\">Remove</a>\n" +
    "      <a ng-click=\"showRemoveRequestOption=!showRemoveRequestOption\" class=\"btn btn-secondary large js-toggle-element js-toggle-element-close\">Cancel</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-show=\"showRemovePendingTransfer\" class=\"popover-wrap\">\n" +
    "    <a id=\"cancel-bank-transfer\" class=\"btn btn-light btn-full-width large js-toggle-element\" ng-click=\"showRemovePendingTransferOption=!showRemovePendingTransferOption\">Cancel Transfer</a>\n" +
    "    <div class=\"popover\" ng-show=\"showRemovePendingTransferOption\">\n" +
    "      <p>Are you sure you want to cancel this scheduled bank transfer?</p>\n" +
    "      <a id=\"confirmation-cancel-btn\" ng-click=\"removeRequest('bank/transfer')\" class=\"btn large\">Cancel Transfer</a>\n" +
    "      <a ng-click=\"showRemovePendingTransferOption=!showRemovePendingTransferOption\" class=\"btn btn-secondary large js-toggle-element js-toggle-element-close\">Close</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-show=\"showAddMessage\" class=\"popover-wrap\">\n" +
    "      <a class=\"btn btn-light btn-full-width large js-toggle-element\" ng-click=\"showAddMessageOption = (child.showAddMessageOption = true)\">Add message</a>\n" +
    "      <div class=\"popover\" ng-show=\"showAddMessageOption && child.showAddMessageOption\">\n" +
    "          <textarea ng-model=\"message\" placeholder=\"type your message...\"></textarea>\n" +
    "          <a ng-click=\"addMessage(message)\" class=\"btn large akimbo-form-add-message\">Add</a>\n" +
    "          <a ng-click=\"showAddMessageOption = (child.showAddMessageOption = false)\" class=\"btn btn-secondary large js-toggle-element js-toggle-element-close\">Cancel</a>\n" +
    "      </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"showAddPhoto\" class=\"popover-wrap\">\n" +
    "      <div\n" +
    "         class=\"btn btn-light btn-full-width large js-toggle-element btn-upload\">\n" +
    "        Add Photo or Receipt\n" +
    "        <input type=\"file\" nv-file-select options=\"{{child.uploadOptions}}\" uploader=\"uploader\"/>\n" +
    "      </div>\n" +
    "  </div>\n" +
    "  <a ng-show=\"showChangePin\" ui-sref=\"member.home.profile/changepin.step1\" class=\"btn btn-light btn-full-width large fb-connect\">Change PIN</a>\n" +
    "  <a ng-show=\"showFacebook\" ui-sref=\"member.home\" class=\"btn btn-light btn-full-width large fb-connect\">Connect Facebook</a>\n" +
    "  <a ng-show=\"showProfile\" ui-sref=\"member.home.profile.step1\" class=\"btn btn-light btn-full-width large fb-connect\">Profile</a>\n" +
    "  <a ng-show=\"showPayee\" ui-sref=\"member.home.billpay.new\" class=\"btn btn-light btn-full-width large\">Add new payee</a>\n" +
    "  <a ng-show=\"showAddBank && (!$root.user.restrictions.BNK-TRN-IN && !$root.user.restrictions.BNKTRN-OUT)\" ui-sref=\"member.home.bank/add.step1\" class=\"btn btn-light btn-full-width large\">Add bank</a>\n" +
    "  <a ng-show=\"showManageBank\" ui-sref=\"member.home.bank/manage.list\" class=\"btn btn-light btn-full-width large\">Manage banks</a>\n" +
    "  <a ng-show=\"showFulfillRequest\" ng-click=\"fulFillRequest()\" class=\"btn btn-light btn-full-width large\">Fulfill Request</a>\n" +
    "  <a ng-show=\"showManageAutoTransfers\" ui-sref=\"member.home.transfers/manage.list\" class=\"btn btn-light btn-full-width large\">Manage auto transfers</a>\n" +
    "  <a ng-show=\"showAutoLoads\" ui-sref=\"member.home.bank/transfer/recurring.step1({transferType: 'load'})\" class=\"btn btn-light btn-full-width large\">Setup auto loads</a>\n" +
    "  <a ng-show=\"showAutoSends\" ui-sref=\"member.home.send/recurring.step1\" class=\"btn btn-light btn-full-width large\">Setup auto sends</a>\n" +
    "  <a ng-show=\"showPassword\" ui-sref=\"member.home.profile/password.step1\" class=\"btn btn-light btn-full-width large\">Change password</a>\n" +
    "  <a ng-show=\"showAddress\" ui-sref=\"member.home.profile.step1\" class=\"btn btn-light btn-full-width large\">Update address</a>\n" +
    "  <a ng-show=\"showSms\" ui-sref=\"member.home.profile/smsmanage.step1\" class=\"btn btn-light btn-full-width large\">Manage text alerts</a>\n" +
    "  <a ng-show=\"showLoadCheck\" href=\"http://ingomoney.com/\" target=\"_blank\" class=\"btn btn-light btn-full-width large\" confirmation-overlay>Load check</a>\n" +
    "  <a ng-show=\"showCashLoad\" href=\"https://www.mastercard.us/en-us/personal/get-support/reload-a-prepaid-card.html\" target=\"_blank\" class=\"btn btn-light btn-full-width large\" confirmation-overlay>Find Locations</a>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/shared/overlay/side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/overlay/side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>{{title}}</h2>\n" +
    "  <p ng-bind-html=\"info\"></p>\n" +
    "  <p>{{info2}}</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/viewAllCards.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/viewAllCards.html",
    "<div class=\"account-selector\" when-paginated-scrolled callback=\"loadMoreCards()\" scroll-bar-display disabled='disabled'>\n" +
    "  <div class=\"view-all-container\">\n" +
    "    <div class=\"view-all-header\">\n" +
    "      <div class=\"top-header\">\n" +
    "        <div class=\"container\">\n" +
    "          <a class=\"top-header__brand-logos\" href=\"/app/#/member/{{username}}/\" title=\"Home page\" rel=\"home\" style=\"color: #000\">\n" +
    "            <!-- Colored logos for transparent header -->\n" +
    "            <img class=\"top-header__brand-img\" ng-if=\"brand.defaultBrandLogo && header.removeBkg\" ng-src=\"assets/images/{{default_brand}}/logo-color.svg\" alt=\"\">\n" +
    "            <img class=\"top-header__brand-img\" ng-if=\"brand.brandLogo && header.removeBkg\" ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "            <!-- White logos for colored header -->\n" +
    "            <img class=\"top-header__brand-img\" ng-if=\"brand.defaultBrandLogo && !header.removeBkg\" ng-src=\"assets/images/{{default_brand}}/logo.svg\" alt=\"\">\n" +
    "            <img class=\"top-header__brand-img\" ng-if=\"brand.brandLogo && !header.removeBkg\" ng-src=\"assets/images/{{brand.name}}/logo.svg\" alt=\"\">\n" +
    "          </a>\n" +
    "          <ul class=\"top-header__nav\" ng-if=\"firstName\">\n" +
    "            <li class=\"account-li\">\n" +
    "              Hello {{firstName}}\n" +
    "            </li>\n" +
    "            <li class=\"hide-mobile\">\n" +
    "              <a ui-sref=\"member.home.profile.step1\">My Account</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <a ui-sref=\"logout\" id=\"logout\">Logout</a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "          <ul class=\"top-header__nav top-header__nav--right hide-mobile\" ng-if=\"!header.secondaryLinks\">\n" +
    "            <li>\n" +
    "              <a ng-hide=\"brand.ssoHide\" href=\"/app/#/member/{{username}}/\">Home</a>\n" +
    "              <a ng-show=\"brand.ssoHide\" href=\"{{brand.homeUrl}}\">Home</a>\n" +
    "            </li>\n" +
    "            <li ng-repeat=\"link in brand.headerLinks track by $index\">\n" +
    "              <a href=\"{{link.url}}\">{{link.text}}</a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "          <ul class=\"top-header__nav top-header__nav--right hide-mobile\" ng-if=\"header.secondaryLinks\">\n" +
    "            <li>\n" +
    "              <a ui-sref=\"root.register.step1\">Register a card</a>\n" +
    "            </li>\n" +
    "            <li ng-show=\"brand.programLegal['fees']\">\n" +
    "              <a href=\"{{brand.programLegal.fees}}\">Fees</a>\n" +
    "            </li>\n" +
    "            <li ng-show=\"brand.programLegal['help']\">\n" +
    "              <a href=\"{{brand.programLegal.help}}\" title=\"\">Help</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <a class=\"btn btn-small btn-no-min-width\" ui-sref=\"root.login\" title=\"\">Log In</a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "          <div class=\"mobile-nav\" ng-click=\"expanded = !expanded\">\n" +
    "            <span class=\"icon-menu-burger\"></span>Menu\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <ul class=\"mobile-nav-menu\" ng-show=\"expanded\" ng-click=\"expanded = !expanded\" ng-if=\"!header.secondaryLinks\">\n" +
    "          <li>\n" +
    "            <a ng-hide=\"brand.ssoHide\" href=\"/app/#/member/{{username}}/\">Home</a>\n" +
    "            <a ng-show=\"brand.ssoHide\" href=\"{{brand.homeUrl}}\">Home</a>\n" +
    "          </li>\n" +
    "          <li ng-repeat=\"link in brand.headerLinks track by $index\">\n" +
    "            <a href=\"{{link.url}}\">{{link.text}}</a>\n" +
    "          </li>\n" +
    "          <li>\n" +
    "            <a ui-sref=\"member.home.profile.step1\">My Account</a>\n" +
    "          </li>\n" +
    "          <li>\n" +
    "            <a ui-sref=\"logout\">Logout</a>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "        <ul class=\"mobile-nav-menu\" ng-show=\"expanded\" ng-click=\"expanded = !expanded\" ng-if=\"header.secondaryLinks\">\n" +
    "          <li>\n" +
    "            <a ui-sref=\"root.register.step1\">Register a card</a>\n" +
    "          </li>\n" +
    "          <li ng-show=\"brand.program['fees']\">\n" +
    "            <a href=\"{{brand.programLegal.fees}}\">Fees</a>\n" +
    "          </li>\n" +
    "          <li ng-show=\"brand.program['help']\">\n" +
    "            <a href=\"{{brand.programLegal.help}}\" title=\"\">Help</a>\n" +
    "          </li>\n" +
    "          <li>\n" +
    "            <a class=\"btn btn-small btn-no-min-width\" ui-sref=\"root.login\" title=\"\">Log In</a>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "      </div>\n" +
    "      <form>\n" +
    "        <div class=\"form-group\">\n" +
    "          <div class=\"input-group\">\n" +
    "            <span class=\"icon-search\"></span><input id=\"viewAllSearch\" type=\"text\" class=\"form-control view-all-input\" placeholder=\"Search By Name\" ng-model=\"searchAccount\" ng-keyup=\"cardSearch()\"><button id=\"searchClose\"><span class=\"icon-close-circle\" ng-click=\"reset()\" ng-show=\"searchAccount.length > 0 ? true : false\"></span></button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "    <div class=\"view-all-content\">\n" +
    "      <div class=\"view-all-back-header\">\n" +
    "        <button id=\"back-btn\" class=\"back-btn\" ng-click=\"goBack()\">\n" +
    "          <span class=\"icon-arrow-left-full\"></span>Back\n" +
    "        </button>\n" +
    "        <div ng-hide=\"hideViewOptions\" class=\"view-options\">\n" +
    "          <span class=\"icon-list\" ng-class='{ \"active\" : viewType === \"list\" }' ng-click=\"changeView('list')\"></span>\n" +
    "          <span class=\"icon-grid\" ng-class='{ \"active\" : viewType === \"grid\" }' ng-click=\"changeView('grid')\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <!-- <div class=\"view-all-card-count\">\n" +
    "        <p>\n" +
    "        {{filtered.length}}\n" +
    "        <ng-pluralize count=\"getAccountLength()\"\n" +
    "        when=\"{'one': 'Card', 'other': 'Cards'}\">\n" +
    "        </ng-pluralize>\n" +
    "        out of {{accounts.length}}\n" +
    "        </p>\n" +
    "        </div> -->\n" +
    "        <table class=\"account-table\" ng-show=\"viewType === 'list'\">\n" +
    "          <tbody>\n" +
    "            <tr class=\"account-row\" ng-repeat=\"account in accounts | orderBy:sortType:sortReverse | filter: searchAccount as filtered\">\n" +
    "              <td class=\"account-card-image\">\n" +
    "                <div id=\"select-{{account.username}}\" ng-click=\"cardSelected(account.username)\" ui-sref-active=\"selected\">\n" +
    "                  <div class=\"card-design\" ng-class=\"'card-design--' + account.cardStyle\">\n" +
    "                    <div>\n" +
    "                      <card-image design-id=\"account.designId\"/>\n" +
    "                    </div>\n" +
    "                    <svg class=\"card-design__shadow\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"225\" height=\"110\">\n" +
    "                      <g>\n" +
    "                      <image x=\"0\" y=\"0\" width=\"225\" height=\"110\" xlink:href=\"\" ng-href=\"/app/assets/images/dashboard-cards/akimbocard-shadow.svg\"/>\n" +
    "                      </g>\n" +
    "                    </svg>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "                <td class=\"account-title-col\">\n" +
    "                  <div id=\"account-title\" class=\"account-title\">\n" +
    "                    {{ account.title }}\n" +
    "                  </div>\n" +
    "                    <span class=\"card-design__view-all-card-type\">{{account.cardDisplayType}}</span>\n" +
    "                    <br/>\n" +
    "                    <br/>\n" +
    "                  <span ng-show=\"account.cardLastFour\">...{{ account.cardLastFour }}</span>\n" +
    "                </td >\n" +
    "                <td class=\"account-balance\">\n" +
    "                  {{account.balance | akimboCurrency}}\n" +
    "                  <div class=\"account-transaction-link\">\n" +
    "                    <a href=\"#/member/{{account.username}}/feed/expanded\">View Transactions</a>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "                <td class=\"account-load\">\n" +
    "                  <button ng-show=\"!account.gift && !account.virtual\" class=\"btn load-card-btn\" ui-sref=\"member.home.send/transfer.step1\">LOAD CARD</button>\n" +
    "                </td>\n" +
    "                <td class=\"account-status\">\n" +
    "                  <div class=\"account-status-field\" ng-show=\"{{!account.main && (account.status === 'Active' || account.status === 'Inactive')}}\">\n" +
    "                    <div class=\"toggle-input-enroll\">\n" +
    "                      <div id=\"activate-{{account.username}}\" class=\"toggle-bg {{account.status === 'Active' ? 'on' : 'off'}}\">\n" +
    "                        <input\n" +
    "                          type=\"radio\"\n" +
    "                          name=\"toggle-{{$index}}\"\n" +
    "                          value=\"Inactive\"\n" +
    "                          ng-model=\"account.status\"\n" +
    "                          ng-click=\"updateStatus(account)\">\n" +
    "                        <input\n" +
    "                          type=\"radio\"\n" +
    "                          name=\"toggle-{{$index}}\"\n" +
    "                          value=\"Active\"\n" +
    "                          ng-model=\"account.status\"\n" +
    "                          ng-click=\"updateStatus(account)\">\n" +
    "                        <span class=\"switch {{account.status === 'Active' ? 'on': 'off'}}\"></span>\n" +
    "                      </div>\n" +
    "                    </div>\n" +
    "                    <h3 class=\"toggle-status-enroll\">{{ account.status === 'Active' ? 'Card is Active': 'Card is Inactive'}}</h3>\n" +
    "                  </div>\n" +
    "                  <div class=\"account-activation-btn\" ng-show=\"account.status === 'Pre-Active'\">\n" +
    "                    <a ui-sref=\"member.home.profile/activate.step1\">\n" +
    "                      <button class=\"btn activate-btn\" ng-click=\"activateCard\">Activate Card</button>\n" +
    "                    </a>\n" +
    "                  </div>\n" +
    "                  <div ng-show=\"account.status !== 'Pre-Active' && account.status !== 'Active' && account.status !== 'Inactive'\">\n" +
    "                    <h3 class=\"unavailable-txt\">Unable to activate this card</h3>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                  <div class=\"account-atm-field\" ng-show='{{account.atmAccess}} === true || {{account.atmAccess}} === false'>\n" +
    "                    <div class=\"toggle-input-enroll account-toggle atm-toggle\">\n" +
    "                      <div id=\"atm-{{account.username}}\" class=\"toggle-bg {{account.atmAccess ? 'on' : 'off'}}\">\n" +
    "                        <input\n" +
    "                          type=\"radio\"\n" +
    "                          name=\"atm-{{$index}}\"\n" +
    "                          ng-value={{false}}\n" +
    "                          ng-model=\"account.atmAccess\"\n" +
    "                          ng-click=\"updateATMAccess(account)\">\n" +
    "                        <input\n" +
    "                          type=\"radio\"\n" +
    "                          name=\"atm-{{$index}}\"\n" +
    "                          ng-value={{true}}\n" +
    "                          ng-model=\"account.atmAccess\"\n" +
    "                          ng-click=\"updateATMAccess(account)\">\n" +
    "                        <span class=\"switch {{account.atmAccess ? 'on' : 'off'}}\"></span>\n" +
    "                      </div>\n" +
    "                    </div>\n" +
    "                    <h3 class=\"toggle-status-enroll account-toggle-label\">{{ account.atmAccess ? 'ATM is Enabled': 'ATM is Disabled'}}</h3>\n" +
    "                  </div>\n" +
    "                  <div ng-show=\"account.atmAccess === 'invalid' && !account.main\">\n" +
    "                    <h3 class=\"unavailable-txt\">Unable to change ATM Access</h3>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "        <ul class=\"account-list-cards\" ng-show=\"viewType === 'grid'\">\n" +
    "          <li ng-repeat=\"account in accounts | orderBy:sortType:sortReverse | filter: searchAccount as filtered\" class=\"account-card-image grid-image\">\n" +
    "            <div class=\"card-meta\">\n" +
    "              <div class=\"title\">\n" +
    "                {{ account.title }}\n" +
    "              </div>\n" +
    "              <div class=\"balance\">\n" +
    "                {{account.balance | akimboCurrency}}\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div ng-click=\"cardSelected(account.username)\" ui-sref-active=\"selected\">\n" +
    "              <div class=\"card-design\" ng-class=\"'card-design--' + account.cardStyle\">\n" +
    "                <div>\n" +
    "                  <card-image design-id=\"account.designId\"/>\n" +
    "                </div>\n" +
    "                <div class=\"card-design__text\">\n" +
    "                  <span class=\"card-design__view-all-grid-card-type\">{{account.cardDisplayType}}</span>\n" +
    "                  <span class=\"card-design__view-all-grid-last-four\" ng-show=\"!hideAccountAttribute() && account.cardLastFour\">..{{account.cardLastFour}}</span>\n" +
    "                </div>\n" +
    "                <svg class=\"card-design__shadow\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"225\" height=\"110\">\n" +
    "                  <g>\n" +
    "                  <image x=\"0\" y=\"0\" width=\"225\" height=\"110\" xlink:href=\"\" ng-href=\"/app/assets/images/dashboard-cards/akimbocard-shadow.svg\"/>\n" +
    "                  </g>\n" +
    "                </svg>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "        <div id=\"waterfall-loading\" class=\"waterfall-loading\">\n" +
    "          <div ng-show=\"disabled\">LOADING...<span class=\"view-all-loading loading-indicator\"></span></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-show=\"accounts.showModal\">\n" +
    "    <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "    <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "      <div class=\"con-overlay con-overlay-small\">\n" +
    "        <div class=\"con-overlay-header\">\n" +
    "          <div class=\"con-overlay-header-main\">\n" +
    "            <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "            <h1>Something Went Wrong</h1>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"con-overlay-body\">\n" +
    "          <p ng-if=\"alertMessage\">{{alertMessage}}</p>\n" +
    "          <p ng-if=\"!alertMessage\" class=\"text\">Sorry about that, please try again.</p>\n" +
    "          <a class=\"btn btn-full-width\" ng-click=\"accounts.showModal = !accounts.showModal\">OK</a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/virtual-card-expanded.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/virtual-card-expanded.html",
    "<div class=\"view-card-widget\">\n" +
    "  <span class=\"view-card-title\">Your Virtual Card</span>\n" +
    "  <div ng-if=\"!isDoneLoading\">\n" +
    "    <span class=\"loading-indicator\"></span>\n" +
    "  </div>\n" +
    "  <div ng-if=\"isDoneLoading\">\n" +
    "    <p class=\"view-card-last-four\">{{account.cardLastFour}}</p>\n" +
    "    <div ng-click=\"cardSelected(account.username)\" ui-sref-active=\"selected\">\n" +
    "      <div class=\"virtual-card-design\" ng-class=\"'card-design--' + account.cardStyle\">\n" +
    "        <div class=\"virtual-card-animation-scene\">\n" +
    "          <div class=\"virtual-card-animation\" id=\"flipCardAnimation\" ng-click=\"toggleFlipCard()\">\n" +
    "            <div class=\"card-face virtual-card-design__img\">\n" +
    "              <div class=\"virtual-card-design__button-container\">\n" +
    "                <div id=\"view-virtual-btn-expanded\" class=\"virtual-card-design__button virtual-card-button\">\n" +
    "                  View your virtual number\n" +
    "                </div>\n" +
    "              </div>\n" +
    "              <div class=\"virtual-svg\">\n" +
    "                <div class=\"virtual-card-design__card-last-four-top\" style=\"color:{{fontColor}}\">\n" +
    "                  <span class=\"icon-menu-dots virtual-card-design__dots-icon\"></span>\n" +
    "                  {{account.cardLastFour}}\n" +
    "                </div>\n" +
    "                <svg\n" +
    "                        class=\"virtual-card-svg\"\n" +
    "                        height=\"88\"\n" +
    "                        width=\"140\"\n" +
    "                        x=\"0\"\n" +
    "                        y=\"0\"\n" +
    "                        preserveAspectRatio=\"xMidYMid meet\"\n" +
    "                        shape-rendering=\"crispEdges\"\n" +
    "                        xmlns=\"http://www.w3.org/2000/svg\"\n" +
    "                        xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
    "                  <g>\n" +
    "\n" +
    "                    <image class=\"virtual-card-design__svg\" xlink:href=\"\" ng-href=\"/app/assets/images/mobile-cards/card-{{designId}}.svg\" fallback-href=\"/app/assets/images/mobile-cards/card-default.svg\"/>\n" +
    "                  </g>\n" +
    "                </svg>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"card-face virtual-card-design__back\">\n" +
    "              <div class=\"virtual-card-design__back-container\">\n" +
    "                <div class=\"virtual-card-design__close-icon\">\n" +
    "                  <span class=\"icon-close virtual-card-design__icon-close\"></span>\n" +
    "                </div>\n" +
    "                <div class=\"virtual-card-design__back-title\">\n" +
    "                  Card Number\n" +
    "                </div>\n" +
    "                <div id=\"card-number\" class=\"virtual-card-design__back-number\">\n" +
    "                  {{cardNumber | creditCardFilter}}\n" +
    "                  <button\n" +
    "                          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "                          ngclipboard\n" +
    "                          ngclipboard-success=\"copySuccess(e)\"\n" +
    "                          ng-click=\"$event.stopPropagation()\"\n" +
    "                          data-clipboard-text=\"{{cardNumber}}\"\n" +
    "                  >\n" +
    "                    <span class=\"icon-copy virtual-card-design__icon-copy\"></span>\n" +
    "                  </button>\n" +
    "                  <div class='virtual-card-copied' ng-show=\"copiedText === cardNumber\"><em>Copied!</em></div>\n" +
    "                </div>\n" +
    "                <div class=\"virtual-card-design__exp-cvv-container\">\n" +
    "                  <div class=\"virtual-card-design__exp-container\">\n" +
    "                    <div class=\"virtual-card-design__back-title\">\n" +
    "                      Expiration Date\n" +
    "                    </div>\n" +
    "                    <div id=\"exp-date\" class=\"virtual-card-design__back-number\">\n" +
    "                      {{expDate | expFilter}}\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                  <div class=\"virtual-card-design__cvv-container\">\n" +
    "                    <div class=\"virtual-card-design__back-title\">\n" +
    "                      Security Code\n" +
    "                    </div>\n" +
    "                    <div id=\"cvv\" class=\"virtual-card-design__back-number\">\n" +
    "                      {{cvv}}\n" +
    "                      <button\n" +
    "                              class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "                              ngclipboard\n" +
    "                              ngclipboard-success=\"copySuccess(e)\"\n" +
    "                              ng-click=\"$event.stopPropagation()\"\n" +
    "                              data-clipboard-text=\"{{cvv}}\"\n" +
    "                      >\n" +
    "                        <span class=\"icon-copy virtual-card-design__icon-copy\"></span>\n" +
    "                      </button>\n" +
    "                      <div class='virtual-card-copied' ng-show=\"copiedText === cvv\"><em>Copied!</em></div>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"virtual-card-design__info last-virtual-card-widget\" ng-controller=\"virtualCtrl\">\n" +
    "          <div class=\"virtual-card-design__text\">\n" +
    "            <div class=\"virtual-card-design__address-title\">\n" +
    "              NAME AND ADDRESS FOR THIS CARD\n" +
    "            </div>\n" +
    "            <div class=\"virtual-card-design__address\">\n" +
    "              <ul class=\"address__list\">\n" +
    "                <li class=\"address__list\">{{account.firstName}} {{account.lastName}}</li>\n" +
    "                <li class=\"address__list\">{{address.Address}}</li>\n" +
    "                <li class=\"address__list\">{{address.AddressSuite}}</li>\n" +
    "                <li class=\"address__list\">{{address.City}}, {{address.State}} {{address.PostalCode}}</li>\n" +
    "              </ul>\n" +
    "            </div>\n" +
    "            <a ng-click=\"editAddress()\">\n" +
    "              <div class=\"virtual-card-design__button\">\n" +
    "                Change Address\n" +
    "              </div>\n" +
    "            </a>\n" +
    "          </div>\n" +
    "          <div class=\"virtual-card-design__address-icon\">\n" +
    "            <span class=\"icon-mail virtual-card-design__icon-mail\"></span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"virtual-card-design__row2\">\n" +
    "      <div class=\"virtual-card-design\" ng-class=\"'card-design--' + account.cardStyle\">\n" +
    "        <div class=\"virtual-card-design__info\" ng-controller=\"virtualCtrl\">\n" +
    "          <div class=\"virtual-card-design__text virtual-learn-more\">\n" +
    "            <div class=\"virtual-card-design__address virtual-card-questions\">\n" +
    "              How do you use virtual cards?\n" +
    "            </div>\n" +
    "            <a ng-click=\"howToUseVirtualCards()\">\n" +
    "              <div class=\"virtual-card-design__button\">\n" +
    "                Learn More\n" +
    "              </div>\n" +
    "            </a>\n" +
    "          </div>\n" +
    "          <!--        <div class=\"virtual-card-design__address-icon\">-->\n" +
    "          <!--          <span class=\"icon-virtual-card virtual-card-design__icon\"></span>-->\n" +
    "          <!--        </div>-->\n" +
    "        </div>\n" +
    "        <div class=\"virtual-card-design__info last-virtual-card-widget\" ng-controller=\"virtualCtrl\">\n" +
    "          <div class=\"virtual-card-design__text virtual-learn-more\">\n" +
    "            <div class=\"virtual-card-design__address virtual-card-questions\">\n" +
    "              How do I add my card to my mobile wallet?\n" +
    "            </div>\n" +
    "            <a ng-click=\"addToWallet()\">\n" +
    "              <div class=\"virtual-card-design__button\">\n" +
    "                Learn More\n" +
    "              </div>\n" +
    "            </a>\n" +
    "          </div>\n" +
    "          <!--        <div class=\"virtual-card-design__address-icon\">-->\n" +
    "          <!--          <span class=\"icon-PIN virtual-card-design__icon\"></span>-->\n" +
    "          <!--        </div>-->\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/shared/virtual-card.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/virtual-card.html",
    "<div class=\"view-card-widget\">\n" +
    "  <span class=\"view-card-title\">Your Virtual Card</span>\n" +
    "  <div ng-if=\"!isDoneLoading\">\n" +
    "    <span class=\"loading-indicator\"></span>\n" +
    "  </div>\n" +
    "  <div ng-if=\"isDoneLoading\">\n" +
    "    <p class=\"view-card-last-four\">{{account.cardLastFour}}</p>\n" +
    "    <div ng-click=\"cardSelected(account.username)\" ui-sref-active=\"selected\">\n" +
    "      <div class=\"virtual-card-design\" ng-class=\"'card-design--' + account.cardStyle\">\n" +
    "        <div class=\"virtual-card-animation-scene\">\n" +
    "          <div class=\"virtual-card-animation\" id=\"flipCardAnimation\" ng-click=\"toggleFlipCard()\">\n" +
    "            <div class=\"card-face virtual-card-design__img\">\n" +
    "              <div class=\"virtual-card-design__button-container\">\n" +
    "                <div id=\"view-virtual-btn\" class=\"virtual-card-design__button virtual-card-button\">\n" +
    "                  View your virtual number\n" +
    "                </div>\n" +
    "              </div>\n" +
    "              <div class=\"virtual-svg\">\n" +
    "                <div class=\"virtual-card-design__card-last-four-top\" style=\"color:{{fontColor}}\">\n" +
    "                  <span class=\"icon-menu-dots virtual-card-design__dots-icon\"></span>\n" +
    "                  {{account.cardLastFour}}\n" +
    "                </div>\n" +
    "                <svg\n" +
    "                        class=\"virtual-card-svg\"\n" +
    "                        height=\"88\"\n" +
    "                        width=\"140\"\n" +
    "                        x=\"0\"\n" +
    "                        y=\"0\"\n" +
    "                        preserveAspectRatio=\"xMidYMid meet\"\n" +
    "                        shape-rendering=\"crispEdges\"\n" +
    "                        xmlns=\"http://www.w3.org/2000/svg\"\n" +
    "                        xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
    "                  <g>\n" +
    "                    <image class=\"virtual-card-design__svg\" xlink:href=\"\" ng-href=\"/app/assets/images/mobile-cards/card-{{designId}}.svg\" fallback-href=\"/app/assets/images/mobile-cards/card-default.svg\"/>\n" +
    "                  </g>\n" +
    "                </svg>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"card-face virtual-card-design__back\">\n" +
    "              <div class=\"virtual-card-design__back-container\">\n" +
    "                <div class=\"virtual-card-design__close-icon\">\n" +
    "                  <span class=\"icon-close virtual-card-design__icon-close\"></span>\n" +
    "                </div>\n" +
    "                <div class=\"virtual-card-design__back-title\">\n" +
    "                  Card Number\n" +
    "                </div>\n" +
    "                <div class=\"virtual-card-design__back-number\">\n" +
    "                  {{cardNumber | creditCardFilter}}\n" +
    "                  <button\n" +
    "                          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "                          ngclipboard\n" +
    "                          ngclipboard-success=\"copySuccess(e)\"\n" +
    "                          ng-click=\"$event.stopPropagation()\"\n" +
    "                          data-clipboard-text=\"{{cardNumber}}\"\n" +
    "                  >\n" +
    "                    <span class=\"icon-copy virtual-card-design__icon-copy\"></span>\n" +
    "                  </button>\n" +
    "                  <div class='virtual-card-copied' ng-show=\"copiedText === cardNumber\"><em>Copied!</em></div>\n" +
    "                </div>\n" +
    "                <div class=\"virtual-card-design__exp-cvv-container\">\n" +
    "                  <div class=\"virtual-card-design__exp-container\">\n" +
    "                    <div class=\"virtual-card-design__back-title\">\n" +
    "                      Expiration Date\n" +
    "                    </div>\n" +
    "                    <div class=\"virtual-card-design__back-number\">\n" +
    "                      {{expDate | expFilter}}\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                  <div class=\"virtual-card-design__cvv-container\">\n" +
    "                    <div class=\"virtual-card-design__back-title\">\n" +
    "                      Security Code\n" +
    "                    </div>\n" +
    "                    <div class=\"virtual-card-design__back-number\">\n" +
    "                      {{cvv}}\n" +
    "                      <button\n" +
    "                              class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "                              ngclipboard\n" +
    "                              ngclipboard-success=\"copySuccess(e)\"\n" +
    "                              ng-click=\"$event.stopPropagation()\"\n" +
    "                              data-clipboard-text=\"{{cvv}}\"\n" +
    "                      >\n" +
    "                        <span class=\"icon-copy virtual-card-design__icon-copy\"></span>\n" +
    "                      </button>\n" +
    "                      <div class='virtual-card-copied' ng-show=\"copiedText === cvv\"><em>Copied!</em></div>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/shared/widget.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/widget.html",
    "<!-- If widget has a state and it's not equal to paypal or venmo -->\n" +
    "<div\n" +
    "  id=\"widget-{{widget.title.replaceAll(' ', '-').toLowerCase()}}\"\n" +
    "  class=\"widget-box btn\"\n" +
    "  ng-if=\"widget.state && widget.state != 'member.home.venmo.step1' && widget.state != 'member.home.paypal.step1'\"\n" +
    "  ng-class=\"{\n" +
    "  'widget-box--centered': isFullWidthBtn,\n" +
    "  'btn-alt': isAltBtn,\n" +
    "  'btn-alt-2': isAlt2Btn}\"\n" +
    "  ng-click=\"navigate(widget)\">\n" +
    "  <span class=\"{{widget.icon}}\"></span>\n" +
    "  <p>{{widget.title}}</p>\n" +
    "</div>\n" +
    "\n" +
    "<!-- If widget has a state of venmo -->\n" +
    "<div\n" +
    "  id=\"widget-{{widget.title.replaceAll(' ', '-').toLowerCase()}}\"\n" +
    "  class=\"widget-box btn btn-white widget-box--centered\"\n" +
    "  ng-if=\"widget.state === 'member.home.venmo.step1'\"\n" +
    "  ng-click=\"navigate(widget)\">\n" +
    "<div>\n" +
    "  <svg width=\"105\" height=\"28\" viewBox=\"0 0 105 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
    "    <path d=\"M25.8066 7C26.3526 7.88525 26.5842 8.7853 26.5842 9.92701C26.5842 13.5765 23.4959 18.3135 20.9974 21.6671H15.3108L13 7.79648L18.0018 7.29591L19.2083 17.1595C20.3515 15.3224 21.7458 12.3929 21.7458 10.3906C21.7458 9.313 21.5434 8.55351 21.2509 7.92471L25.8066 7ZM32.305 13.0858C33.2093 13.0858 35.5542 12.6617 35.5542 11.34C35.5542 10.6865 35.0984 10.3511 34.5792 10.3511C33.6407 10.3511 32.4318 11.5076 32.305 13.0858ZM32.2051 15.7194C32.2051 17.3641 33.0826 18.0176 34.2891 18.0176C35.5834 18.0176 36.7876 17.6847 38.4134 16.8636L37.7918 21.0087C36.6608 21.5611 34.8961 21.9359 33.1825 21.9359C28.8535 21.9359 27.2911 19.3023 27.2911 15.9487C27.2911 11.6359 29.8334 7.06165 35.035 7.06165C37.8918 7.06165 39.5176 8.67927 39.5176 10.9553C39.5176 14.5653 34.8693 15.7194 32.2051 15.7465V15.7194ZM53.9549 10.2205C53.9549 10.7851 53.8501 11.5446 53.7891 12.0723L52.2901 21.6671H47.4151L48.7874 12.8565L48.8751 11.8677C48.8751 11.2142 48.4949 11.086 48.0366 11.086C47.3761 11.086 46.7301 11.3819 46.3499 11.5718L44.7874 21.6696H39.9124L42.1232 7.29837H46.3523L46.4132 8.45241C47.4175 7.79895 48.7508 7.03946 50.6033 7.03946C53.0676 7.03946 53.9573 8.35131 53.9573 10.2648L53.9549 10.2205ZM68.4141 8.61762C69.8084 7.6288 71.1051 7.03699 72.9576 7.03699C75.4341 7.03699 76.3092 8.34884 76.3092 10.2624C76.2994 10.8665 76.2483 11.4682 76.1459 12.0748L74.6468 21.6696H69.7718L71.1661 12.6913L71.2441 11.9712C71.2441 11.2537 70.8516 11.086 70.3544 11.086C69.7718 11.086 69.1624 11.3424 68.7286 11.5718L67.1808 21.6696H62.3058L63.7024 12.6641L63.7634 11.9712C63.7634 11.2537 63.3709 11.086 62.8883 11.086C62.2253 11.086 61.6184 11.3819 61.1845 11.5718L59.6611 21.6424H54.7641L56.9969 7.29837H61.1601L61.3259 8.49186C62.3033 7.75949 63.5976 7.03946 65.3502 7.03946C66.9126 7.03946 67.8925 7.69785 68.4117 8.62009L68.4141 8.61762ZM85.9958 12.7899C85.9958 11.6359 85.7033 10.8147 84.8526 10.8147C82.9124 10.8147 82.5199 14.2694 82.5199 16.0153C82.5199 17.3641 82.8734 18.1853 83.7509 18.1853C85.5644 18.1853 85.9958 14.5653 85.9958 12.7899ZM77.5401 15.8082C77.5401 11.2783 79.9557 7.03699 85.3767 7.03699C89.5009 7.03699 91 9.50288 91 12.8959C91 17.3641 88.6624 22 83.0659 22C78.9393 22 77.5401 19.2653 77.5401 15.8082Z\" fill=\"#0070E0\"/>\n" +
    "  </svg>\n" +
    "</div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- If widget has a state of paypal -->\n" +
    "<div\n" +
    "        id=\"widget-{{widget.title.replaceAll(' ', '-').toLowerCase()}}\"\n" +
    "        class=\"widget-box btn btn-white widget-box--centered\"\n" +
    "        ng-if=\"widget.state === 'member.home.paypal.step1'\"\n" +
    "        ng-click=\"navigate(widget)\">\n" +
    "  <div>\n" +
    "    <svg width=\"105\" height=\"28\" viewBox=\"0 0 105 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
    "      <g clip-path=\"url(#clip0_2_22)\">\n" +
    "        <path d=\"M17.3793 3.97354C17.4465 3.97333 17.5138 3.97302 17.581 3.97263C17.7635 3.97186 17.9459 3.9724 18.1284 3.97322C18.3201 3.97391 18.5119 3.97354 18.7037 3.97333C19.0263 3.97314 19.3489 3.9738 19.6715 3.97498C20.0425 3.97631 20.4135 3.97632 20.7845 3.9756C21.143 3.97493 21.5014 3.97522 21.8599 3.97593C22.0116 3.97621 22.1633 3.97618 22.3149 3.97586C23.9432 3.97323 25.4025 4.2036 26.6259 5.38611C27.3444 6.11041 27.8747 7.15566 27.8778 8.18829C27.8768 8.23477 27.8758 8.28125 27.8747 8.32914C27.8756 8.45702 27.8756 8.45702 27.9192 8.57023C28.0631 8.69674 28.2219 8.77891 28.3911 8.86513C28.5891 8.97479 28.7568 9.13372 28.9255 9.28302C28.9692 9.32153 28.9692 9.32153 29.0139 9.36082C29.844 10.1395 30.2453 11.2443 30.3182 12.3582C30.3552 13.6796 29.8327 15.0416 28.9674 16.0335C28.9339 16.0731 28.9005 16.1126 28.866 16.1533C27.9765 17.1815 26.6402 17.8926 25.2779 18.0042C25.0906 18.0104 24.9033 18.0109 24.7159 18.0116C24.6339 18.0123 24.552 18.013 24.47 18.0138C24.2694 18.0157 24.0687 18.0173 23.8681 18.0179C23.755 18.0182 23.642 18.019 23.5289 18.0202C23.4229 18.0214 23.3169 18.022 23.2109 18.0218C22.8104 18.0255 22.8104 18.0255 22.4689 18.2138C22.321 18.4403 22.2968 18.6891 22.2578 18.9512C22.2502 18.9998 22.2426 19.0485 22.2348 19.0986C22.2184 19.204 22.2022 19.3094 22.1862 19.4148C22.1608 19.5818 22.1349 19.7487 22.1089 19.9155C22.0537 20.2698 21.9993 20.6241 21.9449 20.9785C21.8861 21.361 21.8272 21.7435 21.7676 22.1259C21.7376 22.3181 21.7083 22.5105 21.6791 22.7029C21.6634 22.8038 21.6477 22.9048 21.632 23.0057C21.6218 23.0741 21.6218 23.0741 21.6114 23.1438C21.5613 23.4607 21.5106 23.7421 21.2531 23.9581C21.1234 24.023 20.9861 24.0073 20.8436 24.0081C20.81 24.0084 20.7764 24.0088 20.7418 24.0091C20.6302 24.0102 20.5187 24.0109 20.4072 24.0115C20.3692 24.0117 20.3311 24.0119 20.2919 24.0121C20.0905 24.0133 19.8891 24.0141 19.6877 24.0147C19.4796 24.0154 19.2715 24.0173 19.0634 24.0194C18.9035 24.0208 18.7436 24.0213 18.5836 24.0215C18.5069 24.0218 18.4302 24.0224 18.3535 24.0235C18.2461 24.0248 18.1387 24.0248 18.0313 24.0245C17.9997 24.0252 17.968 24.0258 17.9354 24.0266C17.768 24.0246 17.6972 24.0064 17.5659 23.8989C17.417 23.7111 17.4228 23.5621 17.4379 23.3291C17.4682 23.085 17.5072 22.8425 17.5465 22.5997C17.5577 22.5291 17.5688 22.4584 17.58 22.3878C17.6033 22.2406 17.6269 22.0933 17.6505 21.9461C17.6809 21.7574 17.7109 21.5686 17.7408 21.3798C17.7638 21.2343 17.7869 21.0888 17.8101 20.9434C17.8212 20.8738 17.8323 20.8041 17.8434 20.7345C17.8588 20.6374 17.8744 20.5404 17.89 20.4434C17.8946 20.4146 17.8992 20.3859 17.9038 20.3562C17.9229 20.2385 17.9451 20.1302 17.9829 20.0168C17.9377 20.0171 17.8925 20.0173 17.8459 20.0176C17.4196 20.0202 16.9933 20.0221 16.567 20.0233C16.3479 20.0239 16.1287 20.0248 15.9096 20.0263C15.6981 20.0276 15.4866 20.0284 15.2751 20.0287C15.1944 20.0289 15.1138 20.0294 15.0331 20.0301C14.92 20.031 14.8071 20.0311 14.694 20.0311C14.644 20.0317 14.644 20.0317 14.593 20.0324C14.4019 20.0314 14.2707 20.02 14.1258 19.891C13.9802 19.636 13.9982 19.455 14.0467 19.1714C14.0561 19.1106 14.0561 19.1106 14.0657 19.0485C14.0787 18.9646 14.0921 18.8807 14.1058 18.7968C14.1242 18.685 14.1415 18.573 14.1584 18.4609C14.1907 18.2469 14.2244 18.0332 14.2583 17.8195C14.2711 17.7383 14.2838 17.657 14.2966 17.5758C14.3311 17.357 14.3656 17.1382 14.4002 16.9194C14.4371 16.6856 14.474 16.4517 14.5108 16.2178C14.5897 15.7171 14.6687 15.2163 14.7477 14.7156C14.8778 13.8919 15.0077 13.0681 15.1376 12.2444C15.1698 12.0401 15.202 11.8359 15.2342 11.6317C15.4202 10.4524 15.6056 9.27308 15.7888 8.09339C15.8177 7.90719 15.8466 7.721 15.8756 7.53481C15.8893 7.44689 15.903 7.35897 15.9166 7.27105C15.9254 7.21446 15.9343 7.15788 15.9431 7.1013C15.9966 6.75708 16.0499 6.41281 16.1028 6.0685C16.132 5.87875 16.1616 5.68905 16.1912 5.49937C16.2044 5.41442 16.2175 5.32945 16.2304 5.24447C16.2476 5.13131 16.2653 5.01823 16.283 4.90516C16.2878 4.87313 16.2926 4.8411 16.2975 4.8081C16.3415 4.53311 16.3935 4.21135 16.6335 4.03665C16.8649 3.94414 17.1334 3.97155 17.3793 3.97354Z\" fill=\"#002F86\"/>\n" +
    "        <path d=\"M27.8773 8.57022C28.8396 8.97157 29.5687 9.85123 29.9798 10.7889C30.4854 12.0256 30.3709 13.3528 29.8734 14.5678C29.6458 15.1029 29.35 15.5949 28.9674 16.0335C28.934 16.073 28.9005 16.1126 28.866 16.1533C27.9765 17.1814 26.6403 17.8926 25.278 18.0042C25.0906 18.0104 24.9033 18.0109 24.7159 18.0116C24.6339 18.0123 24.552 18.013 24.47 18.0138C24.2694 18.0157 24.0687 18.0173 23.8681 18.0178C23.755 18.0182 23.642 18.019 23.529 18.0202C23.4229 18.0214 23.3169 18.022 23.2109 18.0218C22.8104 18.0255 22.8104 18.0255 22.469 18.2138C22.321 18.4403 22.2968 18.6891 22.2578 18.9512C22.2502 18.9998 22.2426 19.0485 22.2348 19.0986C22.2184 19.204 22.2022 19.3094 22.1862 19.4148C22.1608 19.5818 22.135 19.7487 22.1089 19.9155C22.0538 20.2698 21.9993 20.6241 21.9449 20.9785C21.8861 21.361 21.8273 21.7435 21.7676 22.1258C21.7377 22.3181 21.7083 22.5105 21.6791 22.7029C21.6634 22.8038 21.6477 22.9047 21.632 23.0056C21.6252 23.0512 21.6184 23.0968 21.6114 23.1438C21.5613 23.4607 21.5106 23.7421 21.2531 23.9581C21.1234 24.0229 20.9861 24.0073 20.8436 24.0081C20.81 24.0084 20.7764 24.0088 20.7418 24.0091C20.6303 24.0102 20.5188 24.0109 20.4072 24.0115C20.3692 24.0117 20.3311 24.0119 20.2919 24.0121C20.0905 24.0133 19.8891 24.0141 19.6877 24.0147C19.4796 24.0154 19.2715 24.0172 19.0635 24.0194C18.9035 24.0208 18.7436 24.0213 18.5836 24.0215C18.5069 24.0218 18.4302 24.0224 18.3535 24.0234C18.2461 24.0248 18.1388 24.0248 18.0314 24.0245C17.9997 24.0251 17.9681 24.0258 17.9354 24.0265C17.768 24.0246 17.6973 24.0064 17.5659 23.8989C17.417 23.7112 17.4231 23.562 17.4379 23.3291C17.4673 23.0904 17.5053 22.8533 17.5435 22.6159C17.5545 22.5464 17.5655 22.4769 17.5765 22.4074C17.5994 22.262 17.6226 22.1167 17.6459 21.9715C17.6756 21.7869 17.7048 21.6023 17.7339 21.4176C17.7565 21.2741 17.7793 21.1306 17.8022 20.9871C17.813 20.9192 17.8238 20.8512 17.8345 20.7832C17.8834 20.4747 17.9335 20.1678 18.0019 19.8629C18.0946 19.4428 18.1555 19.0171 18.2214 18.5922C18.2359 18.4991 18.2505 18.4061 18.2651 18.3131C18.3032 18.0693 18.3411 17.8254 18.379 17.5816C18.4097 17.3844 18.4406 17.1873 18.4714 16.9901C18.5291 16.621 18.5868 16.2518 18.6442 15.8827C18.6571 15.8001 18.67 15.7175 18.6829 15.6349C18.7139 15.4366 18.7435 15.2382 18.7707 15.0393C18.7761 15.0011 18.7814 14.9629 18.7869 14.9236C18.7968 14.8524 18.8064 14.7811 18.8155 14.7097C18.8501 14.4626 18.9047 14.2667 19.094 14.0917C19.2776 13.9677 19.4416 13.9732 19.6552 13.9737C19.6889 13.9737 19.7226 13.9736 19.7573 13.9735C19.8307 13.9733 19.904 13.9733 19.9774 13.9732C20.1347 13.9731 20.292 13.9722 20.4493 13.9713C20.7419 13.9698 21.0344 13.9684 21.327 13.9685C22.6068 13.9854 22.6068 13.9854 23.8525 13.7275C23.8836 13.7174 23.9147 13.7074 23.9467 13.6971C24.8669 13.3985 25.6598 12.8766 26.3261 12.1761C26.3535 12.148 26.3809 12.1199 26.4091 12.0909C27.2588 11.19 27.7617 9.92114 27.828 8.68913C27.8354 8.61215 27.8354 8.61215 27.8773 8.57022Z\" fill=\"#006FDF\"/>\n" +
    "        <path d=\"M38.2156 7.96726C38.254 7.9669 38.2925 7.96655 38.332 7.96618C38.3948 7.96656 38.3948 7.96656 38.4589 7.96695C38.5032 7.96673 38.5476 7.96651 38.5932 7.96628C38.7402 7.96573 38.8871 7.9661 39.0341 7.96652C39.1366 7.96644 39.2391 7.96632 39.3416 7.96616C39.5568 7.96597 39.7721 7.96624 39.9874 7.96683C40.2617 7.96754 40.536 7.96714 40.8103 7.96638C41.0223 7.96592 41.2343 7.96607 41.4463 7.9664C41.5473 7.96648 41.6484 7.96638 41.7494 7.96608C42.985 7.96327 44.0762 8.18068 45.0249 9.03145C45.0514 9.05458 45.078 9.07771 45.1054 9.10155C45.6964 9.6492 46.1229 10.5341 46.1568 11.3375C46.159 11.3821 46.1612 11.4266 46.1634 11.4725C46.1941 12.6919 45.7288 13.7782 44.941 14.6918C44.914 14.7231 44.8871 14.7544 44.8593 14.7867C44.0166 15.6879 42.7917 16.1177 41.5829 16.1643C41.1914 16.1742 40.7997 16.1765 40.4081 16.1785C40.2596 16.1794 40.111 16.181 39.9625 16.1827C39.9169 16.1828 39.8713 16.1828 39.8244 16.1828C39.7613 16.1836 39.7613 16.1836 39.697 16.1845C39.6601 16.1847 39.6231 16.1849 39.5851 16.1851C39.4892 16.1946 39.4892 16.1946 39.4178 16.2522C39.3508 16.3471 39.3368 16.421 39.3187 16.5357C39.3082 16.5997 39.3082 16.5997 39.2974 16.6649C39.2904 16.7113 39.2833 16.7577 39.276 16.8055C39.2682 16.8539 39.2604 16.9023 39.2524 16.9522C39.2274 17.108 39.2031 17.2639 39.1789 17.4198C39.1627 17.5211 39.1465 17.6224 39.1303 17.7237C39.0655 18.1299 39.0012 18.5361 38.9427 18.9433C38.9354 18.9929 38.9282 19.0425 38.9207 19.0937C38.907 19.1875 38.8937 19.2813 38.8808 19.3753C38.8485 19.5957 38.8171 19.7838 38.6941 19.9748C38.5847 20.0295 38.5027 20.0233 38.3802 20.0249C38.308 20.0259 38.308 20.0259 38.2343 20.0269C38.0143 20.0288 37.7943 20.0305 37.5742 20.0314C37.458 20.032 37.3418 20.0332 37.2255 20.0349C37.0583 20.0374 36.8912 20.0381 36.7239 20.0387C36.6719 20.0397 36.6198 20.0406 36.5662 20.0416C36.4936 20.0414 36.4936 20.0414 36.4195 20.0412C36.3769 20.0416 36.3344 20.0419 36.2905 20.0423C36.1786 20.0168 36.1786 20.0168 36.077 19.9419C35.9233 19.6288 36.0688 19.1679 36.1225 18.8316C36.133 18.7645 36.133 18.7645 36.1437 18.696C36.167 18.5476 36.1905 18.3992 36.214 18.2508C36.2308 18.1438 36.2477 18.0368 36.2644 17.9298C36.3052 17.6703 36.3461 17.4108 36.3872 17.1513C36.4205 16.9404 36.4538 16.7295 36.487 16.5185C36.4941 16.4734 36.4941 16.4734 36.5014 16.4273C36.511 16.3661 36.5206 16.305 36.5303 16.2438C36.6204 15.6715 36.7108 15.0991 36.8012 14.5268C36.8788 14.0361 36.9561 13.5454 37.0333 13.0546C37.1231 12.4839 37.213 11.9132 37.3031 11.3425C37.3127 11.2817 37.3223 11.2208 37.3319 11.1599C37.3367 11.13 37.3414 11.1 37.3463 11.0692C37.3795 10.8585 37.4127 10.6478 37.4458 10.4371C37.4904 10.1535 37.5352 9.86996 37.5801 9.58644C37.5966 9.48238 37.613 9.37831 37.6293 9.27424C37.6516 9.13223 37.6741 8.99025 37.6967 8.84829C37.7031 8.80707 37.7095 8.76585 37.7161 8.72338C37.8064 8.16028 37.8064 8.16028 37.9327 8.02878C38.0356 7.97706 38.1008 7.96742 38.2156 7.96726ZM40.2453 10.5828C40.165 10.8774 40.1172 11.174 40.0708 11.4756C40.0584 11.5551 40.0584 11.5551 40.0457 11.6362C40.0284 11.7478 40.0111 11.8594 39.994 11.971C39.972 12.1137 39.9497 12.2564 39.9274 12.399C39.906 12.5358 39.8849 12.6726 39.8638 12.8095C39.8558 12.8605 39.8478 12.9116 39.8395 12.9642C39.8323 13.0118 39.825 13.0594 39.8175 13.1084C39.811 13.1501 39.8046 13.1918 39.7979 13.2348C39.7848 13.3445 39.7816 13.4495 39.7842 13.5597C40.0361 13.5629 40.2881 13.5652 40.5401 13.5667C40.6255 13.5673 40.711 13.5681 40.7965 13.5692C41.5813 13.5791 42.3221 13.5563 42.9268 12.988C43.2306 12.6364 43.3675 12.1924 43.3426 11.7332C43.3057 11.426 43.1915 11.1393 42.9705 10.9182C42.601 10.6312 42.2016 10.5633 41.7439 10.5705C41.7007 10.5707 41.6576 10.5709 41.6131 10.5711C41.4769 10.5718 41.3406 10.5733 41.2044 10.5749C41.1114 10.5756 41.0184 10.5762 40.9253 10.5767C40.6987 10.578 40.472 10.5801 40.2453 10.5828Z\" fill=\"#003087\"/>\n" +
    "        <path d=\"M67.3066 7.9723C67.364 7.97185 67.364 7.97185 67.4226 7.9714C67.4646 7.9715 67.5065 7.9716 67.5497 7.97171C67.594 7.9715 67.6383 7.97128 67.6839 7.97106C67.8308 7.97048 67.9778 7.97052 68.1248 7.97062C68.2272 7.97045 68.3297 7.97027 68.4321 7.97007C68.6475 7.96976 68.8628 7.96977 69.0782 7.96999C69.3525 7.97023 69.6267 7.96953 69.901 7.96855C70.113 7.96793 70.325 7.9679 70.537 7.96803C70.638 7.96801 70.7389 7.96779 70.8399 7.96736C72.046 7.96292 73.0918 8.1446 74.0373 8.94759C74.0656 8.96937 74.094 8.99115 74.1232 9.01359C74.7401 9.50438 75.158 10.3576 75.2531 11.1279C75.3208 12.3447 75.0654 13.5042 74.2625 14.456C73.3378 15.4797 72.2482 16.0733 70.8509 16.1593C70.6709 16.1645 70.4911 16.1651 70.311 16.1652C70.21 16.166 70.109 16.1668 70.0081 16.1677C69.8507 16.1689 69.6934 16.1698 69.5361 16.1698C69.383 16.17 69.2299 16.1714 69.0768 16.1731C69.0295 16.1728 68.9822 16.1725 68.9335 16.1722C68.8898 16.1729 68.8461 16.1736 68.8011 16.1743C68.7434 16.1745 68.7434 16.1745 68.6846 16.1747C68.5795 16.1932 68.5795 16.1932 68.5144 16.2883C68.4523 16.4313 68.4241 16.5694 68.4021 16.7226C68.3973 16.7532 68.3925 16.7838 68.3875 16.8154C68.3719 16.9163 68.3568 17.0172 68.3418 17.1181C68.3309 17.1886 68.32 17.259 68.3091 17.3294C68.2804 17.5147 68.2522 17.7 68.2242 17.8854C68.1793 18.1817 68.1337 18.478 68.088 18.7742C68.0722 18.8774 68.0566 18.9806 68.0411 19.0838C68.0313 19.1475 68.0215 19.2112 68.0118 19.275C68.0076 19.3034 68.0034 19.3318 67.999 19.3611C67.9256 19.8356 67.9256 19.8356 67.7999 19.9712C67.6836 20.028 67.6001 20.033 67.4708 20.0337C67.4235 20.0342 67.3762 20.0348 67.3275 20.0353C67.2766 20.0352 67.2257 20.0351 67.1733 20.0349C67.1209 20.0352 67.0685 20.0354 67.0145 20.0356C66.9037 20.0359 66.7929 20.0359 66.6821 20.0355C66.5402 20.035 66.3984 20.0358 66.2566 20.0371C66.1211 20.038 65.9855 20.0377 65.85 20.0376C65.7991 20.038 65.7482 20.0385 65.6958 20.039C65.6485 20.0386 65.6012 20.0382 65.5525 20.0378C65.5109 20.0378 65.4694 20.0378 65.4265 20.0378C65.3168 20.0168 65.3168 20.0168 65.2182 19.9552C65.0517 19.6996 65.1691 19.2911 65.2154 19.0046C65.2261 18.9361 65.2261 18.9361 65.237 18.8661C65.2608 18.7137 65.2851 18.5614 65.3094 18.409C65.3266 18.2995 65.3438 18.19 65.361 18.0805C65.4028 17.8143 65.445 17.5481 65.4872 17.282C65.5364 16.972 65.5853 16.6619 65.6342 16.3518C65.7215 15.7985 65.8091 15.2452 65.8968 14.692C65.9819 14.1553 66.0667 13.6187 66.1513 13.082C66.2435 12.4971 66.3358 11.9123 66.4283 11.3275C66.4382 11.2652 66.4481 11.2028 66.4579 11.1404C66.4628 11.1097 66.4676 11.0791 66.4726 11.0475C66.5068 10.8314 66.5409 10.6153 66.575 10.3992C66.6165 10.1359 66.6581 9.87264 66.7 9.6094C66.7213 9.47513 66.7426 9.34085 66.7637 9.20654C66.7866 9.06092 66.8098 8.91535 66.833 8.76978C66.8396 8.72738 66.8462 8.68497 66.853 8.64128C66.9174 8.24179 66.9174 8.24179 66.9938 8.06708C67.1257 7.97912 67.1562 7.97268 67.3066 7.9723ZM69.3416 10.5828C69.2814 10.9586 69.2213 11.3343 69.1612 11.7101C69.1333 11.8846 69.1054 12.059 69.0775 12.2335C69.0505 12.4018 69.0236 12.5701 68.9967 12.7383C68.9865 12.8026 68.9762 12.8669 68.9658 12.9312C68.9514 13.0211 68.9371 13.1109 68.9228 13.2008C68.9146 13.252 68.9064 13.3032 68.8979 13.356C68.8784 13.4695 68.8784 13.4695 68.8804 13.5597C69.1384 13.5629 69.3963 13.5652 69.6543 13.5667C69.7418 13.5673 69.8292 13.5681 69.9167 13.5692C70.6556 13.5783 71.4212 13.5814 72 13.0476C72.3496 12.6559 72.4719 12.2027 72.4585 11.6869C72.4231 11.3432 72.2465 11.056 71.9829 10.8344C71.7171 10.6826 71.4577 10.5772 71.1503 10.578C71.11 10.5781 71.0697 10.5781 71.0282 10.5781C70.9851 10.5783 70.9419 10.5785 70.8974 10.5787C70.853 10.5788 70.8086 10.5788 70.7628 10.5789C70.621 10.5791 70.4792 10.5797 70.3373 10.5802C70.2412 10.5804 70.145 10.5806 70.0488 10.5808C69.8131 10.5812 69.5773 10.5819 69.3416 10.5828Z\" fill=\"#0070E0\"/>\n" +
    "        <path d=\"M82.045 12.1761C82.0461 12.1478 82.0472 12.1195 82.0483 12.0903C82.0507 12.0529 82.0531 12.0155 82.0555 11.9769C82.0575 11.94 82.0594 11.903 82.0614 11.8649C82.0944 11.7253 82.1438 11.6789 82.2547 11.5891C82.3631 11.5681 82.3631 11.5681 82.4872 11.5681C82.5338 11.5677 82.5804 11.5673 82.6284 11.5669C82.7035 11.5676 82.7035 11.5676 82.7802 11.5683C82.8318 11.5682 82.8834 11.5682 82.9365 11.5681C83.0455 11.5682 83.1545 11.5687 83.2635 11.5695C83.3754 11.5703 83.4872 11.5708 83.5991 11.5704C83.7603 11.5699 83.9214 11.5702 84.0825 11.5709C84.1327 11.5708 84.1829 11.5707 84.2346 11.5705C84.281 11.5711 84.3275 11.5716 84.3754 11.5722C84.4163 11.5724 84.4572 11.5726 84.4994 11.5728C84.6231 11.5923 84.6525 11.6172 84.7283 11.7149C84.7983 12.0973 84.6831 12.5287 84.6225 12.9089C84.6111 12.982 84.5998 13.0551 84.5884 13.1283C84.5577 13.3257 84.5266 13.523 84.4954 13.7203C84.4693 13.8853 84.4434 14.0504 84.4176 14.2154C84.3566 14.6048 84.2952 14.9941 84.2336 15.3834C84.1702 15.7846 84.1072 16.1859 84.0446 16.5872C83.9907 16.9324 83.9365 17.2776 83.882 17.6227C83.8495 17.8285 83.8172 18.0344 83.7851 18.2403C83.7549 18.4338 83.7243 18.6272 83.6935 18.8205C83.6822 18.8914 83.6711 18.9623 83.6602 19.0332C83.6452 19.1301 83.6297 19.227 83.614 19.3239C83.6055 19.378 83.597 19.4322 83.5882 19.488C83.5392 19.7075 83.4974 19.887 83.3028 20.0168C83.2029 20.0277 83.2029 20.0277 83.0834 20.0283C83.0386 20.0287 82.9938 20.0291 82.9477 20.0295C82.8993 20.0295 82.851 20.0294 82.8012 20.0294C82.7515 20.0296 82.7018 20.0297 82.6506 20.0299C82.5455 20.0302 82.4404 20.0302 82.3353 20.03C82.1742 20.0299 82.0132 20.0309 81.8522 20.0319C81.7501 20.032 81.6481 20.032 81.546 20.032C81.4978 20.0324 81.4495 20.0328 81.3998 20.0332C81.3549 20.0329 81.31 20.0326 81.2637 20.0324C81.2045 20.0324 81.2045 20.0324 81.1441 20.0325C81.0194 20.0139 80.9619 19.9772 80.8711 19.891C80.8456 19.7962 80.8456 19.7962 80.8397 19.6944C80.8373 19.6606 80.8349 19.6267 80.8325 19.5917C80.8314 19.566 80.8303 19.5402 80.8292 19.5136C80.7951 19.5349 80.761 19.5562 80.7259 19.5782C80.4516 19.7447 80.1786 19.884 79.8754 19.9906C79.8472 20.0005 79.8191 20.0105 79.7901 20.0208C78.7573 20.3685 77.6335 20.2396 76.6689 19.7614C75.8582 19.3443 75.268 18.6487 74.9596 17.7945C74.5605 16.5382 74.6898 15.1371 75.2755 13.9618C75.4604 13.6051 75.6649 13.2809 75.9239 12.9727C75.9722 12.9142 75.9722 12.9142 76.0215 12.8545C77.551 11.0832 80.1836 10.8112 82.045 12.1761ZM77.8682 14.5737C77.4874 15.0254 77.2771 15.6016 77.3152 16.1955C77.37 16.6316 77.5576 17.0811 77.8944 17.3753C78.3972 17.7504 78.9189 17.899 79.5421 17.8186C80.1917 17.7008 80.7146 17.3776 81.0939 16.838C81.4214 16.3225 81.5459 15.7459 81.4324 15.1421C81.2843 14.6432 80.9795 14.2745 80.5357 14.0136C79.636 13.5303 78.5362 13.86 77.8682 14.5737Z\" fill=\"#0070E0\"/>\n" +
    "        <path d=\"M52.768 12.0896C52.8 12.1181 52.8319 12.1467 52.8649 12.1761C52.8725 12.1443 52.8802 12.1124 52.888 12.0796C52.8985 12.0379 52.9091 11.9963 52.9199 11.9533C52.9302 11.912 52.9404 11.8706 52.9509 11.828C52.993 11.7084 53.0171 11.6649 53.1165 11.5891C53.2196 11.5728 53.2196 11.5728 53.3436 11.5721C53.4133 11.5713 53.4133 11.5713 53.4844 11.5705C53.5596 11.5707 53.5596 11.5707 53.6364 11.5709C53.7137 11.5706 53.7137 11.5706 53.7926 11.5702C53.9296 11.5699 54.0667 11.5702 54.2037 11.5707C54.3428 11.5708 54.482 11.5693 54.6211 11.5682C54.727 11.5681 54.8329 11.5682 54.9387 11.5683C54.9888 11.5678 55.0389 11.5673 55.0906 11.5669C55.1371 11.5672 55.1837 11.5676 55.2317 11.568C55.2727 11.5681 55.3136 11.5681 55.3558 11.5681C55.4977 11.5956 55.5424 11.6449 55.632 11.7568C55.6431 11.8573 55.6431 11.8573 55.6284 11.9727C55.6203 12.0399 55.6203 12.0399 55.6121 12.1084C55.6048 12.1584 55.5975 12.2084 55.5901 12.2599C55.5787 12.3413 55.5787 12.3413 55.5671 12.4242C55.5397 12.6158 55.5096 12.807 55.4795 12.9982C55.4682 13.0714 55.4568 13.1446 55.4454 13.2178C55.4148 13.4151 55.3839 13.6124 55.3529 13.8097C55.3336 13.9332 55.3142 14.0566 55.2949 14.18C55.2276 14.6109 55.16 15.0419 55.0923 15.4728C55.0292 15.874 54.9666 16.2753 54.9042 16.6766C54.8504 17.0218 54.7964 17.367 54.7421 17.7122C54.7097 17.918 54.6775 18.1239 54.6456 18.3299C54.6156 18.5233 54.5852 18.7166 54.5545 18.9099C54.5433 18.9808 54.5323 19.0517 54.5214 19.1226C54.5065 19.2195 54.4911 19.3163 54.4756 19.4131C54.4628 19.4943 54.4628 19.4943 54.4498 19.5771C54.4154 19.7266 54.3683 19.843 54.2904 19.9748C54.1837 20.0282 54.1074 20.023 53.988 20.0242C53.9424 20.0247 53.8968 20.0253 53.8498 20.0258C53.7755 20.0263 53.7755 20.0263 53.6998 20.0267C53.6492 20.0271 53.5985 20.0274 53.5463 20.0278C53.4389 20.0284 53.3316 20.0288 53.2242 20.0291C53.0598 20.0299 52.8954 20.0317 52.7309 20.0335C52.6268 20.034 52.5226 20.0343 52.4185 20.0346C52.3692 20.0353 52.3198 20.0361 52.269 20.0368C52.2002 20.0367 52.2002 20.0367 52.13 20.0365C52.0897 20.0367 52.0493 20.037 52.0078 20.0372C51.8695 20.0108 51.82 19.9571 51.7329 19.849C51.7006 19.7354 51.6989 19.6326 51.691 19.5136C51.6549 19.5354 51.6189 19.5572 51.5818 19.5796C50.9056 19.9815 50.2312 20.2098 49.4375 20.2028C49.3862 20.2025 49.3348 20.2021 49.282 20.2018C48.2396 20.1824 47.3148 19.781 46.5808 19.0351C46.3933 18.8361 46.2471 18.621 46.1149 18.3815C46.0868 18.3335 46.0868 18.3335 46.0581 18.2846C45.7077 17.6463 45.5647 16.8398 45.6118 16.1174C45.6135 16.0903 45.6152 16.0632 45.617 16.0353C45.7065 14.7452 46.1827 13.6179 47.0792 12.6792C47.1043 12.651 47.1295 12.6227 47.1553 12.5936C48.5232 11.1133 51.1975 10.7996 52.768 12.0896ZM48.7562 14.566C48.3203 15.0769 48.1722 15.6682 48.2112 16.327C48.2911 16.8103 48.5743 17.2277 48.9619 17.5192C49.4115 17.8199 49.9408 17.8983 50.4688 17.8093C51.0707 17.6823 51.5685 17.4043 51.9319 16.8954C51.9969 16.7919 52.0549 16.6876 52.1103 16.5786C52.1266 16.5464 52.143 16.5142 52.1599 16.481C52.3789 15.9963 52.4154 15.4705 52.2436 14.9688C52.0493 14.4895 51.7141 14.155 51.2487 13.9386C50.3815 13.572 49.3783 13.9007 48.7562 14.566Z\" fill=\"#003087\"/>\n" +
    "        <path d=\"M56.6718 11.5728C56.7467 11.5722 56.7467 11.5722 56.8231 11.5716C56.9041 11.572 56.9041 11.572 56.9867 11.5724C57.0426 11.5723 57.0986 11.5722 57.1545 11.572C57.2716 11.5718 57.3888 11.5721 57.5059 11.5727C57.6561 11.5734 57.8062 11.573 57.9563 11.5723C58.0718 11.5718 58.1873 11.5719 58.3027 11.5723C58.385 11.5724 58.4673 11.572 58.5496 11.5716C58.5995 11.572 58.6495 11.5724 58.7009 11.5728C58.7449 11.5729 58.789 11.573 58.8343 11.5731C58.9441 11.5891 58.9441 11.5891 59.0188 11.6442C59.1036 11.7615 59.1371 11.8972 59.1778 12.0343C59.1879 12.0672 59.198 12.1001 59.2085 12.134C59.2421 12.244 59.2752 12.3542 59.3083 12.4644C59.3318 12.5416 59.3554 12.6188 59.379 12.6959C59.4439 12.9089 59.5082 13.1221 59.5725 13.3353C59.6325 13.5341 59.6927 13.7328 59.7529 13.9316C59.9311 14.5203 60.1087 15.1091 60.2857 15.6981C60.3134 15.6981 60.3411 15.6981 60.3696 15.6981C60.386 15.6695 60.4024 15.6409 60.4193 15.6114C60.7114 15.1024 61.0042 14.594 61.3076 14.0917C61.4695 13.8233 61.6293 13.5538 61.7887 13.284C61.9163 13.0682 62.0443 12.8527 62.1724 12.6373C62.2005 12.5901 62.2286 12.5428 62.2575 12.4941C62.338 12.3591 62.4189 12.2243 62.4999 12.0896C62.5243 12.0487 62.5486 12.0078 62.5737 11.9657C62.5963 11.9283 62.6189 11.8908 62.6422 11.8523C62.6619 11.8195 62.6816 11.7868 62.7018 11.753C62.7593 11.673 62.7593 11.673 62.8851 11.5891C63.0031 11.5782 63.0031 11.5782 63.1482 11.5776C63.2025 11.5772 63.2568 11.5768 63.3127 11.5764C63.372 11.5764 63.4313 11.5764 63.4906 11.5765C63.5513 11.5763 63.612 11.5761 63.6727 11.5759C63.7999 11.5756 63.9271 11.5756 64.0543 11.5759C64.2175 11.5761 64.3807 11.5754 64.5439 11.5744C64.6693 11.5738 64.7946 11.5738 64.92 11.5739C64.9802 11.5739 65.0404 11.5737 65.1006 11.5732C65.1846 11.5727 65.2686 11.5731 65.3526 11.5735C65.4004 11.5735 65.4483 11.5734 65.4976 11.5734C65.5348 11.5786 65.5719 11.5838 65.6103 11.5891C65.7089 11.7371 65.7122 11.7921 65.6941 11.9665C65.6367 12.0895 65.6367 12.0895 65.5559 12.2184C65.5414 12.2418 65.527 12.2652 65.5121 12.2893C65.465 12.3655 65.4171 12.4411 65.3692 12.5168C65.3361 12.57 65.3031 12.6232 65.2701 12.6765C65.2043 12.7827 65.1383 12.8888 65.072 12.9947C64.9555 13.1816 64.8424 13.3705 64.7298 13.5598C64.5133 13.9218 64.2943 14.2824 64.0752 14.6429C63.8872 14.9521 63.6998 15.2617 63.514 15.5723C63.2974 15.9343 63.0785 16.295 62.8594 16.6554C62.6714 16.9647 62.484 17.2743 62.2982 17.5849C62.0816 17.9469 61.8627 18.3075 61.6435 18.668C61.4555 18.9773 61.2681 19.2869 61.0823 19.5975C60.8092 20.0536 60.5337 20.5083 60.257 20.9623C60.163 21.1166 60.0694 21.2713 59.9761 21.4261C59.9151 21.5272 59.8538 21.6281 59.7924 21.729C59.7495 21.7998 59.7069 21.8709 59.6643 21.9419C59.6382 21.9847 59.6121 22.0274 59.5853 22.0714C59.5626 22.109 59.5399 22.1465 59.5165 22.1852C59.4425 22.2875 59.3874 22.3415 59.2795 22.4067C59.1599 22.4224 59.1599 22.4224 59.02 22.4223C58.9676 22.4226 58.9151 22.4228 58.861 22.4231C58.8039 22.4228 58.7469 22.4224 58.6898 22.4219C58.6311 22.4219 58.5724 22.4219 58.5137 22.422C58.3909 22.422 58.2681 22.4216 58.1453 22.4208C57.9879 22.4199 57.8304 22.4198 57.673 22.4201C57.5519 22.4203 57.4308 22.42 57.3097 22.4196C57.2517 22.4194 57.1936 22.4194 57.1355 22.4194C57.0545 22.4194 56.9734 22.4188 56.8923 22.4182C56.8462 22.418 56.8 22.4178 56.7525 22.4176C56.6382 22.4067 56.6382 22.4067 56.5124 22.3229C56.4666 22.1971 56.4619 22.1354 56.5105 22.0098C56.5315 21.974 56.5525 21.9383 56.5742 21.9014C56.5976 21.861 56.6211 21.8206 56.6453 21.779C56.6706 21.7371 56.696 21.6952 56.7221 21.652C56.7464 21.6113 56.7707 21.5707 56.7957 21.5288C56.8742 21.3989 56.9539 21.2699 57.0339 21.141C57.063 21.0939 57.0921 21.0468 57.122 20.9983C57.2942 20.7198 57.4674 20.442 57.6412 20.1645C57.6937 20.0805 57.746 19.9965 57.7981 19.9123C57.9178 19.7192 58.0393 19.5284 58.168 19.3412C58.1903 19.3077 58.2126 19.2743 58.2356 19.2398C58.2765 19.1785 58.3186 19.118 58.362 19.0585C58.4414 18.9376 58.4903 18.8506 58.4686 18.7038C58.4579 18.6684 58.4472 18.633 58.4361 18.5965C58.4239 18.5557 58.4118 18.5149 58.3992 18.4728C58.3853 18.4289 58.3715 18.3849 58.3572 18.3396C58.3431 18.2945 58.329 18.2493 58.3145 18.2028C58.266 18.0498 58.2165 17.8972 58.1667 17.7446C58.148 17.6871 58.1293 17.6295 58.1107 17.572C58.0711 17.45 58.0315 17.328 57.9918 17.2061C57.8977 16.9168 57.8039 16.6274 57.7101 16.3381C57.689 16.2731 57.6679 16.2081 57.6468 16.1431C57.4258 15.4617 57.2071 14.7797 56.9896 14.0972C56.8681 13.716 56.7458 13.3352 56.6204 12.9554C56.5982 12.888 56.5761 12.8207 56.5539 12.7533C56.5139 12.6316 56.4734 12.51 56.4326 12.3885C56.4151 12.3354 56.3976 12.2823 56.3801 12.2292C56.3651 12.1841 56.35 12.139 56.3345 12.0926C56.3008 11.9586 56.2879 11.8523 56.3028 11.7149C56.4046 11.5696 56.5016 11.5732 56.6718 11.5728Z\" fill=\"#003087\"/>\n" +
    "        <path d=\"M20.3919 8.01898C20.4405 8.01868 20.4892 8.01838 20.5393 8.01807C20.593 8.01796 20.6466 8.01785 20.7019 8.01773C20.7588 8.01747 20.8157 8.01719 20.8726 8.01689C21.06 8.01601 21.2475 8.01558 21.4349 8.01516C21.4996 8.01499 21.5644 8.01482 21.6291 8.01464C21.934 8.01384 22.2388 8.01325 22.5437 8.0129C22.8938 8.01249 23.244 8.01139 23.5941 8.00969C23.8657 8.00842 24.1372 8.0078 24.4087 8.00767C24.5703 8.00757 24.732 8.00721 24.8937 8.00614C25.7427 8.00082 26.5559 8.02341 27.3559 8.34486C27.389 8.3574 27.4222 8.36994 27.4563 8.38286C27.5957 8.43648 27.7102 8.48677 27.8354 8.57022C28.0379 9.43929 27.4648 10.6218 27.03 11.3451C26.8715 11.5987 26.6921 11.8264 26.4938 12.0503C26.4684 12.0807 26.443 12.1112 26.4168 12.1425C25.6683 13.0316 24.5639 13.605 23.4457 13.872C23.3864 13.8863 23.3274 13.9012 23.2687 13.9174C22.9252 14.0012 22.5782 13.9908 22.227 13.9905C22.1087 13.9905 21.9905 13.991 21.8722 13.9917C21.5361 13.9937 21.2001 13.9947 20.8641 13.995C20.6578 13.9952 20.4516 13.9962 20.2453 13.9977C20.167 13.9981 20.0888 13.9982 20.0105 13.998C19.901 13.9977 19.7916 13.9985 19.6822 13.9994C19.6502 13.9991 19.6182 13.9987 19.5852 13.9984C19.3225 14.0024 19.1475 14.0835 18.9498 14.262C18.9278 14.288 18.9278 14.288 18.9053 14.3145C18.9414 14.0044 18.9902 13.6965 19.0389 13.3883C19.0482 13.3294 19.0574 13.2706 19.0667 13.2117C19.0915 13.0538 19.1164 12.896 19.1413 12.7381C19.1673 12.5736 19.1932 12.4092 19.2191 12.2447C19.2509 12.0432 19.2827 11.8418 19.3144 11.6403C19.3789 11.232 19.4429 10.8236 19.5066 10.4152C19.5365 10.224 19.5664 10.0327 19.5964 9.84152C19.6125 9.73881 19.6285 9.63609 19.6444 9.53337C19.6665 9.39104 19.6888 9.24874 19.7112 9.10645C19.7207 9.04461 19.7207 9.04461 19.7305 8.98151C19.8355 8.31691 19.8355 8.31691 20.0792 8.06708C20.1887 8.01234 20.2693 8.0195 20.3919 8.01898Z\" fill=\"#001C64\"/>\n" +
    "        <path d=\"M87.1013 7.97039C87.1494 7.96972 87.1976 7.96905 87.2472 7.96836C87.2992 7.96814 87.3512 7.96791 87.4048 7.96768C87.4849 7.96711 87.4849 7.96711 87.5666 7.96653C87.6796 7.96592 87.7926 7.96552 87.9057 7.9654C88.0504 7.96517 88.195 7.96359 88.3397 7.96168C88.4779 7.96013 88.6161 7.96007 88.7543 7.95982C88.8062 7.959 88.8581 7.95818 88.9116 7.95734C88.9599 7.95759 89.0081 7.95785 89.0579 7.95811C89.1003 7.9579 89.1428 7.95768 89.1865 7.95746C89.2981 7.98324 89.2981 7.98324 89.3996 8.05819C89.5055 8.27351 89.4582 8.46359 89.4239 8.69603C89.42 8.72337 89.4162 8.75072 89.4122 8.7789C89.3795 9.00949 89.3431 9.23947 89.3065 9.46947C89.2944 9.54663 89.2822 9.6238 89.2701 9.70097C89.2372 9.91 89.2042 10.119 89.171 10.328C89.1359 10.5498 89.101 10.7717 89.066 10.9936C88.9994 11.4163 88.9326 11.839 88.8657 12.2617C88.7913 12.7323 88.7171 13.2029 88.6429 13.6735C88.5153 14.4828 88.3874 15.2921 88.2593 16.1013C88.1749 16.635 88.0907 17.1688 88.007 17.7026C87.9775 17.8907 87.9479 18.0787 87.9183 18.2668C87.8961 18.4081 87.8739 18.5494 87.8519 18.6907C87.8285 18.8408 87.8049 18.9909 87.7812 19.1409C87.7746 19.1836 87.768 19.2263 87.7612 19.2703C87.6711 19.8371 87.6711 19.8371 87.5468 19.9712C87.4305 20.028 87.347 20.033 87.2177 20.0337C87.1704 20.0343 87.1231 20.0348 87.0744 20.0353C87.0235 20.0352 86.9726 20.0351 86.9202 20.035C86.8678 20.0352 86.8154 20.0354 86.7614 20.0356C86.6505 20.0359 86.5398 20.0359 86.429 20.0355C86.2871 20.035 86.1453 20.0359 86.0035 20.0371C85.868 20.038 85.7324 20.0377 85.5969 20.0376C85.546 20.0381 85.4951 20.0385 85.4427 20.039C85.3954 20.0386 85.3481 20.0382 85.2994 20.0378C85.2578 20.0378 85.2163 20.0378 85.1734 20.0378C85.0637 20.0168 85.0637 20.0168 84.9651 19.9552C84.8119 19.7199 84.9026 19.3749 84.9459 19.1097C84.954 19.0581 84.954 19.0581 84.9623 19.0054C84.9802 18.891 84.9986 18.7767 85.017 18.6624C85.03 18.5799 85.043 18.4973 85.056 18.4148C85.0914 18.1907 85.1271 17.9667 85.1629 17.7426C85.2007 17.5056 85.2382 17.2684 85.2757 17.0313C85.3472 16.5798 85.4189 16.1282 85.4908 15.6767C85.579 15.1229 85.6668 14.5691 85.7545 14.0152C85.8466 13.4345 85.9387 12.8538 86.0311 12.2731C86.0604 12.0888 86.0897 11.9046 86.119 11.7203C86.126 11.6759 86.1331 11.6316 86.1404 11.5858C86.2247 11.0554 86.3086 10.5248 86.3912 9.99407C86.4051 9.90478 86.4191 9.81549 86.433 9.72621C86.4728 9.47117 86.5125 9.21611 86.5517 8.96098C86.5649 8.87651 86.5781 8.79204 86.5913 8.70757C86.5996 8.6526 86.5996 8.6526 86.6081 8.59652C86.6369 8.41355 86.6673 8.23848 86.7407 8.0671C86.8829 7.9723 86.9344 7.97215 87.1013 7.97039Z\" fill=\"#0070E0\"/>\n" +
    "      </g>\n" +
    "      <defs>\n" +
    "        <clipPath id=\"clip0_2_22\">\n" +
    "          <rect width=\"75.4658\" height=\"20\" fill=\"white\" transform=\"translate(14 4)\"/>\n" +
    "        </clipPath>\n" +
    "      </defs>\n" +
    "    </svg>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- If widget doesn't have a state, but it has an url -->\n" +
    "<div\n" +
    "        id=\"widget-{{widget.title.replaceAll(' ', '-').toLowerCase()}}\"\n" +
    "  class=\"widget-box btn\"\n" +
    "  ng-if=\"widget.url\"\n" +
    "  ng-class=\"{\n" +
    "    'widget-box--centered': isFullWidthBtn,\n" +
    "    'btn-alt': isAltBtn,\n" +
    "    'btn-alt-2': isAlt2Btn}\">\n" +
    "  <a class=\"widget-box__link\" confirmation-overlay confirmation-overlay-message=\"{{widget.confirmationOverlayMessage}}\" href=\"{{widget.url}}\" target=\"_blank\">\n" +
    "    <span class=\"{{widget.icon}}\"></span>\n" +
    "    {{widget.title}}\n" +
    "  </a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/shared/widgets.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/shared/widgets.html",
    "<div class=\"widget-row\">\n" +
    "  <div\n" +
    "      ng-repeat=\"widget in filteredNotifications = (widgets | widgetFilter: { color: 'notification', accountType: accountType, isMain: isMain })\"\n" +
    "      class=\"col-widget-full-width\">\n" +
    "    <ak-widget widget=\"widget\"></ak-widget>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-if=\"loadWidgets.length > 0\" class=\"widget-line-break\">\n" +
    "  <div class=\"widget-title\">Load</div>\n" +
    "  <div class=\"border-line\"></div>\n" +
    "</div>\n" +
    "<div class=\"widget-row\">\n" +
    "  <div\n" +
    "     ng-repeat=\"widget in loadWidgets = (widgets | widgetFilter: { color: 'green', accountType: accountType, isMain: isMain })\"\n" +
    "     class=\"col-widget\">\n" +
    "    <ak-widget widget=\"widget\"></ak-widget>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-if=\"withdrawWidgets.length > 0\" class=\"widget-line-break\">\n" +
    "  <div class=\"widget-title\">Withdraw</div>\n" +
    "  <div class=\"border-line\"></div>\n" +
    "</div>\n" +
    "<div class=\"widget-row\">\n" +
    "  <div\n" +
    "     ng-repeat=\"widget in withdrawWidgets = (widgets | widgetFilter: { color: 'blue', accountType: accountType, isMain: isMain })\"\n" +
    "     class=\"col-widget\">\n" +
    "    <ak-widget widget=\"widget\"></ak-widget>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-if=\"accountWidgets.length > 0\" class=\"widget-line-break\">\n" +
    "  <div class=\"widget-title\">Account</div>\n" +
    "  <div class=\"border-line\"></div>\n" +
    "</div>\n" +
    "<div class=\"widget-row\">\n" +
    "  <div\n" +
    "     ng-repeat=\"widget in accountWidgets = (widgets | widgetFilter: { color: ' ', accountType: accountType, isMain: isMain })\"\n" +
    "     class=\"col-widget\">\n" +
    "    <ak-widget widget=\"widget\"></ak-widget>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/add/side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/add/side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Important Tip</h2>\n" +
    "  <p>The primary cardholder is ultimately responsible for all activity on sub-cards and only the primary cardholder can contact customer service.</p>\n" +
    "</div>\n" +
    "<div ng-show=\"isPhysical\" class=\"overlay-side\" ng-if=\"address1\">\n" +
    "  <h2>Shipping Information</h2>\n" +
    "  <p>Your card should arrive within 5-7 days at {{address1}}{{address2 ? ', ' + address2 + ',' : ','}} {{city}}, {{state}}, {{zip}}.</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/add/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/add/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"tooManySubs\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Sorry, you can only have up to 5 sub-cards.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.firstName.$error.required && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please re-enter your First Name using only letters or hyphens.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">First Name</label>\n" +
    "    <input\n" +
    "      type=\"text\"\n" +
    "      name=\"firstName\"\n" +
    "      ng-model=\"formData.FirstName\"\n" +
    "      required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.lastName.$error.required && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please re-enter your Last Name using only letters or hyphens.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Last Name</label>\n" +
    "    <input\n" +
    "      type=\"text\"\n" +
    "      name=\"lastName\"\n" +
    "      ng-model=\"formData.LastName\"\n" +
    "      required>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\">Company Name</label>\n" +
    "    <input\n" +
    "      maxlength=\"24\"\n" +
    "      type=\"text\"\n" +
    "      name=\"companyName\"\n" +
    "      ng-model=\"formData.CorporateName\"\n" +
    "      >\n" +
    "      <span class=\"overlay-title-subtext\">(optional) 24 characters or less</span>\n" +
    "  </li>\n" +
    "  <li style=\"height:0px;padding:0px;margin:0px;border:0px;\"></li>\n" +
    "</ul>\n" +
    "<ul class=\"form js-autoscroll-form noBorder\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"alert.errorShown && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>You must select at least one card to reissue using the toggle buttons on the right</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"extra-space extra-padding\">{{cardTypeLabel}}</label>\n" +
    "    <div class=\"checkbox-wrapper\" ng-show=\"(hasVirtualSubProgram && hasPhysicalSubProgram)\">\n" +
    "      <span id='virtual-checkbox' class=\"list-checkbox checkbox\" ng-class=\"formData.Virtual ? 'icon-box-check' : 'icon-box'\" ng-click=\"formData.Virtual = !formData.Virtual\">\n" +
    "        <span class=\"checkbox-label\">Virtual Card</span>\n" +
    "      </span>\n" +
    "      <span id='physical-checkbox' class=\"list-checkbox checkbox\" ng-class=\"!formData.Virtual ? 'icon-box-check' : 'icon-box'\" ng-click=\"formData.Virtual = !formData.Virtual\">\n" +
    "        <span class=\"checkbox-label\">Physical Card</span>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"extra-space extra-padding\">Enable ATM access?</label>\n" +
    "    <div class=\"toggle-input\">\n" +
    "      <div class=\"toggle-bg {{formData.atm}}\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"toggle-2\"\n" +
    "          value=\"off\"\n" +
    "          ng-model=\"formData.atm\">\n" +
    "        <input\n" +
    "          type=\"radio\"\n" +
    "          name=\"toggle-2\"\n" +
    "          value=\"on\"\n" +
    "          ng-model=\"formData.atm\">\n" +
    "        <span class=\"switch {{formData.atm}}\"></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <h3 class=\"toggle-status\">{{formData.atm == 'on' ? 'Enabled': 'Disabled'}}</h3>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/add/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/add/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">First Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-first_name\">{{formData.FirstName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Last Name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-last_name\">{{formData.LastName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Card Type&nbsp;</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-virtual\">{{formData.Virtual ? 'Virtual' : 'Physical'}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/close/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/close/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">First name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-first_name\">{{FirstName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Last name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-last_name\">{{LastName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <div class=\"overlay-list\">\n" +
    "      <p class=\"overlay-list-header\" ng-if=\"canBeClosed\">\n" +
    "        Card can be closed\n" +
    "      </p>\n" +
    "      <p class=\"overlay-list-header\" ng-if=\"!canBeClosed\">\n" +
    "        Card cannot be closed\n" +
    "      </p>\n" +
    "      <li ng-repeat=\"r in reasons\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <p class=\"close-reasons\">{{r}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "  </div>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/disable/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/disable/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">First name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-first_name\">{{FirstName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Last name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-last_name\">{{LastName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/subaccount/enable/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/enable/step1.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">First name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-first_name\">{{FirstName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Last name</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"step1-last_name\">{{LastName}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>");
}]);

angular.module("../app/views/member/subaccount/feed/feed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/feed/feed.html",
    "<div class=\"feed-list-header\">\n" +
    "  <div style=\"width:inherit;\" class=\"feed-list-title-wrapper\">\n" +
    "    <h2 style=\"vertical-align:middle;margin-left:9px;\" class=\"sub-card-filter\">{{feedTitle}}</h2>\n" +
    "  </div>\n" +
    "  <span id=\"loadingFeed\" class=\"loading-indicator\" ng-show=\"loading\"></span>\n" +
    "  <button class=\"view-more-transactions icon-menu-burger tooltip-wrap\" style=\"display: inline-block;\" ui-sref=\"member.home.expanded\">\n" +
    "    <span class=\"tooltip\">View more</span>\n" +
    "  </button>\n" +
    "</div>\n" +
    "<ul class=\"feed-list akimbo-widget-feed\">\n" +
    "  <li ng-repeat=\"subCard in subCards\" class=\"akimbo-user akimbo-user-detailed akimbo-sub-account\" ui-sref=\"member.home.subaccount.transactions({Username: subCard.Username, FirstName: subCard.FirstName, LastName: subCard.LastName, Balance: subCard.Balance})\">\n" +
    "    <div class=\"akimbo-media-box\">\n" +
    "      <div class=\"icon-wrap\">\n" +
    "        <span class=\"icon-sub\"></span>\n" +
    "      </div>\n" +
    "      <div class=\"akimbo-media-box-content\">\n" +
    "        <h2 class=\"user-detailed-title large\">{{subCard.FirstName}} {{subCard.LastName}}</h2>\n" +
    "        <p class=\"user-detailed-subtitle\"><strong>x{{subCard.CardLastFour}}</strong></p>\n" +
    "        <div class=\"user-detailed-text\">{{subCard.StatusDesc}}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"akimbo-balance\">\n" +
    "      <div class=\"carret\">\n" +
    "        <span class=\"icon-arrow-right\"></span>\n" +
    "      </div>\n" +
    "      <p class=\"user-detailed-subtitle\"><strong>{{subCard.Balance | akimboCurrency}}</strong></p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/feed/transactions.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/feed/transactions.html",
    "<div class=\"feed-list-header\">\n" +
    "  <a ui-sref=\"member.home.subaccount\" style=\"display: inherit;float:left;margin:1px 0 0 0\" class=\"view-more-transactions icon-arrow-left tooltip-wrap\">\n" +
    "    <span class=\"tooltip\">Summary</span>\n" +
    "  </a>\n" +
    "  <a ui-sref=\"member.home.subaccount\" style=\"width:inherit;\" class=\"feed-list-title-wrapper\">\n" +
    "    <h2 style=\"vertical-align:middle;margin-left:9px;\" class=\"sub-card-filter\">All Cards</h2>\n" +
    "  </a>\n" +
    "  <button class=\"view-more-transactions icon-menu-burger tooltip-wrap\" style=\"display: inline-block;\" ui-sref=\"member.home.expanded\">\n" +
    "    <span class=\"tooltip\">View more</span>\n" +
    "  </button>\n" +
    "  <div ng-show=\"!loading\" style=\"line-height:25px;margin-left:3px;width:100%;text-align:center;\" class=\"sub-card-balance\">\n" +
    "    <span style=\"font-size:16px;margin-right:9px;margin-top:-1px;\" class=\"icon-sub\"></span>\n" +
    "    <span class=\"\" style=\"\">{{subTitle}}</span>\n" +
    "  </div>\n" +
    "  <span id=\"loadingFeed\" class=\"loading-indicator\" ng-show=\"loading\"></span>\n" +
    "</div>\n" +
    "<ul class=\"feed-list akimbo-widget-feed\">\n" +
    "  <li class=\"akimbo-user akimbo-user-detailed bl-notification-transaction\" ng-repeat=\"notification in akimboFeed.notifications\" ng-click=\"notificationClick(notification.Url)\">\n" +
    "    <div class=\"akimbo-media-box\">\n" +
    "      <div class=\"akimbo-media-box-content\">\n" +
    "        <h2 class=\"user-detailed-title\">{{notification.FormattedTitle}}</h2>\n" +
    "        <p class=\"user-detailed-subtitle\"><strong>{{notification.FormattedDescription}}</strong></p>\n" +
    "        <div class=\"user-detailed-subtitle\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"akimbo-balance\">\n" +
    "      <div class=\"akimbo-balance-container\">\n" +
    "        <div class=\"icon-wrap\">\n" +
    "          <span class=\"{{notification.Icon}}\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-repeat=\"transaction in akimboFeed.transactions\"\n" +
    "      ng-class=\"transaction.Amount > 0 ? 'bl-in-transaction' : 'bl-out-transaction'\"\n" +
    "      class=\"akimbo-user akimbo-user-detailed three-line-transaction\"\n" +
    "      ui-sref=\"member.home.transaction.detail({id: transaction.Id})\">\n" +
    "    <div class=\"akimbo-media-box\">\n" +
    "      <div class=\"icon-wrap\">\n" +
    "        <span ng-class=\"transaction.Amount > 0 ? 'in-transaction' : 'out-transaction'\" class=\"{{transaction.Icon}}\"></span>\n" +
    "      </div>\n" +
    "      <div class=\"akimbo-media-box-content\">\n" +
    "        <h2\n" +
    "          class=\"user-detailed-title\"\n" +
    "          ng-class=\"transaction.Amount > 0 ? 'in-transaction' : 'out-transaction'\">{{transaction.Status == 'pending' ?\n" +
    "        ('Pending ' + transaction.Title) : transaction.Title}}</h2>\n" +
    "        <p class=\"user-detailed-subtitle\"><strong>{{transaction.FormattedDate}}</strong></p>\n" +
    "        <div ng-class=\"transaction.Amount > 0 ? 'in-transaction' : 'out-transaction'\" class=\"user-detailed-text transaction-desc\">{{transaction.Description}}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"akimbo-balance\">\n" +
    "      <div class=\"akimbo-balance-container\">\n" +
    "        <p class=\"user-detailed-subtitle\"><strong>{{transaction.Amount\n" +
    "        | akimboCurrency}}</strong></p>\n" +
    "        <p ng-if=\"transaction.Balance != 0\" class=\"user-detailed-text\">{{transaction.Balance | akimboCurrency}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/load/header-content.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/load/header-content.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ul class=\"form js-autoscroll-form\">\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "      <label for=\"#\">To</label>\n" +
    "      <div class=\"content\">\n" +
    "        <div class=\"akimbo-media-box\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{transferFrom.FirstName + ' ' + transferFrom.LastName}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transferFrom.Username}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/retrieve/header-content.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/retrieve/header-content.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>{{title}}</h1>\n" +
    "        <p>{{info}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ul class=\"form js-autoscroll-form\">\n" +
    "    <li class=\"form-with-content-small\">\n" +
    "      <label for=\"#\">From</label>\n" +
    "      <div class=\"content\">\n" +
    "        <div class=\"akimbo-media-box\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{transferFrom.FirstName + ' ' + transferFrom.LastName}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transferFrom.Username}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/retrieve/search.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/retrieve/search.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-select-grid form-top-label userpicker-results\">\n" +
    "    <label for=\"#\" id=\"userpicker-results-title-template\" style=\"display:none;\">SubAccounts</label>\n" +
    "    <ul class=\"form-select-list-grid\" id=\"userpicker-results-list-template\" style=\"display:none;\">\n" +
    "      <li>\n" +
    "        <div class=\"akimbo-media-box\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\"></h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\"></p>\n" +
    "          </div>\n" +
    "        </div><!-- .akimbo-media-box -->\n" +
    "      </li>\n" +
    "    </ul><!-- .overlay-results-list -->\n" +
    "  </li>\n" +
    "  <li class=\"form-select-grid userpicker-load\" ng-show=\"searchLoading\">\n" +
    "    <label for=\"#\" id=\"userpicker-results-title-template\">Loading...</label>\n" +
    "    <ul class=\"form-select-list-grid\" id=\"userpicker-results-list-template\">\n" +
    "      <li>\n" +
    "        <div class=\"akimbo-media-box\">\n" +
    "          <span class=\"loading-indicator\"></span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small userpicker-no-results-message\" ng-show=\"searchResult.length == 0 && !searchLoading\">\n" +
    "    <label for=\"#\">Tip</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"content\">We didn't find any members that matched. Try searching using a username, email address or phone number.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-select-grid form-top-label userpicker-member-results\" ng-show=\"searchResult.length > 0\">\n" +
    "    <label for=\"#\" style=\"display: table-cell;\">Cards</label>\n" +
    "    <ul class=\"form-select-list-grid\" style=\"display: block;\">\n" +
    "      <li>\n" +
    "        <div\n" +
    "          class=\"akimbo-media-box userpicker-select\"\n" +
    "          ui-sref=\"member.home.subaccount/retrieve.step1(member)\"\n" +
    "          ng-repeat=\"member in searchResult\">\n" +
    "          <div class=\"img-wrap\">\n" +
    "            <img ng-src=\"assets/images/{{brand.name}}/logo-color.svg\" alt=\"\">\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{member.FirstName + ' ' + member.LastName}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{member.Username}}</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/retrieve/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/retrieve/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!overlayForm.Amount.$valid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.number\">Please enter only a number.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.max\">You can only send up to $1,000.</li>\n" +
    "        <li ng-show=\"overlayForm.Amount.$error.required\">Please enter the amount you would like to send.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "        type=\"number\"\n" +
    "        name=\"Amount\"\n" +
    "        class=\"input-small\"\n" +
    "        ng-model=\"formData.Amount\"\n" +
    "        ng-change=\"formatAmountMessage()\"\n" +
    "        required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\" ng-show=\"!amountMessage && !amountValid\">\n" +
    "      <p>Card balance: {{transferFrom.Balance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountMessage && !amountValid\" class=\"content amount-balance-not-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-warning-triangle\"></span>\n" +
    "        <p>{{amountMessage}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"amountValid\" class=\"content amount-balance-enough\">\n" +
    "      <div class=\"alert\">\n" +
    "        <span class=\"icon-thumbs-up\"></span>\n" +
    "        <p>Sweet. You've got enough on your Card.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Destination</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">Your {{brand.programName}} Card</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/retrieve/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/retrieve/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Destination</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">Your {{brand.programName}} Card</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/subaccount/retrieve/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/subaccount/retrieve/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Destination</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"transfer_from\">Your {{brand.programName}} Card</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/transaction/detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/transaction/detail.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Description</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{transaction.Description}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Location</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{transaction.Location}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{transaction.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Time</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{transaction.FormattedDate}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-show=\"transaction.Note\" class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Note</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{transaction.Note}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-show=\"transaction.Photo\" class=\"content-image\">\n" +
    "      <img src=\"{{transaction.Photo}}\"/>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/transaction/side-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/transaction/side-text.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Did you know?</h2>\n" +
    "  <p>Your card may be used everywhere Debit Mastercard<span class=\"x-medium\"><sup style=\"vertical-align:super\">&reg;</sup></span> is accepted.</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/transfers/manage.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/transfers/manage.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-select-grid\" ng-if=\"!hideManageAutoBankLoads\">\n" +
    "    <label for=\"#\" class=\"group-label\">Auto Bank Loads</label>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ui-sref=\"member.home.bank/recurring/edit.step1({transferType: 'load', recurringId: transfer.Id})\" ng-repeat=\"transfer in bankTransfers | filter: {Direction: 'in'}\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-bank-auto in-transaction\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{banks[transfer.BankSerialNo]}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transfer.TransferAmount | akimboCurrency}} ({{transfer.scheduleText}})</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li ui-sref=\"member.home.bank/transfer/recurring.step1({transferType: 'load'})\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-icon-plus sub-list-icon\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title sub-list-title\">Set Up Auto Bank Load</h5>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li class=\"form-select-grid\" ng-if=\"!hideManageAutoSends\">\n" +
    "    <label for=\"#\" class=\"group-label\">Auto Sends</label>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ng-repeat=\"transfer in cardTransfers\" ui-sref=\"member.home.send/recurring/edit.step1({recurringId: transfer.Id})\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-akimbo-send out-transaction\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{transfer.ToFirstName}} {{transfer.ToLastName}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transfer.TransferAmount | akimboCurrency}} ({{transfer.scheduleText}})</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li ui-sref=\"member.home.send/recurring.step1\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-icon-plus sub-list-icon\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title sub-list-title\">Set Up Auto Send</h5>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <li class=\"form-select-grid\" ng-if=\"!hideManageAutoWithdrawals\">\n" +
    "    <label for=\"#\" class=\"group-label\">Auto Withdrawals</label>\n" +
    "    <ul class=\"form\">\n" +
    "      <li ui-sref=\"member.home.bank/recurring/edit.step1({transferType: 'withdraw', recurringId: transfer.Id})\" ng-repeat=\"transfer in bankTransfers | filter: {Direction: 'out'}\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-akimbo-withdraw out-transaction\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title\">{{banks[transfer.BankSerialNo]}}</h5>\n" +
    "            <p class=\"akimbo-media-box-subtitle\">{{transfer.TransferAmount | akimboCurrency}} ({{transfer.scheduleText}})</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li ui-sref=\"member.home.bank/transfer/recurring.step1({transferType: 'withdraw'})\">\n" +
    "        <div class=\"akimbo-media-box form-select\">\n" +
    "          <div class=\"icon-wrap\">\n" +
    "            <span class=\"icon-icon-plus sub-list-icon\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"akimbo-media-box-content\">\n" +
    "            <h5 class=\"akimbo-media-box-title sub-list-title\">Set Up Auto Withdraw</h5>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/upgrade/cip-failure.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/upgrade/cip-failure.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label></label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>We were unable to complete your {{brand.commonProgramName}} upgrade, we'll need you to provide additional\n" +
    "      identifying information. <span class=\"underline\">Please provide us with a copy of a government\n" +
    "      issued Driver's License or Identification Card</span>. If the ID you provide does not have the\n" +
    "      current mailing address as listed on your {{brand.commonProgramName}} account, we'll also need you to\n" +
    "      send us a \"Proof of Address\" in the form of a recent utility bill or bank statement.</p>\n" +
    "      <br>\n" +
    "      <p>We certainly apologize for the inconvenience. If you have any questions about this request,\n" +
    "      please call us at <b class=\"underline\">{{brand.programContactPhone}}</b>, 7am - 7pm Central\n" +
    "      Time, Monday-Friday, or email us at <a href=\"mailto:{{brand.programContactEmail}}\">{{brand.programContactEmail}}</a>.\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/upgrade/header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/upgrade/header.html",
    "<div class=\"overlay-header-form\">\n" +
    "  <div class=\"alert alert-tip js-close-target\">\n" +
    "    <div class=\"alert-wrap\">\n" +
    "      <span class=\"icon-point-down\"></span>\n" +
    "      <div class=\"content\">\n" +
    "        <h1>Upgrade to a reloadable {{brand.commonProgramName}} account.</h1>\n" +
    "        <p>In order to upgrade, we’ll need some additional information from you. Make sure your address is correct, because we’ll be sending you a shiny new <span ng-bind-html=\"brand.fullProgramName\"></span> at no charge. You’ll continue to be able to use any gift cards, and can transfer the gift card balance to your reloadable {{brand.commonProgramName}} account at any time.</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/upgrade/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/upgrade/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.FirstName.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your first name</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"FirstName\">First Name</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.FirstName\"\n" +
    "       name=\"FirstName\"\n" +
    "       tabindex=\"1\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.LastName.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your last name</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"LastName\">Last Name</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.LastName\"\n" +
    "       name=\"LastName\"\n" +
    "       tabindex=\"2\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.StreetAddress.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your street address</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Streetaddress\">Street Address</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.StreetAddress\"\n" +
    "       name=\"StreetAddress\"\n" +
    "       tabindex=\"3\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.SuiteNumber.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your suite number</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"SuiteNumber\">Suite Number</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.SuiteNumber\"\n" +
    "       tabindex=\"4\"\n" +
    "       name=\"SuiteNumber\">\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.City.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your city</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"City\">City</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.City\"\n" +
    "       name=\"City\"\n" +
    "       tabindex=\"5\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.State.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your state</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"State\">State</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.State\"\n" +
    "       name=\"State\"\n" +
    "       tabindex=\"6\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.Zip.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your zip</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"Zip\">Zip</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.Zip\"\n" +
    "       name=\"Zip\"\n" +
    "       tabindex=\"7\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label>{{brand.cards.length > 1 ? \"Select your card style\" : \"Card style\"}}</label>\n" +
    "    <div class=\"card-checkbox\" ng-repeat=\"card in brand.cards track by $index\" ng-init=\"formData.CardDesignId=brand.cards[0]\">\n" +
    "      <label>\n" +
    "        <input class=\"card-checkbox__input\" ng-model=\"formData.CardDesignId\" name=\"cards\" type=\"radio\" checked=\"checked\" value=\"{{card}}\">\n" +
    "        <div class=\"card-checkbox__check\">\n" +
    "          <span class=\"icon-check\"></span>\n" +
    "        </div>\n" +
    "        <img ng-src=\"assets/images/{{brand.name}}/card-{{card}}.png\">\n" +
    "      </label>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/upgrade/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/upgrade/step2.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"(overlayForm.Ssn1.$invalid || overlayForm.Ssn2.$invalid || overlayForm.Ssn3.$invalid ) && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please enter your social security number</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"contact-social-security-number\">\n" +
    "    <label for=\"Ssn1\">Social security number</label>\n" +
    "    <div class=\"social-security-number\">\n" +
    "      <div class=\"col-1-of-3\">\n" +
    "        <input\n" +
    "           tabindex=\"1\"\n" +
    "           name=\"Ssn1\"\n" +
    "           auto-tab-to=\"Ssn2\"\n" +
    "           id=\"Ssn1\"\n" +
    "           type=\"password\"\n" +
    "           pattern=\"\\d*\"\n" +
    "           maxlength=\"3\"\n" +
    "           placeholder=\"XXX\"\n" +
    "           required\n" +
    "           ng-model=\"formData.Ssn1\">\n" +
    "      </div>\n" +
    "      <div class=\"col-1-of-3\">\n" +
    "        <input\n" +
    "           tabindex=\"2\"\n" +
    "           name=\"Ssn2\"\n" +
    "           auto-tab-to=\"Ssn3\"\n" +
    "           id=\"Ssn2\"\n" +
    "           type=\"password\"\n" +
    "           pattern=\"\\d*\"\n" +
    "           maxlength=\"2\"\n" +
    "           placeholder=\"XX\"\n" +
    "           required\n" +
    "           ng-model=\"formData.Ssn2\">\n" +
    "      </div>\n" +
    "      <div class=\"col-1-of-3 col-last\">\n" +
    "        <input\n" +
    "           tabindex=\"3\"\n" +
    "           id=\"Ssn3\"\n" +
    "           name=\"Ssn3\"\n" +
    "           type=\"password\"\n" +
    "           pattern=\"\\d*\"\n" +
    "           maxlength=\"4\"\n" +
    "           placeholder=\"XXXX\"\n" +
    "           required\n" +
    "           ng-model=\"formData.Ssn3\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li \n" +
    "     class=\"akimbo-form-field-error form-error\" \n" +
    "     ng-show=\"(!overlayForm.Dob1.$valid || !overlayForm.Dob2.$valid || !overlayForm.Dob3.$valid) && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"overlayForm.Dob1.$error.required\">Please enter the month of birth</li>\n" +
    "        <li ng-show=\"overlayForm.Dob2.$error.required\">Please enter the day of birth</li>\n" +
    "        <li ng-show=\"overlayForm.Dob3.$error.required\">Please enter the year of birth</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"dash-form\">\n" +
    "    <label for=\"birthDate\">Date of Birth</label>\n" +
    "    <select\n" +
    "       name=\"Dob1\"\n" +
    "       tabindex=\"4\"\n" +
    "       required\n" +
    "       ng-model=\"formData.Dob1\"\n" +
    "       ng-options=\"month for month in range(1, 12)\">\n" +
    "      <option value=\"\" ng-if=\"!formData.Dob1\">Month</option>\n" +
    "    </select>\n" +
    "    <select\n" +
    "       name=\"Dob2\"\n" +
    "       tabindex=\"5\"\n" +
    "       required\n" +
    "       ng-model=\"formData.Dob2\"\n" +
    "       ng-options=\"day for day in range(1,31)\">\n" +
    "      <option value=\"\" ng-if=\"!formData.Dob2\">Day</option>\n" +
    "    </select>\n" +
    "    <select\n" +
    "       name=\"Dob3\"\n" +
    "       tabindex=\"6\"       \n" +
    "       required\n" +
    "       ng-model=\"formData.Dob3\"\n" +
    "       ng-options=\"year for year in range(1900, maxYear, true)\">\n" +
    "      <option value=\"\" ng-if=\"!formData.Dob3\">Year</option>\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.SecurityQuestionOption1.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please choose a securty question</p>\n" +
    "    </div>\n" +
    "  </li>  \n" +
    "  <li class=\"upgrade-select-input\">\n" +
    "    <label>Question</label>\n" +
    "    <select\n" +
    "       name=\"SecurityQuestionOption1\" \n" +
    "       tabindex=\"7\" \n" +
    "       ng-model=\"formData.SecurityQuestionOption1\" \n" +
    "       ng-options=\"q.label for q in questions track by q.key\"\n" +
    "       required>\n" +
    "      <option value=\"\" ng-if=\"!formData.SecurityQuestionOption1\">Choose a question</option>\n" +
    "    </select>\n" +
    "  </li>  \n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.answer1.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please answer securty question</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"answer1\">Answer</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.answer1\"\n" +
    "       name=\"answer1\"\n" +
    "       tabindex=\"8\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.SecurityQuestionOption2.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please choose a securty question</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"upgrade-select-input\">\n" +
    "    <label>Question</label>    \n" +
    "    <select\n" +
    "       name=\"SecurityQuestionOption2\" \n" +
    "       tabindex=\"9\" \n" +
    "       ng-model=\"formData.SecurityQuestionOption2\" \n" +
    "       ng-options=\"q.label for q in questions track by q.key\"\n" +
    "       required>\n" +
    "      <option value=\"\" ng-if=\"!formData.SecurityQuestionOption2\">Choose a question</option>\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.answer2.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please answer securty question</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"answer2\">Answer</label>\n" +
    "    <input\n" +
    "       type=\"text\"\n" +
    "       ng-model=\"formData.answer2\"\n" +
    "       name=\"answer2\"\n" +
    "       tabindex=\"10\"\n" +
    "       required>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"overlayForm.answer2.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please read and check that you agree with the agreement policies.</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small upgrade-tos\">\n" +
    "    <label></label>\n" +
    "    <input\n" +
    "       type=\"checkbox\"\n" +
    "       id=\"terms_and_conditions\"\n" +
    "       class=\"enrollment-checkbox\"\n" +
    "       tabindex=\"11\"\n" +
    "       required\n" +
    "       ng-model=\"formData.Tos\">    \n" +
    "    <div class=\"content\"><p>Check this box if you agree to the <a target=\"_blank\" href=\"{{brand.programLegal.privacy}}\">Privacy Policy</a>, <a target=\"_blank\" href=\"https://akimbocard.com/cardholder-agreement\">Cardholder Agreement</a>, and <a target=\"_blank\" href=\"{{brand.programLegal.disclosure}}\">E-Sign Disclosure</a></p></div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/upgrade/success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/upgrade/success.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label></label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>All done! To view your upgraded account, please click the button below and log in again.</p>\n" +
    "      <a ui-sref=\"logout\" class=\"btn upgrade-btn\">Continue</a>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/venmo/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/venmo/layout.html",
    "<div class=\"overlay-wrapper overlay-active\">\n" +
    "  <div class=\"overlay {{overlay.headerClass}}\" ng-class=\"noSidebar ? 'overlay--no-sidebar' : ''\">\n" +
    "    <div id='close-widget' class=\"overlay-close icon-circle-x overlay-override-close\" ng-controller='overlayCtrl' ng-click=\"back()\"></div>\n" +
    "    <div class=\"overlay-header overlay-background-white-override\">\n" +
    "      <div class=\"overlay-header-main\">\n" +
    "        <svg width=\"105\" height=\"28\" viewBox=\"0 0 105 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
    "          <path d=\"M25.8066 7C26.3526 7.88525 26.5842 8.7853 26.5842 9.92701C26.5842 13.5765 23.4959 18.3135 20.9974 21.6671H15.3108L13 7.79648L18.0018 7.29591L19.2083 17.1595C20.3515 15.3224 21.7458 12.3929 21.7458 10.3906C21.7458 9.313 21.5434 8.55351 21.2509 7.92471L25.8066 7ZM32.305 13.0858C33.2093 13.0858 35.5542 12.6617 35.5542 11.34C35.5542 10.6865 35.0984 10.3511 34.5792 10.3511C33.6407 10.3511 32.4318 11.5076 32.305 13.0858ZM32.2051 15.7194C32.2051 17.3641 33.0826 18.0176 34.2891 18.0176C35.5834 18.0176 36.7876 17.6847 38.4134 16.8636L37.7918 21.0087C36.6608 21.5611 34.8961 21.9359 33.1825 21.9359C28.8535 21.9359 27.2911 19.3023 27.2911 15.9487C27.2911 11.6359 29.8334 7.06165 35.035 7.06165C37.8918 7.06165 39.5176 8.67927 39.5176 10.9553C39.5176 14.5653 34.8693 15.7194 32.2051 15.7465V15.7194ZM53.9549 10.2205C53.9549 10.7851 53.8501 11.5446 53.7891 12.0723L52.2901 21.6671H47.4151L48.7874 12.8565L48.8751 11.8677C48.8751 11.2142 48.4949 11.086 48.0366 11.086C47.3761 11.086 46.7301 11.3819 46.3499 11.5718L44.7874 21.6696H39.9124L42.1232 7.29837H46.3523L46.4132 8.45241C47.4175 7.79895 48.7508 7.03946 50.6033 7.03946C53.0676 7.03946 53.9573 8.35131 53.9573 10.2648L53.9549 10.2205ZM68.4141 8.61762C69.8084 7.6288 71.1051 7.03699 72.9576 7.03699C75.4341 7.03699 76.3092 8.34884 76.3092 10.2624C76.2994 10.8665 76.2483 11.4682 76.1459 12.0748L74.6468 21.6696H69.7718L71.1661 12.6913L71.2441 11.9712C71.2441 11.2537 70.8516 11.086 70.3544 11.086C69.7718 11.086 69.1624 11.3424 68.7286 11.5718L67.1808 21.6696H62.3058L63.7024 12.6641L63.7634 11.9712C63.7634 11.2537 63.3709 11.086 62.8883 11.086C62.2253 11.086 61.6184 11.3819 61.1845 11.5718L59.6611 21.6424H54.7641L56.9969 7.29837H61.1601L61.3259 8.49186C62.3033 7.75949 63.5976 7.03946 65.3502 7.03946C66.9126 7.03946 67.8925 7.69785 68.4117 8.62009L68.4141 8.61762ZM85.9958 12.7899C85.9958 11.6359 85.7033 10.8147 84.8526 10.8147C82.9124 10.8147 82.5199 14.2694 82.5199 16.0153C82.5199 17.3641 82.8734 18.1853 83.7509 18.1853C85.5644 18.1853 85.9958 14.5653 85.9958 12.7899ZM77.5401 15.8082C77.5401 11.2783 79.9557 7.03699 85.3767 7.03699C89.5009 7.03699 91 9.50288 91 12.8959C91 17.3641 88.6624 22 83.0659 22C78.9393 22 77.5401 19.2653 77.5401 15.8082Z\" fill=\"#0070E0\"/>\n" +
    "        </svg>\n" +
    "      </div>\n" +
    "    </div><!-- .overlay-header -->\n" +
    "    <div ui-view=\"header\"></div>\n" +
    "    <!-- .overlay-header-form -->\n" +
    "    <div class=\"overlay-body\">\n" +
    "      <div class=\"overlay-main\">\n" +
    "        <form name=\"overlayForm\" class=\"widget-form\" ng-submit=\"processForm(formData)\">\n" +
    "          <div ui-view=\"step\"></div>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "      <div ui-view=\"side\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"overlay-background\"></div>\n" +
    "</div>\n" +
    "<div ui-view=\"footer\"></div>\n" +
    "<div class=\"overlay-mask\"></div>\n" +
    "");
}]);

angular.module("../app/views/member/venmo/side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/venmo/side-options.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Questions?</h2>\n" +
    "  <p>{{info}}</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/venmo/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/venmo/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"akimbo-form-field-error form-error\" ng-show=\"!formData.recipient && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>Please Enter Destination Account</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li>\n" +
    "    <label class=\"overlay-title-text\" for=\"recipient\">Destination Account</label>\n" +
    "    <div class=\"error-block-top__hint-text input-full\">\n" +
    "      <span>Can be a Venmo email or Venmo phone number</span>\n" +
    "    </div>\n" +
    "    <input\n" +
    "            ng-model=\"formData.recipient\"\n" +
    "            name=\"recipient\"\n" +
    "            id=\"recipient\"\n" +
    "            ng-change=\"clearRecipientError()\"\n" +
    "            value=\"{{formData.recipient}}\">\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\" ng-show=\"recipientMessage && !recipientValid\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>{{recipientMessage}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"overlay-title-text\" for=\"Amount\">Amount</label>\n" +
    "    <div class=\"input\">\n" +
    "      <input\n" +
    "              id=\"Amount\"\n" +
    "              value=\"{{formData.Amount}}\"\n" +
    "              type=\"number\"\n" +
    "              name=\"Amount\"\n" +
    "              ng-model=\"formData.Amount\"\n" +
    "              class=\"input-small\"\n" +
    "              ng-change=\"formatAmountMessage()\"\n" +
    "              required>\n" +
    "    </div>\n" +
    "    <div class=\"content amount-balance\" style=\"display: table-cell;\">\n" +
    "      <p>Balance: {{balance | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small content amount-balance-not-enough\" ng-show=\"amountMessage && !amountValid\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <p>{{amountMessage}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/venmo/step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/venmo/step2.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"address-label\">Recipient</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"address-container\" id=\"transfer_to\">\n" +
    "        {{ formData.recipient }}<br>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label>Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{ formData.Amount | akimboCurrency }}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/venmo/step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/venmo/step3.html",
    "<ul class=\"form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Amount</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"Amount\">{{formData.Amount | akimboCurrency}}</p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"address-label\">Recipient</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"address-container\" id=\"transfer_to\">\n" +
    "        {{ formData.recipient }}<br>\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/virtual/side-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/virtual/side-options.html",
    "<div class=\"overlay-side\">\n" +
    "  <h2>Options</h2>\n" +
    "  <a class=\"btn btn-light btn-full-width large\" ng-click=\"addToWallet()\">\n" +
    "    Add to Digital Wallet\n" +
    "  </a>\n" +
    "  <a class=\"btn btn-light btn-full-width large\" ng-click=\"editAddress()\">\n" +
    "    Edit Address\n" +
    "  </a>\n" +
    "  <p ng-show=\"copySuccess\"><em>Copied!</em></p>\n" +
    "  <p ng-show=\"copyError\"><em>{{copyMsg}}</em></p>\n" +
    "  <br/>\n" +
    "  <div ng-show=\"showDefaultAddress\">\n" +
    "    <h2>Default Address</h2>\n" +
    "    <p>The physical address listed in your profile may be a default address. To make purchases online easier, we recommend updating it to your personal address.</p>\n" +
    "  </div>\n" +
    "  <h2>Cardholder Services</h2>\n" +
    "  <p>{{info}}</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/member/virtual/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/virtual/step1.html",
    "<ul class=\"form js-autoscroll-form\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label class=\"group-label ak-aligned-label\"></label>\n" +
    "    <div class=\"content\">\n" +
    "      <p class=\"content\">\n" +
    "        What's a virtual card, you ask? A virtual card allows you to pay for online purchases without\n" +
    "        having an actual card in your hand. You can use the card number that appears to make online\n" +
    "        purchases.  You can also use your virtual card in stores that support Apple Pay or Google Pay.\n" +
    "        For more information, click Add to Digital Wallet.\n" +
    "      </p>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/wallet/apple.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/wallet/apple.html",
    "<ul class=\"form view-virtual\" ng-hide=\"hideCardInfo\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Card Number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"cardNumber\">{{cardNumber | creditCardFilter}}</p>\n" +
    "      <button\n" +
    "        class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "        ngclipboard\n" +
    "        ngclipboard-success=\"copySuccess(e);\"\n" +
    "        data-clipboard-text=\"{{cardNumber}}\"\n" +
    "        >\n" +
    "        <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "        <span class=\"icon-copy\"></span>\n" +
    "        <p ng-show=\"copiedText === cardNumber\"><em>Copied!</em></p>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Expiration Date</label>\n" +
    "    <div class=\"content\">\n" +
    "     <p>{{expDate | expFilter}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{expDate}}\"\n" +
    "        >\n" +
    "          <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === expDate\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">CVV Code</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{cvv}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{cvv}}\"\n" +
    "        >\n" +
    "          <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === cvv\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Zipcode</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{address.PostalCode}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{address.PostalCode}}\"\n" +
    "        >\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === address.PostalCode\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<ul class=\"form digital-wallet\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 1: Open the Wallet app on your iPhone and tap the add button.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 2: Tap Continue, then tap Enter Card Details Manually.</div>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 3: Enter your card information and tap Next.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 4: Enter the requested information.</div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/wallet/google.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/wallet/google.html",
    "<ul class=\"form view-virtual\" ng-hide=\"hideCardInfo\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Card Number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"cardNumber\">{{cardNumber | creditCardFilter}}</p>\n" +
    "      <button\n" +
    "        class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "        ngclipboard\n" +
    "        ngclipboard-success=\"copySuccess(e);\"\n" +
    "        data-clipboard-text=\"{{cardNumber}}\"\n" +
    "        >\n" +
    "        <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "        <span class=\"icon-copy\"></span>\n" +
    "        <p ng-show=\"copiedText === cardNumber\"><em>Copied!</em></p>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Expiration Date</label>\n" +
    "    <div class=\"content\">\n" +
    "     <p>{{expDate | expFilter}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{expDate}}\"\n" +
    "        >\n" +
    "          <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === expDate\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">CVV Code</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{cvv}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{cvv}}\"\n" +
    "        >\n" +
    "          <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === cvv\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Zipcode</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{address.PostalCode}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{address.PostalCode}}\"\n" +
    "        >\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === address.PostalCode\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<ul class=\"form digital-wallet\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 1: Open the Google Pay app.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 2: At the bottom, tap Payment.</div>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 3: At the bottom, tap the Add button and then Credit or debit card.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 4: Enter your card information.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 5: If you’re asked to verify your payment method, choose an option from the list.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 6: Find and enter the verification code.</div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/wallet/samsung.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/wallet/samsung.html",
    "<ul class=\"form view-virtual\" ng-hide=\"hideCardInfo\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Card Number</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p id=\"cardNumber\">{{cardNumber | creditCardFilter}}</p>\n" +
    "      <button\n" +
    "        class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "        ngclipboard\n" +
    "        ngclipboard-success=\"copySuccess(e);\"\n" +
    "        data-clipboard-text=\"{{cardNumber}}\"\n" +
    "        >\n" +
    "        <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "        <span class=\"icon-copy\"></span>\n" +
    "        <p ng-show=\"copiedText === cardNumber\"><em>Copied!</em></p>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Expiration Date</label>\n" +
    "    <div class=\"content\">\n" +
    "     <p>{{expDate | expFilter}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{expDate}}\"\n" +
    "        >\n" +
    "          <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === expDate\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">CVV Code</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{cvv}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{cvv}}\"\n" +
    "        >\n" +
    "          <span class=\"tooltip\">Copy to Clipboard</span>\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === cvv\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <label for=\"#\">Zipcode</label>\n" +
    "    <div class=\"content\">\n" +
    "      <p>{{address.PostalCode}}</p>\n" +
    "      <button\n" +
    "          class=\"tooltip-wrap copy-to-clipboard\"\n" +
    "          ngclipboard\n" +
    "          ngclipboard-success=\"copySuccess(e);\"\n" +
    "          data-clipboard-text=\"{{address.PostalCode}}\"\n" +
    "        >\n" +
    "          <span class=\"icon-copy\"></span>\n" +
    "          <p ng-show=\"copiedText === address.PostalCode\"><em>Copied!</em></p>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<ul class=\"form digital-wallet\">\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 1: Navigate to and open Samsung Pay on your phone.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 2: Tap Menu in the top left corner, and then tap Cards.</div>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 3: Next, tap Add card (blue +card icon), and then tap Add credit/debit card.</div>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small\">\n" +
    "    <div>Step 4: Follow the on-screen instructions to register your card.</div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/member/wallet/step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/member/wallet/step1.html",
    "<ul class=\"form digital-wallet\">\n" +
    "  <li class=\"form-with-content-small device-select\">\n" +
    "    <label>Apple Pay</label>\n" +
    "    <a class=\"btn btn-light large tooltip-wrap\" ng-click=\"go('member.home.profile/wallet.apple')\">\n" +
    "      Apple Pay\n" +
    "      <span class=\"tooltip\">Click here for steps to add your card to your digital wallet</span>\n" +
    "    </a>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small device-select\" >\n" +
    "    <label>Google Pay</label>\n" +
    "    <a class=\"btn btn-light large tooltip-wrap\" ng-click=\"go('member.home.profile/wallet.google')\">\n" +
    "      Google Pay\n" +
    "      <span class=\"tooltip\">Click here for steps to add your card to your digital wallet</span>\n" +
    "    </a>\n" +
    "  </li>\n" +
    "  <li class=\"form-with-content-small device-select\">\n" +
    "    <label>Samsung Pay</label>\n" +
    "    <a class=\"btn btn-light large tooltip-wrap\" ng-click=\"go('member.home.profile/wallet.samsung')\">\n" +
    "      Samsung Pay\n" +
    "      <span class=\"tooltip\">Click here for steps to add your card to your digital wallet</span>\n" +
    "    </a>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../app/views/mobile-id/mobile-id-collect.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/mobile-id/mobile-id-collect.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "          <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "           \"has-success\": joinForm.firstName.$valid,\n" +
    "           \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "           \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "          <label for=\"firstName\">Your First Name</label>\n" +
    "          <input\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"firstName\"\n" +
    "             pattern=\"[A-Za-z ]+\"\n" +
    "             id=\"firstName\"\n" +
    "             tabindex=\"1\"\n" +
    "             ng-model=\"formData.firstName\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.firstName.hasFocus=true'\n" +
    "             ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "           \"has-success\": joinForm.lastName.$valid,\n" +
    "           \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "           \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "          <label for=\"lastName\">Your Last Name</label>\n" +
    "          <input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"lastName\"\n" +
    "             pattern=\"[A-Za-z ]+\"\n" +
    "             id=\"lastName\"\n" +
    "             tabindex=\"2\"\n" +
    "             ng-model=\"formData.lastName\"\n" +
    "             required\n" +
    "             ng-focus='joinForm.lastName.hasFocus=true'\n" +
    "             ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.email.$error.required && submitted\">Please provide a valid email</span>\n" +
    "          <span ng-show=\"joinForm.email.$error.pattern\">We're sorry but accented and special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.email.hasFocus,\n" +
    "           \"has-success\": joinForm.email.$valid,\n" +
    "           \"has-error\": joinForm.email.$invalid && (form.$submitted || joinForm.email.$touched),\n" +
    "           \"is-empty\": !joinForm.email.$viewValue }'>\n" +
    "          <label for=\"email\">Email</label>\n" +
    "          <input\n" +
    "             class=\"radius-all\"\n" +
    "             type=\"text\"\n" +
    "             name=\"email\"\n" +
    "             pattern=\"[A-Za-z0-9.@_+-]+\"\n" +
    "             id=\"email\"\n" +
    "             tabindex=\"3\"\n" +
    "             autocomplete=\"new-password\"\n" +
    "             ng-model=\"formData.email\"\n" +
    "             ng-focus='joinForm.email.hasFocus=true'\n" +
    "             ng-blur='joinForm.email.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-2-3\">\n" +
    "          <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-3\">\n" +
    "          <span ng-show=\"joinForm.phone.$invalid && submitted\">Required phone number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "           \"has-success\": joinForm.password.$valid,\n" +
    "           \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "           \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "          <label for=\"password\">Password</label>\n" +
    "          <input\n" +
    "             class=\"radius-left\"\n" +
    "             name=\"password\"\n" +
    "             id=\"password\"\n" +
    "             tabindex=\"4\"\n" +
    "             required\n" +
    "             autocomplete=\"new-password\"\n" +
    "             validate-password\n" +
    "             type=\"{{passwordInputType}}\"\n" +
    "             ng-model=\"formData.password\"\n" +
    "             ng-focus='joinForm.password.hasFocus=true'\n" +
    "             ng-blur='joinForm.password.hasFocus=false'>\n" +
    "          <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Password</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "           ng-class='{ \"has-focus\": joinForm.phone.hasFocus,\n" +
    "           \"has-success\": joinForm.phone.$valid,\n" +
    "           \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "           \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "          <label for=\"phone\">Mobile Phone</label>\n" +
    "          <input\n" +
    "            id=\"phone\"\n" +
    "            name=\"phone\"\n" +
    "            class=\"radius-right\"\n" +
    "            type=\"tel\"\n" +
    "            tabindex=\"5\"\n" +
    "            required\n" +
    "            clean=\"true\"\n" +
    "            minlength=\"10\"\n" +
    "            maxlength=\"15\"\n" +
    "            ng-change=\"formatPhone()\"\n" +
    "            ak-input-only-phone\n" +
    "            ng-model-options=\"{ allowInvalid: true }\"\n" +
    "            ng-model=\"formData.phone\"\n" +
    "            ng-focus='joinForm.phone.hasFocus=true'\n" +
    "            ng-blur='joinForm.phone.hasFocus=false'>\n" +
    "          <div\n" +
    "            class=\"form-group__feedback\"\n" +
    "            ak-format-foreign-phone-number=\"formData.phone\">\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <br>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"checkbox-item\" ng-click=\"formData.eSign = !formData.eSign\">\n" +
    "          <div id=\"eSignBox\" class=\"checkbox-item__box\" ng-class=\"formData.eSign ? '' : 'checkbox-item__box--disabled'\">\n" +
    "            <span class=\"checkbox-item__icon\" ng-class=\"formData.eSign ? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "              class=\"checkbox-item__input\"\n" +
    "              type=\"checkbox\"\n" +
    "              name=\"eSign\"\n" +
    "              id=\"eSign\"\n" +
    "              ng-model=\"formData.eSign\"\n" +
    "              tabindex=\"6\"\n" +
    "              required>\n" +
    "            <p class=\"checkbox-item__text checkbox-item__text--small\">\n" +
    "              Check this box if you agree to the\n" +
    "              <a target=\"_blank\" href=\"{{brand.programLegal.disclosure}}\">E-Sign Disclosure</a>\n" +
    "            </p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"checkbox-item\"\n" +
    "             ng-click=\"formData.Tos = !formData.Tos\">\n" +
    "          <div id=\"tosBox\" class=\"checkbox-item__box\"\n" +
    "               ng-class=\"formData.Tos ? '' : 'checkbox-item__box--disabled'\">\n" +
    "            <span class=\"checkbox-item__icon\"\n" +
    "                  ng-class=\"formData.Tos ? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "                    class=\"checkbox-item__input\"\n" +
    "                    type=\"checkbox\"\n" +
    "                    name=\"terms_and_conditions\"\n" +
    "                    id=\"terms_and_conditions\"\n" +
    "                    ng-model=\"formData.Tos\"\n" +
    "                    tabindex=\"7\"\n" +
    "                    required>\n" +
    "            <p class=\"checkbox-item__text checkbox-item__text--small\">\n" +
    "              Check this box if you agree to the\n" +
    "              <a target=\"_blank\" href=\"{{brand.programLegal.privacy}}\">Privacy Policy</a>\n" +
    "              and <a target=\"_blank\" href=\"{{brand.programLegal.agreement}}\">Cardholder Agreement</a>\n" +
    "            </p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li ng-hide=\"disableText\" class=\"floatingForm-li\">\n" +
    "        <div class=\"checkbox-item\"\n" +
    "             ng-click=\"formData.textAlerts = !formData.textAlerts\">\n" +
    "          <div class=\"checkbox-item__box\"\n" +
    "               ng-class=\"formData.textAlerts ? '' : 'checkbox-item__box--disabled'\">\n" +
    "            <span class=\"checkbox-item__icon\"\n" +
    "                  ng-class=\"formData.textAlerts ? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "                    class=\"checkbox-item__input\"\n" +
    "                    type=\"checkbox\"\n" +
    "                    name=\"textAlerts\"\n" +
    "                    ng-model=\"formData.textAlerts\"\n" +
    "                    tabindex=\"8\">\n" +
    "            <p class=\"checkbox-item__text checkbox-item__text--small\">Enroll in text alerts. Receive real-time purchase alerts with balance and transaction information.*</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    <span ng-show=\"(joinForm.terms_and_conditions.$error.required || joinForm.eSign.$error.required) && submitted\">\n" +
    "      <br/><br/>\n" +
    "      <span class=\"underline\">Please read and check that you agree with the agreement policies.</span>\n" +
    "      <br/><br/>\n" +
    "      If you have any questions, please contact us at {{brand.programContactPhone}} or email us at {{brand.programContactEmail}}\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right collect-slide-img\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gift-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "      <span class=\"loading-indicator\"></span>\n" +
    "      <p>Processing</p>\n" +
    "  </div>\n" +
    "  <a ng-hide=\"loading\" id=\"finishBtn\" class=\"btn btn--float-right\" ng-click=\"attemptSubmission(joinForm)\">FINISH</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/mobile-id/mobile-id-success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/mobile-id/mobile-id-success.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "</div>\n" +
    "<div class=\"overlay-wrapper\">\n" +
    "  <div class=\"overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/mobile-id/mobile-id.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/mobile-id/mobile-id.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "  <button class=\"btn btn-small btn--float-right\" ng-click=\"makeAuthorizeRequest()\">Start Mobile ID</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/register/esign-disclosure.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/register/esign-disclosure.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\" ng-controller=\"esignDisclosureCtrl as vm\">\n" +
    "\n" +
    "    <!-- E-Sign Disclosure Section -->\n" +
    "    <div ng-if=\"vm.section1\">\n" +
    "        <h3 class=\"exMarginBtm\">Read the E-Sign Disclosure below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the E-Sign Disclosure.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcDisclosure) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.eSignDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.eSignErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-esign\" class=\"btn btn-register\" ng-click=\"vm.section1 = false; vm.section2 = true; vm.eSignAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.eSignAgreed\">\n" +
    "        <h3 class=\"exMarginBtm\">E-Sign Disclosure Document</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to E-Sign Disclosure\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcDisclosureDownload, 'E-Sign_Disclosure.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Cardholder Agreement Section -->\n" +
    "    <div ng-if=\"vm.section2\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Cardholder Agreement below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Cardholder Agreement.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcAgreement) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.cardholderAgreementDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.cardholderAgreementErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-agreement\" class=\"btn btn-register\" ng-click=\"vm.section2 = false; vm.section3 = true; vm.disclosureAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.disclosureAgreed\" style=\"padding-top: 60px\">\n" +
    "        <h3 class=\"exMarginBtm\">Cardholder Agreement Document</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to Cardholder Agreement Document\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcAgreementDownload, 'Cardholder_Agreement.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Privacy Policy Section -->\n" +
    "    <div ng-if=\"vm.section3\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Sunrise Banks Privacy Policy below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Sunrise Banks Privacy Policy.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcPrivacyDownload, 'Sunrise_Banks_Privacy_Policy.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                ng-src=\"{{ vm.trustSrc(vm.pdfGDSrcPrivacy) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\"\n" +
    "        >\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.privacyPolicyDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.privacyPolicyErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-privacypolicy\" class=\"btn btn-register\" ng-click=\"vm.section3 = false; vm.section4 = true; vm.privacyAgreed = true;\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.privacyAgreed\" style=\"padding-top: 60px\">\n" +
    "        <h3 class=\"exMarginBtm\">Sunrise Bank's Privacy Policy</h3>\n" +
    "        <div class=\"modern-widget-info-top-checked\">\n" +
    "            <div class=\"check-alignment-with-text\">\n" +
    "                <div style=\"font-size: 24px; padding-right: 6px;\">\n" +
    "                    <span class=\"icon-check check check-dark-gray\"></span>\n" +
    "                </div>\n" +
    "                Agreed to the Sunrise Bank's Privacy Policy\n" +
    "            </div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.pdfGDSrcPrivacyDownload, 'Sunrise_Banks_Privacy_Policy.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <div class=\"modern-widget-info-bottom-checked\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Fee Schedule Section -->\n" +
    "    <div ng-if=\"vm.section4\">\n" +
    "        <h3 class=\"exMarginBtm exMarginTop\">Read the Fees Schedule below</h3>\n" +
    "        <div class=\"modern-widget-info-top\">\n" +
    "            <div>Press the button below the document to agree to the Fees Schedule.</div>\n" +
    "            <a ng-click=\"vm.downloadFile(vm.feesScheduleDownload, 'Fee_Schedule.pdf')\" class=\"downloadBtn\">Download</a>\n" +
    "        </div>\n" +
    "        <iframe\n" +
    "                src=\"{{ vm.trustSrc(vm.feesSchedule) }}\"\n" +
    "                width=\"100%\"\n" +
    "                height=\"400px\"\n" +
    "                style=\"border: solid 1px #EBEBEB\">\n" +
    "        </iframe>\n" +
    "        <div class=\"modern-widget-section bg-white modern-form-section modern-widget-info-bottom\">\n" +
    "            <span ng-show=\"!$scope.cardholderAgreementDocument && $scope.nextClicked\">\n" +
    "                {{ $scope.cardholderAgreementErrorMessage }}\n" +
    "            </span>\n" +
    "            <a id=\"btn-fees\" class=\"btn btn-register\" ng-click=\"vm.Finish('root.register.step2')\">Agree & Continue</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/register/fee-schedule.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/register/fee-schedule.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <p>\n" +
    "    <a target=\"_blank\" ng-href=\"{{ feeSchedule.pdfSrc }}\">Download the Fee Schedule.</a>\n" +
    "  </p>\n" +
    "  <br/>\n" +
    "  <iframe\n" +
    "    src=\"{{ feeSchedule.trustSrc(feeSchedule.pdfSrc + '#toolbar=0') }}\"\n" +
    "    width=\"100%\"\n" +
    "    height=\"600px\"\n" +
    "    style=\"border: none;\">\n" +
    "  </iframe>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <a id=\"btn-fee-schedule\" class=\"btn btn-register\" ng-click=\"feeSchedule.goTo('root.register.step2')\">Next</a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/register/register-step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/register/register-step1.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.email.$error.required && submitted\">Please provide an email</span>\n" +
    "          <span ng-show=\"joinForm.email.$error.email && submitted\">Please provide a valid email</span>\n" +
    "          <span ng-show=\"joinForm.email.$error.pattern\">We're sorry but accented and special characters may not be used</span>\n" +
    "          <span ng-show=\"joinForm.email.$error.unique\">Please provide a unique email</span>\n" +
    "          <span ng-show=\"joinForm.email.networkError\">Network Error - {{joinForm.email.networkError}}</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-full\"\n" +
    "          ng-class='{ \"has-focus\": joinForm.email.hasFocus,\n" +
    "          \"has-success\": joinForm.email.$valid,\n" +
    "          \"has-error\": joinForm.email.$invalid && (form.$submitted || joinForm.email.$touched),\n" +
    "          \"is-empty\": !joinForm.email.$viewValue }'>\n" +
    "            <label for=\"email\">Email</label>\n" +
    "            <input\n" +
    "              class=\"radius-all\"\n" +
    "              type=\"email\"\n" +
    "              name=\"email\"\n" +
    "              id=\"email\"\n" +
    "              tabindex=\"1\"\n" +
    "              ng-model=\"formData.email\"\n" +
    "              required\n" +
    "              pattern=\"[A-Za-z0-9.@_+-]+\"\n" +
    "              ng-blur=\"checkEmail(formData.email)\"\n" +
    "              ng-focus='joinForm.email.hasFocus=true'\n" +
    "              ng-blur='joinForm.email.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.phone.$invalid && submitted\">Please provide a valid mobile phone number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-full\"\n" +
    "          ng-class='{ \"has-focus\": joinForm.phone.hasFocus,\n" +
    "          \"has-success\": joinForm.phone.$valid,\n" +
    "          \"has-error\": joinForm.phone.$invalid && (form.$submitted || joinForm.phone.$touched),\n" +
    "          \"is-empty\": !joinForm.phone.$viewValue }'>\n" +
    "            <label for=\"phone\">Mobile Phone</label>\n" +
    "            <input\n" +
    "              id=\"phone\"\n" +
    "              name=\"phone\"\n" +
    "              class=\"radius-all\"\n" +
    "              type=\"tel\"\n" +
    "              tabindex=\"2\"\n" +
    "              required\n" +
    "              clean=\"true\"\n" +
    "              minlength=\"10\"\n" +
    "              maxlength=\"10\"\n" +
    "              ak-input-only-numbers\n" +
    "              ng-model-options=\"{ allowInvalid: true }\"\n" +
    "              ng-model=\"formData.phone\"\n" +
    "              ng-focus='joinForm.phone.hasFocus=true'\n" +
    "              ng-blur='joinForm.phone.hasFocus=false'>\n" +
    "          <div class=\"form-group__feedback\" ak-format-phone-number=\"formData.phone\"></div>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\" ng-if=\"registrationVersion == 'CardID'\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.CardID.$error.required && submitted\">Please provide a Card ID</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-full\"\n" +
    "          ng-class='{ \"has-focus\": joinForm.CardID.hasFocus,\n" +
    "          \"has-success\": joinForm.CardID.$valid,\n" +
    "          \"has-error\": joinForm.CardID.$invalid && (form.$submitted || joinForm.CardID.$touched),\n" +
    "          \"is-empty\": !joinForm.CardID.$viewValue }'>\n" +
    "            <label for=\"CardID\">Card ID</label>\n" +
    "            <input\n" +
    "              id=\"CardID\"\n" +
    "              name=\"CardID\"\n" +
    "              class=\"radius-all\"\n" +
    "              type=\"text\"\n" +
    "              tabindex=\"3\"\n" +
    "              ng-model=\"formData.CardID\"\n" +
    "              required\n" +
    "              clean=\"true\"\n" +
    "              ng-focus='joinForm.CardID.hasFocus=true'\n" +
    "              ng-blur='joinForm.CardID.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\" ng-if=\"registrationVersion !== 'CardID'\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.number.$invalid && submitted\">Please enter a valid card number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.exp.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.cvv.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-half\"\n" +
    "          ng-class='{ \"has-focus\": joinForm.number.hasFocus,\n" +
    "          \"has-success\": joinForm.number.$valid,\n" +
    "          \"has-error\": joinForm.number.$invalid && (form.$submitted || joinForm.number.$touched),\n" +
    "          \"is-empty\": !joinForm.number.$viewValue }'>\n" +
    "            <label for=\"number\">Card Number</label>\n" +
    "            <input\n" +
    "              id=\"number\"\n" +
    "              name=\"number\"\n" +
    "              class=\"radius-left\"\n" +
    "              type=\"text\"\n" +
    "              tabindex=\"4\"\n" +
    "              ng-model=\"formData.cardNumber\"\n" +
    "              mask=\"9999-9999-9999-9999\"\n" +
    "              required\n" +
    "              clean=\"true\"\n" +
    "              ng-focus='joinForm.number.hasFocus=true'\n" +
    "              ng-blur='joinForm.number.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-1-4\"\n" +
    "          ng-class='{ \"has-focus\": joinForm.exp.hasFocus,\n" +
    "          \"has-success\": joinForm.exp.$valid,\n" +
    "          \"has-error\": joinForm.exp.$invalid && (form.$submitted || joinForm.exp.$touched),\n" +
    "          \"is-empty\": !joinForm.exp.$viewValue }'>\n" +
    "          <label for=\"exp\">MM/YY</label>\n" +
    "          <input\n" +
    "            id=\"exp\"\n" +
    "            name=\"exp\"\n" +
    "            class=\"radius-none\"\n" +
    "            type=\"text\"\n" +
    "            tabindex=\"5\"\n" +
    "            ng-model=\"formData.exp\"\n" +
    "            exp-input-helper\n" +
    "            mask=\"99/99\"\n" +
    "            required\n" +
    "            ng-focus='joinForm.exp.hasFocus=true'\n" +
    "            ng-blur='joinForm.exp.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "          class=\"form-group input-1-4\"\n" +
    "          ng-class='{ \"has-focus\": joinForm.cvv.hasFocus,\n" +
    "          \"has-success\": joinForm.cvv.$valid,\n" +
    "          \"has-error\": joinForm.cvv.$invalid && (form.$submitted || joinForm.cvv.$touched),\n" +
    "          \"is-empty\": !joinForm.cvv.$viewValue }'>\n" +
    "            <label for=\"cvv\">CVV</label>\n" +
    "            <input\n" +
    "              id=\"cvv\"\n" +
    "              name=\"cvv\"\n" +
    "              class=\"radius-right\"\n" +
    "              type=\"text\"\n" +
    "              tabindex=\"6\"\n" +
    "              ng-model=\"formData.cvv\"\n" +
    "              required\n" +
    "              ng-focus='joinForm.cvv.hasFocus=true'\n" +
    "              ng-blur='joinForm.cvv.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <br>\n" +
    "      <text-alerts-checkbox form-data=\"formData\"/>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right\">\n" +
    "    <img alt=\"\" ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <span class=\"error-shown-hand\" ng-show=\"submitted\">\n" +
    "    <span id=\"akimbo-form-error-message\">Oops, something is wrong</span>\n" +
    "    <span class=\"icon-point-up\"></span>\n" +
    "  </span>\n" +
    "  <a class=\"btn btn-register\" ng-click=\"attemptNextStep(joinForm, 'root.register.esignDisclosure')\">Next</a>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/selectVerificationMethod.html'\"></div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/register/register-step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/register/register-step2.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.firstName.$error.required && submitted\">Please provide your first name</span>\n" +
    "          <span ng-show=\"joinForm.firstName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.lastName.$error.required && submitted\">Please provide your last name</span>\n" +
    "          <span ng-show=\"joinForm.lastName.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.firstName.hasFocus,\n" +
    "					 \"has-success\": joinForm.firstName.$valid,\n" +
    "					 \"has-error\": joinForm.firstName.$invalid && (form.$submitted || joinForm.firstName.$touched),\n" +
    "					 \"is-empty\": !joinForm.firstName.$viewValue }'>\n" +
    "					<label for=\"firstName\">Your First Name</label>\n" +
    "					<input\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"firstName\"\n" +
    "             pattern=\"[A-Za-z ]+\"\n" +
    "             tabindex=\"1\"\n" +
    "             ng-model=\"formData.firstName\"\n" +
    "             required\n" +
    "						 ng-focus='joinForm.firstName.hasFocus=true',\n" +
    "             ng-blur='joinForm.firstName.hasFocus=false'>\n" +
    "				</div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.lastName.hasFocus,\n" +
    "					 \"has-success\": joinForm.lastName.$valid,\n" +
    "					 \"has-error\": joinForm.lastName.$invalid && (form.$submitted || joinForm.lastName.$touched),\n" +
    "					 \"is-empty\": !joinForm.lastName.$viewValue }'>\n" +
    "					<label for=\"lastName\">Your Last Name</label>\n" +
    "					<input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"lastName\"\n" +
    "             tabindex=\"2\"\n" +
    "             pattern=\"[A-Za-z ]+\"\n" +
    "             ng-model=\"formData.lastName\"\n" +
    "             required\n" +
    "						 ng-focus='joinForm.lastName.hasFocus=true',\n" +
    "             ng-blur='joinForm.lastName.hasFocus=false'>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-3-4\">\n" +
    "          <span ng-show=\"joinForm.address.$error.required && submitted\">Please provide your address</span>\n" +
    "          <span ng-show=\"joinForm.address.$invalid && !joinForm.address.$error.required && submitted\">Oops, we do not accept PO box's</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-3-4\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.address.hasFocus,\n" +
    "					 \"has-success\": joinForm.address.$valid,\n" +
    "					 \"has-error\": joinForm.address.$invalid && (form.$submitted || joinForm.address.$touched),\n" +
    "					 \"is-empty\": !joinForm.address.$viewValue }'>\n" +
    "					<label for=\"address\">Street Address</label>\n" +
    "					<input\n" +
    "             id=\"address\"\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"address\"\n" +
    "             tabindex=\"3\"\n" +
    "             ng-model=\"formData.address\"\n" +
    "             required\n" +
    "             validate-po-box\n" +
    "						 ng-focus='joinForm.address.hasFocus=true',\n" +
    "             ng-blur='joinForm.address.hasFocus=false'>\n" +
    "				</div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.address2.hasFocus,\n" +
    "					 \"has-success\": joinForm.address2.$valid,\n" +
    "					 \"has-error\": joinForm.address2.$invalid && (form.$submitted || joinForm.address2.$touched),\n" +
    "					 \"is-empty\": !joinForm.address2.$viewValue }'>\n" +
    "					<label for=\"address2\">Apt No.</label>\n" +
    "					<input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"address2\"\n" +
    "             tabindex=\"4\"\n" +
    "             ng-model=\"formData.address2\"\n" +
    "						 ng-focus='joinForm.address2.hasFocus=true',\n" +
    "             ng-blur='joinForm.address2.hasFocus=false'>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.city.$error.required && submitted\">Please provide your city</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.state.$error.required && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-1-4\">\n" +
    "          <span ng-show=\"joinForm.zip.$invalid && submitted\">Required</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.city.hasFocus,\n" +
    "					 \"has-success\": joinForm.city.$valid,\n" +
    "					 \"has-error\": joinForm.city.$invalid && (form.$submitted || joinForm.city.$touched),\n" +
    "					 \"is-empty\": !joinForm.city.$viewValue }'>\n" +
    "					<label for=\"city\">City</label>\n" +
    "					<input\n" +
    "             class=\"radius-left\"\n" +
    "             type=\"text\"\n" +
    "             name=\"city\"\n" +
    "             tabindex=\"5\"\n" +
    "             ng-model=\"formData.city\"\n" +
    "             required\n" +
    "						 ng-focus='joinForm.city.hasFocus=true',\n" +
    "             ng-blur='joinForm.city.hasFocus=false'>\n" +
    "				</div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.state.hasFocus,\n" +
    "					 \"has-success\": joinForm.state.$valid,\n" +
    "					 \"has-error\": joinForm.state.$invalid && (form.$submitted || joinForm.state.$touched),\n" +
    "					 \"is-empty\": !joinForm.state.$viewValue }'>\n" +
    "					<label for=\"state\">State</label>\n" +
    "					<input\n" +
    "             class=\"radius-none\"\n" +
    "             type=\"text\"\n" +
    "             name=\"state\"\n" +
    "             tabindex=\"6\"\n" +
    "             required\n" +
    "             max=\"2\"\n" +
    "             maxlength=\"2\"\n" +
    "             ng-maxlength=\"2\"\n" +
    "             ng-model=\"formData.state\"\n" +
    "						 ng-focus='joinForm.state.hasFocus=true',\n" +
    "             ng-blur='joinForm.state.hasFocus=false'>\n" +
    "				</div>\n" +
    "        <div\n" +
    "           class=\"form-group input-1-4\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.zip.hasFocus,\n" +
    "					 \"has-success\": joinForm.zip.$valid,\n" +
    "					 \"has-error\": joinForm.zip.$invalid && (form.$submitted || joinForm.zip.$touched),\n" +
    "					 \"is-empty\": !joinForm.zip.$viewValue }'>\n" +
    "					<label for=\"zip\">Zip</label>\n" +
    "					<input\n" +
    "             class=\"radius-right\"\n" +
    "             type=\"text\"\n" +
    "             name=\"zip\"\n" +
    "             tabindex=\"7\"\n" +
    "             required\n" +
    "             min=\"5\"\n" +
    "             minlength=\"5\"\n" +
    "             ng-minlength=\"5\"\n" +
    "             ngMinlength=\"5\"\n" +
    "             ng-model=\"formData.zip\"\n" +
    "						 ng-focus='joinForm.zip.hasFocus=true',\n" +
    "             ng-blur='joinForm.zip.hasFocus=false'>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "      <li class=\"birth-date floatingForm-li\" ng-if=\"validation.requiresKyc\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"(joinForm.dob1.$error.required || joinForm.dob2.$error.required || joinForm.dob3.$error.required) && submitted\">Please enter your full birthday</span>\n" +
    "        </div>\n" +
    "        <div class=\"input-1-3\">\n" +
    "          <select\n" +
    "             id=\"birthDat1\"\n" +
    "             class=\"radius-left\"\n" +
    "             tabindex=\"9\"\n" +
    "             name=\"dob1\"\n" +
    "             ng-model=\"formData.Dob1\"\n" +
    "             required\n" +
    "             ng-options=\"month for month in range(1, 12)\">\n" +
    "            <option value=\"\" ng-if=\"!formData.Dob1\">Birth Month</option>\n" +
    "          </select>\n" +
    "        </div>\n" +
    "        <div class=\"input-1-3\">\n" +
    "          <select\n" +
    "             id=\"birthDate2\"\n" +
    "             class=\"radius-none\"\n" +
    "             tabindex=\"10\"\n" +
    "             name=\"dob2\"\n" +
    "             required\n" +
    "             ng-model=\"formData.Dob2\"\n" +
    "             ng-options=\"day for day in range(1,31)\">\n" +
    "            <option value=\"\" ng-if=\"!formData.Dob2\">Birth Day</option>\n" +
    "          </select>\n" +
    "        </div>\n" +
    "        <div class=\"input-1-3\">\n" +
    "          <select\n" +
    "             id=\"birthDate3\"\n" +
    "             class=\"radius-right\"\n" +
    "             tabindex=\"11\"\n" +
    "             name=\"dob3\"\n" +
    "             required\n" +
    "             ng-model=\"formData.Dob3\"\n" +
    "             ng-options=\"year for year in range(1900, latestAgeYear, true)\">\n" +
    "            <option value=\"\" ng-if=\"!formData.Dob3\">Birth Year</option>\n" +
    "          </select>\n" +
    "        </div>\n" +
    "        <a class=\"info\" ng-click=\"showAlert('Please provide your date of birth. Your date of birth is requested to help validate your identity and for verification purposes when you contact us.')\"></a>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\" ng-if=\"validation.requiresKyc\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.ssn.$invalid && submitted\">Please enter a valid Social Security Number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.ssn.hasFocus,\n" +
    "					 \"has-success\": joinForm.ssn.$valid,\n" +
    "					 \"has-error\": joinForm.ssn.$invalid && (form.$submitted || joinForm.ssn.$touched),\n" +
    "					 \"is-empty\": !joinForm.ssn.$viewValue }'>\n" +
    "					<label for=\"ssn\">Social Security Number</label>\n" +
    "					<input\n" +
    "             id=\"ssn\"\n" +
    "             name=\"ssn\"\n" +
    "             class=\"radius-all\"\n" +
    "             type=\"{{ssnInputType}}\"\n" +
    "             tabindex=\"12\"\n" +
    "             ng-model=\"formData.Ssn\"\n" +
    "             mask=\"999-99-9999\"\n" +
    "             clean=\"true\"\n" +
    "             required\n" +
    "						 ng-focus='joinForm.ssn.hasFocus=true',\n" +
    "             ng-blur='joinForm.ssn.hasFocus=false'>\n" +
    "          <span ng-click=\"ssnInputType = (ssnInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.ssn.$valid\" class=\"input-helper-btn\">{{ssnInputType == 'text' ? 'Hide' : 'Show'}}<br>SSN</span>\n" +
    "				</div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <a class=\"btn btn-register\" ng-click=\"attemptNextStep(joinForm, 'root.register.step3')\">Next</a>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../app/views/register/register-step3.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/register/register-step3.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul class=\"floatingForm-form\">\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.pin.$invalid && submitted\">Please provide a 4 digit pin number</span>\n" +
    "        </div>\n" +
    "        <div class=\"error-block-top input-half\">\n" +
    "          <span ng-show=\"joinForm.pin1.$invalid && submitted\">Please confirm card pin matches</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.pin.hasFocus,\n" +
    "					 \"has-success\": joinForm.pin.$valid,\n" +
    "					 \"has-error\": joinForm.pin.$invalid && (form.$submitted || joinForm.pin.$touched),\n" +
    "					 \"is-empty\": !joinForm.pin.$viewValue }'>\n" +
    "					<label for=\"pin\">Set Card Pin</label>\n" +
    "					<input\n" +
    "             class=\"radius-left\"\n" +
    "             name=\"pin\"\n" +
    "             tabindex=\"1\"\n" +
    "             required\n" +
    "             type=\"Password\"\n" +
    "             ng-model=\"formData.pin\"\n" +
    "             data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "             mask=\"9999\"\n" +
    "             ng-maxlength=\"4\"\n" +
    "             ng-minlength=\"4\"\n" +
    "             maxlength=\"4\"\n" +
    "						 ng-focus='joinForm.pin.hasFocus=true',\n" +
    "             ng-blur='joinForm.pin.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-half\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.pin1.hasFocus,\n" +
    "					 \"has-success\": joinForm.pin1.$valid,\n" +
    "					 \"has-error\": joinForm.pin1.$invalid && (form.$submitted || joinForm.pin1.$touched),\n" +
    "					 \"is-empty\": !joinForm.pin1.$viewValue }'>\n" +
    "					<label for=\"pin\">Confirm Card Pin</label>\n" +
    "					<input\n" +
    "             class=\"radius-right\"\n" +
    "             name=\"pin1\"\n" +
    "             tabindex=\"2\"\n" +
    "             required\n" +
    "             type=\"Password\"\n" +
    "             ng-model=\"formData.pin1\"\n" +
    "             data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "             mask=\"9999\"\n" +
    "             ng-maxlength=\"4\"\n" +
    "             ng-minlength=\"4\"\n" +
    "             maxlength=\"4\"\n" +
    "             match-elem\n" +
    "						 ng-focus='joinForm.pin1.hasFocus=true',\n" +
    "             ng-blur='joinForm.pin1.hasFocus=false'>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div class=\"error-block-top input-full\">\n" +
    "          <span ng-show=\"joinForm.password.$invalid && submitted\">At least 8 characters and 1 number</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "           class=\"form-group input-full\"\n" +
    "					 ng-class='{ \"has-focus\": joinForm.password.hasFocus,\n" +
    "					 \"has-success\": joinForm.password.$valid,\n" +
    "					 \"has-error\": joinForm.password.$invalid && (form.$submitted || joinForm.password.$touched),\n" +
    "					 \"is-empty\": !joinForm.password.$viewValue }'>\n" +
    "					<label for=\"password\">Create Password</label>\n" +
    "					<input\n" +
    "             class=\"radius-all\"\n" +
    "             name=\"password\"\n" +
    "             tabindex=\"3\"\n" +
    "             required\n" +
    "             validate-password\n" +
    "             type=\"{{passwordInputType}}\"\n" +
    "             ng-model=\"formData.password\"\n" +
    "						 ng-focus='joinForm.password.hasFocus=true',\n" +
    "             ng-blur='joinForm.password.hasFocus=false'>\n" +
    "          <span ng-click=\"passwordInputType = (passwordInputType == 'text' ? 'password' : 'text')\" ng-show=\"joinForm.password.$valid\" class=\"input-helper-btn\">{{passwordInputType == 'text' ? 'Hide' : 'Show'}}<br>Password</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "    <a class=\"btn btn-register\" ng-click=\"attemptNextStep(joinForm, 'root.register.step4')\">Next</a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/register/register-step4.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/register/register-step4.html",
    "<div class=\"modern-widget-section modern-form-section bg-white\">\n" +
    "  <div class=\"modern-widget-left\">\n" +
    "    <ul>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.employer.hasFocus,\n" +
    "					 \"has-success\": joinForm.employer.$valid,\n" +
    "					 \"has-error\": joinForm.employer.$invalid && (form.$submitted || joinForm.employer.$touched),\n" +
    "					 \"is-empty\": !joinForm.employer.$viewValue }'>\n" +
    "          <label for=\"employer\">Employer</label>\n" +
    "          <input\n" +
    "                  id=\"employer\"\n" +
    "                  class=\"radius-all\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"employer\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  tabindex=\"1\"\n" +
    "                  ng-model=\"formData.employer\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.employer.hasFocus=true',\n" +
    "                  ng-blur='joinForm.employer.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div class=\"error-red input-full\">\n" +
    "          <span ng-show=\"joinForm.employer.$error.required && submitted\">Please provide your employer</span>\n" +
    "          <span ng-show=\"joinForm.employer.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <div\n" +
    "                class=\"form-group input-full\"\n" +
    "                ng-class='{ \"has-focus\": joinForm.occupation.hasFocus,\n" +
    "					 \"has-success\": joinForm.occupation.$valid,\n" +
    "					 \"has-error\": joinForm.occupation.$invalid && (form.$submitted || joinForm.occupation.$touched),\n" +
    "					 \"is-empty\": !joinForm.occupation.$viewValue }'>\n" +
    "          <label for=\"occupation\">Occupation</label>\n" +
    "          <input\n" +
    "                  id=\"occupation\"\n" +
    "                  class=\"radius-all\"\n" +
    "                  type=\"text\"\n" +
    "                  name=\"occupation\"\n" +
    "                  pattern=\"[A-Za-z ]+\"\n" +
    "                  tabindex=\"1\"\n" +
    "                  ng-model=\"formData.occupation\"\n" +
    "                  required\n" +
    "                  ng-focus='joinForm.occupation.hasFocus=true',\n" +
    "                  ng-blur='joinForm.occupation.hasFocus=false'>\n" +
    "        </div>\n" +
    "        <div class=\"error-red input-full\">\n" +
    "          <span ng-show=\"joinForm.occupation.$error.required && submitted\">Please provide your occupation</span>\n" +
    "          <span ng-show=\"joinForm.occupation.$error.pattern\">Special characters may not be used</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <label for=\"countryCode\">Country of citizenship</label>\n" +
    "        <select id=\"countryCode\" class=\"first force-dropdown-arrow\" tabindex=\"5\" ng-model=\"formData.countryCode\" ng-options=\"country.code as country.name for country in countries\" required>\n" +
    "          <option value=\"\" ng-if=\"!formData.countryCode\" disabled selected>Select Country of Citizenship</option>\n" +
    "        </select>\n" +
    "        <div class=\"error-red input-full\">\n" +
    "          <span ng-show=\"!formData.countryCode && submitted\">Please provide your country of citizenship</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <label for=\"primarySourceOfFunds\">Primary Source of Funds</label>\n" +
    "        <select id=\"primarySourceOfFunds\" class=\"first force-dropdown-arrow\" tabindex=\"5\" ng-model=\"formData.primarySourceOfFunds\" required>\n" +
    "          <option value=\"\" ng-if=\"!formData.primarySourceOfFunds\">Select Primary Source of Funds</option>\n" +
    "          <option value=\"paycheck\">Paycheck</option>\n" +
    "          <option value=\"government benefits\">Government Benefits</option>\n" +
    "          <option value=\"retirement\">Retirement</option>\n" +
    "          <option value=\"cash\">Cash</option>\n" +
    "          <option value=\"other\">Other</option>\n" +
    "        </select>\n" +
    "        <div class=\"error-red input-full\">\n" +
    "          <span ng-show=\"!formData.primarySourceOfFunds && submitted\">Please select your primary source of funds</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"floatingForm-li\">\n" +
    "        <label for=\"primaryUseOfAccount\">Primary Use of Account</label>\n" +
    "        <select id=\"primaryUseOfAccount\" class=\"first force-dropdown-arrow\" tabindex=\"5\" ng-model=\"formData.primaryUseOfAccount\" required>\n" +
    "          <option value=\"\" ng-if=\"!formData.primaryUseOfAccount\">Select Primary Use of Account</option>\n" +
    "          <option value=\"household expense\">Household Expenses</option>\n" +
    "          <option value=\"investment\">Investment</option>\n" +
    "          <option value=\"savings\">Savings</option>\n" +
    "          <option value=\"other\">Other</option>\n" +
    "        </select>\n" +
    "        <div class=\"error-red input-full\">\n" +
    "          <span ng-show=\"!formData.primaryUseOfAccount.$error.required && submitted\">Please select your primary use of your account</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modern-widget-right\">\n" +
    "    <img ng-src=\"assets/images/{{brand.name}}/gpr-vertical-banner.png\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modern-widget-section bg-white modern-form-section\">\n" +
    "  <a class=\"btn btn-register\" ng-click=\"attemptSubmission(joinForm)\">Finish</a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/register/register-success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/register/register-success.html",
    "<div class=\"modern-widget-section modern-form-section bg-white exPadding\">\n" +
    "  <p class=\"modern-widget-warning-text\">{{ successMessage }}<br/>\n" +
    "  <img ng-src=\"assets/images/{{brand.name}}/join-welcome.png\" alt=\"\">\n" +
    "  <div class=\"text-center\">\n" +
    "    <a id='dashboardBtn' class=\"btn btn--float-right\" ng-click=\"goToDashboard()\">Continue To Dashboard</a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"alertError.show\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{alertError.message}}<br/>\n" +
    "        <a class=\"btn btn-full-width\" ng-click=\"alertError.show = !alertError.show\">OK</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-show=\"parent.overlayLoading\" class=\"overlay-wrapper\">\n" +
    "  <div class=\"overlay-mask\"></div>\n" +
    "  <div class=\"overlay-loader\">\n" +
    "    <span style=\"width:48px;\" class=\"loading-indicator\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/resetpassword/corporate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/resetpassword/corporate.html",
    "<div class=\"alert\">\n" +
    "    <p>In order to reset your password, please contact <a href=\"mailto:partnersupport@usio.com\">partnersupport@usio.com</a>. A representative will assist you with accessing your account.</p>\n" +
    "</div>\n" +
    "<button type=\"button\" ng-show=\"!loading\" class=\"btn x-large\" ng-click=\"back()\">OK</button>\n" +
    "");
}]);

angular.module("../app/views/resetpassword/error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/resetpassword/error.html",
    "<div class=\"alert\">\n" +
    "  <span class=\"icon-warning-triangle\"></span>\n" +
    "  <p>Sorry, we were unable to update your password. Please try again at a later time. <a ui-sref=\"root.login\">Click here to return to the login</a></p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/resetpassword/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/resetpassword/layout.html",
    "<div ng-hide=\"brand.ssoHide\" class=\"login-container\">\n" +
    "  <div class=\"login-box\">\n" +
    "    <div class=\"login-box-header\">\n" +
    "      <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "      <h1>Forgot Username/Password</h1>\n" +
    "    </div>\n" +
    "    <div class=\"login-box-body\">\n" +
    "      <form id=\"frm-login\" name=\"resetForm\" class=\"en-form reset-pw\">\n" +
    "        <div ui-view=\"step\"></div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/resetpassword/mobile-success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/resetpassword/mobile-success.html",
    "<div class=\"alert\">\n" +
    "  <span class=\"icon-thumbs-up\"></span>\n" +
    "  <p>Your password has been successfully updated!</p><br/><br/>\n" +
    "  <p>Tap the Logo in the top left of this window to return to the app to log in.</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/resetpassword/reset-step1.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/resetpassword/reset-step1.html",
    "<div class=\"alert\">\n" +
    "  <span class=\"icon-point-down\"></span>\n" +
    "  <p>To retrieve your username or reset your password, please enter your email address below.</p>\n" +
    "  <p class=\"secondary\" ng-show=\"showUsioSupport\">Commercial cardholders should contact <a href=\"mailto:partnersupport@usio.com\">partnersupport@usio.com</a> for login assistance.</p>\n" +
    "</div>\n" +
    "<ul>\n" +
    "  <li class=\"akimbo-form-field-error form-error noBorder\" ng-show=\"resetForm.Email.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li ng-show=\"resetForm.Email.$error.email && attempted\">Please Enter an Email</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error noBorder\" ng-show=\"isEmailUnique && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li>We were unable to locate your account. If you have a card, you may need to <a href=\"https://app.akimbocard.com/app/#/register\">register</a>. Otherwise, you can join {{brand.programName}} by clicking <a href=\"https://app.akimbocard.com/app/#/enrollment\">here</a>. If you feel you have received this message in error, please call customer service at 855-925-4626.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<label>Email</label>\n" +
    "<input\n" +
    "  type=\"email\"\n" +
    "  class=\"large\"\n" +
    "  name=\"Email\"\n" +
    "  placeholder=\"Email\"\n" +
    "  autocomplete=\"new-password\"\n" +
    "  required\n" +
    "  ng-model=\"formData.Email\"\n" +
    "  ng-keyup=\"$event.keyCode === 13 && attemptEmailVerification(resetForm)\">\n" +
    "<button id=\"continue-btn\" type=\"button\" ng-show=\"!loading\" class=\"btn x-large\" ng-click=\"attemptEmailVerification(resetForm)\" ng-disabled=\"showValidateEmail\">Continue</button>\n" +
    "<div ng-show=\"loading\" id=\"loading-login\" style=\"float:right;\">\n" +
    "  <span alt=\"Loading...\" class=\"loading-indicator\"></span>\n" +
    "</div>\n" +
    "<div ng-include=\"'app/partials/verifyContact.html'\"></div>\n" +
    "");
}]);

angular.module("../app/views/resetpassword/reset-step2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/resetpassword/reset-step2.html",
    "<div class=\"alert\">\n" +
    "  <span class=\"icon-point-down\"></span>\n" +
    "  <p>Your username is provided below. If you would like to also reset your password, enter a new password in the fields below.</p>\n" +
    "</div>\n" +
    "<h2>Your username is {{formData.username}}, <a ui-sref=\"root.login\">Click to log in now</a></h2>\n" +
    "<br>\n" +
    "<ul>\n" +
    "  <input type=\"text\" value=\"\" style=\"display:none\" id=\"prevent_autofill_username\"/>\n" +
    "  <input type=\"password\" value=\"\" style=\"display:none\" id=\"prevent_autofill_password\"/>\n" +
    "  <li class=\"akimbo-form-field-error form-error noBorder\" ng-if=\"formData.cardType == 'primary'\" ng-show=\"(!resetForm.Dob1.$valid || !resetForm.Dob2.$valid || !resetForm.Dob3.$valid) && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li>Please select the date of birth month day and year.</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"birth-date\" ng-if=\"formData.cardType == 'primary'\">\n" +
    "    <label for=\"birthDate\">Date of birth</label>\n" +
    "    <select\n" +
    "      id=\"birthDate1\"\n" +
    "      class=\"first\"\n" +
    "      name=\"Dob1\"\n" +
    "      ng-model=\"formData.Dob1\"\n" +
    "      ng-required=\"formData.cardType == 'primary'\"\n" +
    "      ng-options=\"month for month in range(1, 12)\">\n" +
    "      <option value=\"\" ng-if=\"!formData.Dob1\">Month</option>\n" +
    "    </select>\n" +
    "    <select\n" +
    "      id=\"birthDate2\"\n" +
    "      tabindex=\"3\"\n" +
    "      name=\"Dob2\"\n" +
    "      ng-model=\"formData.Dob2\"\n" +
    "      ng-required=\"formData.cardType == 'primary'\"\n" +
    "      ng-options=\"day for day in range(1,31)\">\n" +
    "      <option value=\"\" ng-if=\"!formData.Dob2\">Day</option>\n" +
    "    </select>\n" +
    "    <select\n" +
    "      id=\"birthDate3\"\n" +
    "      tabindex=\"4\"\n" +
    "      name=\"Dob3\"\n" +
    "      ng-model=\"formData.Dob3\"\n" +
    "      ng-required=\"formData.cardType == 'primary'\"\n" +
    "      ng-options=\"year for year in range(1900, latestAgeYear, true)\">\n" +
    "      <option value=\"\" ng-if=\"!formData.Dob3\">Year</option>\n" +
    "    </select>\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error noBorder\" ng-show=\"resetForm.Ssn.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li>Please enter the last 4 digits of your social security number</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li ng-if=\"formData.cardType == 'primary'\">\n" +
    "    <label for=\"ssn\">Last 4 Digits of Social Security Number</label>\n" +
    "    <input\n" +
    "       name=\"Ssn\"\n" +
    "       autocomplete=\"new-password\"\n" +
    "       id=\"Ssn\"\n" +
    "       type=\"text\"\n" +
    "       data-ng-pattern=\"/^[0-9]+$/\"\n" +
    "       maxlength=\"4\"\n" +
    "       ng-minlength=\"4\"\n" +
    "       ng-maxlength=\"4\"\n" +
    "       ng-model=\"formData.Ssn\"\n" +
    "       ng-required=\"formData.cardType == 'primary'\">\n" +
    "  </li>\n" +
    "  <li class=\"akimbo-form-field-error form-error noBorder\" ng-show=\"resetForm.Password.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li>Please enter a new password</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"security-password reduced-input\">\n" +
    "    <div class=\"password\">\n" +
    "      <label for=\"password\">Password <span ng-show=\"resetForm.Password.$invalid && passwordBlurred\" class=\"inputHelper\">At least 8 characters and 1 number</span></label>\n" +
    "      <input\n" +
    "         id=\"password\"\n" +
    "         name=\"Password\"\n" +
    "         type=\"password\"\n" +
    "         ng-model=\"formData.Password\"\n" +
    "         ng-blur=\"passwordBlurred = true;\"\n" +
    "         ng-change=\"confirmPWMatch()\"\n" +
    "         validate-password\n" +
    "         required>\n" +
    "      <span ng-show=\"resetForm.Password.$valid\" class=\"icon-check check check-green\"></span>\n" +
    "      <span ng-show=\"resetForm.Password.$invalid\" class=\"icon-check check check-gray\"></span>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"reduced-input akimbo-form-field-error form-error noBorder\" ng-show=\"resetForm.Password1.$invalid && attempted\">\n" +
    "    <div class=\"alert\">\n" +
    "      <span class=\"icon-warning-triangle\"></span>\n" +
    "      <ul class=\"form\">\n" +
    "        <li>Please confirm the new password</li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"reduced-input\">\n" +
    "    <div class=\"confirm-password\">\n" +
    "      <label for=\"confirmPassword\">Confirm password</label>\n" +
    "      <input\n" +
    "         id=\"confirmPassword\"\n" +
    "         name=\"Password1\"\n" +
    "         type=\"password\"\n" +
    "         ng-model=\"formData.Password1\"\n" +
    "         ng-change=\"confirmPWMatch()\"\n" +
    "         required>\n" +
    "      <span ng-show=\"resetForm.Password1.$valid\" class=\"icon-check check check-green\"></span>\n" +
    "      <span ng-show=\"resetForm.Password1.$invalid\" class=\"icon-check check check-gray\"></span>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<button id=\"resetBtn\" ng-show=\"!loading\" class=\"btn x-large\" ng-click=\"attemptReset(resetForm)\">Reset</button>\n" +
    "<div ng-show=\"loading\" id=\"loading-login\" style=\"float:right;\">\n" +
    "  <span alt=\"Loading...\" class=\"loading-indicator\"></span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/resetpassword/success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/resetpassword/success.html",
    "<div class=\"alert\">\n" +
    "  <span class=\"icon-thumbs-up\"></span>\n" +
    "  <p>Your password has been successfully updated! <a id=\"loginLink\" ui-sref=\"root.login\">Click here to login now</a></p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/signup/confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/confirmation.html",
    "<div class=\"title-with-icon\">\n" +
    "  <span class=\"title-with-icon__icon title-with-icon__icon--dark icon-check-fill mobile-hide\"></span>\n" +
    "  <h3 class=\"title-with-icon__text\">You’ve ordered your card!</h3>\n" +
    "</div>\n" +
    "<div class=\"signup-section\">\n" +
    "  <ul>\n" +
    "    <li class=\"checkbox-item\">\n" +
    "      <div class=\"checkbox-item__box checkbox-item__box--no-border\">\n" +
    "        <span class=\"checkbox-item__icon icon-mail\"></span>\n" +
    "      </div>\n" +
    "      <div class=\"checkbox-item__content\">\n" +
    "        <h3 class=\"checkbox-item__title\">Your card will be delivered to the following address:</h3>\n" +
    "        <p>{{confirmation.orderData.StreetAddress}}</p>\n" +
    "        <p>{{confirmation.orderData.address2}}</p>\n" +
    "        <p>{{confirmation.orderData.City}}, {{confirmation.orderData.State}} {{confirmation.orderData.Zipcode}}</p>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "    <li class=\"checkbox-item\">\n" +
    "      <div class=\"checkbox-item__box checkbox-item__box--no-border\">\n" +
    "        <span class=\"checkbox-item__icon icon-envelope\"></span>\n" +
    "      </div>\n" +
    "      <div class=\"checkbox-item__content\">\n" +
    "        <h3 class=\"checkbox-item__title\">We’ve emailed you a confirmation.</h3>\n" +
    "        <p>Please check your email.</p>\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section-bkg-wrap\">\n" +
    "  <div class=\"title-with-icon\">\n" +
    "    <span class=\"title-with-icon__icon icon-bank-circle mobile-hide\"></span>\n" +
    "    <h3 class=\"title-with-icon__text\">What would you like to do next?</h3>\n" +
    "  </div>\n" +
    "  <div class=\"signup-section\">\n" +
    "    <ul>\n" +
    "      <li class=\"checkbox-item\">\n" +
    "        <div class=\"checkbox-item__box checkbox-item__box--no-border\">\n" +
    "          <span class=\"checkbox-item__icon icon-bank\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <h3 class=\"checkbox-item__title\">Load your card.</h3>\n" +
    "          <p>You can link a bank account or get your direct deposit information.</p>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"checkbox-item\">\n" +
    "        <div class=\"checkbox-item__box checkbox-item__box--no-border\">\n" +
    "          <span class=\"checkbox-item__icon icon-dashboard\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <h3 class=\"checkbox-item__title\">View the dashboard.</h3>\n" +
    "          <p>Access all of your cards and features in one place.</p>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section signup-section--padding clear\">\n" +
    "  <button class=\"btn btn-register\" ng-click=\"confirmation.goTo('member.home.subaccount/load.step1')\">\n" +
    "    Load my\n" +
    "    <ng-pluralize count=\"confirmation.orderData.cardsQty\"\n" +
    "      when=\"{'one': 'card', 'other': 'cards'}\">\n" +
    "  </button>\n" +
    "  <button class=\"btn btn-light btn-register\" ng-click=\"confirmation.goTo('member.home')\">View my dashboard</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/signup/create.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/create.html",
    "<div class=\"title-with-icon\">\n" +
    "  <span class=\"title-with-icon__icon icon-card-circle mobile-hide\"></span>\n" +
    "  <h3 class=\"title-with-icon__text\">\n" +
    "    Great, let's create your card.\n" +
    "  </h3>\n" +
    "</div>\n" +
    "<div ui-view=\"signup-progress\"></div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section-bkg-wrap\">\n" +
    "  <div class=\"title-with-icon\">\n" +
    "    <span class=\"title-with-icon__icon icon-female-circle mobile-hide\"></span>\n" +
    "    <h3 class=\"title-with-icon__text\">Who will use this card?</h3>\n" +
    "  </div>\n" +
    "  <div class=\"signup-section\">\n" +
    "    <ul>\n" +
    "      <li class=\"checkbox-item\"\n" +
    "        tabindex=\"1\"\n" +
    "        ng-click=\"create.checkCardPurpose('personal', create.currentCard)\"\n" +
    "        ng-keyup=\"create.checkPressedKey($event)\">\n" +
    "        <div class=\"checkbox-item__box\"\n" +
    "          ng-class=\"create.currentCard.CardPurpose == 'personal' ? '' : 'checkbox-item__box--disabled'\">\n" +
    "          <span class=\"checkbox-item__icon\"\n" +
    "            ng-class=\"create.currentCard.CardPurpose == 'personal' ? 'icon-check' : 'icon-female'\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <input\n" +
    "            class=\"checkbox-item__input\"\n" +
    "            type=\"radio\"\n" +
    "            name=\"CardPurpose\"\n" +
    "            ng-model=\"create.currentCard.CardPurpose\"\n" +
    "            value=\"personal\">\n" +
    "          <h3 class=\"checkbox-item__title\">Me</h3>\n" +
    "          <p class=\"checkbox-item__text\">I will be the primary user of this card. Great for personal budgeting.</p>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"checkbox-item\"\n" +
    "        tabindex=\"2\"\n" +
    "        ng-click=\"create.checkCardPurpose('allowance', create.currentCard)\"\n" +
    "        ng-keyup=\"create.checkPressedKey($event)\">\n" +
    "        <div class=\"checkbox-item__box\"\n" +
    "          ng-class=\"create.currentCard.CardPurpose == 'allowance' ? '' : 'checkbox-item__box--disabled'\">\n" +
    "          <span class=\"checkbox-item__icon\"\n" +
    "            ng-class=\"create.currentCard.CardPurpose == 'allowance' ? 'icon-check' : 'icon-male'\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <input\n" +
    "            class=\"checkbox-item__input\"\n" +
    "            type=\"radio\"\n" +
    "            name=\"CardPurpose\"\n" +
    "            ng-model=\"create.currentCard.CardPurpose\"\n" +
    "            value=\"allowance\">\n" +
    "          <h3 class=\"checkbox-item__title\">Someone else</h3>\n" +
    "          <p class=\"checkbox-item__text\">I will provide this card to someone else, but only I can manage and load the card. Great for allowances.</p>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "      <li class=\"checkbox-item\"\n" +
    "        tabindex=\"3\"\n" +
    "        ng-click=\"create.checkCardPurpose('household', create.currentCard)\"\n" +
    "        ng-keyup=\"create.checkPressedKey($event)\">\n" +
    "        <div class=\"checkbox-item__box\"\n" +
    "          ng-class=\"create.currentCard.CardPurpose == 'household' ? '' : 'checkbox-item__box--disabled'\">\n" +
    "          <span class=\"checkbox-item__icon\"\n" +
    "            ng-class=\"create.currentCard.CardPurpose == 'household' ? 'icon-check' : 'icon-couple'\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox-item__content\">\n" +
    "          <input\n" +
    "            class=\"checkbox-item__input\"\n" +
    "            type=\"radio\"\n" +
    "            name=\"CardPurpose\"\n" +
    "            ng-model=\"create.currentCard.CardPurpose\"\n" +
    "            value=\"household\">\n" +
    "          <h3 class=\"checkbox-item__title\">Shared card</h3>\n" +
    "          <p class=\"checkbox-item__text\">Multiple people in my household may use this card, but only I can manage and load the card. Great for household budgeting.</p>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section signup-section--padding clear\">\n" +
    "  <button class=\"btn btn-register\" ng-click=\"create.nextStep()\">Next</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/signup/customize.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/customize.html",
    "<div class=\"title-with-icon\">\n" +
    "  <span class=\"title-with-icon__icon icon-card-circle mobile-hide\"></span>\n" +
    "  <h3 class=\"title-with-icon__text\">\n" +
    "    Customize your \"{{ customize.currentCard.FirstName || 'Card' }} {{ customize.currentCard.LastName || 'Name' }}\" card.</h3>\n" +
    "</div>\n" +
    "<div ui-view=\"signup-progress\"></div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section-bkg-wrap\">\n" +
    "  <div class=\"title-with-icon\">\n" +
    "    <span class=\"title-with-icon__icon icon-card-circle mobile-hide\"></span>\n" +
    "    <h3 class=\"title-with-icon__text\" ng-switch=\"customize.currentCard.CardPurpose\">\n" +
    "      <span ng-switch-when=\"personal\">Set a name for this card.</span>\n" +
    "      <span ng-switch-when=\"allowance\">Set the name and access for this card.</span>\n" +
    "      <span ng-switch-when=\"household\">Set the name for this card.</span>\n" +
    "    </h3>\n" +
    "  </div>\n" +
    "  <div class=\"signup-section floatingForm-form\" ng-form=\"signupCustomizeForm\">\n" +
    "    <div class=\"signup-field\">\n" +
    "      <label class=\"signup-field__label\">Name On Card</label>\n" +
    "      <p class=\"signup-field__description\" ng-switch=\"customize.currentCard.CardPurpose\">\n" +
    "        <span ng-switch-when=\"personal\">Please provide your first and last name.</span>\n" +
    "        <span ng-switch-when=\"allowance\">Provide the first and last name of the person who will use this card.</span>\n" +
    "        <span ng-switch-when=\"household\">You’re not required to use a person’s name. Examples: “Grocery Budget”, “Decker Family”, “Fun Money”.</span>\n" +
    "      </p>\n" +
    "      <div class=\"form-error-row\">\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupCustomizeForm.FirstName.$invalid && customize.submitted\">First Name is required</span>\n" +
    "        </div>\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupCustomizeForm.LastName.$invalid && customize.submitted\">Last Name is required</span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupCustomizeForm.FirstName.hasFocus,\n" +
    "        \"has-success\": signupCustomizeForm.FirstName.$valid,\n" +
    "        \"has-error\": signupCustomizeForm.FirstName.$invalid && (form.$submitted || signupCustomizeForm.FirstName.$touched),\n" +
    "        \"is-empty\": !signupCustomizeForm.FirstName.$viewValue }'>\n" +
    "        <label for=\"FirstName\">First Name</label>\n" +
    "        <input\n" +
    "          id=\"FirstName\"\n" +
    "          name=\"FirstName\"\n" +
    "          class=\"radius-left\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"customize.currentCard.FirstName\"\n" +
    "          clean=\"true\"\n" +
    "          required\n" +
    "          ng-focus='signupCustomizeForm.FirstName.hasFocus=true',\n" +
    "          ng-blur='signupCustomizeForm.FirstName.hasFocus=false'>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupCustomizeForm.LastName.hasFocus,\n" +
    "        \"has-success\": signupCustomizeForm.LastName.$valid,\n" +
    "        \"has-error\": signupCustomizeForm.LastName.$invalid && (form.$submitted || signupCustomizeForm.LastName.$touched),\n" +
    "        \"is-empty\": !signupCustomizeForm.LastName.$viewValue }'>\n" +
    "        <label for=\"LastName\">Last Name</label>\n" +
    "        <input\n" +
    "          id=\"LastName\"\n" +
    "          name=\"LastName\"\n" +
    "          class=\"radius-right\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"customize.currentCard.LastName\"\n" +
    "          required\n" +
    "          ng-focus='signupCustomizeForm.LastName.hasFocus=true',\n" +
    "          ng-blur='signupCustomizeForm.LastName.hasFocus=false'>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"signup-field\" ng-hide=\"true\">\n" +
    "      <label class=\"signup-field__label\">Label</label>\n" +
    "      <p class=\"signup-field__description\">Optional. Print a label on this card. Examples: “Groceries”, “Fun Money”.</p>\n" +
    "      <div\n" +
    "        class=\"form-group input-full\"\n" +
    "        ng-class='{ \"has-focus\": signupCustomizeForm.CardLabel.hasFocus,\n" +
    "        \"has-success\": signupCustomizeForm.CardLabel.$valid,\n" +
    "        \"has-error\": signupCustomizeForm.CardLabel.$invalid && (form.$submitted || signupCustomizeForm.CardLabel.$touched),\n" +
    "        \"is-empty\": !signupCustomizeForm.CardLabel.$viewValue }'>\n" +
    "        <label for=\"CardLabel\">Optional Card Label</label>\n" +
    "        <input\n" +
    "          id=\"CardLabel\"\n" +
    "          name=\"CardLabel\"\n" +
    "          class=\"radius-all\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"customize.currentCard.CardLabel\"\n" +
    "          ng-focus='signupCustomizeForm.CardLabel.hasFocus=true',\n" +
    "          ng-blur='signupCustomizeForm.CardLabel.hasFocus=false'>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"supportsPhysical\" class=\"signup-field\">\n" +
    "\n" +
    "      <label class=\"signup-field__label\">Create a physical card or a virtual card?</label>\n" +
    "\n" +
    "      <h3 class=\"toggle-status-enroll\">{{customize.currentCard.Virtual == 'on' ? 'Virtual Card': 'Physical Card'}}</h3>\n" +
    "      <div class=\"toggle-input-enroll\">\n" +
    "        <div class=\"toggle-bg {{customize.currentCard.Virtual}}\">\n" +
    "          <input\n" +
    "            type=\"radio\"\n" +
    "            name=\"toggle-1\"\n" +
    "            value=\"off\"\n" +
    "            ng-model=\"customize.currentCard.Virtual\">\n" +
    "          <input\n" +
    "            type=\"radio\"\n" +
    "            name=\"toggle-1\"\n" +
    "            value=\"on\"\n" +
    "            ng-model=\"customize.currentCard.Virtual\">\n" +
    "          <span class=\"switch {{customize.currentCard.Virtual}}\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"signup-field\" ng-show=\"customize.currentCard.CardPurpose == 'allowance'\">\n" +
    "      <label class=\"signup-field__label\">International and ATM Access</label>\n" +
    "      <ul>\n" +
    "        <li class=\"checkbox-item\"\n" +
    "          ng-click=\"customize.currentCard.ATMInternationalAccess = !customize.currentCard.ATMInternationalAccess\">\n" +
    "          <div class=\"checkbox-item__box\"\n" +
    "            ng-class=\"customize.currentCard.ATMInternationalAccess ? '' : 'checkbox-item__box--disabled'\">\n" +
    "            <span class=\"checkbox-item__icon\"\n" +
    "              ng-class=\"customize.currentCard.ATMInternationalAccess ? 'icon-check' : 'icon-atm'\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "              class=\"checkbox-item__input\"\n" +
    "              type=\"checkbox\"\n" +
    "              name=\"ATMInternationalAccess\"\n" +
    "              ng-model=\"customize.currentCard.ATMInternationalAccess\">\n" +
    "            <h3 class=\"checkbox-item__title\">Allow this card to be used internationally and at ATMs?</h3>\n" +
    "            <p>We’ll add your name to this card.</p>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section signup-section--padding clear\">\n" +
    "  <button type=\"button\" class=\"btn btn-light btn-register btn-register--left\" ui-sref=\"signup.create\">Back</button>\n" +
    "  <button class=\"btn btn-register\" ng-click=\"customize.nextStep(signupCustomizeForm.$valid)\">Next</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/signup/fee-schedule.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/fee-schedule.html",
    "<div class=\"title-with-icon\">\n" +
    "  <span class=\"title-with-icon__icon icon-lock-circle mobile-hide\"></span>\n" +
    "  <h3  class=\"title-with-icon__text\">Here are the fees for this card</h3>\n" +
    "</div>\n" +
    "<div class=\"signup-section floatingForm-form\" ng-form=\"signupLoginForm\">\n" +
    "  <div class=\"signup-field\">\n" +
    "    <label class=\"signup-field__label signup-field__label--margin-bottom\">\n" +
    "      You’ll also receive a copy in your cardholder package.\n" +
    "    </label>\n" +
    "    <p>\n" +
    "      <a target=\"_blank\" ng-href=\"{{ feeSchedule.pdfSrc }}\">Download the Fee Schedule.</a>\n" +
    "    </p>\n" +
    "    <br/>\n" +
    "    <iframe\n" +
    "        src=\"{{ feeSchedule.trustSrc(feeSchedule.pdfSrc + '#toolbar=0') }}\"\n" +
    "        width=\"100%\"\n" +
    "        height=\"600px\"\n" +
    "        style=\"border: none;\">\n" +
    "    </iframe>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section signup-section--padding clear\">\n" +
    "  <button\n" +
    "    type=\"button\"\n" +
    "    class=\"btn btn-light btn-register btn-register--left\"\n" +
    "    ng-disabled='feeSchedule.showModal'\n" +
    "    ng-click='feeSchedule.openModal()'>\n" +
    "      Finish Enrollment Later\n" +
    "  </button>\n" +
    "  <button type=\"button\" class=\"btn btn-register\" ui-sref=\"signup.order\">Next</button>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"verify-email\" ng-show=\"feeSchedule.showModal\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-large\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-large\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <div class=\"overlay-close icon-circle-x\" ng-click=\"feeSchedule.closeModal()\"></div>\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1><b>CANCEL ENROLLMENT</b></h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body exPadding\">\n" +
    "        <h1>Are you sure you would like to cancel your enrollment?</h1>\n" +
    "          </br>\n" +
    "        <p>If you would like to continue your enrollment at a later time you can just login with your credentials</p>\n" +
    "      </div>\n" +
    "      <div class=\"overlay-footer\">\n" +
    "        <p id=\"resend\">\n" +
    "          <button type=\"button\" class=\"btn btn-light btn-register btn-register--left\" ng-click=\"feeSchedule.goToLogin()\">Yes</button>\n" +
    "          <button type=\"button\" class=\"btn btn-register\" ng-click=\"feeSchedule.closeModal()\">No</button>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/signup/layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/layout.html",
    "<div class=\"overlay overlay-brand-bkg overlay--border-primary-1 modern-widget join\">\n" +
    "  <div class=\"overlay-header\">\n" +
    "    <div class=\"overlay-header-main\">\n" +
    "      <span class=\"overlay-header__icon icon-house mobile-hide\"></span>\n" +
    "      <h1 ng-hide=\"signup.$state.includes('signup.confirmation')\">Let's get your house in order.</h1>\n" +
    "      <h1 ng-show=\"signup.$state.includes('signup.confirmation')\">Success!</h1>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <form novalidate=\"novalidate\">\n" +
    "    <div ui-view=\"step\"></div>\n" +
    "  </form>\n" +
    "</div><!-- .overlay -->\n" +
    "");
}]);

angular.module("../app/views/signup/order.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/order.html",
    "<div class=\"title-with-icon\">\n" +
    "  <span class=\"title-with-icon__icon icon-check-circle mobile-hide\"></span>\n" +
    "  <h3 class=\"title-with-icon__text\">Great! This card is complete.</h3>\n" +
    "</div>\n" +
    "<div ui-view=\"signup-progress\"></div>\n" +
    "<div class=\"signup-section signup-section--centered signup-section--padding\">\n" +
    "  <button class=\"btn btn-small\" ng-click=\"order.createMore()\">Create more cards</button>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"signup-section-bkg-wrap\">\n" +
    "  <div class=\"title-with-icon\">\n" +
    "    <span class=\"title-with-icon__icon icon-mail-circle mobile-hide\"></span>\n" +
    "    <h3 class=\"title-with-icon__text\">Let’s make it official:</h3>\n" +
    "  </div>\n" +
    "  <div class=\"signup-section floatingForm-form\" ng-form=\"signupOrderForm\">\n" +
    "    <div class=\"signup-field\">\n" +
    "      <label class=\"signup-field__label\">Where should we send your card?</label>\n" +
    "      <div class=\"form-error-row\">\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.FirstName.$invalid && order.submitted\">First Name is required</span>\n" +
    "        </div>\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.LastName.$invalid && order.submitted\">Last Name is required</span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.FirstName.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.FirstName.$valid,\n" +
    "        \"has-error\": signupOrderForm.FirstName.$invalid && (form.$submitted || signupOrderForm.FirstName.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.FirstName.$viewValue }'>\n" +
    "        <label for=\"FirstName\">First Name</label>\n" +
    "        <input\n" +
    "          id=\"FirstName\"\n" +
    "          name=\"FirstName\"\n" +
    "          class=\"radius-left\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"order.orderData.FirstName\"\n" +
    "          clean=\"true\"\n" +
    "          ng-required=\"order.orderData.CardPurpose !== 'personal'\"\n" +
    "          ng-focus='signupOrderForm.FirstName.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.FirstName.hasFocus=false'>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.LastName.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.LastName.$valid,\n" +
    "        \"has-error\": signupOrderForm.LastName.$invalid && (form.$submitted || signupOrderForm.LastName.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.LastName.$viewValue }'>\n" +
    "        <label for=\"LastName\">Last Name</label>\n" +
    "        <input\n" +
    "          id=\"LastName\"\n" +
    "          name=\"LastName\"\n" +
    "          class=\"radius-right\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"order.orderData.LastName\"\n" +
    "          ng-required=\"order.orderData.CardPurpose !== 'personal'\"\n" +
    "          ng-focus='signupOrderForm.LastName.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.LastName.hasFocus=false'>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"signup-field\">\n" +
    "      <div class=\"form-error-row\">\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.StreetAddress.$invalid && order.submitted\">Address 1 is required</span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.StreetAddress.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.StreetAddress.$valid,\n" +
    "        \"has-error\": signupOrderForm.StreetAddress.$invalid && (form.$submitted || signupOrderForm.StreetAddress.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.StreetAddress.$viewValue }'>\n" +
    "        <label for=\"StreetAddress\">Address 1</label>\n" +
    "        <input\n" +
    "          id=\"StreetAddress\"\n" +
    "          name=\"StreetAddress\"\n" +
    "          class=\"radius-left\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"order.orderData.StreetAddress\"\n" +
    "          clean=\"true\"\n" +
    "          required\n" +
    "          ng-focus='signupOrderForm.StreetAddress.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.StreetAddress.hasFocus=false'>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.address2.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.address2.$valid,\n" +
    "        \"has-error\": signupOrderForm.address2.$invalid && (form.$submitted || signupOrderForm.address2.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.address2.$viewValue }'>\n" +
    "        <label for=\"address2\">Address 2</label>\n" +
    "        <input\n" +
    "          id=\"address2\"\n" +
    "          name=\"address2\"\n" +
    "          class=\"radius-right\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"order.orderData.SuiteNumber\"\n" +
    "          ng-focus='signupOrderForm.address2.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.address2.hasFocus=false'>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"signup-field\">\n" +
    "      <div class=\"form-error-row\">\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.City.$invalid && order.submitted\">City is required</span>&nbsp;\n" +
    "        </div>\n" +
    "        <div class=\"form-error-row__col form-error-row__col--half\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.State.$invalid && order.submitted\">State is required</span>&nbsp;\n" +
    "        </div>\n" +
    "        <div class=\"form-error-row__col form-error-row__col--half\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.Zipcode.$invalid && order.submitted\">Zip Code is required</span>&nbsp;\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.City.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.City.$valid,\n" +
    "        \"has-error\": signupOrderForm.City.$invalid && (form.$submitted || signupOrderForm.City.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.City.$viewValue }'>\n" +
    "        <label for=\"City\">City</label>\n" +
    "        <input\n" +
    "          id=\"City\"\n" +
    "          name=\"City\"\n" +
    "          class=\"radius-left\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"order.orderData.City\"\n" +
    "          clean=\"true\"\n" +
    "          required\n" +
    "          ng-focus='signupOrderForm.City.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.City.hasFocus=false'>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-1-4\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.State.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.State.$valid,\n" +
    "        \"has-error\": signupOrderForm.State.$invalid && (form.$submitted || signupOrderForm.State.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.State.$viewValue }'>\n" +
    "        <label for=\"State\">State</label>\n" +
    "        <input\n" +
    "          id=\"State\"\n" +
    "          name=\"State\"\n" +
    "          class=\"radius-none\"\n" +
    "          type=\"text\"\n" +
    "          required\n" +
    "          max=\"2\"\n" +
    "          maxlength=\"2\"\n" +
    "          ng-maxlength=\"2\"\n" +
    "          ng-model=\"order.orderData.State\"\n" +
    "          ng-focus='signupOrderForm.State.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.State.hasFocus=false'>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-1-4\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.Zipcode.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.Zipcode.$valid,\n" +
    "        \"has-error\": signupOrderForm.Zipcode.$invalid && (form.$submitted || signupOrderForm.Zipcode.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.Zipcode.$viewValue }'>\n" +
    "        <label for=\"Zipcode\">Zip Code</label>\n" +
    "        <input\n" +
    "          id=\"Zipcode\"\n" +
    "          name=\"Zipcode\"\n" +
    "          class=\"radius-right\"\n" +
    "          type=\"text\"\n" +
    "          required\n" +
    "          autocomplete=\"new-password\"\n" +
    "          min=\"5\"\n" +
    "          minlength=\"5\"\n" +
    "          ng-minlength=\"5\"\n" +
    "          ngMinlength=\"5\"\n" +
    "          ng-model=\"order.orderData.Zipcode\"\n" +
    "          ng-focus='signupOrderForm.Zipcode.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.Zipcode.hasFocus=false'>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"signup-field\">\n" +
    "      <label class=\"signup-field__label\">Personal Information</label>\n" +
    "      <div class=\"form-error-row\">\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.Ssn.$invalid && order.submitted\">Social Security Number is required</span>&nbsp;\n" +
    "        </div>\n" +
    "        <div class=\"form-error-row__col\">\n" +
    "          <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.Dob.$invalid && order.submitted\">Date Of Birth is required</span>&nbsp;\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.Ssn.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.Ssn.$valid,\n" +
    "        \"has-error\": signupOrderForm.NoSsn ? null : signupOrderForm.Ssn.$invalid && (form.$submitted || signupOrderForm.Ssn.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.Ssn.$viewValue }'>\n" +
    "        <label for=\"Ssn\">Social Security Number</label>\n" +
    "        <input\n" +
    "          ng-disabled=\"order.orderData.NoSsn ? true : false\"\n" +
    "          id=\"Ssn\"\n" +
    "          name=\"Ssn\"\n" +
    "          class=\"radius-left\"\n" +
    "          type=\"password\"\n" +
    "          ng-required=\"!order.orderData.NoSsn\"\n" +
    "          clean=\"true\"\n" +
    "          mask=\"999-99-9999\"\n" +
    "          ng-model=\"order.orderData.Ssn\"\n" +
    "          ng-focus='signupOrderForm.Ssn.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.Ssn.hasFocus=false'>\n" +
    "      </div>\n" +
    "      <div\n" +
    "        class=\"form-group input-half\"\n" +
    "        ng-class='{ \"has-focus\": signupOrderForm.Dob.hasFocus,\n" +
    "        \"has-success\": signupOrderForm.Dob.$valid,\n" +
    "        \"has-error\": signupOrderForm.Dob.$invalid && (form.$submitted || signupOrderForm.Dob.$touched),\n" +
    "        \"is-empty\": !signupOrderForm.Dob.$viewValue }'>\n" +
    "        <label for=\"Dob\">Date Of Birth (mm/dd/yyyy)</label>\n" +
    "        <input\n" +
    "          id=\"Dob\"\n" +
    "          name=\"Dob\"\n" +
    "          class=\"radius-right\"\n" +
    "          type=\"text\"\n" +
    "          ng-model=\"order.orderData.Dob\"\n" +
    "          required\n" +
    "          mask=\"19/39/9999\"\n" +
    "          ng-focus='signupOrderForm.Dob.hasFocus=true',\n" +
    "          ng-blur='signupOrderForm.Dob.hasFocus=false'>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"signup-field\">\n" +
    "      <div class=\"form-error-row\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.Ssn.$invalid && order.submitted\">You need to either enter a Social Security number or select this field to proceed.</span>\n" +
    "      </div>\n" +
    "      <ul>\n" +
    "        <li class=\"checkbox-item\" tabindex=\"1\" ng-keyup=\"$event.keyCode === 13 && order.placeOrder(signupOrderForm.$valid)\"  ng-click=\"order.clearSsn()\">\n" +
    "          <div class=\"checkbox-item__box\"\n" +
    "            ng-class=\"order.orderData.NoSsn ? '' : 'checkbox-item__box--disabled'\" ng-click=\"order.orderData.NoSsn = !order.orderData.NoSsn\">\n" +
    "            <span class=\"checkbox-item__icon\"\n" +
    "              ng-class=\"order.orderData.NoSsn? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "              class=\"checkbox-item__input\"\n" +
    "              type=\"checkbox\"\n" +
    "              name=\"NoSsn\"\n" +
    "              ng-model=\"order.orderData.NoSsn\"\n" +
    "              >\n" +
    "            <h3 class=\"checkbox-item__title\">I do not have a Social Security Number</h3>\n" +
    "            <p>You will be required to provide a passport or id to complete enrollment.</p>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <div class=\"signup-field\">\n" +
    "      <label class=\"signup-field__label\">OK, last step.</label>\n" +
    "      <div class=\"form-error-row\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupOrderForm.legalAgree.$invalid && order.submitted\">You need to agree to our legal documents</span>\n" +
    "      </div>\n" +
    "      <ul>\n" +
    "        <li class=\"checkbox-item\" tabindex=\"1\" ng-keyup=\"$event.keyCode === 13 && order.placeOrder(signupOrderForm.$valid)\">\n" +
    "          <div class=\"checkbox-item__box\"\n" +
    "            ng-class=\"order.orderData.legalAgree ? '' : 'checkbox-item__box--disabled'\" ng-click=\"order.orderData.legalAgree = !order.orderData.legalAgree\">\n" +
    "            <span class=\"checkbox-item__icon\"\n" +
    "              ng-class=\"order.orderData.legalAgree ? 'icon-check' : ''\"></span>\n" +
    "          </div>\n" +
    "          <div class=\"checkbox-item__content\">\n" +
    "            <input\n" +
    "              class=\"checkbox-item__input\"\n" +
    "              type=\"checkbox\"\n" +
    "              name=\"legalAgree\"\n" +
    "              ng-model=\"order.orderData.legalAgree\"\n" +
    "              required>\n" +
    "            <h3 class=\"checkbox-item__title\">Check if you agree to our legal documents</h3>\n" +
    "            <p><a href=\"https://akimbocard.com/e-sign-disclosure\" target=\"_blank\">E-Sign Disclosure</a>, <a href=\"https://akimbocard.com/privacy-policy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://akimbocard.com/cardholder-agreement\" target=\"_blank\">Cardholder Agreement</a></p>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "\n" +
    "<div ng-show=\"order.errorShow\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-small\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-small\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1>Heads up!</h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body\">\n" +
    "        <p class=\"con-large\">{{order.errorMessage}}</p>\n" +
    "        <div class=\"btn-container\">\n" +
    "        <a class=\"btn btn-small btn--float-left btn-no-min-width\" ng-if=\"order.showBack\" ng-click=\"order.hideModal()\">Go Back</a>\n" +
    "        <a class=\"btn btn--float-right\" ng-if=\"order.verificationFlag\" ng-click=\"order.goToDashboard('member.home.profile/verification.step1')\">Continue To Dashboard</a>\n" +
    "      </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"signup-section signup-section--padding clear\">\n" +
    "  <button class=\"btn btn-light btn-register btn-register--left\" ng-if=\"order.showBack\" ng-click=\"order.goBack()\">Back</button>\n" +
    "\n" +
    "  <button class=\"btn btn-register\"  ng-hide=\"order.loading\" ng-click=\"order.placeOrder(signupOrderForm.$valid)\">\n" +
    "    Order my\n" +
    "    <ng-pluralize count=\"order.cardOrderService.getCards().length\"\n" +
    "      when=\"{'one': 'card', 'other': '{} cards'}\"></ng-pluralize>\n" +
    "  </button>\n" +
    "  <div class=\"form-loader\" ng-show=\"order.loading\">\n" +
    "    <span class=\"loading-indicator\" alt=\"\"></span>\n" +
    "    <p>We are ordering your <ng-pluralize count=\"order.cardOrderService.getCards().length\"\n" +
    "      when=\"{'one': 'card', 'other': 'cards'}\"></ng-pluralize>...</p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/signup/signin.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/signin.html",
    "<div class=\"title-with-icon\">\n" +
    "  <span class=\"title-with-icon__icon icon-lock-circle mobile-hide\"></span>\n" +
    "  <h3 class=\"title-with-icon__text\">Login and Account Setup</h3>\n" +
    "</div>\n" +
    "<div ui-view=\"signup-progress\"></div>\n" +
    "<div class=\"signup-section floatingForm-form\" ng-form=\"signupLoginForm\">\n" +
    "  <div class=\"signup-field\">\n" +
    "    <label class=\"signup-field__label signup-field__label--margin-bottom\">Let's set up your account and login information so you can manage and load the cards you create.<span ng-show=\"signin.currentCard.CardPurpose !== 'personal'\"><br/><br/>Tip: You'll be managing this card, so we need your information here and not the information for the card you're currently creating.</label>\n" +
    "    <div class=\"form-error-row\">\n" +
    "      <div class=\"form-error-row__col\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.FirstName.$invalid && signin.submitted\">First Name is required</span>\n" +
    "      </div>\n" +
    "      <div class=\"form-error-row__col\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.LastName.$invalid && signin.submitted\">Last Name is required</span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"form-group input-half\"\n" +
    "      ng-class='{ \"has-focus\": signupLoginForm.FirstName.hasFocus,\n" +
    "      \"has-success\": signupLoginForm.FirstName.$valid,\n" +
    "      \"has-error\": signupLoginForm.FirstName.$invalid && (form.$submitted || signupLoginForm.FirstName.$touched),\n" +
    "      \"is-empty\": !signupLoginForm.FirstName.$viewValue }'>\n" +
    "      <label for=\"FirstName\">First Name</label>\n" +
    "      <input\n" +
    "        id=\"FirstName\"\n" +
    "        name=\"FirstName\"\n" +
    "        class=\"radius-left\"\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"signin.loginData.FirstName\"\n" +
    "        clean=\"true\"\n" +
    "        ng-required=\"signin.loginData.CardPurpose !== 'personal'\"\n" +
    "        ng-focus='signupLoginForm.FirstName.hasFocus=true',\n" +
    "        ng-blur='signupLoginForm.FirstName.hasFocus=false'>\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"form-group input-half\"\n" +
    "      ng-class='{ \"has-focus\": signupLoginForm.LastName.hasFocus,\n" +
    "      \"has-success\": signupLoginForm.LastName.$valid,\n" +
    "      \"has-error\": signupLoginForm.LastName.$invalid && (form.$submitted || signupLoginForm.LastName.$touched),\n" +
    "      \"is-empty\": !signupLoginForm.LastName.$viewValue }'>\n" +
    "      <label for=\"LastName\">Last Name</label>\n" +
    "      <input\n" +
    "        id=\"LastName\"\n" +
    "        name=\"LastName\"\n" +
    "        class=\"radius-right\"\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"signin.loginData.LastName\"\n" +
    "        ng-required=\"signin.loginData.CardPurpose !== 'personal'\"\n" +
    "        ng-focus='signupLoginForm.LastName.hasFocus=true',\n" +
    "        ng-blur='signupLoginForm.LastName.hasFocus=false'>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"signup-field\">\n" +
    "    <div class=\"form-error-row\">\n" +
    "      <div class=\"form-error-row__col\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.Phone.$invalid && signin.submitted\">\n" +
    "          Please provide a valid phone number\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"form-error-row__col\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.Email.$error.required && signin.submitted\">Please provide an email</span>\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.Email.$error.Email && signin.submitted\">Please provide a valid email</span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"form-group input-half\"\n" +
    "      ng-class='{ \"has-focus\": signupLoginForm.Phone.hasFocus,\n" +
    "      \"has-success\": signupLoginForm.Phone.$valid,\n" +
    "      \"has-error\": signupLoginForm.Phone.$invalid && (form.$submitted || signupLoginForm.Phone.$touched),\n" +
    "      \"is-empty\": !signupLoginForm.Phone.$viewValue }'>\n" +
    "        <label for=\"Phone\">Mobile Number</label>\n" +
    "        <input\n" +
    "          id=\"Phone\"\n" +
    "          name=\"Phone\"\n" +
    "          class=\"radius-left\"\n" +
    "          type=\"tel\"\n" +
    "          clean=\"true\"\n" +
    "          required\n" +
    "          minlength=\"10\"\n" +
    "          maxlength=\"10\"\n" +
    "          ak-input-only-numbers\n" +
    "          ng-model-options=\"{ allowInvalid: true }\"\n" +
    "          ng-model=\"signin.loginData.Phone\"\n" +
    "          ng-focus='signupLoginForm.Phone.hasFocus=true',\n" +
    "          ng-blur='signupLoginForm.Phone.hasFocus=false'>\n" +
    "        <div\n" +
    "          class=\"form-group__feedback\"\n" +
    "          ak-format-phone-number=\"signin.loginData.Phone\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"form-group input-half\"\n" +
    "      ng-class='{ \"has-focus\": signupLoginForm.Email.hasFocus,\n" +
    "      \"has-success\": signupLoginForm.Email.$valid,\n" +
    "      \"has-error\": signupLoginForm.Email.$invalid && (form.$submitted || signupLoginForm.Email.$touched),\n" +
    "      \"is-empty\": !signupLoginForm.Email.$viewValue }'>\n" +
    "      <label for=\"Email\">Email Address</label>\n" +
    "      <input\n" +
    "        id=\"Email\"\n" +
    "        name=\"Email\"\n" +
    "        type=\"email\"\n" +
    "        class=\"radius-right\"\n" +
    "        ng-model=\"signin.loginData.Email\"\n" +
    "        required\n" +
    "        ng-focus='signupLoginForm.Email.hasFocus=true',\n" +
    "        ng-blur='signupLoginForm.Email.hasFocus=false'>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"signup-field\">\n" +
    "    <div class=\"form-error-row\">\n" +
    "      <div class=\"form-error-row__col\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.Password.$invalid && signin.submitted\">Password is required</span>\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.Password.$invalid && signupLoginForm.Password.hasFocus\">At least 8 characters and 1 number</span>\n" +
    "      </div>\n" +
    "      <div class=\"form-error-row__col\">\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.ConfirmPassword.$invalid && signupLoginForm.ConfirmPassword.$pristine && signin.submitted\">Confirm Password is required</span>\n" +
    "        <span class=\"form-error-row__msg\" ng-show=\"signupLoginForm.ConfirmPassword.$invalid && signupLoginForm.ConfirmPassword.$dirty && !signupLoginForm.ConfirmPassword.hasFocus\">Passwords don't match</span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"form-group input-half\"\n" +
    "      ng-class='{ \"has-focus\": signupLoginForm.Password.hasFocus,\n" +
    "      \"has-success\": signupLoginForm.Password.$valid,\n" +
    "      \"has-error\": signupLoginForm.Password.$invalid && (form.$submitted || signupLoginForm.Password.$touched),\n" +
    "      \"is-empty\": !signupLoginForm.Password.$viewValue }'>\n" +
    "      <label for=\"password\">Password</label>\n" +
    "      <input\n" +
    "        id=\"Password\"\n" +
    "        name=\"Password\"\n" +
    "        type=\"password\"\n" +
    "        class=\"radius-left\"\n" +
    "        clean=\"true\"\n" +
    "        required\n" +
    "        validate-password\n" +
    "        ng-model=\"signin.loginData.Password\"\n" +
    "        ng-focus='signupLoginForm.Password.hasFocus=true',\n" +
    "        ng-blur='signupLoginForm.Password.hasFocus=false'>\n" +
    "    </div>\n" +
    "    <div\n" +
    "      class=\"form-group input-half\"\n" +
    "      ng-class='{ \"has-focus\": signupLoginForm.ConfirmPassword.hasFocus,\n" +
    "      \"has-success\": signupLoginForm.ConfirmPassword.$valid,\n" +
    "      \"has-error\": signupLoginForm.ConfirmPassword.$invalid && (form.$submitted || signupLoginForm.ConfirmPassword.$touched),\n" +
    "      \"is-empty\": !signupLoginForm.ConfirmPassword.$viewValue }'>\n" +
    "      <label for=\"ConfirmPassword\">Confirm Password</label>\n" +
    "      <input\n" +
    "        id=\"ConfirmPassword\"\n" +
    "        name=\"ConfirmPassword\"\n" +
    "        class=\"radius-right\"\n" +
    "        type=\"password\"\n" +
    "        required\n" +
    "        confirm-password\n" +
    "        ng-model=\"signin.loginData.ConfirmPassword\"\n" +
    "        ng-focus='signupLoginForm.ConfirmPassword.hasFocus=true',\n" +
    "        ng-blur='signupLoginForm.ConfirmPassword.hasFocus=false'>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<hr class=\"overlay__divider\">\n" +
    "<div class=\"title-with-icon\" ng-show=\"signin.showError\">\n" +
    "  <span class=\"title-with-icon__icon icon-exclamation-circle mobile-hide\"></span>\n" +
    "  <h3 class=\"title-with-icon__text\">{{signin.errorMessage}}</h3>\n" +
    "</div>\n" +
    "<div class=\"signup-section signup-section--padding clear\">\n" +
    "  <button type=\"button\" class=\"btn btn-light btn-register btn-register--left\" ui-sref=\"signup.customize\">Back</button>\n" +
    "  <button\n" +
    "    class=\"btn btn-register\"\n" +
    "    ng-disabled=\"signin.showValidateEmail\"\n" +
    "    ng-hide=\"signin.loading\"\n" +
    "    ng-click=\"signin.checkEmail(signupLoginForm.$valid)\">\n" +
    "      Next\n" +
    "  </button>\n" +
    "  <div class=\"form-loader\" ng-show=\"signin.loading\">\n" +
    "    <span class=\"loading-indicator\" alt=\"\"></span>\n" +
    "    <p>We are creating your account...</p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"verify-email\" ng-show=\"signin.showValidateEmail\">\n" +
    "  <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "  <div class=\"con-overlay-wrapper-large\" id=\"confirmation_overlay\">\n" +
    "    <div class=\"con-overlay con-overlay-large\">\n" +
    "      <div class=\"con-overlay-header\">\n" +
    "        <div class=\"con-overlay-header-main\">\n" +
    "          <div class=\"overlay-close icon-circle-x\" ng-click=\"signin.close()\"></div>\n" +
    "          <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "          <h1><b>VERIFY EMAIL</b></h1>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"con-overlay-body exPadding\">\n" +
    "        <h1>We've just sent an email to:</h1>\n" +
    "        <br>\n" +
    "        <h2>{{signin.loginData.Email}}</h2>\n" +
    "        <br>\n" +
    "        <p>In order for us to verify your email address, please check your email in a new window/tab and click the link provided. If the link does not work, enter the verification code in the box below.</p>\n" +
    "        <div id=\"emailVerifyFeedback\">\n" +
    "          <span ng-show=\"signin.attemptedVerify\"><b>Please enter a Verification Code</b></span>\n" +
    "          <span ng-show=\"signin.invalidVerify\"><b>Oops, invalid Verification Code</b></span>\n" +
    "        </div>\n" +
    "        <div class=\"reduced-input validateCodeInput\">\n" +
    "          <input\n" +
    "            name=\"VerificationCode\"\n" +
    "            placeholder=\"Verification Code\"\n" +
    "            class=\"pinInput\"\n" +
    "            ng-model=\"signin.loginData.VerificationCode\"\n" +
    "            ng-keyup=\"signin.checkPressedKey($event)\" />\n" +
    "        </div>\n" +
    "        <a class=\"btn\" ng-click=\"signin.submitCode()\" ng-show=\"!signin.loading\">Verify</a>\n" +
    "        <br>\n" +
    "        <p id=\"resend\">\n" +
    "          <a ng-click=\"signin.reSend()\">Resend Email</a>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "      <div class=\"overlay-footer\">\n" +
    "        <div>\n" +
    "          <h2 id=\"feedback\">Please do not close this window/tab</h2>\n" +
    "        </div>\n" +
    "        <div id=\"akimbo-form-footer-buttons\" ng-show=\"!signin.loading\">\n" +
    "          <h2 id=\"countDown\">Expires in <b>{{signin.counter | formatTimer}}</b></h2>\n" +
    "        </div>\n" +
    "        <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"signin.loading\">\n" +
    "          <span class=\"loading-indicator\"></span>\n" +
    "          <p>Processing</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/views/signup/signup-progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/views/signup/signup-progress.html",
    "<div class=\"signup-section signup-section--centered\">\n" +
    "  <div class=\"centered-error-message\" ng-show=\"progress.loadError\">\n" +
    "    <p>Oops, something went wrong. Please try again. Code: {{progress.errorCode}}</p>\n" +
    "  </div>\n" +
    "  <div class=\"card-and-progress\" ng-repeat=\"card in progress.cards\" ng-show=\"progress.showCard($index)\">\n" +
    "    <div class=\"card-preview\">\n" +
    "      <span class=\"card-preview__remove icon-close-circle\"\n" +
    "        ng-click=\"progress.removeCard($index)\"\n" +
    "        ng-show=\"progress.$state.includes('signup.order') && progress.cards.length > 1\"></span>\n" +
    "      <img class=\"card-preview__logo\" ng-src=\"assets/images/akimbo-logo.svg\" alt=\"\">\n" +
    "      <div class=\"card-preview__card-label\" ng-show=\"progress.showLabel($index)\">\n" +
    "        {{ progress.cards[$index].CardLabel || 'Label' }}\n" +
    "      </div>\n" +
    "      <div class=\"card-preview__card-name\">\n" +
    "        {{ progress.cards[$index].FirstName || 'Card' }} {{ progress.cards[$index].LastName || 'Name' }}\n" +
    "      </div>\n" +
    "      <img class=\"card-preview__brand\" ng-src=\"assets/images/mastercard.svg\" alt=\"\">\n" +
    "    </div>\n" +
    "    <div class=\"signup-progress\">\n" +
    "      <ul ng-show=\"progress.$state.includes('signup.create')\">\n" +
    "        <li class=\"signup-progress__item signup-progress__item--active\">\n" +
    "          <span class=\"signup-progress__icon icon-check\"></span>\n" +
    "          Looking good! We'll guide you through the process of creating your cards.\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "      <ul ng-hide=\"progress.$state.includes('signup.create')\">\n" +
    "        <li class=\"signup-progress__item signup-progress__item--active\">\n" +
    "          <span class=\"signup-progress__icon icon-female\"></span>\n" +
    "          <span ng-switch=\"progress.cards[$index].CardPurpose\">\n" +
    "            <span ng-switch-when=\"personal\">This card is for me</span>\n" +
    "            <span ng-switch-when=\"allowance\">This card is for someone else</span>\n" +
    "            <span ng-switch-when=\"household\">This card is shared</span>\n" +
    "          </span>\n" +
    "        </li>\n" +
    "        <li class=\"signup-progress__item\"\n" +
    "          ng-class=\"{'signup-progress__item--active': progress.cards[$index].ATMInternationalAccess}\">\n" +
    "            <span class=\"signup-progress__icon icon-atm\"></span>\n" +
    "            International and ATM access\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "      <ul ng-show=\"progress.$state.includes('signup.order')\">\n" +
    "        <li class=\"signup-progress__item\">\n" +
    "          <button type=\"button\" class=\"btn btn-light btn-x-small\" ng-click=\"progress.editCard($index)\">Edit this card</button>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <div class=\"card-and-progress__loader\" ng-show=\"progress.loading\">\n" +
    "      <span class=\"loading-indicator\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/partials/selectVerificationMethod.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/partials/selectVerificationMethod.html",
    "<div class=\"select-verification-method\" ng-show=\"showSelectVerificationMethod\">\n" +
    "    <div id=\"verification_overlay_bg\"></div>\n" +
    "    <div class=\"con-overlay-wrapper-large\" id=\"verification_overlay\">\n" +
    "        <div class=\"con-overlay con-overlay-large\">\n" +
    "            <div class=\"con-overlay-header\">\n" +
    "              <div class=\"con-overlay-header-main\">\n" +
    "                <div class=\"overlay-close icon-close-circle\" ng-click=\"close()\"></div>\n" +
    "                <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "                <h1><b>VERIFY YOUR ACCOUNT</b></h1>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"con-overlay-body exPadding\" >\n" +
    "                <h1 id='enroll-verification-txt'>In order to verify your account, we need to send you a verification code.</h1>\n" +
    "                <br>\n" +
    "                <p>Where would you like us to send this code?</p>\n" +
    "                <div id=\"selectVerificationMethodFeedback\">\n" +
    "                    <ul class=\"floatingForm-form\">\n" +
    "                      <li ng-hide=\"hidePhoneVerification\" class=\"checkbox-item\" ng-click=\"verificationMethodChange('phone')\">\n" +
    "                          <div class=\"checkbox-item__box\"\n" +
    "                            ng-class=\"formData.verificationMethod == 'phone' ? '' : 'checkbox-item__box--disabled'\">\n" +
    "                            <span class=\"checkbox-item__icon\"\n" +
    "                              ng-class=\"formData.verificationMethod == 'phone' ? 'icon-check' : 'icon-phone'\"></span>\n" +
    "                          </div>\n" +
    "                          <div class=\"checkbox-item__content\">\n" +
    "                            <input\n" +
    "                              class=\"checkbox-item__input\"\n" +
    "                              type=\"radio\"\n" +
    "                              name=\"verificationMethod\"\n" +
    "                              value=\"phone\"\n" +
    "                              ng-model=\"formData.verificationMethod\">\n" +
    "                            <p class=\"checkbox-item__text\">Mobile: {{formData.phone || formData.Phone1 + formData.Phone2 + formData.Phone3 | phoneNumberFilter}}</p>\n" +
    "                          </div>\n" +
    "                        </li>\n" +
    "                        <li id=\"verification-email-checkbox\" class=\"checkbox-item\" ng-click=\"verificationMethodChange('email')\">\n" +
    "                          <div class=\"checkbox-item__box\"\n" +
    "                            ng-class=\"formData.verificationMethod == 'email' ? '' : 'checkbox-item__box--disabled'\">\n" +
    "                            <span class=\"checkbox-item__icon\"\n" +
    "                              ng-class=\"formData.verificationMethod == 'email' ? 'icon-check' : 'icon-envelope'\"></span>\n" +
    "                          </div>\n" +
    "                          <div class=\"checkbox-item__content\">\n" +
    "                            <input\n" +
    "                              class=\"checkbox-item__input\"\n" +
    "                              type=\"radio\"\n" +
    "                              name=\"verificationMethod\"\n" +
    "                              value=\"email\"\n" +
    "                              ng-model=\"formData.verificationMethod\">\n" +
    "                            <p class=\"checkbox-item__text\">Email: {{formData.email || formData.Email}}</p>\n" +
    "                          </div>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </div>\n" +
    "                <br>\n" +
    "                <a class=\"btn\" id='veriMethodNextBtn' ng-click=\"submitSelectVerificationMethod()\">Next</a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"overlay-mask\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/partials/verifyContact.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/partials/verifyContact.html",
    "<div id=\"verifyContact\" class=\"verify-email\" ng-show=\"showValidateEmail\" >\n" +
    "    <div class=\"overlay-background\"></div>\n" +
    "    <div class=\"con-overlay-wrapper\" id=\"confirmation_overlay\">\n" +
    "        <div class=\"con-overlay con-overlay\" name=\"validationCodeWidget\" id=\"validationCodeWidget\">\n" +
    "            <div class=\"con-overlay-header\">\n" +
    "                <div id=\"verification-header\" class=\"con-overlay-header-main\">\n" +
    "                    <div class=\"overlay-close icon-close-circle\" ng-click=\"close()\"></div>\n" +
    "                    <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "                    <h1 ng-show=\"verificationMethodIsPhone\"><b>VERIFY MOBILE</b></h1>\n" +
    "                    <h1 ng-show=\"verificationMethodIsEmail\"><b>VERIFY EMAIL</b></h1>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"con-overlay-body exPadding\">\n" +
    "                <h1 ng-show=\"verificationMethodIsPhone\">We've just sent a text message to:</h1>\n" +
    "                <h1 ng-show=\"verificationMethodIsEmail\">We've just sent an email to:</h1>\n" +
    "                <br>\n" +
    "                <h2 ng-show=\"verificationMethodIsPhone\">{{formData.phone || formData.Phone1 + formData.Phone2 + formData.Phone3 | phoneNumberFilter}}</h2>\n" +
    "                <h2 ng-show=\"verificationMethodIsEmail\">{{formData.email || formData.Email}}</h2>\n" +
    "                <br>\n" +
    "                <p ng-show=\"verificationMethodIsPhone\">In order for us to verify your mobile number, please check your text messages and enter the verification code in the box below.</p>\n" +
    "                <p ng-show=\"verificationMethodIsEmail\">In order for us to verify your email address, please check your email in a new window/tab and enter the verification code in the box below.</p>\n" +
    "                <div id=\"emailVerifyFeedback\">\n" +
    "                    <span ng-show=\"attemptedVerify\"><b>Please enter a Verification Code</b></span>\n" +
    "                    <span ng-show=\"invalidVerify\"><b>Oops, invalid Verification Code</b></span>\n" +
    "                </div>\n" +
    "                <div class=\"validateCodeInput\">\n" +
    "                    <input\n" +
    "                            id=\"verificationCode\"\n" +
    "                            name=\"VerificationCode\"\n" +
    "                            placeholder=\"Verification Code\"\n" +
    "                            class=\"pinInput\"\n" +
    "                            ng-model=\"formData.VerificationCode\"\n" +
    "                            ng-keyup=\"$event.keyCode === 13 && submitCode()\"/>\n" +
    "                </div>\n" +
    "                <a class=\"btn\" id='verifyBtn' ng-click=\"submitCode()\">Verify</a>\n" +
    "                <br>\n" +
    "                <p id=\"resend\">\n" +
    "                    <a class=\"ak-link\" ng-click=\"reSend()\">Resend code</a>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "            <div class=\"con-overlay-footer\">\n" +
    "                <div>\n" +
    "                    <h2 id=\"feedback\">Please do not close this window/tab</h2>\n" +
    "                </div>\n" +
    "                <div id=\"akimbo-form-footer-buttons\" ng-show=\"!loading\">\n" +
    "                    <h2 id=\"countDown\">Expires in <b>{{counter | formatTimer}}</b></h2>\n" +
    "                </div>\n" +
    "                <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "                    <span class=\"loading-indicator\"></span>\n" +
    "                    <p>Processing</p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"overlay-mask\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../app/partials/verifyEmailOld.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../app/partials/verifyEmailOld.html",
    "<div class=\"verify-email\" ng-show=\"showValidateEmail\">\n" +
    "    <div id=\"confirmation_overlay_bg\" style=\"opacity: 0.85; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; z-index: 20; background-color: rgb(115, 117, 116);\"></div>\n" +
    "    <div class=\"con-overlay-wrapper-large\" id=\"confirmation_overlay\">\n" +
    "        <div class=\"con-overlay con-overlay-large\">\n" +
    "            <div class=\"con-overlay-header\">\n" +
    "                <div class=\"con-overlay-header-main\">\n" +
    "                    <div class=\"overlay-close icon-close-circle\" ng-click=\"close()\"></div>\n" +
    "                    <img class=\"login-box-icon\" ng-src=\"assets/images/{{brand.name}}/login-icon.svg\" alt=\"\">\n" +
    "                    <h1><b>VERIFY EMAIL</b></h1>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"con-overlay-body exPadding\">\n" +
    "                <h1>We've just sent an email to:</h1>\n" +
    "                <br>\n" +
    "                <h2>{{formData.updatedEmail || formData.Email}}</h2>\n" +
    "                <br>\n" +
    "                <p>In order for us to verify your email address, please check your email in a new window/tab and click the link provided. If the link does not work, enter the verification code in the box below.</p>\n" +
    "                <div id=\"emailVerifyFeedback\">\n" +
    "                    <span ng-show=\"attemptedVerify\"><b>Please enter a Verification Code</b></span>\n" +
    "                    <span ng-show=\"invalidVerify\"><b>Oops, invalid Verification Code</b></span>\n" +
    "                </div>\n" +
    "                <div class=\"reduced-input validateCodeInput\">\n" +
    "                    <input\n" +
    "                            name=\"VerificationCode\"\n" +
    "                            placeholder=\"Verification Code\"\n" +
    "                            class=\"pinInput\"\n" +
    "                            ng-model=\"formData.VerificationCode\"/>\n" +
    "                </div>\n" +
    "                <a class=\"btn\" ng-click=\"submitCode()\">Verify</a>\n" +
    "                <br>\n" +
    "                <p id=\"resend\">\n" +
    "                    <a ng-click=\"reSend()\">Resend Email</a>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "            <div class=\"overlay-footer\">\n" +
    "                <div>\n" +
    "                    <h2 id=\"feedback\">Please do not close this window/tab</h2>\n" +
    "                </div>\n" +
    "                <div id=\"akimbo-form-footer-buttons\" ng-show=\"!loading\">\n" +
    "                    <h2 id=\"countDown\">Expires in <b>{{counter | formatTimer}}</b></h2>\n" +
    "                </div>\n" +
    "                <div id=\"akimbo-form-footer-spinner\" class=\"form-loader\" ng-show=\"loading\">\n" +
    "                    <span class=\"loading-indicator\"></span>\n" +
    "                    <p>Processing</p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);
